/*eslint-disable block-scoped-var, id-length, no-control-regex, no-magic-numbers, no-prototype-builtins, no-redeclare, no-shadow, no-var, sort-vars*/
"use strict";

var $protobuf = require("protobufjs/minimal");

// Common aliases
var $Reader = $protobuf.Reader, $Writer = $protobuf.Writer, $util = $protobuf.util;

// Exported root namespace
var $root = $protobuf.roots["default"] || ($protobuf.roots["default"] = {});

$root.Timestamp = (function() {

    /**
     * Properties of a Timestamp.
     * @exports ITimestamp
     * @interface ITimestamp
     * @property {number|Long|null} [Value] Timestamp Value
     */

    /**
     * Constructs a new Timestamp.
     * @exports Timestamp
     * @classdesc Represents a Timestamp.
     * @implements ITimestamp
     * @constructor
     * @param {ITimestamp=} [properties] Properties to set
     */
    function Timestamp(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Timestamp Value.
     * @member {number|Long} Value
     * @memberof Timestamp
     * @instance
     */
    Timestamp.prototype.Value = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * Creates a new Timestamp instance using the specified properties.
     * @function create
     * @memberof Timestamp
     * @static
     * @param {ITimestamp=} [properties] Properties to set
     * @returns {Timestamp} Timestamp instance
     */
    Timestamp.create = function create(properties) {
        return new Timestamp(properties);
    };

    /**
     * Encodes the specified Timestamp message. Does not implicitly {@link Timestamp.verify|verify} messages.
     * @function encode
     * @memberof Timestamp
     * @static
     * @param {ITimestamp} message Timestamp message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Timestamp.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Value != null && message.hasOwnProperty("Value"))
            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.Value);
        return writer;
    };

    /**
     * Encodes the specified Timestamp message, length delimited. Does not implicitly {@link Timestamp.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Timestamp
     * @static
     * @param {ITimestamp} message Timestamp message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Timestamp.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Timestamp message from the specified reader or buffer.
     * @function decode
     * @memberof Timestamp
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Timestamp} Timestamp
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Timestamp.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Timestamp();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Value = reader.int64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Timestamp message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Timestamp
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Timestamp} Timestamp
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Timestamp.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Timestamp message.
     * @function verify
     * @memberof Timestamp
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Timestamp.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Value != null && message.hasOwnProperty("Value"))
            if (!$util.isInteger(message.Value) && !(message.Value && $util.isInteger(message.Value.low) && $util.isInteger(message.Value.high)))
                return "Value: integer|Long expected";
        return null;
    };

    /**
     * Creates a Timestamp message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Timestamp
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Timestamp} Timestamp
     */
    Timestamp.fromObject = function fromObject(object) {
        if (object instanceof $root.Timestamp)
            return object;
        var message = new $root.Timestamp();
        if (object.Value != null)
            if ($util.Long)
                (message.Value = $util.Long.fromValue(object.Value)).unsigned = false;
            else if (typeof object.Value === "string")
                message.Value = parseInt(object.Value, 10);
            else if (typeof object.Value === "number")
                message.Value = object.Value;
            else if (typeof object.Value === "object")
                message.Value = new $util.LongBits(object.Value.low >>> 0, object.Value.high >>> 0).toNumber();
        return message;
    };

    /**
     * Creates a plain object from a Timestamp message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Timestamp
     * @static
     * @param {Timestamp} message Timestamp
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Timestamp.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.Value = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.Value = options.longs === String ? "0" : 0;
        if (message.Value != null && message.hasOwnProperty("Value"))
            if (typeof message.Value === "number")
                object.Value = options.longs === String ? String(message.Value) : message.Value;
            else
                object.Value = options.longs === String ? $util.Long.prototype.toString.call(message.Value) : options.longs === Number ? new $util.LongBits(message.Value.low >>> 0, message.Value.high >>> 0).toNumber() : message.Value;
        return object;
    };

    /**
     * Converts this Timestamp to JSON.
     * @function toJSON
     * @memberof Timestamp
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Timestamp.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Timestamp;
})();

$root.NullableInt32 = (function() {

    /**
     * Properties of a NullableInt32.
     * @exports INullableInt32
     * @interface INullableInt32
     * @property {number|null} [Value] NullableInt32 Value
     */

    /**
     * Constructs a new NullableInt32.
     * @exports NullableInt32
     * @classdesc Represents a NullableInt32.
     * @implements INullableInt32
     * @constructor
     * @param {INullableInt32=} [properties] Properties to set
     */
    function NullableInt32(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * NullableInt32 Value.
     * @member {number} Value
     * @memberof NullableInt32
     * @instance
     */
    NullableInt32.prototype.Value = 0;

    /**
     * Creates a new NullableInt32 instance using the specified properties.
     * @function create
     * @memberof NullableInt32
     * @static
     * @param {INullableInt32=} [properties] Properties to set
     * @returns {NullableInt32} NullableInt32 instance
     */
    NullableInt32.create = function create(properties) {
        return new NullableInt32(properties);
    };

    /**
     * Encodes the specified NullableInt32 message. Does not implicitly {@link NullableInt32.verify|verify} messages.
     * @function encode
     * @memberof NullableInt32
     * @static
     * @param {INullableInt32} message NullableInt32 message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    NullableInt32.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Value != null && message.hasOwnProperty("Value"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Value);
        return writer;
    };

    /**
     * Encodes the specified NullableInt32 message, length delimited. Does not implicitly {@link NullableInt32.verify|verify} messages.
     * @function encodeDelimited
     * @memberof NullableInt32
     * @static
     * @param {INullableInt32} message NullableInt32 message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    NullableInt32.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a NullableInt32 message from the specified reader or buffer.
     * @function decode
     * @memberof NullableInt32
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {NullableInt32} NullableInt32
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    NullableInt32.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NullableInt32();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Value = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a NullableInt32 message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof NullableInt32
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {NullableInt32} NullableInt32
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    NullableInt32.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a NullableInt32 message.
     * @function verify
     * @memberof NullableInt32
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    NullableInt32.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Value != null && message.hasOwnProperty("Value"))
            if (!$util.isInteger(message.Value))
                return "Value: integer expected";
        return null;
    };

    /**
     * Creates a NullableInt32 message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof NullableInt32
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {NullableInt32} NullableInt32
     */
    NullableInt32.fromObject = function fromObject(object) {
        if (object instanceof $root.NullableInt32)
            return object;
        var message = new $root.NullableInt32();
        if (object.Value != null)
            message.Value = object.Value | 0;
        return message;
    };

    /**
     * Creates a plain object from a NullableInt32 message. Also converts values to other types if specified.
     * @function toObject
     * @memberof NullableInt32
     * @static
     * @param {NullableInt32} message NullableInt32
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    NullableInt32.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.Value = 0;
        if (message.Value != null && message.hasOwnProperty("Value"))
            object.Value = message.Value;
        return object;
    };

    /**
     * Converts this NullableInt32 to JSON.
     * @function toJSON
     * @memberof NullableInt32
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    NullableInt32.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NullableInt32;
})();

$root.NullableInt64 = (function() {

    /**
     * Properties of a NullableInt64.
     * @exports INullableInt64
     * @interface INullableInt64
     * @property {number|Long|null} [Value] NullableInt64 Value
     */

    /**
     * Constructs a new NullableInt64.
     * @exports NullableInt64
     * @classdesc Represents a NullableInt64.
     * @implements INullableInt64
     * @constructor
     * @param {INullableInt64=} [properties] Properties to set
     */
    function NullableInt64(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * NullableInt64 Value.
     * @member {number|Long} Value
     * @memberof NullableInt64
     * @instance
     */
    NullableInt64.prototype.Value = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * Creates a new NullableInt64 instance using the specified properties.
     * @function create
     * @memberof NullableInt64
     * @static
     * @param {INullableInt64=} [properties] Properties to set
     * @returns {NullableInt64} NullableInt64 instance
     */
    NullableInt64.create = function create(properties) {
        return new NullableInt64(properties);
    };

    /**
     * Encodes the specified NullableInt64 message. Does not implicitly {@link NullableInt64.verify|verify} messages.
     * @function encode
     * @memberof NullableInt64
     * @static
     * @param {INullableInt64} message NullableInt64 message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    NullableInt64.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Value != null && message.hasOwnProperty("Value"))
            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.Value);
        return writer;
    };

    /**
     * Encodes the specified NullableInt64 message, length delimited. Does not implicitly {@link NullableInt64.verify|verify} messages.
     * @function encodeDelimited
     * @memberof NullableInt64
     * @static
     * @param {INullableInt64} message NullableInt64 message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    NullableInt64.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a NullableInt64 message from the specified reader or buffer.
     * @function decode
     * @memberof NullableInt64
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {NullableInt64} NullableInt64
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    NullableInt64.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NullableInt64();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Value = reader.int64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a NullableInt64 message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof NullableInt64
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {NullableInt64} NullableInt64
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    NullableInt64.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a NullableInt64 message.
     * @function verify
     * @memberof NullableInt64
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    NullableInt64.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Value != null && message.hasOwnProperty("Value"))
            if (!$util.isInteger(message.Value) && !(message.Value && $util.isInteger(message.Value.low) && $util.isInteger(message.Value.high)))
                return "Value: integer|Long expected";
        return null;
    };

    /**
     * Creates a NullableInt64 message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof NullableInt64
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {NullableInt64} NullableInt64
     */
    NullableInt64.fromObject = function fromObject(object) {
        if (object instanceof $root.NullableInt64)
            return object;
        var message = new $root.NullableInt64();
        if (object.Value != null)
            if ($util.Long)
                (message.Value = $util.Long.fromValue(object.Value)).unsigned = false;
            else if (typeof object.Value === "string")
                message.Value = parseInt(object.Value, 10);
            else if (typeof object.Value === "number")
                message.Value = object.Value;
            else if (typeof object.Value === "object")
                message.Value = new $util.LongBits(object.Value.low >>> 0, object.Value.high >>> 0).toNumber();
        return message;
    };

    /**
     * Creates a plain object from a NullableInt64 message. Also converts values to other types if specified.
     * @function toObject
     * @memberof NullableInt64
     * @static
     * @param {NullableInt64} message NullableInt64
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    NullableInt64.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.Value = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.Value = options.longs === String ? "0" : 0;
        if (message.Value != null && message.hasOwnProperty("Value"))
            if (typeof message.Value === "number")
                object.Value = options.longs === String ? String(message.Value) : message.Value;
            else
                object.Value = options.longs === String ? $util.Long.prototype.toString.call(message.Value) : options.longs === Number ? new $util.LongBits(message.Value.low >>> 0, message.Value.high >>> 0).toNumber() : message.Value;
        return object;
    };

    /**
     * Converts this NullableInt64 to JSON.
     * @function toJSON
     * @memberof NullableInt64
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    NullableInt64.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NullableInt64;
})();

$root.NullableDouble = (function() {

    /**
     * Properties of a NullableDouble.
     * @exports INullableDouble
     * @interface INullableDouble
     * @property {number|null} [Value] NullableDouble Value
     */

    /**
     * Constructs a new NullableDouble.
     * @exports NullableDouble
     * @classdesc Represents a NullableDouble.
     * @implements INullableDouble
     * @constructor
     * @param {INullableDouble=} [properties] Properties to set
     */
    function NullableDouble(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * NullableDouble Value.
     * @member {number} Value
     * @memberof NullableDouble
     * @instance
     */
    NullableDouble.prototype.Value = 0;

    /**
     * Creates a new NullableDouble instance using the specified properties.
     * @function create
     * @memberof NullableDouble
     * @static
     * @param {INullableDouble=} [properties] Properties to set
     * @returns {NullableDouble} NullableDouble instance
     */
    NullableDouble.create = function create(properties) {
        return new NullableDouble(properties);
    };

    /**
     * Encodes the specified NullableDouble message. Does not implicitly {@link NullableDouble.verify|verify} messages.
     * @function encode
     * @memberof NullableDouble
     * @static
     * @param {INullableDouble} message NullableDouble message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    NullableDouble.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Value != null && message.hasOwnProperty("Value"))
            writer.uint32(/* id 1, wireType 1 =*/9).double(message.Value);
        return writer;
    };

    /**
     * Encodes the specified NullableDouble message, length delimited. Does not implicitly {@link NullableDouble.verify|verify} messages.
     * @function encodeDelimited
     * @memberof NullableDouble
     * @static
     * @param {INullableDouble} message NullableDouble message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    NullableDouble.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a NullableDouble message from the specified reader or buffer.
     * @function decode
     * @memberof NullableDouble
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {NullableDouble} NullableDouble
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    NullableDouble.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NullableDouble();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Value = reader.double();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a NullableDouble message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof NullableDouble
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {NullableDouble} NullableDouble
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    NullableDouble.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a NullableDouble message.
     * @function verify
     * @memberof NullableDouble
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    NullableDouble.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Value != null && message.hasOwnProperty("Value"))
            if (typeof message.Value !== "number")
                return "Value: number expected";
        return null;
    };

    /**
     * Creates a NullableDouble message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof NullableDouble
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {NullableDouble} NullableDouble
     */
    NullableDouble.fromObject = function fromObject(object) {
        if (object instanceof $root.NullableDouble)
            return object;
        var message = new $root.NullableDouble();
        if (object.Value != null)
            message.Value = Number(object.Value);
        return message;
    };

    /**
     * Creates a plain object from a NullableDouble message. Also converts values to other types if specified.
     * @function toObject
     * @memberof NullableDouble
     * @static
     * @param {NullableDouble} message NullableDouble
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    NullableDouble.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.Value = 0;
        if (message.Value != null && message.hasOwnProperty("Value"))
            object.Value = options.json && !isFinite(message.Value) ? String(message.Value) : message.Value;
        return object;
    };

    /**
     * Converts this NullableDouble to JSON.
     * @function toJSON
     * @memberof NullableDouble
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    NullableDouble.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NullableDouble;
})();

$root.CategoryBase = (function() {

    /**
     * Properties of a CategoryBase.
     * @exports ICategoryBase
     * @interface ICategoryBase
     * @property {string|null} [Id] CategoryBase Id
     * @property {string|null} [Name] CategoryBase Name
     * @property {string|null} [ParentId] CategoryBase ParentId
     * @property {string|null} [BackgroundColor] CategoryBase BackgroundColor
     * @property {Array.<IEvent>|null} [Events] CategoryBase Events
     * @property {Array.<string>|null} [OriginalCategories] CategoryBase OriginalCategories
     * @property {boolean|null} [HasLive] CategoryBase HasLive
     * @property {Array.<number>|null} [SpecificLiveEventsToShow] CategoryBase SpecificLiveEventsToShow
     */

    /**
     * Constructs a new CategoryBase.
     * @exports CategoryBase
     * @classdesc Represents a CategoryBase.
     * @implements ICategoryBase
     * @constructor
     * @param {ICategoryBase=} [properties] Properties to set
     */
    function CategoryBase(properties) {
        this.Events = [];
        this.OriginalCategories = [];
        this.SpecificLiveEventsToShow = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * CategoryBase Id.
     * @member {string} Id
     * @memberof CategoryBase
     * @instance
     */
    CategoryBase.prototype.Id = "";

    /**
     * CategoryBase Name.
     * @member {string} Name
     * @memberof CategoryBase
     * @instance
     */
    CategoryBase.prototype.Name = "";

    /**
     * CategoryBase ParentId.
     * @member {string} ParentId
     * @memberof CategoryBase
     * @instance
     */
    CategoryBase.prototype.ParentId = "";

    /**
     * CategoryBase BackgroundColor.
     * @member {string} BackgroundColor
     * @memberof CategoryBase
     * @instance
     */
    CategoryBase.prototype.BackgroundColor = "";

    /**
     * CategoryBase Events.
     * @member {Array.<IEvent>} Events
     * @memberof CategoryBase
     * @instance
     */
    CategoryBase.prototype.Events = $util.emptyArray;

    /**
     * CategoryBase OriginalCategories.
     * @member {Array.<string>} OriginalCategories
     * @memberof CategoryBase
     * @instance
     */
    CategoryBase.prototype.OriginalCategories = $util.emptyArray;

    /**
     * CategoryBase HasLive.
     * @member {boolean} HasLive
     * @memberof CategoryBase
     * @instance
     */
    CategoryBase.prototype.HasLive = false;

    /**
     * CategoryBase SpecificLiveEventsToShow.
     * @member {Array.<number>} SpecificLiveEventsToShow
     * @memberof CategoryBase
     * @instance
     */
    CategoryBase.prototype.SpecificLiveEventsToShow = $util.emptyArray;

    /**
     * Creates a new CategoryBase instance using the specified properties.
     * @function create
     * @memberof CategoryBase
     * @static
     * @param {ICategoryBase=} [properties] Properties to set
     * @returns {CategoryBase} CategoryBase instance
     */
    CategoryBase.create = function create(properties) {
        return new CategoryBase(properties);
    };

    /**
     * Encodes the specified CategoryBase message. Does not implicitly {@link CategoryBase.verify|verify} messages.
     * @function encode
     * @memberof CategoryBase
     * @static
     * @param {ICategoryBase} message CategoryBase message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CategoryBase.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Id != null && message.hasOwnProperty("Id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.Id);
        if (message.Name != null && message.hasOwnProperty("Name"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.Name);
        if (message.ParentId != null && message.hasOwnProperty("ParentId"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.ParentId);
        if (message.BackgroundColor != null && message.hasOwnProperty("BackgroundColor"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.BackgroundColor);
        if (message.Events != null && message.Events.length)
            for (var i = 0; i < message.Events.length; ++i)
                $root.Event.encode(message.Events[i], writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
        if (message.OriginalCategories != null && message.OriginalCategories.length)
            for (var i = 0; i < message.OriginalCategories.length; ++i)
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.OriginalCategories[i]);
        if (message.HasLive != null && message.hasOwnProperty("HasLive"))
            writer.uint32(/* id 7, wireType 0 =*/56).bool(message.HasLive);
        if (message.SpecificLiveEventsToShow != null && message.SpecificLiveEventsToShow.length) {
            writer.uint32(/* id 8, wireType 2 =*/66).fork();
            for (var i = 0; i < message.SpecificLiveEventsToShow.length; ++i)
                writer.int32(message.SpecificLiveEventsToShow[i]);
            writer.ldelim();
        }
        return writer;
    };

    /**
     * Encodes the specified CategoryBase message, length delimited. Does not implicitly {@link CategoryBase.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CategoryBase
     * @static
     * @param {ICategoryBase} message CategoryBase message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CategoryBase.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CategoryBase message from the specified reader or buffer.
     * @function decode
     * @memberof CategoryBase
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CategoryBase} CategoryBase
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CategoryBase.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CategoryBase();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Id = reader.string();
                break;
            case 2:
                message.Name = reader.string();
                break;
            case 3:
                message.ParentId = reader.string();
                break;
            case 4:
                message.BackgroundColor = reader.string();
                break;
            case 5:
                if (!(message.Events && message.Events.length))
                    message.Events = [];
                message.Events.push($root.Event.decode(reader, reader.uint32()));
                break;
            case 6:
                if (!(message.OriginalCategories && message.OriginalCategories.length))
                    message.OriginalCategories = [];
                message.OriginalCategories.push(reader.string());
                break;
            case 7:
                message.HasLive = reader.bool();
                break;
            case 8:
                if (!(message.SpecificLiveEventsToShow && message.SpecificLiveEventsToShow.length))
                    message.SpecificLiveEventsToShow = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.SpecificLiveEventsToShow.push(reader.int32());
                } else
                    message.SpecificLiveEventsToShow.push(reader.int32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a CategoryBase message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CategoryBase
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CategoryBase} CategoryBase
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CategoryBase.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CategoryBase message.
     * @function verify
     * @memberof CategoryBase
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CategoryBase.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Id != null && message.hasOwnProperty("Id"))
            if (!$util.isString(message.Id))
                return "Id: string expected";
        if (message.Name != null && message.hasOwnProperty("Name"))
            if (!$util.isString(message.Name))
                return "Name: string expected";
        if (message.ParentId != null && message.hasOwnProperty("ParentId"))
            if (!$util.isString(message.ParentId))
                return "ParentId: string expected";
        if (message.BackgroundColor != null && message.hasOwnProperty("BackgroundColor"))
            if (!$util.isString(message.BackgroundColor))
                return "BackgroundColor: string expected";
        if (message.Events != null && message.hasOwnProperty("Events")) {
            if (!Array.isArray(message.Events))
                return "Events: array expected";
            for (var i = 0; i < message.Events.length; ++i) {
                var error = $root.Event.verify(message.Events[i]);
                if (error)
                    return "Events." + error;
            }
        }
        if (message.OriginalCategories != null && message.hasOwnProperty("OriginalCategories")) {
            if (!Array.isArray(message.OriginalCategories))
                return "OriginalCategories: array expected";
            for (var i = 0; i < message.OriginalCategories.length; ++i)
                if (!$util.isString(message.OriginalCategories[i]))
                    return "OriginalCategories: string[] expected";
        }
        if (message.HasLive != null && message.hasOwnProperty("HasLive"))
            if (typeof message.HasLive !== "boolean")
                return "HasLive: boolean expected";
        if (message.SpecificLiveEventsToShow != null && message.hasOwnProperty("SpecificLiveEventsToShow")) {
            if (!Array.isArray(message.SpecificLiveEventsToShow))
                return "SpecificLiveEventsToShow: array expected";
            for (var i = 0; i < message.SpecificLiveEventsToShow.length; ++i)
                if (!$util.isInteger(message.SpecificLiveEventsToShow[i]))
                    return "SpecificLiveEventsToShow: integer[] expected";
        }
        return null;
    };

    /**
     * Creates a CategoryBase message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CategoryBase
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CategoryBase} CategoryBase
     */
    CategoryBase.fromObject = function fromObject(object) {
        if (object instanceof $root.CategoryBase)
            return object;
        var message = new $root.CategoryBase();
        if (object.Id != null)
            message.Id = String(object.Id);
        if (object.Name != null)
            message.Name = String(object.Name);
        if (object.ParentId != null)
            message.ParentId = String(object.ParentId);
        if (object.BackgroundColor != null)
            message.BackgroundColor = String(object.BackgroundColor);
        if (object.Events) {
            if (!Array.isArray(object.Events))
                throw TypeError(".CategoryBase.Events: array expected");
            message.Events = [];
            for (var i = 0; i < object.Events.length; ++i) {
                if (typeof object.Events[i] !== "object")
                    throw TypeError(".CategoryBase.Events: object expected");
                message.Events[i] = $root.Event.fromObject(object.Events[i]);
            }
        }
        if (object.OriginalCategories) {
            if (!Array.isArray(object.OriginalCategories))
                throw TypeError(".CategoryBase.OriginalCategories: array expected");
            message.OriginalCategories = [];
            for (var i = 0; i < object.OriginalCategories.length; ++i)
                message.OriginalCategories[i] = String(object.OriginalCategories[i]);
        }
        if (object.HasLive != null)
            message.HasLive = Boolean(object.HasLive);
        if (object.SpecificLiveEventsToShow) {
            if (!Array.isArray(object.SpecificLiveEventsToShow))
                throw TypeError(".CategoryBase.SpecificLiveEventsToShow: array expected");
            message.SpecificLiveEventsToShow = [];
            for (var i = 0; i < object.SpecificLiveEventsToShow.length; ++i)
                message.SpecificLiveEventsToShow[i] = object.SpecificLiveEventsToShow[i] | 0;
        }
        return message;
    };

    /**
     * Creates a plain object from a CategoryBase message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CategoryBase
     * @static
     * @param {CategoryBase} message CategoryBase
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CategoryBase.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.Events = [];
            object.OriginalCategories = [];
            object.SpecificLiveEventsToShow = [];
        }
        if (options.defaults) {
            object.Id = "";
            object.Name = "";
            object.ParentId = "";
            object.BackgroundColor = "";
            object.HasLive = false;
        }
        if (message.Id != null && message.hasOwnProperty("Id"))
            object.Id = message.Id;
        if (message.Name != null && message.hasOwnProperty("Name"))
            object.Name = message.Name;
        if (message.ParentId != null && message.hasOwnProperty("ParentId"))
            object.ParentId = message.ParentId;
        if (message.BackgroundColor != null && message.hasOwnProperty("BackgroundColor"))
            object.BackgroundColor = message.BackgroundColor;
        if (message.Events && message.Events.length) {
            object.Events = [];
            for (var j = 0; j < message.Events.length; ++j)
                object.Events[j] = $root.Event.toObject(message.Events[j], options);
        }
        if (message.OriginalCategories && message.OriginalCategories.length) {
            object.OriginalCategories = [];
            for (var j = 0; j < message.OriginalCategories.length; ++j)
                object.OriginalCategories[j] = message.OriginalCategories[j];
        }
        if (message.HasLive != null && message.hasOwnProperty("HasLive"))
            object.HasLive = message.HasLive;
        if (message.SpecificLiveEventsToShow && message.SpecificLiveEventsToShow.length) {
            object.SpecificLiveEventsToShow = [];
            for (var j = 0; j < message.SpecificLiveEventsToShow.length; ++j)
                object.SpecificLiveEventsToShow[j] = message.SpecificLiveEventsToShow[j];
        }
        return object;
    };

    /**
     * Converts this CategoryBase to JSON.
     * @function toJSON
     * @memberof CategoryBase
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CategoryBase.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CategoryBase;
})();

$root.FirstLevelCategory = (function() {

    /**
     * Properties of a FirstLevelCategory.
     * @exports IFirstLevelCategory
     * @interface IFirstLevelCategory
     * @property {Array.<ISecondLevelCategory>|null} [Categories] FirstLevelCategory Categories
     */

    /**
     * Constructs a new FirstLevelCategory.
     * @exports FirstLevelCategory
     * @classdesc Represents a FirstLevelCategory.
     * @implements IFirstLevelCategory
     * @constructor
     * @param {IFirstLevelCategory=} [properties] Properties to set
     */
    function FirstLevelCategory(properties) {
        this.Categories = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * FirstLevelCategory Categories.
     * @member {Array.<ISecondLevelCategory>} Categories
     * @memberof FirstLevelCategory
     * @instance
     */
    FirstLevelCategory.prototype.Categories = $util.emptyArray;

    /**
     * Creates a new FirstLevelCategory instance using the specified properties.
     * @function create
     * @memberof FirstLevelCategory
     * @static
     * @param {IFirstLevelCategory=} [properties] Properties to set
     * @returns {FirstLevelCategory} FirstLevelCategory instance
     */
    FirstLevelCategory.create = function create(properties) {
        return new FirstLevelCategory(properties);
    };

    /**
     * Encodes the specified FirstLevelCategory message. Does not implicitly {@link FirstLevelCategory.verify|verify} messages.
     * @function encode
     * @memberof FirstLevelCategory
     * @static
     * @param {IFirstLevelCategory} message FirstLevelCategory message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FirstLevelCategory.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Categories != null && message.Categories.length)
            for (var i = 0; i < message.Categories.length; ++i)
                $root.SecondLevelCategory.encode(message.Categories[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified FirstLevelCategory message, length delimited. Does not implicitly {@link FirstLevelCategory.verify|verify} messages.
     * @function encodeDelimited
     * @memberof FirstLevelCategory
     * @static
     * @param {IFirstLevelCategory} message FirstLevelCategory message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FirstLevelCategory.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a FirstLevelCategory message from the specified reader or buffer.
     * @function decode
     * @memberof FirstLevelCategory
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {FirstLevelCategory} FirstLevelCategory
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FirstLevelCategory.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FirstLevelCategory();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.Categories && message.Categories.length))
                    message.Categories = [];
                message.Categories.push($root.SecondLevelCategory.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a FirstLevelCategory message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof FirstLevelCategory
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {FirstLevelCategory} FirstLevelCategory
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FirstLevelCategory.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a FirstLevelCategory message.
     * @function verify
     * @memberof FirstLevelCategory
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    FirstLevelCategory.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Categories != null && message.hasOwnProperty("Categories")) {
            if (!Array.isArray(message.Categories))
                return "Categories: array expected";
            for (var i = 0; i < message.Categories.length; ++i) {
                var error = $root.SecondLevelCategory.verify(message.Categories[i]);
                if (error)
                    return "Categories." + error;
            }
        }
        return null;
    };

    /**
     * Creates a FirstLevelCategory message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof FirstLevelCategory
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {FirstLevelCategory} FirstLevelCategory
     */
    FirstLevelCategory.fromObject = function fromObject(object) {
        if (object instanceof $root.FirstLevelCategory)
            return object;
        var message = new $root.FirstLevelCategory();
        if (object.Categories) {
            if (!Array.isArray(object.Categories))
                throw TypeError(".FirstLevelCategory.Categories: array expected");
            message.Categories = [];
            for (var i = 0; i < object.Categories.length; ++i) {
                if (typeof object.Categories[i] !== "object")
                    throw TypeError(".FirstLevelCategory.Categories: object expected");
                message.Categories[i] = $root.SecondLevelCategory.fromObject(object.Categories[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a FirstLevelCategory message. Also converts values to other types if specified.
     * @function toObject
     * @memberof FirstLevelCategory
     * @static
     * @param {FirstLevelCategory} message FirstLevelCategory
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    FirstLevelCategory.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.Categories = [];
        if (message.Categories && message.Categories.length) {
            object.Categories = [];
            for (var j = 0; j < message.Categories.length; ++j)
                object.Categories[j] = $root.SecondLevelCategory.toObject(message.Categories[j], options);
        }
        return object;
    };

    /**
     * Converts this FirstLevelCategory to JSON.
     * @function toJSON
     * @memberof FirstLevelCategory
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    FirstLevelCategory.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FirstLevelCategory;
})();

$root.SecondLevelCategory = (function() {

    /**
     * Properties of a SecondLevelCategory.
     * @exports ISecondLevelCategory
     * @interface ISecondLevelCategory
     * @property {ICategoryBase|null} [Base] SecondLevelCategory Base
     * @property {number|null} [DisciplineId] SecondLevelCategory DisciplineId
     * @property {number|null} [GraphicsPresentationId] SecondLevelCategory GraphicsPresentationId
     * @property {Array.<IThirdLevelCategory>|null} [Categories] SecondLevelCategory Categories
     * @property {boolean|null} [IsVirtual] SecondLevelCategory IsVirtual
     */

    /**
     * Constructs a new SecondLevelCategory.
     * @exports SecondLevelCategory
     * @classdesc Represents a SecondLevelCategory.
     * @implements ISecondLevelCategory
     * @constructor
     * @param {ISecondLevelCategory=} [properties] Properties to set
     */
    function SecondLevelCategory(properties) {
        this.Categories = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * SecondLevelCategory Base.
     * @member {ICategoryBase|null|undefined} Base
     * @memberof SecondLevelCategory
     * @instance
     */
    SecondLevelCategory.prototype.Base = null;

    /**
     * SecondLevelCategory DisciplineId.
     * @member {number} DisciplineId
     * @memberof SecondLevelCategory
     * @instance
     */
    SecondLevelCategory.prototype.DisciplineId = 0;

    /**
     * SecondLevelCategory GraphicsPresentationId.
     * @member {number} GraphicsPresentationId
     * @memberof SecondLevelCategory
     * @instance
     */
    SecondLevelCategory.prototype.GraphicsPresentationId = 0;

    /**
     * SecondLevelCategory Categories.
     * @member {Array.<IThirdLevelCategory>} Categories
     * @memberof SecondLevelCategory
     * @instance
     */
    SecondLevelCategory.prototype.Categories = $util.emptyArray;

    /**
     * SecondLevelCategory IsVirtual.
     * @member {boolean} IsVirtual
     * @memberof SecondLevelCategory
     * @instance
     */
    SecondLevelCategory.prototype.IsVirtual = false;

    /**
     * Creates a new SecondLevelCategory instance using the specified properties.
     * @function create
     * @memberof SecondLevelCategory
     * @static
     * @param {ISecondLevelCategory=} [properties] Properties to set
     * @returns {SecondLevelCategory} SecondLevelCategory instance
     */
    SecondLevelCategory.create = function create(properties) {
        return new SecondLevelCategory(properties);
    };

    /**
     * Encodes the specified SecondLevelCategory message. Does not implicitly {@link SecondLevelCategory.verify|verify} messages.
     * @function encode
     * @memberof SecondLevelCategory
     * @static
     * @param {ISecondLevelCategory} message SecondLevelCategory message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SecondLevelCategory.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Base != null && message.hasOwnProperty("Base"))
            $root.CategoryBase.encode(message.Base, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.DisciplineId != null && message.hasOwnProperty("DisciplineId"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.DisciplineId);
        if (message.GraphicsPresentationId != null && message.hasOwnProperty("GraphicsPresentationId"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.GraphicsPresentationId);
        if (message.Categories != null && message.Categories.length)
            for (var i = 0; i < message.Categories.length; ++i)
                $root.ThirdLevelCategory.encode(message.Categories[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        if (message.IsVirtual != null && message.hasOwnProperty("IsVirtual"))
            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.IsVirtual);
        return writer;
    };

    /**
     * Encodes the specified SecondLevelCategory message, length delimited. Does not implicitly {@link SecondLevelCategory.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SecondLevelCategory
     * @static
     * @param {ISecondLevelCategory} message SecondLevelCategory message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SecondLevelCategory.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SecondLevelCategory message from the specified reader or buffer.
     * @function decode
     * @memberof SecondLevelCategory
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SecondLevelCategory} SecondLevelCategory
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SecondLevelCategory.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SecondLevelCategory();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Base = $root.CategoryBase.decode(reader, reader.uint32());
                break;
            case 2:
                message.DisciplineId = reader.int32();
                break;
            case 3:
                message.GraphicsPresentationId = reader.int32();
                break;
            case 4:
                if (!(message.Categories && message.Categories.length))
                    message.Categories = [];
                message.Categories.push($root.ThirdLevelCategory.decode(reader, reader.uint32()));
                break;
            case 5:
                message.IsVirtual = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a SecondLevelCategory message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SecondLevelCategory
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SecondLevelCategory} SecondLevelCategory
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SecondLevelCategory.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SecondLevelCategory message.
     * @function verify
     * @memberof SecondLevelCategory
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SecondLevelCategory.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Base != null && message.hasOwnProperty("Base")) {
            var error = $root.CategoryBase.verify(message.Base);
            if (error)
                return "Base." + error;
        }
        if (message.DisciplineId != null && message.hasOwnProperty("DisciplineId"))
            if (!$util.isInteger(message.DisciplineId))
                return "DisciplineId: integer expected";
        if (message.GraphicsPresentationId != null && message.hasOwnProperty("GraphicsPresentationId"))
            if (!$util.isInteger(message.GraphicsPresentationId))
                return "GraphicsPresentationId: integer expected";
        if (message.Categories != null && message.hasOwnProperty("Categories")) {
            if (!Array.isArray(message.Categories))
                return "Categories: array expected";
            for (var i = 0; i < message.Categories.length; ++i) {
                var error = $root.ThirdLevelCategory.verify(message.Categories[i]);
                if (error)
                    return "Categories." + error;
            }
        }
        if (message.IsVirtual != null && message.hasOwnProperty("IsVirtual"))
            if (typeof message.IsVirtual !== "boolean")
                return "IsVirtual: boolean expected";
        return null;
    };

    /**
     * Creates a SecondLevelCategory message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SecondLevelCategory
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SecondLevelCategory} SecondLevelCategory
     */
    SecondLevelCategory.fromObject = function fromObject(object) {
        if (object instanceof $root.SecondLevelCategory)
            return object;
        var message = new $root.SecondLevelCategory();
        if (object.Base != null) {
            if (typeof object.Base !== "object")
                throw TypeError(".SecondLevelCategory.Base: object expected");
            message.Base = $root.CategoryBase.fromObject(object.Base);
        }
        if (object.DisciplineId != null)
            message.DisciplineId = object.DisciplineId | 0;
        if (object.GraphicsPresentationId != null)
            message.GraphicsPresentationId = object.GraphicsPresentationId | 0;
        if (object.Categories) {
            if (!Array.isArray(object.Categories))
                throw TypeError(".SecondLevelCategory.Categories: array expected");
            message.Categories = [];
            for (var i = 0; i < object.Categories.length; ++i) {
                if (typeof object.Categories[i] !== "object")
                    throw TypeError(".SecondLevelCategory.Categories: object expected");
                message.Categories[i] = $root.ThirdLevelCategory.fromObject(object.Categories[i]);
            }
        }
        if (object.IsVirtual != null)
            message.IsVirtual = Boolean(object.IsVirtual);
        return message;
    };

    /**
     * Creates a plain object from a SecondLevelCategory message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SecondLevelCategory
     * @static
     * @param {SecondLevelCategory} message SecondLevelCategory
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SecondLevelCategory.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.Categories = [];
        if (options.defaults) {
            object.Base = null;
            object.DisciplineId = 0;
            object.GraphicsPresentationId = 0;
            object.IsVirtual = false;
        }
        if (message.Base != null && message.hasOwnProperty("Base"))
            object.Base = $root.CategoryBase.toObject(message.Base, options);
        if (message.DisciplineId != null && message.hasOwnProperty("DisciplineId"))
            object.DisciplineId = message.DisciplineId;
        if (message.GraphicsPresentationId != null && message.hasOwnProperty("GraphicsPresentationId"))
            object.GraphicsPresentationId = message.GraphicsPresentationId;
        if (message.Categories && message.Categories.length) {
            object.Categories = [];
            for (var j = 0; j < message.Categories.length; ++j)
                object.Categories[j] = $root.ThirdLevelCategory.toObject(message.Categories[j], options);
        }
        if (message.IsVirtual != null && message.hasOwnProperty("IsVirtual"))
            object.IsVirtual = message.IsVirtual;
        return object;
    };

    /**
     * Converts this SecondLevelCategory to JSON.
     * @function toJSON
     * @memberof SecondLevelCategory
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SecondLevelCategory.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SecondLevelCategory;
})();

$root.ThirdLevelCategory = (function() {

    /**
     * Properties of a ThirdLevelCategory.
     * @exports IThirdLevelCategory
     * @interface IThirdLevelCategory
     * @property {ICategoryBase|null} [Base] ThirdLevelCategory Base
     * @property {Array.<IFourthLevelCategory>|null} [Categories] ThirdLevelCategory Categories
     */

    /**
     * Constructs a new ThirdLevelCategory.
     * @exports ThirdLevelCategory
     * @classdesc Represents a ThirdLevelCategory.
     * @implements IThirdLevelCategory
     * @constructor
     * @param {IThirdLevelCategory=} [properties] Properties to set
     */
    function ThirdLevelCategory(properties) {
        this.Categories = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ThirdLevelCategory Base.
     * @member {ICategoryBase|null|undefined} Base
     * @memberof ThirdLevelCategory
     * @instance
     */
    ThirdLevelCategory.prototype.Base = null;

    /**
     * ThirdLevelCategory Categories.
     * @member {Array.<IFourthLevelCategory>} Categories
     * @memberof ThirdLevelCategory
     * @instance
     */
    ThirdLevelCategory.prototype.Categories = $util.emptyArray;

    /**
     * Creates a new ThirdLevelCategory instance using the specified properties.
     * @function create
     * @memberof ThirdLevelCategory
     * @static
     * @param {IThirdLevelCategory=} [properties] Properties to set
     * @returns {ThirdLevelCategory} ThirdLevelCategory instance
     */
    ThirdLevelCategory.create = function create(properties) {
        return new ThirdLevelCategory(properties);
    };

    /**
     * Encodes the specified ThirdLevelCategory message. Does not implicitly {@link ThirdLevelCategory.verify|verify} messages.
     * @function encode
     * @memberof ThirdLevelCategory
     * @static
     * @param {IThirdLevelCategory} message ThirdLevelCategory message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ThirdLevelCategory.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Base != null && message.hasOwnProperty("Base"))
            $root.CategoryBase.encode(message.Base, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.Categories != null && message.Categories.length)
            for (var i = 0; i < message.Categories.length; ++i)
                $root.FourthLevelCategory.encode(message.Categories[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified ThirdLevelCategory message, length delimited. Does not implicitly {@link ThirdLevelCategory.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ThirdLevelCategory
     * @static
     * @param {IThirdLevelCategory} message ThirdLevelCategory message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ThirdLevelCategory.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ThirdLevelCategory message from the specified reader or buffer.
     * @function decode
     * @memberof ThirdLevelCategory
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ThirdLevelCategory} ThirdLevelCategory
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ThirdLevelCategory.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ThirdLevelCategory();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Base = $root.CategoryBase.decode(reader, reader.uint32());
                break;
            case 2:
                if (!(message.Categories && message.Categories.length))
                    message.Categories = [];
                message.Categories.push($root.FourthLevelCategory.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ThirdLevelCategory message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ThirdLevelCategory
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ThirdLevelCategory} ThirdLevelCategory
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ThirdLevelCategory.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ThirdLevelCategory message.
     * @function verify
     * @memberof ThirdLevelCategory
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ThirdLevelCategory.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Base != null && message.hasOwnProperty("Base")) {
            var error = $root.CategoryBase.verify(message.Base);
            if (error)
                return "Base." + error;
        }
        if (message.Categories != null && message.hasOwnProperty("Categories")) {
            if (!Array.isArray(message.Categories))
                return "Categories: array expected";
            for (var i = 0; i < message.Categories.length; ++i) {
                var error = $root.FourthLevelCategory.verify(message.Categories[i]);
                if (error)
                    return "Categories." + error;
            }
        }
        return null;
    };

    /**
     * Creates a ThirdLevelCategory message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ThirdLevelCategory
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ThirdLevelCategory} ThirdLevelCategory
     */
    ThirdLevelCategory.fromObject = function fromObject(object) {
        if (object instanceof $root.ThirdLevelCategory)
            return object;
        var message = new $root.ThirdLevelCategory();
        if (object.Base != null) {
            if (typeof object.Base !== "object")
                throw TypeError(".ThirdLevelCategory.Base: object expected");
            message.Base = $root.CategoryBase.fromObject(object.Base);
        }
        if (object.Categories) {
            if (!Array.isArray(object.Categories))
                throw TypeError(".ThirdLevelCategory.Categories: array expected");
            message.Categories = [];
            for (var i = 0; i < object.Categories.length; ++i) {
                if (typeof object.Categories[i] !== "object")
                    throw TypeError(".ThirdLevelCategory.Categories: object expected");
                message.Categories[i] = $root.FourthLevelCategory.fromObject(object.Categories[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a ThirdLevelCategory message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ThirdLevelCategory
     * @static
     * @param {ThirdLevelCategory} message ThirdLevelCategory
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ThirdLevelCategory.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.Categories = [];
        if (options.defaults)
            object.Base = null;
        if (message.Base != null && message.hasOwnProperty("Base"))
            object.Base = $root.CategoryBase.toObject(message.Base, options);
        if (message.Categories && message.Categories.length) {
            object.Categories = [];
            for (var j = 0; j < message.Categories.length; ++j)
                object.Categories[j] = $root.FourthLevelCategory.toObject(message.Categories[j], options);
        }
        return object;
    };

    /**
     * Converts this ThirdLevelCategory to JSON.
     * @function toJSON
     * @memberof ThirdLevelCategory
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ThirdLevelCategory.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ThirdLevelCategory;
})();

$root.FourthLevelCategory = (function() {

    /**
     * Properties of a FourthLevelCategory.
     * @exports IFourthLevelCategory
     * @interface IFourthLevelCategory
     * @property {ICategoryBase|null} [Base] FourthLevelCategory Base
     */

    /**
     * Constructs a new FourthLevelCategory.
     * @exports FourthLevelCategory
     * @classdesc Represents a FourthLevelCategory.
     * @implements IFourthLevelCategory
     * @constructor
     * @param {IFourthLevelCategory=} [properties] Properties to set
     */
    function FourthLevelCategory(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * FourthLevelCategory Base.
     * @member {ICategoryBase|null|undefined} Base
     * @memberof FourthLevelCategory
     * @instance
     */
    FourthLevelCategory.prototype.Base = null;

    /**
     * Creates a new FourthLevelCategory instance using the specified properties.
     * @function create
     * @memberof FourthLevelCategory
     * @static
     * @param {IFourthLevelCategory=} [properties] Properties to set
     * @returns {FourthLevelCategory} FourthLevelCategory instance
     */
    FourthLevelCategory.create = function create(properties) {
        return new FourthLevelCategory(properties);
    };

    /**
     * Encodes the specified FourthLevelCategory message. Does not implicitly {@link FourthLevelCategory.verify|verify} messages.
     * @function encode
     * @memberof FourthLevelCategory
     * @static
     * @param {IFourthLevelCategory} message FourthLevelCategory message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FourthLevelCategory.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Base != null && message.hasOwnProperty("Base"))
            $root.CategoryBase.encode(message.Base, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified FourthLevelCategory message, length delimited. Does not implicitly {@link FourthLevelCategory.verify|verify} messages.
     * @function encodeDelimited
     * @memberof FourthLevelCategory
     * @static
     * @param {IFourthLevelCategory} message FourthLevelCategory message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FourthLevelCategory.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a FourthLevelCategory message from the specified reader or buffer.
     * @function decode
     * @memberof FourthLevelCategory
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {FourthLevelCategory} FourthLevelCategory
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FourthLevelCategory.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FourthLevelCategory();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Base = $root.CategoryBase.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a FourthLevelCategory message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof FourthLevelCategory
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {FourthLevelCategory} FourthLevelCategory
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FourthLevelCategory.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a FourthLevelCategory message.
     * @function verify
     * @memberof FourthLevelCategory
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    FourthLevelCategory.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Base != null && message.hasOwnProperty("Base")) {
            var error = $root.CategoryBase.verify(message.Base);
            if (error)
                return "Base." + error;
        }
        return null;
    };

    /**
     * Creates a FourthLevelCategory message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof FourthLevelCategory
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {FourthLevelCategory} FourthLevelCategory
     */
    FourthLevelCategory.fromObject = function fromObject(object) {
        if (object instanceof $root.FourthLevelCategory)
            return object;
        var message = new $root.FourthLevelCategory();
        if (object.Base != null) {
            if (typeof object.Base !== "object")
                throw TypeError(".FourthLevelCategory.Base: object expected");
            message.Base = $root.CategoryBase.fromObject(object.Base);
        }
        return message;
    };

    /**
     * Creates a plain object from a FourthLevelCategory message. Also converts values to other types if specified.
     * @function toObject
     * @memberof FourthLevelCategory
     * @static
     * @param {FourthLevelCategory} message FourthLevelCategory
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    FourthLevelCategory.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.Base = null;
        if (message.Base != null && message.hasOwnProperty("Base"))
            object.Base = $root.CategoryBase.toObject(message.Base, options);
        return object;
    };

    /**
     * Converts this FourthLevelCategory to JSON.
     * @function toJSON
     * @memberof FourthLevelCategory
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    FourthLevelCategory.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FourthLevelCategory;
})();

$root.WebTopBetCategory = (function() {

    /**
     * Properties of a WebTopBetCategory.
     * @exports IWebTopBetCategory
     * @interface IWebTopBetCategory
     * @property {ICategoryBase|null} [Base] WebTopBetCategory Base
     * @property {number|null} [GraphicsPresentationId] WebTopBetCategory GraphicsPresentationId
     */

    /**
     * Constructs a new WebTopBetCategory.
     * @exports WebTopBetCategory
     * @classdesc Represents a WebTopBetCategory.
     * @implements IWebTopBetCategory
     * @constructor
     * @param {IWebTopBetCategory=} [properties] Properties to set
     */
    function WebTopBetCategory(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * WebTopBetCategory Base.
     * @member {ICategoryBase|null|undefined} Base
     * @memberof WebTopBetCategory
     * @instance
     */
    WebTopBetCategory.prototype.Base = null;

    /**
     * WebTopBetCategory GraphicsPresentationId.
     * @member {number} GraphicsPresentationId
     * @memberof WebTopBetCategory
     * @instance
     */
    WebTopBetCategory.prototype.GraphicsPresentationId = 0;

    /**
     * Creates a new WebTopBetCategory instance using the specified properties.
     * @function create
     * @memberof WebTopBetCategory
     * @static
     * @param {IWebTopBetCategory=} [properties] Properties to set
     * @returns {WebTopBetCategory} WebTopBetCategory instance
     */
    WebTopBetCategory.create = function create(properties) {
        return new WebTopBetCategory(properties);
    };

    /**
     * Encodes the specified WebTopBetCategory message. Does not implicitly {@link WebTopBetCategory.verify|verify} messages.
     * @function encode
     * @memberof WebTopBetCategory
     * @static
     * @param {IWebTopBetCategory} message WebTopBetCategory message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    WebTopBetCategory.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Base != null && message.hasOwnProperty("Base"))
            $root.CategoryBase.encode(message.Base, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.GraphicsPresentationId != null && message.hasOwnProperty("GraphicsPresentationId"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.GraphicsPresentationId);
        return writer;
    };

    /**
     * Encodes the specified WebTopBetCategory message, length delimited. Does not implicitly {@link WebTopBetCategory.verify|verify} messages.
     * @function encodeDelimited
     * @memberof WebTopBetCategory
     * @static
     * @param {IWebTopBetCategory} message WebTopBetCategory message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    WebTopBetCategory.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a WebTopBetCategory message from the specified reader or buffer.
     * @function decode
     * @memberof WebTopBetCategory
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {WebTopBetCategory} WebTopBetCategory
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    WebTopBetCategory.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.WebTopBetCategory();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Base = $root.CategoryBase.decode(reader, reader.uint32());
                break;
            case 2:
                message.GraphicsPresentationId = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a WebTopBetCategory message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof WebTopBetCategory
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {WebTopBetCategory} WebTopBetCategory
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    WebTopBetCategory.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a WebTopBetCategory message.
     * @function verify
     * @memberof WebTopBetCategory
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    WebTopBetCategory.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Base != null && message.hasOwnProperty("Base")) {
            var error = $root.CategoryBase.verify(message.Base);
            if (error)
                return "Base." + error;
        }
        if (message.GraphicsPresentationId != null && message.hasOwnProperty("GraphicsPresentationId"))
            if (!$util.isInteger(message.GraphicsPresentationId))
                return "GraphicsPresentationId: integer expected";
        return null;
    };

    /**
     * Creates a WebTopBetCategory message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof WebTopBetCategory
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {WebTopBetCategory} WebTopBetCategory
     */
    WebTopBetCategory.fromObject = function fromObject(object) {
        if (object instanceof $root.WebTopBetCategory)
            return object;
        var message = new $root.WebTopBetCategory();
        if (object.Base != null) {
            if (typeof object.Base !== "object")
                throw TypeError(".WebTopBetCategory.Base: object expected");
            message.Base = $root.CategoryBase.fromObject(object.Base);
        }
        if (object.GraphicsPresentationId != null)
            message.GraphicsPresentationId = object.GraphicsPresentationId | 0;
        return message;
    };

    /**
     * Creates a plain object from a WebTopBetCategory message. Also converts values to other types if specified.
     * @function toObject
     * @memberof WebTopBetCategory
     * @static
     * @param {WebTopBetCategory} message WebTopBetCategory
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    WebTopBetCategory.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.Base = null;
            object.GraphicsPresentationId = 0;
        }
        if (message.Base != null && message.hasOwnProperty("Base"))
            object.Base = $root.CategoryBase.toObject(message.Base, options);
        if (message.GraphicsPresentationId != null && message.hasOwnProperty("GraphicsPresentationId"))
            object.GraphicsPresentationId = message.GraphicsPresentationId;
        return object;
    };

    /**
     * Converts this WebTopBetCategory to JSON.
     * @function toJSON
     * @memberof WebTopBetCategory
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    WebTopBetCategory.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return WebTopBetCategory;
})();

$root.Odds = (function() {

    /**
     * Properties of an Odds.
     * @exports IOdds
     * @interface IOdds
     * @property {string|null} [TipID] Odds TipID
     * @property {string|null} [Name] Odds Name
     * @property {number|null} [Rate] Odds Rate
     * @property {number|null} [PopularityPercentage] Odds PopularityPercentage
     * @property {boolean|null} [TicketOfDayTip] Odds TicketOfDayTip
     * @property {OfferItemState|null} [State] Odds State
     */

    /**
     * Constructs a new Odds.
     * @exports Odds
     * @classdesc Represents an Odds.
     * @implements IOdds
     * @constructor
     * @param {IOdds=} [properties] Properties to set
     */
    function Odds(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Odds TipID.
     * @member {string} TipID
     * @memberof Odds
     * @instance
     */
    Odds.prototype.TipID = "";

    /**
     * Odds Name.
     * @member {string} Name
     * @memberof Odds
     * @instance
     */
    Odds.prototype.Name = "";

    /**
     * Odds Rate.
     * @member {number} Rate
     * @memberof Odds
     * @instance
     */
    Odds.prototype.Rate = 0;

    /**
     * Odds PopularityPercentage.
     * @member {number} PopularityPercentage
     * @memberof Odds
     * @instance
     */
    Odds.prototype.PopularityPercentage = 0;

    /**
     * Odds TicketOfDayTip.
     * @member {boolean} TicketOfDayTip
     * @memberof Odds
     * @instance
     */
    Odds.prototype.TicketOfDayTip = false;

    /**
     * Odds State.
     * @member {OfferItemState} State
     * @memberof Odds
     * @instance
     */
    Odds.prototype.State = 0;

    /**
     * Creates a new Odds instance using the specified properties.
     * @function create
     * @memberof Odds
     * @static
     * @param {IOdds=} [properties] Properties to set
     * @returns {Odds} Odds instance
     */
    Odds.create = function create(properties) {
        return new Odds(properties);
    };

    /**
     * Encodes the specified Odds message. Does not implicitly {@link Odds.verify|verify} messages.
     * @function encode
     * @memberof Odds
     * @static
     * @param {IOdds} message Odds message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Odds.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.TipID != null && message.hasOwnProperty("TipID"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.TipID);
        if (message.Name != null && message.hasOwnProperty("Name"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.Name);
        if (message.Rate != null && message.hasOwnProperty("Rate"))
            writer.uint32(/* id 3, wireType 5 =*/29).float(message.Rate);
        if (message.PopularityPercentage != null && message.hasOwnProperty("PopularityPercentage"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.PopularityPercentage);
        if (message.TicketOfDayTip != null && message.hasOwnProperty("TicketOfDayTip"))
            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.TicketOfDayTip);
        if (message.State != null && message.hasOwnProperty("State"))
            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.State);
        return writer;
    };

    /**
     * Encodes the specified Odds message, length delimited. Does not implicitly {@link Odds.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Odds
     * @static
     * @param {IOdds} message Odds message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Odds.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an Odds message from the specified reader or buffer.
     * @function decode
     * @memberof Odds
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Odds} Odds
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Odds.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Odds();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.TipID = reader.string();
                break;
            case 2:
                message.Name = reader.string();
                break;
            case 3:
                message.Rate = reader.float();
                break;
            case 4:
                message.PopularityPercentage = reader.int32();
                break;
            case 5:
                message.TicketOfDayTip = reader.bool();
                break;
            case 6:
                message.State = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an Odds message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Odds
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Odds} Odds
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Odds.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an Odds message.
     * @function verify
     * @memberof Odds
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Odds.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.TipID != null && message.hasOwnProperty("TipID"))
            if (!$util.isString(message.TipID))
                return "TipID: string expected";
        if (message.Name != null && message.hasOwnProperty("Name"))
            if (!$util.isString(message.Name))
                return "Name: string expected";
        if (message.Rate != null && message.hasOwnProperty("Rate"))
            if (typeof message.Rate !== "number")
                return "Rate: number expected";
        if (message.PopularityPercentage != null && message.hasOwnProperty("PopularityPercentage"))
            if (!$util.isInteger(message.PopularityPercentage))
                return "PopularityPercentage: integer expected";
        if (message.TicketOfDayTip != null && message.hasOwnProperty("TicketOfDayTip"))
            if (typeof message.TicketOfDayTip !== "boolean")
                return "TicketOfDayTip: boolean expected";
        if (message.State != null && message.hasOwnProperty("State"))
            switch (message.State) {
            default:
                return "State: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
                break;
            }
        return null;
    };

    /**
     * Creates an Odds message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Odds
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Odds} Odds
     */
    Odds.fromObject = function fromObject(object) {
        if (object instanceof $root.Odds)
            return object;
        var message = new $root.Odds();
        if (object.TipID != null)
            message.TipID = String(object.TipID);
        if (object.Name != null)
            message.Name = String(object.Name);
        if (object.Rate != null)
            message.Rate = Number(object.Rate);
        if (object.PopularityPercentage != null)
            message.PopularityPercentage = object.PopularityPercentage | 0;
        if (object.TicketOfDayTip != null)
            message.TicketOfDayTip = Boolean(object.TicketOfDayTip);
        switch (object.State) {
        case "None":
        case 0:
            message.State = 0;
            break;
        case "Created":
        case 1:
            message.State = 1;
            break;
        case "Opened":
        case 2:
            message.State = 2;
            break;
        case "Suspended":
        case 3:
            message.State = 3;
            break;
        case "Closed":
        case 4:
            message.State = 4;
            break;
        }
        return message;
    };

    /**
     * Creates a plain object from an Odds message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Odds
     * @static
     * @param {Odds} message Odds
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Odds.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.TipID = "";
            object.Name = "";
            object.Rate = 0;
            object.PopularityPercentage = 0;
            object.TicketOfDayTip = false;
            object.State = options.enums === String ? "None" : 0;
        }
        if (message.TipID != null && message.hasOwnProperty("TipID"))
            object.TipID = message.TipID;
        if (message.Name != null && message.hasOwnProperty("Name"))
            object.Name = message.Name;
        if (message.Rate != null && message.hasOwnProperty("Rate"))
            object.Rate = options.json && !isFinite(message.Rate) ? String(message.Rate) : message.Rate;
        if (message.PopularityPercentage != null && message.hasOwnProperty("PopularityPercentage"))
            object.PopularityPercentage = message.PopularityPercentage;
        if (message.TicketOfDayTip != null && message.hasOwnProperty("TicketOfDayTip"))
            object.TicketOfDayTip = message.TicketOfDayTip;
        if (message.State != null && message.hasOwnProperty("State"))
            object.State = options.enums === String ? $root.OfferItemState[message.State] : message.State;
        return object;
    };

    /**
     * Converts this Odds to JSON.
     * @function toJSON
     * @memberof Odds
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Odds.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Odds;
})();

$root.Detail = (function() {

    /**
     * Properties of a Detail.
     * @exports IDetail
     * @interface IDetail
     * @property {number|null} [ID] Detail ID
     * @property {string|null} [Name] Detail Name
     * @property {number|null} [LineNumber] Detail LineNumber
     * @property {Array.<IOdds>|null} [OddsList] Detail OddsList
     * @property {number|null} [CombCountMin] Detail CombCountMin
     * @property {number|null} [CombRateMin] Detail CombRateMin
     * @property {number|null} [StakeMax] Detail StakeMax
     * @property {boolean|null} [CanBePlayedAsSystemBet] Detail CanBePlayedAsSystemBet
     * @property {OfferItemState|null} [State] Detail State
     * @property {boolean|null} [Suspended] Detail Suspended
     * @property {string|null} [Info] Detail Info
     */

    /**
     * Constructs a new Detail.
     * @exports Detail
     * @classdesc Represents a Detail.
     * @implements IDetail
     * @constructor
     * @param {IDetail=} [properties] Properties to set
     */
    function Detail(properties) {
        this.OddsList = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Detail ID.
     * @member {number} ID
     * @memberof Detail
     * @instance
     */
    Detail.prototype.ID = 0;

    /**
     * Detail Name.
     * @member {string} Name
     * @memberof Detail
     * @instance
     */
    Detail.prototype.Name = "";

    /**
     * Detail LineNumber.
     * @member {number} LineNumber
     * @memberof Detail
     * @instance
     */
    Detail.prototype.LineNumber = 0;

    /**
     * Detail OddsList.
     * @member {Array.<IOdds>} OddsList
     * @memberof Detail
     * @instance
     */
    Detail.prototype.OddsList = $util.emptyArray;

    /**
     * Detail CombCountMin.
     * @member {number} CombCountMin
     * @memberof Detail
     * @instance
     */
    Detail.prototype.CombCountMin = 0;

    /**
     * Detail CombRateMin.
     * @member {number} CombRateMin
     * @memberof Detail
     * @instance
     */
    Detail.prototype.CombRateMin = 0;

    /**
     * Detail StakeMax.
     * @member {number} StakeMax
     * @memberof Detail
     * @instance
     */
    Detail.prototype.StakeMax = 0;

    /**
     * Detail CanBePlayedAsSystemBet.
     * @member {boolean} CanBePlayedAsSystemBet
     * @memberof Detail
     * @instance
     */
    Detail.prototype.CanBePlayedAsSystemBet = false;

    /**
     * Detail State.
     * @member {OfferItemState} State
     * @memberof Detail
     * @instance
     */
    Detail.prototype.State = 0;

    /**
     * Detail Suspended.
     * @member {boolean} Suspended
     * @memberof Detail
     * @instance
     */
    Detail.prototype.Suspended = false;

    /**
     * Detail Info.
     * @member {string} Info
     * @memberof Detail
     * @instance
     */
    Detail.prototype.Info = "";

    /**
     * Creates a new Detail instance using the specified properties.
     * @function create
     * @memberof Detail
     * @static
     * @param {IDetail=} [properties] Properties to set
     * @returns {Detail} Detail instance
     */
    Detail.create = function create(properties) {
        return new Detail(properties);
    };

    /**
     * Encodes the specified Detail message. Does not implicitly {@link Detail.verify|verify} messages.
     * @function encode
     * @memberof Detail
     * @static
     * @param {IDetail} message Detail message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Detail.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ID != null && message.hasOwnProperty("ID"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.ID);
        if (message.Name != null && message.hasOwnProperty("Name"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.Name);
        if (message.LineNumber != null && message.hasOwnProperty("LineNumber"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.LineNumber);
        if (message.OddsList != null && message.OddsList.length)
            for (var i = 0; i < message.OddsList.length; ++i)
                $root.Odds.encode(message.OddsList[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        if (message.CombCountMin != null && message.hasOwnProperty("CombCountMin"))
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.CombCountMin);
        if (message.CombRateMin != null && message.hasOwnProperty("CombRateMin"))
            writer.uint32(/* id 6, wireType 5 =*/53).float(message.CombRateMin);
        if (message.StakeMax != null && message.hasOwnProperty("StakeMax"))
            writer.uint32(/* id 7, wireType 5 =*/61).float(message.StakeMax);
        if (message.CanBePlayedAsSystemBet != null && message.hasOwnProperty("CanBePlayedAsSystemBet"))
            writer.uint32(/* id 8, wireType 0 =*/64).bool(message.CanBePlayedAsSystemBet);
        if (message.State != null && message.hasOwnProperty("State"))
            writer.uint32(/* id 9, wireType 0 =*/72).int32(message.State);
        if (message.Suspended != null && message.hasOwnProperty("Suspended"))
            writer.uint32(/* id 10, wireType 0 =*/80).bool(message.Suspended);
        if (message.Info != null && message.hasOwnProperty("Info"))
            writer.uint32(/* id 11, wireType 2 =*/90).string(message.Info);
        return writer;
    };

    /**
     * Encodes the specified Detail message, length delimited. Does not implicitly {@link Detail.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Detail
     * @static
     * @param {IDetail} message Detail message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Detail.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Detail message from the specified reader or buffer.
     * @function decode
     * @memberof Detail
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Detail} Detail
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Detail.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Detail();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.ID = reader.int32();
                break;
            case 2:
                message.Name = reader.string();
                break;
            case 3:
                message.LineNumber = reader.int32();
                break;
            case 4:
                if (!(message.OddsList && message.OddsList.length))
                    message.OddsList = [];
                message.OddsList.push($root.Odds.decode(reader, reader.uint32()));
                break;
            case 5:
                message.CombCountMin = reader.int32();
                break;
            case 6:
                message.CombRateMin = reader.float();
                break;
            case 7:
                message.StakeMax = reader.float();
                break;
            case 8:
                message.CanBePlayedAsSystemBet = reader.bool();
                break;
            case 9:
                message.State = reader.int32();
                break;
            case 10:
                message.Suspended = reader.bool();
                break;
            case 11:
                message.Info = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Detail message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Detail
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Detail} Detail
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Detail.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Detail message.
     * @function verify
     * @memberof Detail
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Detail.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ID != null && message.hasOwnProperty("ID"))
            if (!$util.isInteger(message.ID))
                return "ID: integer expected";
        if (message.Name != null && message.hasOwnProperty("Name"))
            if (!$util.isString(message.Name))
                return "Name: string expected";
        if (message.LineNumber != null && message.hasOwnProperty("LineNumber"))
            if (!$util.isInteger(message.LineNumber))
                return "LineNumber: integer expected";
        if (message.OddsList != null && message.hasOwnProperty("OddsList")) {
            if (!Array.isArray(message.OddsList))
                return "OddsList: array expected";
            for (var i = 0; i < message.OddsList.length; ++i) {
                var error = $root.Odds.verify(message.OddsList[i]);
                if (error)
                    return "OddsList." + error;
            }
        }
        if (message.CombCountMin != null && message.hasOwnProperty("CombCountMin"))
            if (!$util.isInteger(message.CombCountMin))
                return "CombCountMin: integer expected";
        if (message.CombRateMin != null && message.hasOwnProperty("CombRateMin"))
            if (typeof message.CombRateMin !== "number")
                return "CombRateMin: number expected";
        if (message.StakeMax != null && message.hasOwnProperty("StakeMax"))
            if (typeof message.StakeMax !== "number")
                return "StakeMax: number expected";
        if (message.CanBePlayedAsSystemBet != null && message.hasOwnProperty("CanBePlayedAsSystemBet"))
            if (typeof message.CanBePlayedAsSystemBet !== "boolean")
                return "CanBePlayedAsSystemBet: boolean expected";
        if (message.State != null && message.hasOwnProperty("State"))
            switch (message.State) {
            default:
                return "State: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
                break;
            }
        if (message.Suspended != null && message.hasOwnProperty("Suspended"))
            if (typeof message.Suspended !== "boolean")
                return "Suspended: boolean expected";
        if (message.Info != null && message.hasOwnProperty("Info"))
            if (!$util.isString(message.Info))
                return "Info: string expected";
        return null;
    };

    /**
     * Creates a Detail message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Detail
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Detail} Detail
     */
    Detail.fromObject = function fromObject(object) {
        if (object instanceof $root.Detail)
            return object;
        var message = new $root.Detail();
        if (object.ID != null)
            message.ID = object.ID | 0;
        if (object.Name != null)
            message.Name = String(object.Name);
        if (object.LineNumber != null)
            message.LineNumber = object.LineNumber | 0;
        if (object.OddsList) {
            if (!Array.isArray(object.OddsList))
                throw TypeError(".Detail.OddsList: array expected");
            message.OddsList = [];
            for (var i = 0; i < object.OddsList.length; ++i) {
                if (typeof object.OddsList[i] !== "object")
                    throw TypeError(".Detail.OddsList: object expected");
                message.OddsList[i] = $root.Odds.fromObject(object.OddsList[i]);
            }
        }
        if (object.CombCountMin != null)
            message.CombCountMin = object.CombCountMin | 0;
        if (object.CombRateMin != null)
            message.CombRateMin = Number(object.CombRateMin);
        if (object.StakeMax != null)
            message.StakeMax = Number(object.StakeMax);
        if (object.CanBePlayedAsSystemBet != null)
            message.CanBePlayedAsSystemBet = Boolean(object.CanBePlayedAsSystemBet);
        switch (object.State) {
        case "None":
        case 0:
            message.State = 0;
            break;
        case "Created":
        case 1:
            message.State = 1;
            break;
        case "Opened":
        case 2:
            message.State = 2;
            break;
        case "Suspended":
        case 3:
            message.State = 3;
            break;
        case "Closed":
        case 4:
            message.State = 4;
            break;
        }
        if (object.Suspended != null)
            message.Suspended = Boolean(object.Suspended);
        if (object.Info != null)
            message.Info = String(object.Info);
        return message;
    };

    /**
     * Creates a plain object from a Detail message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Detail
     * @static
     * @param {Detail} message Detail
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Detail.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.OddsList = [];
        if (options.defaults) {
            object.ID = 0;
            object.Name = "";
            object.LineNumber = 0;
            object.CombCountMin = 0;
            object.CombRateMin = 0;
            object.StakeMax = 0;
            object.CanBePlayedAsSystemBet = false;
            object.State = options.enums === String ? "None" : 0;
            object.Suspended = false;
            object.Info = "";
        }
        if (message.ID != null && message.hasOwnProperty("ID"))
            object.ID = message.ID;
        if (message.Name != null && message.hasOwnProperty("Name"))
            object.Name = message.Name;
        if (message.LineNumber != null && message.hasOwnProperty("LineNumber"))
            object.LineNumber = message.LineNumber;
        if (message.OddsList && message.OddsList.length) {
            object.OddsList = [];
            for (var j = 0; j < message.OddsList.length; ++j)
                object.OddsList[j] = $root.Odds.toObject(message.OddsList[j], options);
        }
        if (message.CombCountMin != null && message.hasOwnProperty("CombCountMin"))
            object.CombCountMin = message.CombCountMin;
        if (message.CombRateMin != null && message.hasOwnProperty("CombRateMin"))
            object.CombRateMin = options.json && !isFinite(message.CombRateMin) ? String(message.CombRateMin) : message.CombRateMin;
        if (message.StakeMax != null && message.hasOwnProperty("StakeMax"))
            object.StakeMax = options.json && !isFinite(message.StakeMax) ? String(message.StakeMax) : message.StakeMax;
        if (message.CanBePlayedAsSystemBet != null && message.hasOwnProperty("CanBePlayedAsSystemBet"))
            object.CanBePlayedAsSystemBet = message.CanBePlayedAsSystemBet;
        if (message.State != null && message.hasOwnProperty("State"))
            object.State = options.enums === String ? $root.OfferItemState[message.State] : message.State;
        if (message.Suspended != null && message.hasOwnProperty("Suspended"))
            object.Suspended = message.Suspended;
        if (message.Info != null && message.hasOwnProperty("Info"))
            object.Info = message.Info;
        return object;
    };

    /**
     * Converts this Detail to JSON.
     * @function toJSON
     * @memberof Detail
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Detail.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Detail;
})();

/**
 * OfferItemState enum.
 * @exports OfferItemState
 * @enum {string}
 * @property {number} None=0 None value
 * @property {number} Created=1 Created value
 * @property {number} Opened=2 Opened value
 * @property {number} Suspended=3 Suspended value
 * @property {number} Closed=4 Closed value
 */
$root.OfferItemState = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "None"] = 0;
    values[valuesById[1] = "Created"] = 1;
    values[valuesById[2] = "Opened"] = 2;
    values[valuesById[3] = "Suspended"] = 3;
    values[valuesById[4] = "Closed"] = 4;
    return values;
})();

/**
 * GameBusinessType enum.
 * @exports GameBusinessType
 * @enum {string}
 * @property {number} None=0 None value
 * @property {number} Handicap1x2=1 Handicap1x2 value
 * @property {number} OverBellow=2 OverBellow value
 * @property {number} VMT=3 VMT value
 * @property {number} CorrectScore=4 CorrectScore value
 * @property {number} SpreadOrHandicap12=5 SpreadOrHandicap12 value
 * @property {number} TipList=6 TipList value
 * @property {number} Winner_1x2=7 Winner_1x2 value
 * @property {number} Winner_12=8 Winner_12 value
 */
$root.GameBusinessType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "None"] = 0;
    values[valuesById[1] = "Handicap1x2"] = 1;
    values[valuesById[2] = "OverBellow"] = 2;
    values[valuesById[3] = "VMT"] = 3;
    values[valuesById[4] = "CorrectScore"] = 4;
    values[valuesById[5] = "SpreadOrHandicap12"] = 5;
    values[valuesById[6] = "TipList"] = 6;
    values[valuesById[7] = "Winner_1x2"] = 7;
    values[valuesById[8] = "Winner_12"] = 8;
    return values;
})();

/**
 * VisualisationSubType enum.
 * @exports VisualisationSubType
 * @enum {string}
 * @property {number} AsIs=1 AsIs value
 * @property {number} MergeMarketTypeHeadersBetweenEvents=2 MergeMarketTypeHeadersBetweenEvents value
 */
$root.VisualisationSubType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[1] = "AsIs"] = 1;
    values[valuesById[2] = "MergeMarketTypeHeadersBetweenEvents"] = 2;
    return values;
})();

/**
 * SelectionVisualisationFlag enum.
 * @exports SelectionVisualisationFlag
 * @enum {string}
 * @property {number} AsIs=1 AsIs value
 * @property {number} SimpleCompetitorSubstitution=2 SimpleCompetitorSubstitution value
 * @property {number} Market1X2=4 Market1X2 value
 * @property {number} Market12=8 Market12 value
 * @property {number} MarketHandicap1X2=16 MarketHandicap1X2 value
 * @property {number} MarketHandicap12=32 MarketHandicap12 value
 * @property {number} MarketVMT=64 MarketVMT value
 */
$root.SelectionVisualisationFlag = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[1] = "AsIs"] = 1;
    values[valuesById[2] = "SimpleCompetitorSubstitution"] = 2;
    values[valuesById[4] = "Market1X2"] = 4;
    values[valuesById[8] = "Market12"] = 8;
    values[valuesById[16] = "MarketHandicap1X2"] = 16;
    values[valuesById[32] = "MarketHandicap12"] = 32;
    values[valuesById[64] = "MarketVMT"] = 64;
    return values;
})();

$root.Game = (function() {

    /**
     * Properties of a Game.
     * @exports IGame
     * @interface IGame
     * @property {string|null} [ID] Game ID
     * @property {string|null} [Name] Game Name
     * @property {number|null} [Sequence] Game Sequence
     * @property {ITimestamp|null} [TurnOff] Game TurnOff
     * @property {GameBusinessType|null} [BusinessType] Game BusinessType
     * @property {Array.<IDetail>|null} [Details] Game Details
     * @property {number|null} [TemplateID] Game TemplateID
     * @property {number|null} [SequenceInSuperGame] Game SequenceInSuperGame
     * @property {boolean|null} [IsSuperGame] Game IsSuperGame
     * @property {boolean|null} [IsDetails] Game IsDetails
     * @property {number|null} [SelectionVisualisationFlags] Game SelectionVisualisationFlags
     * @property {VisualisationSubType|null} [VisualisationSubType] Game VisualisationSubType
     * @property {string|null} [Info] Game Info
     */

    /**
     * Constructs a new Game.
     * @exports Game
     * @classdesc Represents a Game.
     * @implements IGame
     * @constructor
     * @param {IGame=} [properties] Properties to set
     */
    function Game(properties) {
        this.Details = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Game ID.
     * @member {string} ID
     * @memberof Game
     * @instance
     */
    Game.prototype.ID = "";

    /**
     * Game Name.
     * @member {string} Name
     * @memberof Game
     * @instance
     */
    Game.prototype.Name = "";

    /**
     * Game Sequence.
     * @member {number} Sequence
     * @memberof Game
     * @instance
     */
    Game.prototype.Sequence = 0;

    /**
     * Game TurnOff.
     * @member {ITimestamp|null|undefined} TurnOff
     * @memberof Game
     * @instance
     */
    Game.prototype.TurnOff = null;

    /**
     * Game BusinessType.
     * @member {GameBusinessType} BusinessType
     * @memberof Game
     * @instance
     */
    Game.prototype.BusinessType = 0;

    /**
     * Game Details.
     * @member {Array.<IDetail>} Details
     * @memberof Game
     * @instance
     */
    Game.prototype.Details = $util.emptyArray;

    /**
     * Game TemplateID.
     * @member {number} TemplateID
     * @memberof Game
     * @instance
     */
    Game.prototype.TemplateID = 0;

    /**
     * Game SequenceInSuperGame.
     * @member {number} SequenceInSuperGame
     * @memberof Game
     * @instance
     */
    Game.prototype.SequenceInSuperGame = 0;

    /**
     * Game IsSuperGame.
     * @member {boolean} IsSuperGame
     * @memberof Game
     * @instance
     */
    Game.prototype.IsSuperGame = false;

    /**
     * Game IsDetails.
     * @member {boolean} IsDetails
     * @memberof Game
     * @instance
     */
    Game.prototype.IsDetails = false;

    /**
     * Game SelectionVisualisationFlags.
     * @member {number} SelectionVisualisationFlags
     * @memberof Game
     * @instance
     */
    Game.prototype.SelectionVisualisationFlags = 0;

    /**
     * Game VisualisationSubType.
     * @member {VisualisationSubType} VisualisationSubType
     * @memberof Game
     * @instance
     */
    Game.prototype.VisualisationSubType = 1;

    /**
     * Game Info.
     * @member {string} Info
     * @memberof Game
     * @instance
     */
    Game.prototype.Info = "";

    /**
     * Creates a new Game instance using the specified properties.
     * @function create
     * @memberof Game
     * @static
     * @param {IGame=} [properties] Properties to set
     * @returns {Game} Game instance
     */
    Game.create = function create(properties) {
        return new Game(properties);
    };

    /**
     * Encodes the specified Game message. Does not implicitly {@link Game.verify|verify} messages.
     * @function encode
     * @memberof Game
     * @static
     * @param {IGame} message Game message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Game.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ID != null && message.hasOwnProperty("ID"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.ID);
        if (message.Name != null && message.hasOwnProperty("Name"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.Name);
        if (message.Sequence != null && message.hasOwnProperty("Sequence"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.Sequence);
        if (message.TurnOff != null && message.hasOwnProperty("TurnOff"))
            $root.Timestamp.encode(message.TurnOff, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        if (message.BusinessType != null && message.hasOwnProperty("BusinessType"))
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.BusinessType);
        if (message.Details != null && message.Details.length)
            for (var i = 0; i < message.Details.length; ++i)
                $root.Detail.encode(message.Details[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
        if (message.TemplateID != null && message.hasOwnProperty("TemplateID"))
            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.TemplateID);
        if (message.SequenceInSuperGame != null && message.hasOwnProperty("SequenceInSuperGame"))
            writer.uint32(/* id 8, wireType 0 =*/64).int32(message.SequenceInSuperGame);
        if (message.IsSuperGame != null && message.hasOwnProperty("IsSuperGame"))
            writer.uint32(/* id 9, wireType 0 =*/72).bool(message.IsSuperGame);
        if (message.IsDetails != null && message.hasOwnProperty("IsDetails"))
            writer.uint32(/* id 10, wireType 0 =*/80).bool(message.IsDetails);
        if (message.SelectionVisualisationFlags != null && message.hasOwnProperty("SelectionVisualisationFlags"))
            writer.uint32(/* id 11, wireType 0 =*/88).uint32(message.SelectionVisualisationFlags);
        if (message.VisualisationSubType != null && message.hasOwnProperty("VisualisationSubType"))
            writer.uint32(/* id 12, wireType 0 =*/96).int32(message.VisualisationSubType);
        if (message.Info != null && message.hasOwnProperty("Info"))
            writer.uint32(/* id 13, wireType 2 =*/106).string(message.Info);
        return writer;
    };

    /**
     * Encodes the specified Game message, length delimited. Does not implicitly {@link Game.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Game
     * @static
     * @param {IGame} message Game message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Game.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Game message from the specified reader or buffer.
     * @function decode
     * @memberof Game
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Game} Game
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Game.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Game();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.ID = reader.string();
                break;
            case 2:
                message.Name = reader.string();
                break;
            case 3:
                message.Sequence = reader.int32();
                break;
            case 4:
                message.TurnOff = $root.Timestamp.decode(reader, reader.uint32());
                break;
            case 5:
                message.BusinessType = reader.int32();
                break;
            case 6:
                if (!(message.Details && message.Details.length))
                    message.Details = [];
                message.Details.push($root.Detail.decode(reader, reader.uint32()));
                break;
            case 7:
                message.TemplateID = reader.int32();
                break;
            case 8:
                message.SequenceInSuperGame = reader.int32();
                break;
            case 9:
                message.IsSuperGame = reader.bool();
                break;
            case 10:
                message.IsDetails = reader.bool();
                break;
            case 11:
                message.SelectionVisualisationFlags = reader.uint32();
                break;
            case 12:
                message.VisualisationSubType = reader.int32();
                break;
            case 13:
                message.Info = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Game message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Game
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Game} Game
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Game.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Game message.
     * @function verify
     * @memberof Game
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Game.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ID != null && message.hasOwnProperty("ID"))
            if (!$util.isString(message.ID))
                return "ID: string expected";
        if (message.Name != null && message.hasOwnProperty("Name"))
            if (!$util.isString(message.Name))
                return "Name: string expected";
        if (message.Sequence != null && message.hasOwnProperty("Sequence"))
            if (!$util.isInteger(message.Sequence))
                return "Sequence: integer expected";
        if (message.TurnOff != null && message.hasOwnProperty("TurnOff")) {
            var error = $root.Timestamp.verify(message.TurnOff);
            if (error)
                return "TurnOff." + error;
        }
        if (message.BusinessType != null && message.hasOwnProperty("BusinessType"))
            switch (message.BusinessType) {
            default:
                return "BusinessType: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
                break;
            }
        if (message.Details != null && message.hasOwnProperty("Details")) {
            if (!Array.isArray(message.Details))
                return "Details: array expected";
            for (var i = 0; i < message.Details.length; ++i) {
                var error = $root.Detail.verify(message.Details[i]);
                if (error)
                    return "Details." + error;
            }
        }
        if (message.TemplateID != null && message.hasOwnProperty("TemplateID"))
            if (!$util.isInteger(message.TemplateID))
                return "TemplateID: integer expected";
        if (message.SequenceInSuperGame != null && message.hasOwnProperty("SequenceInSuperGame"))
            if (!$util.isInteger(message.SequenceInSuperGame))
                return "SequenceInSuperGame: integer expected";
        if (message.IsSuperGame != null && message.hasOwnProperty("IsSuperGame"))
            if (typeof message.IsSuperGame !== "boolean")
                return "IsSuperGame: boolean expected";
        if (message.IsDetails != null && message.hasOwnProperty("IsDetails"))
            if (typeof message.IsDetails !== "boolean")
                return "IsDetails: boolean expected";
        if (message.SelectionVisualisationFlags != null && message.hasOwnProperty("SelectionVisualisationFlags"))
            if (!$util.isInteger(message.SelectionVisualisationFlags))
                return "SelectionVisualisationFlags: integer expected";
        if (message.VisualisationSubType != null && message.hasOwnProperty("VisualisationSubType"))
            switch (message.VisualisationSubType) {
            default:
                return "VisualisationSubType: enum value expected";
            case 1:
            case 2:
                break;
            }
        if (message.Info != null && message.hasOwnProperty("Info"))
            if (!$util.isString(message.Info))
                return "Info: string expected";
        return null;
    };

    /**
     * Creates a Game message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Game
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Game} Game
     */
    Game.fromObject = function fromObject(object) {
        if (object instanceof $root.Game)
            return object;
        var message = new $root.Game();
        if (object.ID != null)
            message.ID = String(object.ID);
        if (object.Name != null)
            message.Name = String(object.Name);
        if (object.Sequence != null)
            message.Sequence = object.Sequence | 0;
        if (object.TurnOff != null) {
            if (typeof object.TurnOff !== "object")
                throw TypeError(".Game.TurnOff: object expected");
            message.TurnOff = $root.Timestamp.fromObject(object.TurnOff);
        }
        switch (object.BusinessType) {
        case "None":
        case 0:
            message.BusinessType = 0;
            break;
        case "Handicap1x2":
        case 1:
            message.BusinessType = 1;
            break;
        case "OverBellow":
        case 2:
            message.BusinessType = 2;
            break;
        case "VMT":
        case 3:
            message.BusinessType = 3;
            break;
        case "CorrectScore":
        case 4:
            message.BusinessType = 4;
            break;
        case "SpreadOrHandicap12":
        case 5:
            message.BusinessType = 5;
            break;
        case "TipList":
        case 6:
            message.BusinessType = 6;
            break;
        case "Winner_1x2":
        case 7:
            message.BusinessType = 7;
            break;
        case "Winner_12":
        case 8:
            message.BusinessType = 8;
            break;
        }
        if (object.Details) {
            if (!Array.isArray(object.Details))
                throw TypeError(".Game.Details: array expected");
            message.Details = [];
            for (var i = 0; i < object.Details.length; ++i) {
                if (typeof object.Details[i] !== "object")
                    throw TypeError(".Game.Details: object expected");
                message.Details[i] = $root.Detail.fromObject(object.Details[i]);
            }
        }
        if (object.TemplateID != null)
            message.TemplateID = object.TemplateID | 0;
        if (object.SequenceInSuperGame != null)
            message.SequenceInSuperGame = object.SequenceInSuperGame | 0;
        if (object.IsSuperGame != null)
            message.IsSuperGame = Boolean(object.IsSuperGame);
        if (object.IsDetails != null)
            message.IsDetails = Boolean(object.IsDetails);
        if (object.SelectionVisualisationFlags != null)
            message.SelectionVisualisationFlags = object.SelectionVisualisationFlags >>> 0;
        switch (object.VisualisationSubType) {
        case "AsIs":
        case 1:
            message.VisualisationSubType = 1;
            break;
        case "MergeMarketTypeHeadersBetweenEvents":
        case 2:
            message.VisualisationSubType = 2;
            break;
        }
        if (object.Info != null)
            message.Info = String(object.Info);
        return message;
    };

    /**
     * Creates a plain object from a Game message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Game
     * @static
     * @param {Game} message Game
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Game.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.Details = [];
        if (options.defaults) {
            object.ID = "";
            object.Name = "";
            object.Sequence = 0;
            object.TurnOff = null;
            object.BusinessType = options.enums === String ? "None" : 0;
            object.TemplateID = 0;
            object.SequenceInSuperGame = 0;
            object.IsSuperGame = false;
            object.IsDetails = false;
            object.SelectionVisualisationFlags = 0;
            object.VisualisationSubType = options.enums === String ? "AsIs" : 1;
            object.Info = "";
        }
        if (message.ID != null && message.hasOwnProperty("ID"))
            object.ID = message.ID;
        if (message.Name != null && message.hasOwnProperty("Name"))
            object.Name = message.Name;
        if (message.Sequence != null && message.hasOwnProperty("Sequence"))
            object.Sequence = message.Sequence;
        if (message.TurnOff != null && message.hasOwnProperty("TurnOff"))
            object.TurnOff = $root.Timestamp.toObject(message.TurnOff, options);
        if (message.BusinessType != null && message.hasOwnProperty("BusinessType"))
            object.BusinessType = options.enums === String ? $root.GameBusinessType[message.BusinessType] : message.BusinessType;
        if (message.Details && message.Details.length) {
            object.Details = [];
            for (var j = 0; j < message.Details.length; ++j)
                object.Details[j] = $root.Detail.toObject(message.Details[j], options);
        }
        if (message.TemplateID != null && message.hasOwnProperty("TemplateID"))
            object.TemplateID = message.TemplateID;
        if (message.SequenceInSuperGame != null && message.hasOwnProperty("SequenceInSuperGame"))
            object.SequenceInSuperGame = message.SequenceInSuperGame;
        if (message.IsSuperGame != null && message.hasOwnProperty("IsSuperGame"))
            object.IsSuperGame = message.IsSuperGame;
        if (message.IsDetails != null && message.hasOwnProperty("IsDetails"))
            object.IsDetails = message.IsDetails;
        if (message.SelectionVisualisationFlags != null && message.hasOwnProperty("SelectionVisualisationFlags"))
            object.SelectionVisualisationFlags = message.SelectionVisualisationFlags;
        if (message.VisualisationSubType != null && message.hasOwnProperty("VisualisationSubType"))
            object.VisualisationSubType = options.enums === String ? $root.VisualisationSubType[message.VisualisationSubType] : message.VisualisationSubType;
        if (message.Info != null && message.hasOwnProperty("Info"))
            object.Info = message.Info;
        return object;
    };

    /**
     * Converts this Game to JSON.
     * @function toJSON
     * @memberof Game
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Game.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Game;
})();

$root.GameFilterItem = (function() {

    /**
     * Properties of a GameFilterItem.
     * @exports IGameFilterItem
     * @interface IGameFilterItem
     * @property {number|null} [Id] GameFilterItem Id
     * @property {string|null} [Name] GameFilterItem Name
     * @property {boolean|null} [Visible] GameFilterItem Visible
     */

    /**
     * Constructs a new GameFilterItem.
     * @exports GameFilterItem
     * @classdesc Represents a GameFilterItem.
     * @implements IGameFilterItem
     * @constructor
     * @param {IGameFilterItem=} [properties] Properties to set
     */
    function GameFilterItem(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GameFilterItem Id.
     * @member {number} Id
     * @memberof GameFilterItem
     * @instance
     */
    GameFilterItem.prototype.Id = 0;

    /**
     * GameFilterItem Name.
     * @member {string} Name
     * @memberof GameFilterItem
     * @instance
     */
    GameFilterItem.prototype.Name = "";

    /**
     * GameFilterItem Visible.
     * @member {boolean} Visible
     * @memberof GameFilterItem
     * @instance
     */
    GameFilterItem.prototype.Visible = false;

    /**
     * Creates a new GameFilterItem instance using the specified properties.
     * @function create
     * @memberof GameFilterItem
     * @static
     * @param {IGameFilterItem=} [properties] Properties to set
     * @returns {GameFilterItem} GameFilterItem instance
     */
    GameFilterItem.create = function create(properties) {
        return new GameFilterItem(properties);
    };

    /**
     * Encodes the specified GameFilterItem message. Does not implicitly {@link GameFilterItem.verify|verify} messages.
     * @function encode
     * @memberof GameFilterItem
     * @static
     * @param {IGameFilterItem} message GameFilterItem message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameFilterItem.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Id != null && message.hasOwnProperty("Id"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Id);
        if (message.Name != null && message.hasOwnProperty("Name"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.Name);
        if (message.Visible != null && message.hasOwnProperty("Visible"))
            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.Visible);
        return writer;
    };

    /**
     * Encodes the specified GameFilterItem message, length delimited. Does not implicitly {@link GameFilterItem.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GameFilterItem
     * @static
     * @param {IGameFilterItem} message GameFilterItem message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameFilterItem.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GameFilterItem message from the specified reader or buffer.
     * @function decode
     * @memberof GameFilterItem
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GameFilterItem} GameFilterItem
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameFilterItem.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GameFilterItem();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Id = reader.int32();
                break;
            case 2:
                message.Name = reader.string();
                break;
            case 3:
                message.Visible = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GameFilterItem message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GameFilterItem
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GameFilterItem} GameFilterItem
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameFilterItem.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GameFilterItem message.
     * @function verify
     * @memberof GameFilterItem
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GameFilterItem.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Id != null && message.hasOwnProperty("Id"))
            if (!$util.isInteger(message.Id))
                return "Id: integer expected";
        if (message.Name != null && message.hasOwnProperty("Name"))
            if (!$util.isString(message.Name))
                return "Name: string expected";
        if (message.Visible != null && message.hasOwnProperty("Visible"))
            if (typeof message.Visible !== "boolean")
                return "Visible: boolean expected";
        return null;
    };

    /**
     * Creates a GameFilterItem message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GameFilterItem
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GameFilterItem} GameFilterItem
     */
    GameFilterItem.fromObject = function fromObject(object) {
        if (object instanceof $root.GameFilterItem)
            return object;
        var message = new $root.GameFilterItem();
        if (object.Id != null)
            message.Id = object.Id | 0;
        if (object.Name != null)
            message.Name = String(object.Name);
        if (object.Visible != null)
            message.Visible = Boolean(object.Visible);
        return message;
    };

    /**
     * Creates a plain object from a GameFilterItem message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GameFilterItem
     * @static
     * @param {GameFilterItem} message GameFilterItem
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GameFilterItem.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.Id = 0;
            object.Name = "";
            object.Visible = false;
        }
        if (message.Id != null && message.hasOwnProperty("Id"))
            object.Id = message.Id;
        if (message.Name != null && message.hasOwnProperty("Name"))
            object.Name = message.Name;
        if (message.Visible != null && message.hasOwnProperty("Visible"))
            object.Visible = message.Visible;
        return object;
    };

    /**
     * Converts this GameFilterItem to JSON.
     * @function toJSON
     * @memberof GameFilterItem
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GameFilterItem.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GameFilterItem;
})();

$root.GameGroup = (function() {

    /**
     * Properties of a GameGroup.
     * @exports IGameGroup
     * @interface IGameGroup
     * @property {number|null} [ID] GameGroup ID
     * @property {string|null} [Name] GameGroup Name
     * @property {Array.<IGame>|null} [Games] GameGroup Games
     * @property {boolean|null} [IsRapidBets] GameGroup IsRapidBets
     */

    /**
     * Constructs a new GameGroup.
     * @exports GameGroup
     * @classdesc Represents a GameGroup.
     * @implements IGameGroup
     * @constructor
     * @param {IGameGroup=} [properties] Properties to set
     */
    function GameGroup(properties) {
        this.Games = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GameGroup ID.
     * @member {number} ID
     * @memberof GameGroup
     * @instance
     */
    GameGroup.prototype.ID = 0;

    /**
     * GameGroup Name.
     * @member {string} Name
     * @memberof GameGroup
     * @instance
     */
    GameGroup.prototype.Name = "";

    /**
     * GameGroup Games.
     * @member {Array.<IGame>} Games
     * @memberof GameGroup
     * @instance
     */
    GameGroup.prototype.Games = $util.emptyArray;

    /**
     * GameGroup IsRapidBets.
     * @member {boolean} IsRapidBets
     * @memberof GameGroup
     * @instance
     */
    GameGroup.prototype.IsRapidBets = false;

    /**
     * Creates a new GameGroup instance using the specified properties.
     * @function create
     * @memberof GameGroup
     * @static
     * @param {IGameGroup=} [properties] Properties to set
     * @returns {GameGroup} GameGroup instance
     */
    GameGroup.create = function create(properties) {
        return new GameGroup(properties);
    };

    /**
     * Encodes the specified GameGroup message. Does not implicitly {@link GameGroup.verify|verify} messages.
     * @function encode
     * @memberof GameGroup
     * @static
     * @param {IGameGroup} message GameGroup message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameGroup.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ID != null && message.hasOwnProperty("ID"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.ID);
        if (message.Name != null && message.hasOwnProperty("Name"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.Name);
        if (message.Games != null && message.Games.length)
            for (var i = 0; i < message.Games.length; ++i)
                $root.Game.encode(message.Games[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        if (message.IsRapidBets != null && message.hasOwnProperty("IsRapidBets"))
            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.IsRapidBets);
        return writer;
    };

    /**
     * Encodes the specified GameGroup message, length delimited. Does not implicitly {@link GameGroup.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GameGroup
     * @static
     * @param {IGameGroup} message GameGroup message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GameGroup.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GameGroup message from the specified reader or buffer.
     * @function decode
     * @memberof GameGroup
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GameGroup} GameGroup
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameGroup.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GameGroup();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.ID = reader.int32();
                break;
            case 2:
                message.Name = reader.string();
                break;
            case 3:
                if (!(message.Games && message.Games.length))
                    message.Games = [];
                message.Games.push($root.Game.decode(reader, reader.uint32()));
                break;
            case 4:
                message.IsRapidBets = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GameGroup message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GameGroup
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GameGroup} GameGroup
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GameGroup.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GameGroup message.
     * @function verify
     * @memberof GameGroup
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GameGroup.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ID != null && message.hasOwnProperty("ID"))
            if (!$util.isInteger(message.ID))
                return "ID: integer expected";
        if (message.Name != null && message.hasOwnProperty("Name"))
            if (!$util.isString(message.Name))
                return "Name: string expected";
        if (message.Games != null && message.hasOwnProperty("Games")) {
            if (!Array.isArray(message.Games))
                return "Games: array expected";
            for (var i = 0; i < message.Games.length; ++i) {
                var error = $root.Game.verify(message.Games[i]);
                if (error)
                    return "Games." + error;
            }
        }
        if (message.IsRapidBets != null && message.hasOwnProperty("IsRapidBets"))
            if (typeof message.IsRapidBets !== "boolean")
                return "IsRapidBets: boolean expected";
        return null;
    };

    /**
     * Creates a GameGroup message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GameGroup
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GameGroup} GameGroup
     */
    GameGroup.fromObject = function fromObject(object) {
        if (object instanceof $root.GameGroup)
            return object;
        var message = new $root.GameGroup();
        if (object.ID != null)
            message.ID = object.ID | 0;
        if (object.Name != null)
            message.Name = String(object.Name);
        if (object.Games) {
            if (!Array.isArray(object.Games))
                throw TypeError(".GameGroup.Games: array expected");
            message.Games = [];
            for (var i = 0; i < object.Games.length; ++i) {
                if (typeof object.Games[i] !== "object")
                    throw TypeError(".GameGroup.Games: object expected");
                message.Games[i] = $root.Game.fromObject(object.Games[i]);
            }
        }
        if (object.IsRapidBets != null)
            message.IsRapidBets = Boolean(object.IsRapidBets);
        return message;
    };

    /**
     * Creates a plain object from a GameGroup message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GameGroup
     * @static
     * @param {GameGroup} message GameGroup
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GameGroup.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.Games = [];
        if (options.defaults) {
            object.ID = 0;
            object.Name = "";
            object.IsRapidBets = false;
        }
        if (message.ID != null && message.hasOwnProperty("ID"))
            object.ID = message.ID;
        if (message.Name != null && message.hasOwnProperty("Name"))
            object.Name = message.Name;
        if (message.Games && message.Games.length) {
            object.Games = [];
            for (var j = 0; j < message.Games.length; ++j)
                object.Games[j] = $root.Game.toObject(message.Games[j], options);
        }
        if (message.IsRapidBets != null && message.hasOwnProperty("IsRapidBets"))
            object.IsRapidBets = message.IsRapidBets;
        return object;
    };

    /**
     * Converts this GameGroup to JSON.
     * @function toJSON
     * @memberof GameGroup
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GameGroup.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GameGroup;
})();

$root.Tv = (function() {

    /**
     * Properties of a Tv.
     * @exports ITv
     * @interface ITv
     * @property {number|null} [Id] Tv Id
     * @property {ITimestamp|null} [Date] Tv Date
     * @property {string|null} [Name] Tv Name
     */

    /**
     * Constructs a new Tv.
     * @exports Tv
     * @classdesc Represents a Tv.
     * @implements ITv
     * @constructor
     * @param {ITv=} [properties] Properties to set
     */
    function Tv(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Tv Id.
     * @member {number} Id
     * @memberof Tv
     * @instance
     */
    Tv.prototype.Id = 0;

    /**
     * Tv Date.
     * @member {ITimestamp|null|undefined} Date
     * @memberof Tv
     * @instance
     */
    Tv.prototype.Date = null;

    /**
     * Tv Name.
     * @member {string} Name
     * @memberof Tv
     * @instance
     */
    Tv.prototype.Name = "";

    /**
     * Creates a new Tv instance using the specified properties.
     * @function create
     * @memberof Tv
     * @static
     * @param {ITv=} [properties] Properties to set
     * @returns {Tv} Tv instance
     */
    Tv.create = function create(properties) {
        return new Tv(properties);
    };

    /**
     * Encodes the specified Tv message. Does not implicitly {@link Tv.verify|verify} messages.
     * @function encode
     * @memberof Tv
     * @static
     * @param {ITv} message Tv message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Tv.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Id != null && message.hasOwnProperty("Id"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Id);
        if (message.Date != null && message.hasOwnProperty("Date"))
            $root.Timestamp.encode(message.Date, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.Name != null && message.hasOwnProperty("Name"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.Name);
        return writer;
    };

    /**
     * Encodes the specified Tv message, length delimited. Does not implicitly {@link Tv.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Tv
     * @static
     * @param {ITv} message Tv message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Tv.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Tv message from the specified reader or buffer.
     * @function decode
     * @memberof Tv
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Tv} Tv
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Tv.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Tv();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Id = reader.int32();
                break;
            case 2:
                message.Date = $root.Timestamp.decode(reader, reader.uint32());
                break;
            case 3:
                message.Name = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Tv message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Tv
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Tv} Tv
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Tv.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Tv message.
     * @function verify
     * @memberof Tv
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Tv.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Id != null && message.hasOwnProperty("Id"))
            if (!$util.isInteger(message.Id))
                return "Id: integer expected";
        if (message.Date != null && message.hasOwnProperty("Date")) {
            var error = $root.Timestamp.verify(message.Date);
            if (error)
                return "Date." + error;
        }
        if (message.Name != null && message.hasOwnProperty("Name"))
            if (!$util.isString(message.Name))
                return "Name: string expected";
        return null;
    };

    /**
     * Creates a Tv message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Tv
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Tv} Tv
     */
    Tv.fromObject = function fromObject(object) {
        if (object instanceof $root.Tv)
            return object;
        var message = new $root.Tv();
        if (object.Id != null)
            message.Id = object.Id | 0;
        if (object.Date != null) {
            if (typeof object.Date !== "object")
                throw TypeError(".Tv.Date: object expected");
            message.Date = $root.Timestamp.fromObject(object.Date);
        }
        if (object.Name != null)
            message.Name = String(object.Name);
        return message;
    };

    /**
     * Creates a plain object from a Tv message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Tv
     * @static
     * @param {Tv} message Tv
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Tv.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.Id = 0;
            object.Date = null;
            object.Name = "";
        }
        if (message.Id != null && message.hasOwnProperty("Id"))
            object.Id = message.Id;
        if (message.Date != null && message.hasOwnProperty("Date"))
            object.Date = $root.Timestamp.toObject(message.Date, options);
        if (message.Name != null && message.hasOwnProperty("Name"))
            object.Name = message.Name;
        return object;
    };

    /**
     * Converts this Tv to JSON.
     * @function toJSON
     * @memberof Tv
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Tv.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Tv;
})();

$root.Competitor = (function() {

    /**
     * Properties of a Competitor.
     * @exports ICompetitor
     * @interface ICompetitor
     * @property {number|null} [Id] Competitor Id
     * @property {string|null} [Name] Competitor Name
     */

    /**
     * Constructs a new Competitor.
     * @exports Competitor
     * @classdesc Represents a Competitor.
     * @implements ICompetitor
     * @constructor
     * @param {ICompetitor=} [properties] Properties to set
     */
    function Competitor(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Competitor Id.
     * @member {number} Id
     * @memberof Competitor
     * @instance
     */
    Competitor.prototype.Id = 0;

    /**
     * Competitor Name.
     * @member {string} Name
     * @memberof Competitor
     * @instance
     */
    Competitor.prototype.Name = "";

    /**
     * Creates a new Competitor instance using the specified properties.
     * @function create
     * @memberof Competitor
     * @static
     * @param {ICompetitor=} [properties] Properties to set
     * @returns {Competitor} Competitor instance
     */
    Competitor.create = function create(properties) {
        return new Competitor(properties);
    };

    /**
     * Encodes the specified Competitor message. Does not implicitly {@link Competitor.verify|verify} messages.
     * @function encode
     * @memberof Competitor
     * @static
     * @param {ICompetitor} message Competitor message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Competitor.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Id != null && message.hasOwnProperty("Id"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Id);
        if (message.Name != null && message.hasOwnProperty("Name"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.Name);
        return writer;
    };

    /**
     * Encodes the specified Competitor message, length delimited. Does not implicitly {@link Competitor.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Competitor
     * @static
     * @param {ICompetitor} message Competitor message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Competitor.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Competitor message from the specified reader or buffer.
     * @function decode
     * @memberof Competitor
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Competitor} Competitor
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Competitor.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Competitor();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Id = reader.int32();
                break;
            case 2:
                message.Name = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Competitor message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Competitor
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Competitor} Competitor
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Competitor.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Competitor message.
     * @function verify
     * @memberof Competitor
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Competitor.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Id != null && message.hasOwnProperty("Id"))
            if (!$util.isInteger(message.Id))
                return "Id: integer expected";
        if (message.Name != null && message.hasOwnProperty("Name"))
            if (!$util.isString(message.Name))
                return "Name: string expected";
        return null;
    };

    /**
     * Creates a Competitor message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Competitor
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Competitor} Competitor
     */
    Competitor.fromObject = function fromObject(object) {
        if (object instanceof $root.Competitor)
            return object;
        var message = new $root.Competitor();
        if (object.Id != null)
            message.Id = object.Id | 0;
        if (object.Name != null)
            message.Name = String(object.Name);
        return message;
    };

    /**
     * Creates a plain object from a Competitor message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Competitor
     * @static
     * @param {Competitor} message Competitor
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Competitor.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.Id = 0;
            object.Name = "";
        }
        if (message.Id != null && message.hasOwnProperty("Id"))
            object.Id = message.Id;
        if (message.Name != null && message.hasOwnProperty("Name"))
            object.Name = message.Name;
        return object;
    };

    /**
     * Converts this Competitor to JSON.
     * @function toJSON
     * @memberof Competitor
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Competitor.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Competitor;
})();

$root.Event = (function() {

    /**
     * Properties of an Event.
     * @exports IEvent
     * @interface IEvent
     * @property {number|null} [Id] Event Id
     * @property {string|null} [Name] Event Name
     * @property {string|null} [Info] Event Info
     * @property {ITimestamp|null} [Date] Event Date
     * @property {string|null} [StatisticsExternalId] Event StatisticsExternalId
     * @property {Array.<IGameGroup>|null} [GameGroups] Event GameGroups
     * @property {string|null} [CategoryId] Event CategoryId
     * @property {Array.<ITv>|null} [Tvs] Event Tvs
     * @property {Array.<ICompetitor>|null} [Competitors] Event Competitors
     * @property {number|null} [DetailCount] Event DetailCount
     * @property {boolean|null} [IsVmtCompetitor] Event IsVmtCompetitor
     * @property {number|null} [GraphicsPresentationId] Event GraphicsPresentationId
     * @property {string|null} [CategoryPath] Event CategoryPath
     * @property {boolean|null} [IsLive] Event IsLive
     * @property {Array.<IOddsPopularityStats>|null} [SuperOddsPopularityStats] Event SuperOddsPopularityStats
     * @property {string|null} [MarketingMessage] Event MarketingMessage
     */

    /**
     * Constructs a new Event.
     * @exports Event
     * @classdesc Represents an Event.
     * @implements IEvent
     * @constructor
     * @param {IEvent=} [properties] Properties to set
     */
    function Event(properties) {
        this.GameGroups = [];
        this.Tvs = [];
        this.Competitors = [];
        this.SuperOddsPopularityStats = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Event Id.
     * @member {number} Id
     * @memberof Event
     * @instance
     */
    Event.prototype.Id = 0;

    /**
     * Event Name.
     * @member {string} Name
     * @memberof Event
     * @instance
     */
    Event.prototype.Name = "";

    /**
     * Event Info.
     * @member {string} Info
     * @memberof Event
     * @instance
     */
    Event.prototype.Info = "";

    /**
     * Event Date.
     * @member {ITimestamp|null|undefined} Date
     * @memberof Event
     * @instance
     */
    Event.prototype.Date = null;

    /**
     * Event StatisticsExternalId.
     * @member {string} StatisticsExternalId
     * @memberof Event
     * @instance
     */
    Event.prototype.StatisticsExternalId = "";

    /**
     * Event GameGroups.
     * @member {Array.<IGameGroup>} GameGroups
     * @memberof Event
     * @instance
     */
    Event.prototype.GameGroups = $util.emptyArray;

    /**
     * Event CategoryId.
     * @member {string} CategoryId
     * @memberof Event
     * @instance
     */
    Event.prototype.CategoryId = "";

    /**
     * Event Tvs.
     * @member {Array.<ITv>} Tvs
     * @memberof Event
     * @instance
     */
    Event.prototype.Tvs = $util.emptyArray;

    /**
     * Event Competitors.
     * @member {Array.<ICompetitor>} Competitors
     * @memberof Event
     * @instance
     */
    Event.prototype.Competitors = $util.emptyArray;

    /**
     * Event DetailCount.
     * @member {number} DetailCount
     * @memberof Event
     * @instance
     */
    Event.prototype.DetailCount = 0;

    /**
     * Event IsVmtCompetitor.
     * @member {boolean} IsVmtCompetitor
     * @memberof Event
     * @instance
     */
    Event.prototype.IsVmtCompetitor = false;

    /**
     * Event GraphicsPresentationId.
     * @member {number} GraphicsPresentationId
     * @memberof Event
     * @instance
     */
    Event.prototype.GraphicsPresentationId = 0;

    /**
     * Event CategoryPath.
     * @member {string} CategoryPath
     * @memberof Event
     * @instance
     */
    Event.prototype.CategoryPath = "";

    /**
     * Event IsLive.
     * @member {boolean} IsLive
     * @memberof Event
     * @instance
     */
    Event.prototype.IsLive = false;

    /**
     * Event SuperOddsPopularityStats.
     * @member {Array.<IOddsPopularityStats>} SuperOddsPopularityStats
     * @memberof Event
     * @instance
     */
    Event.prototype.SuperOddsPopularityStats = $util.emptyArray;

    /**
     * Event MarketingMessage.
     * @member {string} MarketingMessage
     * @memberof Event
     * @instance
     */
    Event.prototype.MarketingMessage = "";

    /**
     * Creates a new Event instance using the specified properties.
     * @function create
     * @memberof Event
     * @static
     * @param {IEvent=} [properties] Properties to set
     * @returns {Event} Event instance
     */
    Event.create = function create(properties) {
        return new Event(properties);
    };

    /**
     * Encodes the specified Event message. Does not implicitly {@link Event.verify|verify} messages.
     * @function encode
     * @memberof Event
     * @static
     * @param {IEvent} message Event message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Event.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Id != null && message.hasOwnProperty("Id"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Id);
        if (message.Name != null && message.hasOwnProperty("Name"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.Name);
        if (message.Info != null && message.hasOwnProperty("Info"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.Info);
        if (message.Date != null && message.hasOwnProperty("Date"))
            $root.Timestamp.encode(message.Date, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        if (message.StatisticsExternalId != null && message.hasOwnProperty("StatisticsExternalId"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.StatisticsExternalId);
        if (message.GameGroups != null && message.GameGroups.length)
            for (var i = 0; i < message.GameGroups.length; ++i)
                $root.GameGroup.encode(message.GameGroups[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
        if (message.CategoryId != null && message.hasOwnProperty("CategoryId"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.CategoryId);
        if (message.Tvs != null && message.Tvs.length)
            for (var i = 0; i < message.Tvs.length; ++i)
                $root.Tv.encode(message.Tvs[i], writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
        if (message.Competitors != null && message.Competitors.length)
            for (var i = 0; i < message.Competitors.length; ++i)
                $root.Competitor.encode(message.Competitors[i], writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
        if (message.DetailCount != null && message.hasOwnProperty("DetailCount"))
            writer.uint32(/* id 10, wireType 0 =*/80).int32(message.DetailCount);
        if (message.IsVmtCompetitor != null && message.hasOwnProperty("IsVmtCompetitor"))
            writer.uint32(/* id 11, wireType 0 =*/88).bool(message.IsVmtCompetitor);
        if (message.GraphicsPresentationId != null && message.hasOwnProperty("GraphicsPresentationId"))
            writer.uint32(/* id 12, wireType 0 =*/96).int32(message.GraphicsPresentationId);
        if (message.CategoryPath != null && message.hasOwnProperty("CategoryPath"))
            writer.uint32(/* id 13, wireType 2 =*/106).string(message.CategoryPath);
        if (message.IsLive != null && message.hasOwnProperty("IsLive"))
            writer.uint32(/* id 14, wireType 0 =*/112).bool(message.IsLive);
        if (message.SuperOddsPopularityStats != null && message.SuperOddsPopularityStats.length)
            for (var i = 0; i < message.SuperOddsPopularityStats.length; ++i)
                $root.OddsPopularityStats.encode(message.SuperOddsPopularityStats[i], writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();
        if (message.MarketingMessage != null && message.hasOwnProperty("MarketingMessage"))
            writer.uint32(/* id 16, wireType 2 =*/130).string(message.MarketingMessage);
        return writer;
    };

    /**
     * Encodes the specified Event message, length delimited. Does not implicitly {@link Event.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Event
     * @static
     * @param {IEvent} message Event message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Event.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an Event message from the specified reader or buffer.
     * @function decode
     * @memberof Event
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Event} Event
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Event.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Event();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Id = reader.int32();
                break;
            case 2:
                message.Name = reader.string();
                break;
            case 3:
                message.Info = reader.string();
                break;
            case 4:
                message.Date = $root.Timestamp.decode(reader, reader.uint32());
                break;
            case 5:
                message.StatisticsExternalId = reader.string();
                break;
            case 6:
                if (!(message.GameGroups && message.GameGroups.length))
                    message.GameGroups = [];
                message.GameGroups.push($root.GameGroup.decode(reader, reader.uint32()));
                break;
            case 7:
                message.CategoryId = reader.string();
                break;
            case 8:
                if (!(message.Tvs && message.Tvs.length))
                    message.Tvs = [];
                message.Tvs.push($root.Tv.decode(reader, reader.uint32()));
                break;
            case 9:
                if (!(message.Competitors && message.Competitors.length))
                    message.Competitors = [];
                message.Competitors.push($root.Competitor.decode(reader, reader.uint32()));
                break;
            case 10:
                message.DetailCount = reader.int32();
                break;
            case 11:
                message.IsVmtCompetitor = reader.bool();
                break;
            case 12:
                message.GraphicsPresentationId = reader.int32();
                break;
            case 13:
                message.CategoryPath = reader.string();
                break;
            case 14:
                message.IsLive = reader.bool();
                break;
            case 15:
                if (!(message.SuperOddsPopularityStats && message.SuperOddsPopularityStats.length))
                    message.SuperOddsPopularityStats = [];
                message.SuperOddsPopularityStats.push($root.OddsPopularityStats.decode(reader, reader.uint32()));
                break;
            case 16:
                message.MarketingMessage = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an Event message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Event
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Event} Event
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Event.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an Event message.
     * @function verify
     * @memberof Event
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Event.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Id != null && message.hasOwnProperty("Id"))
            if (!$util.isInteger(message.Id))
                return "Id: integer expected";
        if (message.Name != null && message.hasOwnProperty("Name"))
            if (!$util.isString(message.Name))
                return "Name: string expected";
        if (message.Info != null && message.hasOwnProperty("Info"))
            if (!$util.isString(message.Info))
                return "Info: string expected";
        if (message.Date != null && message.hasOwnProperty("Date")) {
            var error = $root.Timestamp.verify(message.Date);
            if (error)
                return "Date." + error;
        }
        if (message.StatisticsExternalId != null && message.hasOwnProperty("StatisticsExternalId"))
            if (!$util.isString(message.StatisticsExternalId))
                return "StatisticsExternalId: string expected";
        if (message.GameGroups != null && message.hasOwnProperty("GameGroups")) {
            if (!Array.isArray(message.GameGroups))
                return "GameGroups: array expected";
            for (var i = 0; i < message.GameGroups.length; ++i) {
                var error = $root.GameGroup.verify(message.GameGroups[i]);
                if (error)
                    return "GameGroups." + error;
            }
        }
        if (message.CategoryId != null && message.hasOwnProperty("CategoryId"))
            if (!$util.isString(message.CategoryId))
                return "CategoryId: string expected";
        if (message.Tvs != null && message.hasOwnProperty("Tvs")) {
            if (!Array.isArray(message.Tvs))
                return "Tvs: array expected";
            for (var i = 0; i < message.Tvs.length; ++i) {
                var error = $root.Tv.verify(message.Tvs[i]);
                if (error)
                    return "Tvs." + error;
            }
        }
        if (message.Competitors != null && message.hasOwnProperty("Competitors")) {
            if (!Array.isArray(message.Competitors))
                return "Competitors: array expected";
            for (var i = 0; i < message.Competitors.length; ++i) {
                var error = $root.Competitor.verify(message.Competitors[i]);
                if (error)
                    return "Competitors." + error;
            }
        }
        if (message.DetailCount != null && message.hasOwnProperty("DetailCount"))
            if (!$util.isInteger(message.DetailCount))
                return "DetailCount: integer expected";
        if (message.IsVmtCompetitor != null && message.hasOwnProperty("IsVmtCompetitor"))
            if (typeof message.IsVmtCompetitor !== "boolean")
                return "IsVmtCompetitor: boolean expected";
        if (message.GraphicsPresentationId != null && message.hasOwnProperty("GraphicsPresentationId"))
            if (!$util.isInteger(message.GraphicsPresentationId))
                return "GraphicsPresentationId: integer expected";
        if (message.CategoryPath != null && message.hasOwnProperty("CategoryPath"))
            if (!$util.isString(message.CategoryPath))
                return "CategoryPath: string expected";
        if (message.IsLive != null && message.hasOwnProperty("IsLive"))
            if (typeof message.IsLive !== "boolean")
                return "IsLive: boolean expected";
        if (message.SuperOddsPopularityStats != null && message.hasOwnProperty("SuperOddsPopularityStats")) {
            if (!Array.isArray(message.SuperOddsPopularityStats))
                return "SuperOddsPopularityStats: array expected";
            for (var i = 0; i < message.SuperOddsPopularityStats.length; ++i) {
                var error = $root.OddsPopularityStats.verify(message.SuperOddsPopularityStats[i]);
                if (error)
                    return "SuperOddsPopularityStats." + error;
            }
        }
        if (message.MarketingMessage != null && message.hasOwnProperty("MarketingMessage"))
            if (!$util.isString(message.MarketingMessage))
                return "MarketingMessage: string expected";
        return null;
    };

    /**
     * Creates an Event message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Event
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Event} Event
     */
    Event.fromObject = function fromObject(object) {
        if (object instanceof $root.Event)
            return object;
        var message = new $root.Event();
        if (object.Id != null)
            message.Id = object.Id | 0;
        if (object.Name != null)
            message.Name = String(object.Name);
        if (object.Info != null)
            message.Info = String(object.Info);
        if (object.Date != null) {
            if (typeof object.Date !== "object")
                throw TypeError(".Event.Date: object expected");
            message.Date = $root.Timestamp.fromObject(object.Date);
        }
        if (object.StatisticsExternalId != null)
            message.StatisticsExternalId = String(object.StatisticsExternalId);
        if (object.GameGroups) {
            if (!Array.isArray(object.GameGroups))
                throw TypeError(".Event.GameGroups: array expected");
            message.GameGroups = [];
            for (var i = 0; i < object.GameGroups.length; ++i) {
                if (typeof object.GameGroups[i] !== "object")
                    throw TypeError(".Event.GameGroups: object expected");
                message.GameGroups[i] = $root.GameGroup.fromObject(object.GameGroups[i]);
            }
        }
        if (object.CategoryId != null)
            message.CategoryId = String(object.CategoryId);
        if (object.Tvs) {
            if (!Array.isArray(object.Tvs))
                throw TypeError(".Event.Tvs: array expected");
            message.Tvs = [];
            for (var i = 0; i < object.Tvs.length; ++i) {
                if (typeof object.Tvs[i] !== "object")
                    throw TypeError(".Event.Tvs: object expected");
                message.Tvs[i] = $root.Tv.fromObject(object.Tvs[i]);
            }
        }
        if (object.Competitors) {
            if (!Array.isArray(object.Competitors))
                throw TypeError(".Event.Competitors: array expected");
            message.Competitors = [];
            for (var i = 0; i < object.Competitors.length; ++i) {
                if (typeof object.Competitors[i] !== "object")
                    throw TypeError(".Event.Competitors: object expected");
                message.Competitors[i] = $root.Competitor.fromObject(object.Competitors[i]);
            }
        }
        if (object.DetailCount != null)
            message.DetailCount = object.DetailCount | 0;
        if (object.IsVmtCompetitor != null)
            message.IsVmtCompetitor = Boolean(object.IsVmtCompetitor);
        if (object.GraphicsPresentationId != null)
            message.GraphicsPresentationId = object.GraphicsPresentationId | 0;
        if (object.CategoryPath != null)
            message.CategoryPath = String(object.CategoryPath);
        if (object.IsLive != null)
            message.IsLive = Boolean(object.IsLive);
        if (object.SuperOddsPopularityStats) {
            if (!Array.isArray(object.SuperOddsPopularityStats))
                throw TypeError(".Event.SuperOddsPopularityStats: array expected");
            message.SuperOddsPopularityStats = [];
            for (var i = 0; i < object.SuperOddsPopularityStats.length; ++i) {
                if (typeof object.SuperOddsPopularityStats[i] !== "object")
                    throw TypeError(".Event.SuperOddsPopularityStats: object expected");
                message.SuperOddsPopularityStats[i] = $root.OddsPopularityStats.fromObject(object.SuperOddsPopularityStats[i]);
            }
        }
        if (object.MarketingMessage != null)
            message.MarketingMessage = String(object.MarketingMessage);
        return message;
    };

    /**
     * Creates a plain object from an Event message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Event
     * @static
     * @param {Event} message Event
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Event.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.GameGroups = [];
            object.Tvs = [];
            object.Competitors = [];
            object.SuperOddsPopularityStats = [];
        }
        if (options.defaults) {
            object.Id = 0;
            object.Name = "";
            object.Info = "";
            object.Date = null;
            object.StatisticsExternalId = "";
            object.CategoryId = "";
            object.DetailCount = 0;
            object.IsVmtCompetitor = false;
            object.GraphicsPresentationId = 0;
            object.CategoryPath = "";
            object.IsLive = false;
            object.MarketingMessage = "";
        }
        if (message.Id != null && message.hasOwnProperty("Id"))
            object.Id = message.Id;
        if (message.Name != null && message.hasOwnProperty("Name"))
            object.Name = message.Name;
        if (message.Info != null && message.hasOwnProperty("Info"))
            object.Info = message.Info;
        if (message.Date != null && message.hasOwnProperty("Date"))
            object.Date = $root.Timestamp.toObject(message.Date, options);
        if (message.StatisticsExternalId != null && message.hasOwnProperty("StatisticsExternalId"))
            object.StatisticsExternalId = message.StatisticsExternalId;
        if (message.GameGroups && message.GameGroups.length) {
            object.GameGroups = [];
            for (var j = 0; j < message.GameGroups.length; ++j)
                object.GameGroups[j] = $root.GameGroup.toObject(message.GameGroups[j], options);
        }
        if (message.CategoryId != null && message.hasOwnProperty("CategoryId"))
            object.CategoryId = message.CategoryId;
        if (message.Tvs && message.Tvs.length) {
            object.Tvs = [];
            for (var j = 0; j < message.Tvs.length; ++j)
                object.Tvs[j] = $root.Tv.toObject(message.Tvs[j], options);
        }
        if (message.Competitors && message.Competitors.length) {
            object.Competitors = [];
            for (var j = 0; j < message.Competitors.length; ++j)
                object.Competitors[j] = $root.Competitor.toObject(message.Competitors[j], options);
        }
        if (message.DetailCount != null && message.hasOwnProperty("DetailCount"))
            object.DetailCount = message.DetailCount;
        if (message.IsVmtCompetitor != null && message.hasOwnProperty("IsVmtCompetitor"))
            object.IsVmtCompetitor = message.IsVmtCompetitor;
        if (message.GraphicsPresentationId != null && message.hasOwnProperty("GraphicsPresentationId"))
            object.GraphicsPresentationId = message.GraphicsPresentationId;
        if (message.CategoryPath != null && message.hasOwnProperty("CategoryPath"))
            object.CategoryPath = message.CategoryPath;
        if (message.IsLive != null && message.hasOwnProperty("IsLive"))
            object.IsLive = message.IsLive;
        if (message.SuperOddsPopularityStats && message.SuperOddsPopularityStats.length) {
            object.SuperOddsPopularityStats = [];
            for (var j = 0; j < message.SuperOddsPopularityStats.length; ++j)
                object.SuperOddsPopularityStats[j] = $root.OddsPopularityStats.toObject(message.SuperOddsPopularityStats[j], options);
        }
        if (message.MarketingMessage != null && message.hasOwnProperty("MarketingMessage"))
            object.MarketingMessage = message.MarketingMessage;
        return object;
    };

    /**
     * Converts this Event to JSON.
     * @function toJSON
     * @memberof Event
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Event.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Event;
})();

$root.OddsPopularityStats = (function() {

    /**
     * Properties of an OddsPopularityStats.
     * @exports IOddsPopularityStats
     * @interface IOddsPopularityStats
     * @property {string|null} [TipID] OddsPopularityStats TipID
     * @property {string|null} [Name] OddsPopularityStats Name
     * @property {number|null} [Percentage] OddsPopularityStats Percentage
     */

    /**
     * Constructs a new OddsPopularityStats.
     * @exports OddsPopularityStats
     * @classdesc Represents an OddsPopularityStats.
     * @implements IOddsPopularityStats
     * @constructor
     * @param {IOddsPopularityStats=} [properties] Properties to set
     */
    function OddsPopularityStats(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * OddsPopularityStats TipID.
     * @member {string} TipID
     * @memberof OddsPopularityStats
     * @instance
     */
    OddsPopularityStats.prototype.TipID = "";

    /**
     * OddsPopularityStats Name.
     * @member {string} Name
     * @memberof OddsPopularityStats
     * @instance
     */
    OddsPopularityStats.prototype.Name = "";

    /**
     * OddsPopularityStats Percentage.
     * @member {number} Percentage
     * @memberof OddsPopularityStats
     * @instance
     */
    OddsPopularityStats.prototype.Percentage = 0;

    /**
     * Creates a new OddsPopularityStats instance using the specified properties.
     * @function create
     * @memberof OddsPopularityStats
     * @static
     * @param {IOddsPopularityStats=} [properties] Properties to set
     * @returns {OddsPopularityStats} OddsPopularityStats instance
     */
    OddsPopularityStats.create = function create(properties) {
        return new OddsPopularityStats(properties);
    };

    /**
     * Encodes the specified OddsPopularityStats message. Does not implicitly {@link OddsPopularityStats.verify|verify} messages.
     * @function encode
     * @memberof OddsPopularityStats
     * @static
     * @param {IOddsPopularityStats} message OddsPopularityStats message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OddsPopularityStats.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.TipID != null && message.hasOwnProperty("TipID"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.TipID);
        if (message.Name != null && message.hasOwnProperty("Name"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.Name);
        if (message.Percentage != null && message.hasOwnProperty("Percentage"))
            writer.uint32(/* id 3, wireType 5 =*/29).float(message.Percentage);
        return writer;
    };

    /**
     * Encodes the specified OddsPopularityStats message, length delimited. Does not implicitly {@link OddsPopularityStats.verify|verify} messages.
     * @function encodeDelimited
     * @memberof OddsPopularityStats
     * @static
     * @param {IOddsPopularityStats} message OddsPopularityStats message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    OddsPopularityStats.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an OddsPopularityStats message from the specified reader or buffer.
     * @function decode
     * @memberof OddsPopularityStats
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {OddsPopularityStats} OddsPopularityStats
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OddsPopularityStats.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.OddsPopularityStats();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.TipID = reader.string();
                break;
            case 2:
                message.Name = reader.string();
                break;
            case 3:
                message.Percentage = reader.float();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an OddsPopularityStats message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof OddsPopularityStats
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {OddsPopularityStats} OddsPopularityStats
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    OddsPopularityStats.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an OddsPopularityStats message.
     * @function verify
     * @memberof OddsPopularityStats
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    OddsPopularityStats.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.TipID != null && message.hasOwnProperty("TipID"))
            if (!$util.isString(message.TipID))
                return "TipID: string expected";
        if (message.Name != null && message.hasOwnProperty("Name"))
            if (!$util.isString(message.Name))
                return "Name: string expected";
        if (message.Percentage != null && message.hasOwnProperty("Percentage"))
            if (typeof message.Percentage !== "number")
                return "Percentage: number expected";
        return null;
    };

    /**
     * Creates an OddsPopularityStats message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof OddsPopularityStats
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {OddsPopularityStats} OddsPopularityStats
     */
    OddsPopularityStats.fromObject = function fromObject(object) {
        if (object instanceof $root.OddsPopularityStats)
            return object;
        var message = new $root.OddsPopularityStats();
        if (object.TipID != null)
            message.TipID = String(object.TipID);
        if (object.Name != null)
            message.Name = String(object.Name);
        if (object.Percentage != null)
            message.Percentage = Number(object.Percentage);
        return message;
    };

    /**
     * Creates a plain object from an OddsPopularityStats message. Also converts values to other types if specified.
     * @function toObject
     * @memberof OddsPopularityStats
     * @static
     * @param {OddsPopularityStats} message OddsPopularityStats
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    OddsPopularityStats.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.TipID = "";
            object.Name = "";
            object.Percentage = 0;
        }
        if (message.TipID != null && message.hasOwnProperty("TipID"))
            object.TipID = message.TipID;
        if (message.Name != null && message.hasOwnProperty("Name"))
            object.Name = message.Name;
        if (message.Percentage != null && message.hasOwnProperty("Percentage"))
            object.Percentage = options.json && !isFinite(message.Percentage) ? String(message.Percentage) : message.Percentage;
        return object;
    };

    /**
     * Converts this OddsPopularityStats to JSON.
     * @function toJSON
     * @memberof OddsPopularityStats
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    OddsPopularityStats.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return OddsPopularityStats;
})();

$root.MobileCategory = (function() {

    /**
     * Properties of a MobileCategory.
     * @exports IMobileCategory
     * @interface IMobileCategory
     * @property {string|null} [Category2Name] MobileCategory Category2Name
     * @property {string|null} [Category3Name] MobileCategory Category3Name
     * @property {string|null} [Category2Id] MobileCategory Category2Id
     * @property {string|null} [Category3Id] MobileCategory Category3Id
     * @property {boolean|null} [HasLive] MobileCategory HasLive
     * @property {Array.<string>|null} [OriginalCategories] MobileCategory OriginalCategories
     */

    /**
     * Constructs a new MobileCategory.
     * @exports MobileCategory
     * @classdesc Represents a MobileCategory.
     * @implements IMobileCategory
     * @constructor
     * @param {IMobileCategory=} [properties] Properties to set
     */
    function MobileCategory(properties) {
        this.OriginalCategories = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * MobileCategory Category2Name.
     * @member {string} Category2Name
     * @memberof MobileCategory
     * @instance
     */
    MobileCategory.prototype.Category2Name = "";

    /**
     * MobileCategory Category3Name.
     * @member {string} Category3Name
     * @memberof MobileCategory
     * @instance
     */
    MobileCategory.prototype.Category3Name = "";

    /**
     * MobileCategory Category2Id.
     * @member {string} Category2Id
     * @memberof MobileCategory
     * @instance
     */
    MobileCategory.prototype.Category2Id = "";

    /**
     * MobileCategory Category3Id.
     * @member {string} Category3Id
     * @memberof MobileCategory
     * @instance
     */
    MobileCategory.prototype.Category3Id = "";

    /**
     * MobileCategory HasLive.
     * @member {boolean} HasLive
     * @memberof MobileCategory
     * @instance
     */
    MobileCategory.prototype.HasLive = false;

    /**
     * MobileCategory OriginalCategories.
     * @member {Array.<string>} OriginalCategories
     * @memberof MobileCategory
     * @instance
     */
    MobileCategory.prototype.OriginalCategories = $util.emptyArray;

    /**
     * Creates a new MobileCategory instance using the specified properties.
     * @function create
     * @memberof MobileCategory
     * @static
     * @param {IMobileCategory=} [properties] Properties to set
     * @returns {MobileCategory} MobileCategory instance
     */
    MobileCategory.create = function create(properties) {
        return new MobileCategory(properties);
    };

    /**
     * Encodes the specified MobileCategory message. Does not implicitly {@link MobileCategory.verify|verify} messages.
     * @function encode
     * @memberof MobileCategory
     * @static
     * @param {IMobileCategory} message MobileCategory message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MobileCategory.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Category2Name != null && message.hasOwnProperty("Category2Name"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.Category2Name);
        if (message.Category3Name != null && message.hasOwnProperty("Category3Name"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.Category3Name);
        if (message.Category2Id != null && message.hasOwnProperty("Category2Id"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.Category2Id);
        if (message.Category3Id != null && message.hasOwnProperty("Category3Id"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.Category3Id);
        if (message.HasLive != null && message.hasOwnProperty("HasLive"))
            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.HasLive);
        if (message.OriginalCategories != null && message.OriginalCategories.length)
            for (var i = 0; i < message.OriginalCategories.length; ++i)
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.OriginalCategories[i]);
        return writer;
    };

    /**
     * Encodes the specified MobileCategory message, length delimited. Does not implicitly {@link MobileCategory.verify|verify} messages.
     * @function encodeDelimited
     * @memberof MobileCategory
     * @static
     * @param {IMobileCategory} message MobileCategory message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MobileCategory.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a MobileCategory message from the specified reader or buffer.
     * @function decode
     * @memberof MobileCategory
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {MobileCategory} MobileCategory
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MobileCategory.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MobileCategory();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Category2Name = reader.string();
                break;
            case 2:
                message.Category3Name = reader.string();
                break;
            case 3:
                message.Category2Id = reader.string();
                break;
            case 4:
                message.Category3Id = reader.string();
                break;
            case 5:
                message.HasLive = reader.bool();
                break;
            case 6:
                if (!(message.OriginalCategories && message.OriginalCategories.length))
                    message.OriginalCategories = [];
                message.OriginalCategories.push(reader.string());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a MobileCategory message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof MobileCategory
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {MobileCategory} MobileCategory
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MobileCategory.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a MobileCategory message.
     * @function verify
     * @memberof MobileCategory
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    MobileCategory.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Category2Name != null && message.hasOwnProperty("Category2Name"))
            if (!$util.isString(message.Category2Name))
                return "Category2Name: string expected";
        if (message.Category3Name != null && message.hasOwnProperty("Category3Name"))
            if (!$util.isString(message.Category3Name))
                return "Category3Name: string expected";
        if (message.Category2Id != null && message.hasOwnProperty("Category2Id"))
            if (!$util.isString(message.Category2Id))
                return "Category2Id: string expected";
        if (message.Category3Id != null && message.hasOwnProperty("Category3Id"))
            if (!$util.isString(message.Category3Id))
                return "Category3Id: string expected";
        if (message.HasLive != null && message.hasOwnProperty("HasLive"))
            if (typeof message.HasLive !== "boolean")
                return "HasLive: boolean expected";
        if (message.OriginalCategories != null && message.hasOwnProperty("OriginalCategories")) {
            if (!Array.isArray(message.OriginalCategories))
                return "OriginalCategories: array expected";
            for (var i = 0; i < message.OriginalCategories.length; ++i)
                if (!$util.isString(message.OriginalCategories[i]))
                    return "OriginalCategories: string[] expected";
        }
        return null;
    };

    /**
     * Creates a MobileCategory message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof MobileCategory
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {MobileCategory} MobileCategory
     */
    MobileCategory.fromObject = function fromObject(object) {
        if (object instanceof $root.MobileCategory)
            return object;
        var message = new $root.MobileCategory();
        if (object.Category2Name != null)
            message.Category2Name = String(object.Category2Name);
        if (object.Category3Name != null)
            message.Category3Name = String(object.Category3Name);
        if (object.Category2Id != null)
            message.Category2Id = String(object.Category2Id);
        if (object.Category3Id != null)
            message.Category3Id = String(object.Category3Id);
        if (object.HasLive != null)
            message.HasLive = Boolean(object.HasLive);
        if (object.OriginalCategories) {
            if (!Array.isArray(object.OriginalCategories))
                throw TypeError(".MobileCategory.OriginalCategories: array expected");
            message.OriginalCategories = [];
            for (var i = 0; i < object.OriginalCategories.length; ++i)
                message.OriginalCategories[i] = String(object.OriginalCategories[i]);
        }
        return message;
    };

    /**
     * Creates a plain object from a MobileCategory message. Also converts values to other types if specified.
     * @function toObject
     * @memberof MobileCategory
     * @static
     * @param {MobileCategory} message MobileCategory
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MobileCategory.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.OriginalCategories = [];
        if (options.defaults) {
            object.Category2Name = "";
            object.Category3Name = "";
            object.Category2Id = "";
            object.Category3Id = "";
            object.HasLive = false;
        }
        if (message.Category2Name != null && message.hasOwnProperty("Category2Name"))
            object.Category2Name = message.Category2Name;
        if (message.Category3Name != null && message.hasOwnProperty("Category3Name"))
            object.Category3Name = message.Category3Name;
        if (message.Category2Id != null && message.hasOwnProperty("Category2Id"))
            object.Category2Id = message.Category2Id;
        if (message.Category3Id != null && message.hasOwnProperty("Category3Id"))
            object.Category3Id = message.Category3Id;
        if (message.HasLive != null && message.hasOwnProperty("HasLive"))
            object.HasLive = message.HasLive;
        if (message.OriginalCategories && message.OriginalCategories.length) {
            object.OriginalCategories = [];
            for (var j = 0; j < message.OriginalCategories.length; ++j)
                object.OriginalCategories[j] = message.OriginalCategories[j];
        }
        return object;
    };

    /**
     * Converts this MobileCategory to JSON.
     * @function toJSON
     * @memberof MobileCategory
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MobileCategory.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MobileCategory;
})();

$root.MobileSearchResult = (function() {

    /**
     * Properties of a MobileSearchResult.
     * @exports IMobileSearchResult
     * @interface IMobileSearchResult
     * @property {string|null} [Id] MobileSearchResult Id
     * @property {number|null} [GraphicsPresentationId] MobileSearchResult GraphicsPresentationId
     * @property {string|null} [Name] MobileSearchResult Name
     * @property {string|null} [Path] MobileSearchResult Path
     * @property {boolean|null} [IsLive] MobileSearchResult IsLive
     * @property {string|null} [SportCategoryId] MobileSearchResult SportCategoryId
     */

    /**
     * Constructs a new MobileSearchResult.
     * @exports MobileSearchResult
     * @classdesc Represents a MobileSearchResult.
     * @implements IMobileSearchResult
     * @constructor
     * @param {IMobileSearchResult=} [properties] Properties to set
     */
    function MobileSearchResult(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * MobileSearchResult Id.
     * @member {string} Id
     * @memberof MobileSearchResult
     * @instance
     */
    MobileSearchResult.prototype.Id = "";

    /**
     * MobileSearchResult GraphicsPresentationId.
     * @member {number} GraphicsPresentationId
     * @memberof MobileSearchResult
     * @instance
     */
    MobileSearchResult.prototype.GraphicsPresentationId = 0;

    /**
     * MobileSearchResult Name.
     * @member {string} Name
     * @memberof MobileSearchResult
     * @instance
     */
    MobileSearchResult.prototype.Name = "";

    /**
     * MobileSearchResult Path.
     * @member {string} Path
     * @memberof MobileSearchResult
     * @instance
     */
    MobileSearchResult.prototype.Path = "";

    /**
     * MobileSearchResult IsLive.
     * @member {boolean} IsLive
     * @memberof MobileSearchResult
     * @instance
     */
    MobileSearchResult.prototype.IsLive = false;

    /**
     * MobileSearchResult SportCategoryId.
     * @member {string} SportCategoryId
     * @memberof MobileSearchResult
     * @instance
     */
    MobileSearchResult.prototype.SportCategoryId = "";

    /**
     * Creates a new MobileSearchResult instance using the specified properties.
     * @function create
     * @memberof MobileSearchResult
     * @static
     * @param {IMobileSearchResult=} [properties] Properties to set
     * @returns {MobileSearchResult} MobileSearchResult instance
     */
    MobileSearchResult.create = function create(properties) {
        return new MobileSearchResult(properties);
    };

    /**
     * Encodes the specified MobileSearchResult message. Does not implicitly {@link MobileSearchResult.verify|verify} messages.
     * @function encode
     * @memberof MobileSearchResult
     * @static
     * @param {IMobileSearchResult} message MobileSearchResult message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MobileSearchResult.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Id != null && message.hasOwnProperty("Id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.Id);
        if (message.GraphicsPresentationId != null && message.hasOwnProperty("GraphicsPresentationId"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.GraphicsPresentationId);
        if (message.Name != null && message.hasOwnProperty("Name"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.Name);
        if (message.Path != null && message.hasOwnProperty("Path"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.Path);
        if (message.IsLive != null && message.hasOwnProperty("IsLive"))
            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.IsLive);
        if (message.SportCategoryId != null && message.hasOwnProperty("SportCategoryId"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.SportCategoryId);
        return writer;
    };

    /**
     * Encodes the specified MobileSearchResult message, length delimited. Does not implicitly {@link MobileSearchResult.verify|verify} messages.
     * @function encodeDelimited
     * @memberof MobileSearchResult
     * @static
     * @param {IMobileSearchResult} message MobileSearchResult message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MobileSearchResult.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a MobileSearchResult message from the specified reader or buffer.
     * @function decode
     * @memberof MobileSearchResult
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {MobileSearchResult} MobileSearchResult
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MobileSearchResult.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MobileSearchResult();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Id = reader.string();
                break;
            case 2:
                message.GraphicsPresentationId = reader.int32();
                break;
            case 3:
                message.Name = reader.string();
                break;
            case 4:
                message.Path = reader.string();
                break;
            case 5:
                message.IsLive = reader.bool();
                break;
            case 6:
                message.SportCategoryId = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a MobileSearchResult message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof MobileSearchResult
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {MobileSearchResult} MobileSearchResult
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MobileSearchResult.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a MobileSearchResult message.
     * @function verify
     * @memberof MobileSearchResult
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    MobileSearchResult.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Id != null && message.hasOwnProperty("Id"))
            if (!$util.isString(message.Id))
                return "Id: string expected";
        if (message.GraphicsPresentationId != null && message.hasOwnProperty("GraphicsPresentationId"))
            if (!$util.isInteger(message.GraphicsPresentationId))
                return "GraphicsPresentationId: integer expected";
        if (message.Name != null && message.hasOwnProperty("Name"))
            if (!$util.isString(message.Name))
                return "Name: string expected";
        if (message.Path != null && message.hasOwnProperty("Path"))
            if (!$util.isString(message.Path))
                return "Path: string expected";
        if (message.IsLive != null && message.hasOwnProperty("IsLive"))
            if (typeof message.IsLive !== "boolean")
                return "IsLive: boolean expected";
        if (message.SportCategoryId != null && message.hasOwnProperty("SportCategoryId"))
            if (!$util.isString(message.SportCategoryId))
                return "SportCategoryId: string expected";
        return null;
    };

    /**
     * Creates a MobileSearchResult message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof MobileSearchResult
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {MobileSearchResult} MobileSearchResult
     */
    MobileSearchResult.fromObject = function fromObject(object) {
        if (object instanceof $root.MobileSearchResult)
            return object;
        var message = new $root.MobileSearchResult();
        if (object.Id != null)
            message.Id = String(object.Id);
        if (object.GraphicsPresentationId != null)
            message.GraphicsPresentationId = object.GraphicsPresentationId | 0;
        if (object.Name != null)
            message.Name = String(object.Name);
        if (object.Path != null)
            message.Path = String(object.Path);
        if (object.IsLive != null)
            message.IsLive = Boolean(object.IsLive);
        if (object.SportCategoryId != null)
            message.SportCategoryId = String(object.SportCategoryId);
        return message;
    };

    /**
     * Creates a plain object from a MobileSearchResult message. Also converts values to other types if specified.
     * @function toObject
     * @memberof MobileSearchResult
     * @static
     * @param {MobileSearchResult} message MobileSearchResult
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MobileSearchResult.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.Id = "";
            object.GraphicsPresentationId = 0;
            object.Name = "";
            object.Path = "";
            object.IsLive = false;
            object.SportCategoryId = "";
        }
        if (message.Id != null && message.hasOwnProperty("Id"))
            object.Id = message.Id;
        if (message.GraphicsPresentationId != null && message.hasOwnProperty("GraphicsPresentationId"))
            object.GraphicsPresentationId = message.GraphicsPresentationId;
        if (message.Name != null && message.hasOwnProperty("Name"))
            object.Name = message.Name;
        if (message.Path != null && message.hasOwnProperty("Path"))
            object.Path = message.Path;
        if (message.IsLive != null && message.hasOwnProperty("IsLive"))
            object.IsLive = message.IsLive;
        if (message.SportCategoryId != null && message.hasOwnProperty("SportCategoryId"))
            object.SportCategoryId = message.SportCategoryId;
        return object;
    };

    /**
     * Converts this MobileSearchResult to JSON.
     * @function toJSON
     * @memberof MobileSearchResult
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MobileSearchResult.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MobileSearchResult;
})();

$root.MobileSearchResponse = (function() {

    /**
     * Properties of a MobileSearchResponse.
     * @exports IMobileSearchResponse
     * @interface IMobileSearchResponse
     * @property {Array.<IMobileSearchResult>|null} [Events] MobileSearchResponse Events
     * @property {Array.<IMobileSearchResult>|null} [Categories] MobileSearchResponse Categories
     */

    /**
     * Constructs a new MobileSearchResponse.
     * @exports MobileSearchResponse
     * @classdesc Represents a MobileSearchResponse.
     * @implements IMobileSearchResponse
     * @constructor
     * @param {IMobileSearchResponse=} [properties] Properties to set
     */
    function MobileSearchResponse(properties) {
        this.Events = [];
        this.Categories = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * MobileSearchResponse Events.
     * @member {Array.<IMobileSearchResult>} Events
     * @memberof MobileSearchResponse
     * @instance
     */
    MobileSearchResponse.prototype.Events = $util.emptyArray;

    /**
     * MobileSearchResponse Categories.
     * @member {Array.<IMobileSearchResult>} Categories
     * @memberof MobileSearchResponse
     * @instance
     */
    MobileSearchResponse.prototype.Categories = $util.emptyArray;

    /**
     * Creates a new MobileSearchResponse instance using the specified properties.
     * @function create
     * @memberof MobileSearchResponse
     * @static
     * @param {IMobileSearchResponse=} [properties] Properties to set
     * @returns {MobileSearchResponse} MobileSearchResponse instance
     */
    MobileSearchResponse.create = function create(properties) {
        return new MobileSearchResponse(properties);
    };

    /**
     * Encodes the specified MobileSearchResponse message. Does not implicitly {@link MobileSearchResponse.verify|verify} messages.
     * @function encode
     * @memberof MobileSearchResponse
     * @static
     * @param {IMobileSearchResponse} message MobileSearchResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MobileSearchResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Events != null && message.Events.length)
            for (var i = 0; i < message.Events.length; ++i)
                $root.MobileSearchResult.encode(message.Events[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.Categories != null && message.Categories.length)
            for (var i = 0; i < message.Categories.length; ++i)
                $root.MobileSearchResult.encode(message.Categories[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified MobileSearchResponse message, length delimited. Does not implicitly {@link MobileSearchResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof MobileSearchResponse
     * @static
     * @param {IMobileSearchResponse} message MobileSearchResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MobileSearchResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a MobileSearchResponse message from the specified reader or buffer.
     * @function decode
     * @memberof MobileSearchResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {MobileSearchResponse} MobileSearchResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MobileSearchResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MobileSearchResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.Events && message.Events.length))
                    message.Events = [];
                message.Events.push($root.MobileSearchResult.decode(reader, reader.uint32()));
                break;
            case 2:
                if (!(message.Categories && message.Categories.length))
                    message.Categories = [];
                message.Categories.push($root.MobileSearchResult.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a MobileSearchResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof MobileSearchResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {MobileSearchResponse} MobileSearchResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MobileSearchResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a MobileSearchResponse message.
     * @function verify
     * @memberof MobileSearchResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    MobileSearchResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Events != null && message.hasOwnProperty("Events")) {
            if (!Array.isArray(message.Events))
                return "Events: array expected";
            for (var i = 0; i < message.Events.length; ++i) {
                var error = $root.MobileSearchResult.verify(message.Events[i]);
                if (error)
                    return "Events." + error;
            }
        }
        if (message.Categories != null && message.hasOwnProperty("Categories")) {
            if (!Array.isArray(message.Categories))
                return "Categories: array expected";
            for (var i = 0; i < message.Categories.length; ++i) {
                var error = $root.MobileSearchResult.verify(message.Categories[i]);
                if (error)
                    return "Categories." + error;
            }
        }
        return null;
    };

    /**
     * Creates a MobileSearchResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof MobileSearchResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {MobileSearchResponse} MobileSearchResponse
     */
    MobileSearchResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.MobileSearchResponse)
            return object;
        var message = new $root.MobileSearchResponse();
        if (object.Events) {
            if (!Array.isArray(object.Events))
                throw TypeError(".MobileSearchResponse.Events: array expected");
            message.Events = [];
            for (var i = 0; i < object.Events.length; ++i) {
                if (typeof object.Events[i] !== "object")
                    throw TypeError(".MobileSearchResponse.Events: object expected");
                message.Events[i] = $root.MobileSearchResult.fromObject(object.Events[i]);
            }
        }
        if (object.Categories) {
            if (!Array.isArray(object.Categories))
                throw TypeError(".MobileSearchResponse.Categories: array expected");
            message.Categories = [];
            for (var i = 0; i < object.Categories.length; ++i) {
                if (typeof object.Categories[i] !== "object")
                    throw TypeError(".MobileSearchResponse.Categories: object expected");
                message.Categories[i] = $root.MobileSearchResult.fromObject(object.Categories[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a MobileSearchResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof MobileSearchResponse
     * @static
     * @param {MobileSearchResponse} message MobileSearchResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MobileSearchResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.Events = [];
            object.Categories = [];
        }
        if (message.Events && message.Events.length) {
            object.Events = [];
            for (var j = 0; j < message.Events.length; ++j)
                object.Events[j] = $root.MobileSearchResult.toObject(message.Events[j], options);
        }
        if (message.Categories && message.Categories.length) {
            object.Categories = [];
            for (var j = 0; j < message.Categories.length; ++j)
                object.Categories[j] = $root.MobileSearchResult.toObject(message.Categories[j], options);
        }
        return object;
    };

    /**
     * Converts this MobileSearchResponse to JSON.
     * @function toJSON
     * @memberof MobileSearchResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MobileSearchResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MobileSearchResponse;
})();

$root.GetWebStandardEventResponse = (function() {

    /**
     * Properties of a GetWebStandardEventResponse.
     * @exports IGetWebStandardEventResponse
     * @interface IGetWebStandardEventResponse
     * @property {IFirstLevelCategory|null} [EventTree] GetWebStandardEventResponse EventTree
     * @property {number|null} [TimeStamp] GetWebStandardEventResponse TimeStamp
     */

    /**
     * Constructs a new GetWebStandardEventResponse.
     * @exports GetWebStandardEventResponse
     * @classdesc Represents a GetWebStandardEventResponse.
     * @implements IGetWebStandardEventResponse
     * @constructor
     * @param {IGetWebStandardEventResponse=} [properties] Properties to set
     */
    function GetWebStandardEventResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GetWebStandardEventResponse EventTree.
     * @member {IFirstLevelCategory|null|undefined} EventTree
     * @memberof GetWebStandardEventResponse
     * @instance
     */
    GetWebStandardEventResponse.prototype.EventTree = null;

    /**
     * GetWebStandardEventResponse TimeStamp.
     * @member {number} TimeStamp
     * @memberof GetWebStandardEventResponse
     * @instance
     */
    GetWebStandardEventResponse.prototype.TimeStamp = 0;

    /**
     * Creates a new GetWebStandardEventResponse instance using the specified properties.
     * @function create
     * @memberof GetWebStandardEventResponse
     * @static
     * @param {IGetWebStandardEventResponse=} [properties] Properties to set
     * @returns {GetWebStandardEventResponse} GetWebStandardEventResponse instance
     */
    GetWebStandardEventResponse.create = function create(properties) {
        return new GetWebStandardEventResponse(properties);
    };

    /**
     * Encodes the specified GetWebStandardEventResponse message. Does not implicitly {@link GetWebStandardEventResponse.verify|verify} messages.
     * @function encode
     * @memberof GetWebStandardEventResponse
     * @static
     * @param {IGetWebStandardEventResponse} message GetWebStandardEventResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetWebStandardEventResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.EventTree != null && message.hasOwnProperty("EventTree"))
            $root.FirstLevelCategory.encode(message.EventTree, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.TimeStamp != null && message.hasOwnProperty("TimeStamp"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.TimeStamp);
        return writer;
    };

    /**
     * Encodes the specified GetWebStandardEventResponse message, length delimited. Does not implicitly {@link GetWebStandardEventResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GetWebStandardEventResponse
     * @static
     * @param {IGetWebStandardEventResponse} message GetWebStandardEventResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetWebStandardEventResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GetWebStandardEventResponse message from the specified reader or buffer.
     * @function decode
     * @memberof GetWebStandardEventResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GetWebStandardEventResponse} GetWebStandardEventResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetWebStandardEventResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetWebStandardEventResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.EventTree = $root.FirstLevelCategory.decode(reader, reader.uint32());
                break;
            case 2:
                message.TimeStamp = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GetWebStandardEventResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GetWebStandardEventResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GetWebStandardEventResponse} GetWebStandardEventResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetWebStandardEventResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GetWebStandardEventResponse message.
     * @function verify
     * @memberof GetWebStandardEventResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GetWebStandardEventResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.EventTree != null && message.hasOwnProperty("EventTree")) {
            var error = $root.FirstLevelCategory.verify(message.EventTree);
            if (error)
                return "EventTree." + error;
        }
        if (message.TimeStamp != null && message.hasOwnProperty("TimeStamp"))
            if (!$util.isInteger(message.TimeStamp))
                return "TimeStamp: integer expected";
        return null;
    };

    /**
     * Creates a GetWebStandardEventResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GetWebStandardEventResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GetWebStandardEventResponse} GetWebStandardEventResponse
     */
    GetWebStandardEventResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.GetWebStandardEventResponse)
            return object;
        var message = new $root.GetWebStandardEventResponse();
        if (object.EventTree != null) {
            if (typeof object.EventTree !== "object")
                throw TypeError(".GetWebStandardEventResponse.EventTree: object expected");
            message.EventTree = $root.FirstLevelCategory.fromObject(object.EventTree);
        }
        if (object.TimeStamp != null)
            message.TimeStamp = object.TimeStamp | 0;
        return message;
    };

    /**
     * Creates a plain object from a GetWebStandardEventResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GetWebStandardEventResponse
     * @static
     * @param {GetWebStandardEventResponse} message GetWebStandardEventResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GetWebStandardEventResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.EventTree = null;
            object.TimeStamp = 0;
        }
        if (message.EventTree != null && message.hasOwnProperty("EventTree"))
            object.EventTree = $root.FirstLevelCategory.toObject(message.EventTree, options);
        if (message.TimeStamp != null && message.hasOwnProperty("TimeStamp"))
            object.TimeStamp = message.TimeStamp;
        return object;
    };

    /**
     * Converts this GetWebStandardEventResponse to JSON.
     * @function toJSON
     * @memberof GetWebStandardEventResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GetWebStandardEventResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GetWebStandardEventResponse;
})();

$root.GetWebStandardEventExtResponse = (function() {

    /**
     * Properties of a GetWebStandardEventExtResponse.
     * @exports IGetWebStandardEventExtResponse
     * @interface IGetWebStandardEventExtResponse
     * @property {IGetWebStandardEventResponse|null} [Event] GetWebStandardEventExtResponse Event
     * @property {boolean|null} [IsLiveAvailable] GetWebStandardEventExtResponse IsLiveAvailable
     */

    /**
     * Constructs a new GetWebStandardEventExtResponse.
     * @exports GetWebStandardEventExtResponse
     * @classdesc Represents a GetWebStandardEventExtResponse.
     * @implements IGetWebStandardEventExtResponse
     * @constructor
     * @param {IGetWebStandardEventExtResponse=} [properties] Properties to set
     */
    function GetWebStandardEventExtResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GetWebStandardEventExtResponse Event.
     * @member {IGetWebStandardEventResponse|null|undefined} Event
     * @memberof GetWebStandardEventExtResponse
     * @instance
     */
    GetWebStandardEventExtResponse.prototype.Event = null;

    /**
     * GetWebStandardEventExtResponse IsLiveAvailable.
     * @member {boolean} IsLiveAvailable
     * @memberof GetWebStandardEventExtResponse
     * @instance
     */
    GetWebStandardEventExtResponse.prototype.IsLiveAvailable = false;

    /**
     * Creates a new GetWebStandardEventExtResponse instance using the specified properties.
     * @function create
     * @memberof GetWebStandardEventExtResponse
     * @static
     * @param {IGetWebStandardEventExtResponse=} [properties] Properties to set
     * @returns {GetWebStandardEventExtResponse} GetWebStandardEventExtResponse instance
     */
    GetWebStandardEventExtResponse.create = function create(properties) {
        return new GetWebStandardEventExtResponse(properties);
    };

    /**
     * Encodes the specified GetWebStandardEventExtResponse message. Does not implicitly {@link GetWebStandardEventExtResponse.verify|verify} messages.
     * @function encode
     * @memberof GetWebStandardEventExtResponse
     * @static
     * @param {IGetWebStandardEventExtResponse} message GetWebStandardEventExtResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetWebStandardEventExtResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Event != null && message.hasOwnProperty("Event"))
            $root.GetWebStandardEventResponse.encode(message.Event, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.IsLiveAvailable != null && message.hasOwnProperty("IsLiveAvailable"))
            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.IsLiveAvailable);
        return writer;
    };

    /**
     * Encodes the specified GetWebStandardEventExtResponse message, length delimited. Does not implicitly {@link GetWebStandardEventExtResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GetWebStandardEventExtResponse
     * @static
     * @param {IGetWebStandardEventExtResponse} message GetWebStandardEventExtResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetWebStandardEventExtResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GetWebStandardEventExtResponse message from the specified reader or buffer.
     * @function decode
     * @memberof GetWebStandardEventExtResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GetWebStandardEventExtResponse} GetWebStandardEventExtResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetWebStandardEventExtResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetWebStandardEventExtResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Event = $root.GetWebStandardEventResponse.decode(reader, reader.uint32());
                break;
            case 2:
                message.IsLiveAvailable = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GetWebStandardEventExtResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GetWebStandardEventExtResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GetWebStandardEventExtResponse} GetWebStandardEventExtResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetWebStandardEventExtResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GetWebStandardEventExtResponse message.
     * @function verify
     * @memberof GetWebStandardEventExtResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GetWebStandardEventExtResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Event != null && message.hasOwnProperty("Event")) {
            var error = $root.GetWebStandardEventResponse.verify(message.Event);
            if (error)
                return "Event." + error;
        }
        if (message.IsLiveAvailable != null && message.hasOwnProperty("IsLiveAvailable"))
            if (typeof message.IsLiveAvailable !== "boolean")
                return "IsLiveAvailable: boolean expected";
        return null;
    };

    /**
     * Creates a GetWebStandardEventExtResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GetWebStandardEventExtResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GetWebStandardEventExtResponse} GetWebStandardEventExtResponse
     */
    GetWebStandardEventExtResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.GetWebStandardEventExtResponse)
            return object;
        var message = new $root.GetWebStandardEventExtResponse();
        if (object.Event != null) {
            if (typeof object.Event !== "object")
                throw TypeError(".GetWebStandardEventExtResponse.Event: object expected");
            message.Event = $root.GetWebStandardEventResponse.fromObject(object.Event);
        }
        if (object.IsLiveAvailable != null)
            message.IsLiveAvailable = Boolean(object.IsLiveAvailable);
        return message;
    };

    /**
     * Creates a plain object from a GetWebStandardEventExtResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GetWebStandardEventExtResponse
     * @static
     * @param {GetWebStandardEventExtResponse} message GetWebStandardEventExtResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GetWebStandardEventExtResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.Event = null;
            object.IsLiveAvailable = false;
        }
        if (message.Event != null && message.hasOwnProperty("Event"))
            object.Event = $root.GetWebStandardEventResponse.toObject(message.Event, options);
        if (message.IsLiveAvailable != null && message.hasOwnProperty("IsLiveAvailable"))
            object.IsLiveAvailable = message.IsLiveAvailable;
        return object;
    };

    /**
     * Converts this GetWebStandardEventExtResponse to JSON.
     * @function toJSON
     * @memberof GetWebStandardEventExtResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GetWebStandardEventExtResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GetWebStandardEventExtResponse;
})();

$root.GetWebStandardEventsResponse = (function() {

    /**
     * Properties of a GetWebStandardEventsResponse.
     * @exports IGetWebStandardEventsResponse
     * @interface IGetWebStandardEventsResponse
     * @property {IFirstLevelCategory|null} [EventTree] GetWebStandardEventsResponse EventTree
     * @property {Array.<IGameFilterItem>|null} [AvailableGames] GetWebStandardEventsResponse AvailableGames
     * @property {number|null} [UnpaginatedEventCount] GetWebStandardEventsResponse UnpaginatedEventCount
     */

    /**
     * Constructs a new GetWebStandardEventsResponse.
     * @exports GetWebStandardEventsResponse
     * @classdesc Represents a GetWebStandardEventsResponse.
     * @implements IGetWebStandardEventsResponse
     * @constructor
     * @param {IGetWebStandardEventsResponse=} [properties] Properties to set
     */
    function GetWebStandardEventsResponse(properties) {
        this.AvailableGames = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GetWebStandardEventsResponse EventTree.
     * @member {IFirstLevelCategory|null|undefined} EventTree
     * @memberof GetWebStandardEventsResponse
     * @instance
     */
    GetWebStandardEventsResponse.prototype.EventTree = null;

    /**
     * GetWebStandardEventsResponse AvailableGames.
     * @member {Array.<IGameFilterItem>} AvailableGames
     * @memberof GetWebStandardEventsResponse
     * @instance
     */
    GetWebStandardEventsResponse.prototype.AvailableGames = $util.emptyArray;

    /**
     * GetWebStandardEventsResponse UnpaginatedEventCount.
     * @member {number} UnpaginatedEventCount
     * @memberof GetWebStandardEventsResponse
     * @instance
     */
    GetWebStandardEventsResponse.prototype.UnpaginatedEventCount = 0;

    /**
     * Creates a new GetWebStandardEventsResponse instance using the specified properties.
     * @function create
     * @memberof GetWebStandardEventsResponse
     * @static
     * @param {IGetWebStandardEventsResponse=} [properties] Properties to set
     * @returns {GetWebStandardEventsResponse} GetWebStandardEventsResponse instance
     */
    GetWebStandardEventsResponse.create = function create(properties) {
        return new GetWebStandardEventsResponse(properties);
    };

    /**
     * Encodes the specified GetWebStandardEventsResponse message. Does not implicitly {@link GetWebStandardEventsResponse.verify|verify} messages.
     * @function encode
     * @memberof GetWebStandardEventsResponse
     * @static
     * @param {IGetWebStandardEventsResponse} message GetWebStandardEventsResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetWebStandardEventsResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.EventTree != null && message.hasOwnProperty("EventTree"))
            $root.FirstLevelCategory.encode(message.EventTree, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.AvailableGames != null && message.AvailableGames.length)
            for (var i = 0; i < message.AvailableGames.length; ++i)
                $root.GameFilterItem.encode(message.AvailableGames[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.UnpaginatedEventCount != null && message.hasOwnProperty("UnpaginatedEventCount"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.UnpaginatedEventCount);
        return writer;
    };

    /**
     * Encodes the specified GetWebStandardEventsResponse message, length delimited. Does not implicitly {@link GetWebStandardEventsResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GetWebStandardEventsResponse
     * @static
     * @param {IGetWebStandardEventsResponse} message GetWebStandardEventsResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetWebStandardEventsResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GetWebStandardEventsResponse message from the specified reader or buffer.
     * @function decode
     * @memberof GetWebStandardEventsResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GetWebStandardEventsResponse} GetWebStandardEventsResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetWebStandardEventsResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetWebStandardEventsResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.EventTree = $root.FirstLevelCategory.decode(reader, reader.uint32());
                break;
            case 2:
                if (!(message.AvailableGames && message.AvailableGames.length))
                    message.AvailableGames = [];
                message.AvailableGames.push($root.GameFilterItem.decode(reader, reader.uint32()));
                break;
            case 3:
                message.UnpaginatedEventCount = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GetWebStandardEventsResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GetWebStandardEventsResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GetWebStandardEventsResponse} GetWebStandardEventsResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetWebStandardEventsResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GetWebStandardEventsResponse message.
     * @function verify
     * @memberof GetWebStandardEventsResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GetWebStandardEventsResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.EventTree != null && message.hasOwnProperty("EventTree")) {
            var error = $root.FirstLevelCategory.verify(message.EventTree);
            if (error)
                return "EventTree." + error;
        }
        if (message.AvailableGames != null && message.hasOwnProperty("AvailableGames")) {
            if (!Array.isArray(message.AvailableGames))
                return "AvailableGames: array expected";
            for (var i = 0; i < message.AvailableGames.length; ++i) {
                var error = $root.GameFilterItem.verify(message.AvailableGames[i]);
                if (error)
                    return "AvailableGames." + error;
            }
        }
        if (message.UnpaginatedEventCount != null && message.hasOwnProperty("UnpaginatedEventCount"))
            if (!$util.isInteger(message.UnpaginatedEventCount))
                return "UnpaginatedEventCount: integer expected";
        return null;
    };

    /**
     * Creates a GetWebStandardEventsResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GetWebStandardEventsResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GetWebStandardEventsResponse} GetWebStandardEventsResponse
     */
    GetWebStandardEventsResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.GetWebStandardEventsResponse)
            return object;
        var message = new $root.GetWebStandardEventsResponse();
        if (object.EventTree != null) {
            if (typeof object.EventTree !== "object")
                throw TypeError(".GetWebStandardEventsResponse.EventTree: object expected");
            message.EventTree = $root.FirstLevelCategory.fromObject(object.EventTree);
        }
        if (object.AvailableGames) {
            if (!Array.isArray(object.AvailableGames))
                throw TypeError(".GetWebStandardEventsResponse.AvailableGames: array expected");
            message.AvailableGames = [];
            for (var i = 0; i < object.AvailableGames.length; ++i) {
                if (typeof object.AvailableGames[i] !== "object")
                    throw TypeError(".GetWebStandardEventsResponse.AvailableGames: object expected");
                message.AvailableGames[i] = $root.GameFilterItem.fromObject(object.AvailableGames[i]);
            }
        }
        if (object.UnpaginatedEventCount != null)
            message.UnpaginatedEventCount = object.UnpaginatedEventCount | 0;
        return message;
    };

    /**
     * Creates a plain object from a GetWebStandardEventsResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GetWebStandardEventsResponse
     * @static
     * @param {GetWebStandardEventsResponse} message GetWebStandardEventsResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GetWebStandardEventsResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.AvailableGames = [];
        if (options.defaults) {
            object.EventTree = null;
            object.UnpaginatedEventCount = 0;
        }
        if (message.EventTree != null && message.hasOwnProperty("EventTree"))
            object.EventTree = $root.FirstLevelCategory.toObject(message.EventTree, options);
        if (message.AvailableGames && message.AvailableGames.length) {
            object.AvailableGames = [];
            for (var j = 0; j < message.AvailableGames.length; ++j)
                object.AvailableGames[j] = $root.GameFilterItem.toObject(message.AvailableGames[j], options);
        }
        if (message.UnpaginatedEventCount != null && message.hasOwnProperty("UnpaginatedEventCount"))
            object.UnpaginatedEventCount = message.UnpaginatedEventCount;
        return object;
    };

    /**
     * Converts this GetWebStandardEventsResponse to JSON.
     * @function toJSON
     * @memberof GetWebStandardEventsResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GetWebStandardEventsResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GetWebStandardEventsResponse;
})();

$root.GetMobileStandardEventsResponse = (function() {

    /**
     * Properties of a GetMobileStandardEventsResponse.
     * @exports IGetMobileStandardEventsResponse
     * @interface IGetMobileStandardEventsResponse
     * @property {IFirstLevelCategory|null} [EventTree] GetMobileStandardEventsResponse EventTree
     * @property {number|null} [UnpaginatedEventCount] GetMobileStandardEventsResponse UnpaginatedEventCount
     */

    /**
     * Constructs a new GetMobileStandardEventsResponse.
     * @exports GetMobileStandardEventsResponse
     * @classdesc Represents a GetMobileStandardEventsResponse.
     * @implements IGetMobileStandardEventsResponse
     * @constructor
     * @param {IGetMobileStandardEventsResponse=} [properties] Properties to set
     */
    function GetMobileStandardEventsResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GetMobileStandardEventsResponse EventTree.
     * @member {IFirstLevelCategory|null|undefined} EventTree
     * @memberof GetMobileStandardEventsResponse
     * @instance
     */
    GetMobileStandardEventsResponse.prototype.EventTree = null;

    /**
     * GetMobileStandardEventsResponse UnpaginatedEventCount.
     * @member {number} UnpaginatedEventCount
     * @memberof GetMobileStandardEventsResponse
     * @instance
     */
    GetMobileStandardEventsResponse.prototype.UnpaginatedEventCount = 0;

    /**
     * Creates a new GetMobileStandardEventsResponse instance using the specified properties.
     * @function create
     * @memberof GetMobileStandardEventsResponse
     * @static
     * @param {IGetMobileStandardEventsResponse=} [properties] Properties to set
     * @returns {GetMobileStandardEventsResponse} GetMobileStandardEventsResponse instance
     */
    GetMobileStandardEventsResponse.create = function create(properties) {
        return new GetMobileStandardEventsResponse(properties);
    };

    /**
     * Encodes the specified GetMobileStandardEventsResponse message. Does not implicitly {@link GetMobileStandardEventsResponse.verify|verify} messages.
     * @function encode
     * @memberof GetMobileStandardEventsResponse
     * @static
     * @param {IGetMobileStandardEventsResponse} message GetMobileStandardEventsResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetMobileStandardEventsResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.EventTree != null && message.hasOwnProperty("EventTree"))
            $root.FirstLevelCategory.encode(message.EventTree, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.UnpaginatedEventCount != null && message.hasOwnProperty("UnpaginatedEventCount"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.UnpaginatedEventCount);
        return writer;
    };

    /**
     * Encodes the specified GetMobileStandardEventsResponse message, length delimited. Does not implicitly {@link GetMobileStandardEventsResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GetMobileStandardEventsResponse
     * @static
     * @param {IGetMobileStandardEventsResponse} message GetMobileStandardEventsResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetMobileStandardEventsResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GetMobileStandardEventsResponse message from the specified reader or buffer.
     * @function decode
     * @memberof GetMobileStandardEventsResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GetMobileStandardEventsResponse} GetMobileStandardEventsResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetMobileStandardEventsResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetMobileStandardEventsResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.EventTree = $root.FirstLevelCategory.decode(reader, reader.uint32());
                break;
            case 2:
                message.UnpaginatedEventCount = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GetMobileStandardEventsResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GetMobileStandardEventsResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GetMobileStandardEventsResponse} GetMobileStandardEventsResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetMobileStandardEventsResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GetMobileStandardEventsResponse message.
     * @function verify
     * @memberof GetMobileStandardEventsResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GetMobileStandardEventsResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.EventTree != null && message.hasOwnProperty("EventTree")) {
            var error = $root.FirstLevelCategory.verify(message.EventTree);
            if (error)
                return "EventTree." + error;
        }
        if (message.UnpaginatedEventCount != null && message.hasOwnProperty("UnpaginatedEventCount"))
            if (!$util.isInteger(message.UnpaginatedEventCount))
                return "UnpaginatedEventCount: integer expected";
        return null;
    };

    /**
     * Creates a GetMobileStandardEventsResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GetMobileStandardEventsResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GetMobileStandardEventsResponse} GetMobileStandardEventsResponse
     */
    GetMobileStandardEventsResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.GetMobileStandardEventsResponse)
            return object;
        var message = new $root.GetMobileStandardEventsResponse();
        if (object.EventTree != null) {
            if (typeof object.EventTree !== "object")
                throw TypeError(".GetMobileStandardEventsResponse.EventTree: object expected");
            message.EventTree = $root.FirstLevelCategory.fromObject(object.EventTree);
        }
        if (object.UnpaginatedEventCount != null)
            message.UnpaginatedEventCount = object.UnpaginatedEventCount | 0;
        return message;
    };

    /**
     * Creates a plain object from a GetMobileStandardEventsResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GetMobileStandardEventsResponse
     * @static
     * @param {GetMobileStandardEventsResponse} message GetMobileStandardEventsResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GetMobileStandardEventsResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.EventTree = null;
            object.UnpaginatedEventCount = 0;
        }
        if (message.EventTree != null && message.hasOwnProperty("EventTree"))
            object.EventTree = $root.FirstLevelCategory.toObject(message.EventTree, options);
        if (message.UnpaginatedEventCount != null && message.hasOwnProperty("UnpaginatedEventCount"))
            object.UnpaginatedEventCount = message.UnpaginatedEventCount;
        return object;
    };

    /**
     * Converts this GetMobileStandardEventsResponse to JSON.
     * @function toJSON
     * @memberof GetMobileStandardEventsResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GetMobileStandardEventsResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GetMobileStandardEventsResponse;
})();

$root.GetWebStandardCategoriesResponse = (function() {

    /**
     * Properties of a GetWebStandardCategoriesResponse.
     * @exports IGetWebStandardCategoriesResponse
     * @interface IGetWebStandardCategoriesResponse
     * @property {IFirstLevelCategory|null} [Categories] GetWebStandardCategoriesResponse Categories
     * @property {number|null} [TimeStamp] GetWebStandardCategoriesResponse TimeStamp
     * @property {number|null} [TodayCount] GetWebStandardCategoriesResponse TodayCount
     * @property {number|null} [TomorrowCount] GetWebStandardCategoriesResponse TomorrowCount
     * @property {number|null} [WeekCount] GetWebStandardCategoriesResponse WeekCount
     */

    /**
     * Constructs a new GetWebStandardCategoriesResponse.
     * @exports GetWebStandardCategoriesResponse
     * @classdesc Represents a GetWebStandardCategoriesResponse.
     * @implements IGetWebStandardCategoriesResponse
     * @constructor
     * @param {IGetWebStandardCategoriesResponse=} [properties] Properties to set
     */
    function GetWebStandardCategoriesResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GetWebStandardCategoriesResponse Categories.
     * @member {IFirstLevelCategory|null|undefined} Categories
     * @memberof GetWebStandardCategoriesResponse
     * @instance
     */
    GetWebStandardCategoriesResponse.prototype.Categories = null;

    /**
     * GetWebStandardCategoriesResponse TimeStamp.
     * @member {number} TimeStamp
     * @memberof GetWebStandardCategoriesResponse
     * @instance
     */
    GetWebStandardCategoriesResponse.prototype.TimeStamp = 0;

    /**
     * GetWebStandardCategoriesResponse TodayCount.
     * @member {number} TodayCount
     * @memberof GetWebStandardCategoriesResponse
     * @instance
     */
    GetWebStandardCategoriesResponse.prototype.TodayCount = 0;

    /**
     * GetWebStandardCategoriesResponse TomorrowCount.
     * @member {number} TomorrowCount
     * @memberof GetWebStandardCategoriesResponse
     * @instance
     */
    GetWebStandardCategoriesResponse.prototype.TomorrowCount = 0;

    /**
     * GetWebStandardCategoriesResponse WeekCount.
     * @member {number} WeekCount
     * @memberof GetWebStandardCategoriesResponse
     * @instance
     */
    GetWebStandardCategoriesResponse.prototype.WeekCount = 0;

    /**
     * Creates a new GetWebStandardCategoriesResponse instance using the specified properties.
     * @function create
     * @memberof GetWebStandardCategoriesResponse
     * @static
     * @param {IGetWebStandardCategoriesResponse=} [properties] Properties to set
     * @returns {GetWebStandardCategoriesResponse} GetWebStandardCategoriesResponse instance
     */
    GetWebStandardCategoriesResponse.create = function create(properties) {
        return new GetWebStandardCategoriesResponse(properties);
    };

    /**
     * Encodes the specified GetWebStandardCategoriesResponse message. Does not implicitly {@link GetWebStandardCategoriesResponse.verify|verify} messages.
     * @function encode
     * @memberof GetWebStandardCategoriesResponse
     * @static
     * @param {IGetWebStandardCategoriesResponse} message GetWebStandardCategoriesResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetWebStandardCategoriesResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Categories != null && message.hasOwnProperty("Categories"))
            $root.FirstLevelCategory.encode(message.Categories, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.TimeStamp != null && message.hasOwnProperty("TimeStamp"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.TimeStamp);
        if (message.TodayCount != null && message.hasOwnProperty("TodayCount"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.TodayCount);
        if (message.TomorrowCount != null && message.hasOwnProperty("TomorrowCount"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.TomorrowCount);
        if (message.WeekCount != null && message.hasOwnProperty("WeekCount"))
            writer.uint32(/* id 5, wireType 0 =*/40).int32(message.WeekCount);
        return writer;
    };

    /**
     * Encodes the specified GetWebStandardCategoriesResponse message, length delimited. Does not implicitly {@link GetWebStandardCategoriesResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GetWebStandardCategoriesResponse
     * @static
     * @param {IGetWebStandardCategoriesResponse} message GetWebStandardCategoriesResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetWebStandardCategoriesResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GetWebStandardCategoriesResponse message from the specified reader or buffer.
     * @function decode
     * @memberof GetWebStandardCategoriesResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GetWebStandardCategoriesResponse} GetWebStandardCategoriesResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetWebStandardCategoriesResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetWebStandardCategoriesResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Categories = $root.FirstLevelCategory.decode(reader, reader.uint32());
                break;
            case 2:
                message.TimeStamp = reader.int32();
                break;
            case 3:
                message.TodayCount = reader.int32();
                break;
            case 4:
                message.TomorrowCount = reader.int32();
                break;
            case 5:
                message.WeekCount = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GetWebStandardCategoriesResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GetWebStandardCategoriesResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GetWebStandardCategoriesResponse} GetWebStandardCategoriesResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetWebStandardCategoriesResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GetWebStandardCategoriesResponse message.
     * @function verify
     * @memberof GetWebStandardCategoriesResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GetWebStandardCategoriesResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Categories != null && message.hasOwnProperty("Categories")) {
            var error = $root.FirstLevelCategory.verify(message.Categories);
            if (error)
                return "Categories." + error;
        }
        if (message.TimeStamp != null && message.hasOwnProperty("TimeStamp"))
            if (!$util.isInteger(message.TimeStamp))
                return "TimeStamp: integer expected";
        if (message.TodayCount != null && message.hasOwnProperty("TodayCount"))
            if (!$util.isInteger(message.TodayCount))
                return "TodayCount: integer expected";
        if (message.TomorrowCount != null && message.hasOwnProperty("TomorrowCount"))
            if (!$util.isInteger(message.TomorrowCount))
                return "TomorrowCount: integer expected";
        if (message.WeekCount != null && message.hasOwnProperty("WeekCount"))
            if (!$util.isInteger(message.WeekCount))
                return "WeekCount: integer expected";
        return null;
    };

    /**
     * Creates a GetWebStandardCategoriesResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GetWebStandardCategoriesResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GetWebStandardCategoriesResponse} GetWebStandardCategoriesResponse
     */
    GetWebStandardCategoriesResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.GetWebStandardCategoriesResponse)
            return object;
        var message = new $root.GetWebStandardCategoriesResponse();
        if (object.Categories != null) {
            if (typeof object.Categories !== "object")
                throw TypeError(".GetWebStandardCategoriesResponse.Categories: object expected");
            message.Categories = $root.FirstLevelCategory.fromObject(object.Categories);
        }
        if (object.TimeStamp != null)
            message.TimeStamp = object.TimeStamp | 0;
        if (object.TodayCount != null)
            message.TodayCount = object.TodayCount | 0;
        if (object.TomorrowCount != null)
            message.TomorrowCount = object.TomorrowCount | 0;
        if (object.WeekCount != null)
            message.WeekCount = object.WeekCount | 0;
        return message;
    };

    /**
     * Creates a plain object from a GetWebStandardCategoriesResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GetWebStandardCategoriesResponse
     * @static
     * @param {GetWebStandardCategoriesResponse} message GetWebStandardCategoriesResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GetWebStandardCategoriesResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.Categories = null;
            object.TimeStamp = 0;
            object.TodayCount = 0;
            object.TomorrowCount = 0;
            object.WeekCount = 0;
        }
        if (message.Categories != null && message.hasOwnProperty("Categories"))
            object.Categories = $root.FirstLevelCategory.toObject(message.Categories, options);
        if (message.TimeStamp != null && message.hasOwnProperty("TimeStamp"))
            object.TimeStamp = message.TimeStamp;
        if (message.TodayCount != null && message.hasOwnProperty("TodayCount"))
            object.TodayCount = message.TodayCount;
        if (message.TomorrowCount != null && message.hasOwnProperty("TomorrowCount"))
            object.TomorrowCount = message.TomorrowCount;
        if (message.WeekCount != null && message.hasOwnProperty("WeekCount"))
            object.WeekCount = message.WeekCount;
        return object;
    };

    /**
     * Converts this GetWebStandardCategoriesResponse to JSON.
     * @function toJSON
     * @memberof GetWebStandardCategoriesResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GetWebStandardCategoriesResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GetWebStandardCategoriesResponse;
})();

$root.GetTicketLineOperationResponse = (function() {

    /**
     * Properties of a GetTicketLineOperationResponse.
     * @exports IGetTicketLineOperationResponse
     * @interface IGetTicketLineOperationResponse
     * @property {Array.<IOdds>|null} [Odds] GetTicketLineOperationResponse Odds
     * @property {string|null} [CategoryText] GetTicketLineOperationResponse CategoryText
     */

    /**
     * Constructs a new GetTicketLineOperationResponse.
     * @exports GetTicketLineOperationResponse
     * @classdesc Represents a GetTicketLineOperationResponse.
     * @implements IGetTicketLineOperationResponse
     * @constructor
     * @param {IGetTicketLineOperationResponse=} [properties] Properties to set
     */
    function GetTicketLineOperationResponse(properties) {
        this.Odds = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GetTicketLineOperationResponse Odds.
     * @member {Array.<IOdds>} Odds
     * @memberof GetTicketLineOperationResponse
     * @instance
     */
    GetTicketLineOperationResponse.prototype.Odds = $util.emptyArray;

    /**
     * GetTicketLineOperationResponse CategoryText.
     * @member {string} CategoryText
     * @memberof GetTicketLineOperationResponse
     * @instance
     */
    GetTicketLineOperationResponse.prototype.CategoryText = "";

    /**
     * Creates a new GetTicketLineOperationResponse instance using the specified properties.
     * @function create
     * @memberof GetTicketLineOperationResponse
     * @static
     * @param {IGetTicketLineOperationResponse=} [properties] Properties to set
     * @returns {GetTicketLineOperationResponse} GetTicketLineOperationResponse instance
     */
    GetTicketLineOperationResponse.create = function create(properties) {
        return new GetTicketLineOperationResponse(properties);
    };

    /**
     * Encodes the specified GetTicketLineOperationResponse message. Does not implicitly {@link GetTicketLineOperationResponse.verify|verify} messages.
     * @function encode
     * @memberof GetTicketLineOperationResponse
     * @static
     * @param {IGetTicketLineOperationResponse} message GetTicketLineOperationResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetTicketLineOperationResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Odds != null && message.Odds.length)
            for (var i = 0; i < message.Odds.length; ++i)
                $root.Odds.encode(message.Odds[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.CategoryText != null && message.hasOwnProperty("CategoryText"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.CategoryText);
        return writer;
    };

    /**
     * Encodes the specified GetTicketLineOperationResponse message, length delimited. Does not implicitly {@link GetTicketLineOperationResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GetTicketLineOperationResponse
     * @static
     * @param {IGetTicketLineOperationResponse} message GetTicketLineOperationResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetTicketLineOperationResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GetTicketLineOperationResponse message from the specified reader or buffer.
     * @function decode
     * @memberof GetTicketLineOperationResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GetTicketLineOperationResponse} GetTicketLineOperationResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetTicketLineOperationResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetTicketLineOperationResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.Odds && message.Odds.length))
                    message.Odds = [];
                message.Odds.push($root.Odds.decode(reader, reader.uint32()));
                break;
            case 2:
                message.CategoryText = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GetTicketLineOperationResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GetTicketLineOperationResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GetTicketLineOperationResponse} GetTicketLineOperationResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetTicketLineOperationResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GetTicketLineOperationResponse message.
     * @function verify
     * @memberof GetTicketLineOperationResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GetTicketLineOperationResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Odds != null && message.hasOwnProperty("Odds")) {
            if (!Array.isArray(message.Odds))
                return "Odds: array expected";
            for (var i = 0; i < message.Odds.length; ++i) {
                var error = $root.Odds.verify(message.Odds[i]);
                if (error)
                    return "Odds." + error;
            }
        }
        if (message.CategoryText != null && message.hasOwnProperty("CategoryText"))
            if (!$util.isString(message.CategoryText))
                return "CategoryText: string expected";
        return null;
    };

    /**
     * Creates a GetTicketLineOperationResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GetTicketLineOperationResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GetTicketLineOperationResponse} GetTicketLineOperationResponse
     */
    GetTicketLineOperationResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.GetTicketLineOperationResponse)
            return object;
        var message = new $root.GetTicketLineOperationResponse();
        if (object.Odds) {
            if (!Array.isArray(object.Odds))
                throw TypeError(".GetTicketLineOperationResponse.Odds: array expected");
            message.Odds = [];
            for (var i = 0; i < object.Odds.length; ++i) {
                if (typeof object.Odds[i] !== "object")
                    throw TypeError(".GetTicketLineOperationResponse.Odds: object expected");
                message.Odds[i] = $root.Odds.fromObject(object.Odds[i]);
            }
        }
        if (object.CategoryText != null)
            message.CategoryText = String(object.CategoryText);
        return message;
    };

    /**
     * Creates a plain object from a GetTicketLineOperationResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GetTicketLineOperationResponse
     * @static
     * @param {GetTicketLineOperationResponse} message GetTicketLineOperationResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GetTicketLineOperationResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.Odds = [];
        if (options.defaults)
            object.CategoryText = "";
        if (message.Odds && message.Odds.length) {
            object.Odds = [];
            for (var j = 0; j < message.Odds.length; ++j)
                object.Odds[j] = $root.Odds.toObject(message.Odds[j], options);
        }
        if (message.CategoryText != null && message.hasOwnProperty("CategoryText"))
            object.CategoryText = message.CategoryText;
        return object;
    };

    /**
     * Converts this GetTicketLineOperationResponse to JSON.
     * @function toJSON
     * @memberof GetTicketLineOperationResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GetTicketLineOperationResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GetTicketLineOperationResponse;
})();

$root.GetCouponLineOperationResponse = (function() {

    /**
     * Properties of a GetCouponLineOperationResponse.
     * @exports IGetCouponLineOperationResponse
     * @interface IGetCouponLineOperationResponse
     * @property {Array.<IOdds>|null} [Odds] GetCouponLineOperationResponse Odds
     * @property {string|null} [CategoryText] GetCouponLineOperationResponse CategoryText
     */

    /**
     * Constructs a new GetCouponLineOperationResponse.
     * @exports GetCouponLineOperationResponse
     * @classdesc Represents a GetCouponLineOperationResponse.
     * @implements IGetCouponLineOperationResponse
     * @constructor
     * @param {IGetCouponLineOperationResponse=} [properties] Properties to set
     */
    function GetCouponLineOperationResponse(properties) {
        this.Odds = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GetCouponLineOperationResponse Odds.
     * @member {Array.<IOdds>} Odds
     * @memberof GetCouponLineOperationResponse
     * @instance
     */
    GetCouponLineOperationResponse.prototype.Odds = $util.emptyArray;

    /**
     * GetCouponLineOperationResponse CategoryText.
     * @member {string} CategoryText
     * @memberof GetCouponLineOperationResponse
     * @instance
     */
    GetCouponLineOperationResponse.prototype.CategoryText = "";

    /**
     * Creates a new GetCouponLineOperationResponse instance using the specified properties.
     * @function create
     * @memberof GetCouponLineOperationResponse
     * @static
     * @param {IGetCouponLineOperationResponse=} [properties] Properties to set
     * @returns {GetCouponLineOperationResponse} GetCouponLineOperationResponse instance
     */
    GetCouponLineOperationResponse.create = function create(properties) {
        return new GetCouponLineOperationResponse(properties);
    };

    /**
     * Encodes the specified GetCouponLineOperationResponse message. Does not implicitly {@link GetCouponLineOperationResponse.verify|verify} messages.
     * @function encode
     * @memberof GetCouponLineOperationResponse
     * @static
     * @param {IGetCouponLineOperationResponse} message GetCouponLineOperationResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetCouponLineOperationResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Odds != null && message.Odds.length)
            for (var i = 0; i < message.Odds.length; ++i)
                $root.Odds.encode(message.Odds[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.CategoryText != null && message.hasOwnProperty("CategoryText"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.CategoryText);
        return writer;
    };

    /**
     * Encodes the specified GetCouponLineOperationResponse message, length delimited. Does not implicitly {@link GetCouponLineOperationResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GetCouponLineOperationResponse
     * @static
     * @param {IGetCouponLineOperationResponse} message GetCouponLineOperationResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetCouponLineOperationResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GetCouponLineOperationResponse message from the specified reader or buffer.
     * @function decode
     * @memberof GetCouponLineOperationResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GetCouponLineOperationResponse} GetCouponLineOperationResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetCouponLineOperationResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetCouponLineOperationResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.Odds && message.Odds.length))
                    message.Odds = [];
                message.Odds.push($root.Odds.decode(reader, reader.uint32()));
                break;
            case 2:
                message.CategoryText = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GetCouponLineOperationResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GetCouponLineOperationResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GetCouponLineOperationResponse} GetCouponLineOperationResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetCouponLineOperationResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GetCouponLineOperationResponse message.
     * @function verify
     * @memberof GetCouponLineOperationResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GetCouponLineOperationResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Odds != null && message.hasOwnProperty("Odds")) {
            if (!Array.isArray(message.Odds))
                return "Odds: array expected";
            for (var i = 0; i < message.Odds.length; ++i) {
                var error = $root.Odds.verify(message.Odds[i]);
                if (error)
                    return "Odds." + error;
            }
        }
        if (message.CategoryText != null && message.hasOwnProperty("CategoryText"))
            if (!$util.isString(message.CategoryText))
                return "CategoryText: string expected";
        return null;
    };

    /**
     * Creates a GetCouponLineOperationResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GetCouponLineOperationResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GetCouponLineOperationResponse} GetCouponLineOperationResponse
     */
    GetCouponLineOperationResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.GetCouponLineOperationResponse)
            return object;
        var message = new $root.GetCouponLineOperationResponse();
        if (object.Odds) {
            if (!Array.isArray(object.Odds))
                throw TypeError(".GetCouponLineOperationResponse.Odds: array expected");
            message.Odds = [];
            for (var i = 0; i < object.Odds.length; ++i) {
                if (typeof object.Odds[i] !== "object")
                    throw TypeError(".GetCouponLineOperationResponse.Odds: object expected");
                message.Odds[i] = $root.Odds.fromObject(object.Odds[i]);
            }
        }
        if (object.CategoryText != null)
            message.CategoryText = String(object.CategoryText);
        return message;
    };

    /**
     * Creates a plain object from a GetCouponLineOperationResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GetCouponLineOperationResponse
     * @static
     * @param {GetCouponLineOperationResponse} message GetCouponLineOperationResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GetCouponLineOperationResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.Odds = [];
        if (options.defaults)
            object.CategoryText = "";
        if (message.Odds && message.Odds.length) {
            object.Odds = [];
            for (var j = 0; j < message.Odds.length; ++j)
                object.Odds[j] = $root.Odds.toObject(message.Odds[j], options);
        }
        if (message.CategoryText != null && message.hasOwnProperty("CategoryText"))
            object.CategoryText = message.CategoryText;
        return object;
    };

    /**
     * Converts this GetCouponLineOperationResponse to JSON.
     * @function toJSON
     * @memberof GetCouponLineOperationResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GetCouponLineOperationResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GetCouponLineOperationResponse;
})();

$root.GetMobileCategoriesResponse = (function() {

    /**
     * Properties of a GetMobileCategoriesResponse.
     * @exports IGetMobileCategoriesResponse
     * @interface IGetMobileCategoriesResponse
     * @property {number|null} [GraphicsPresentationId] GetMobileCategoriesResponse GraphicsPresentationId
     * @property {string|null} [SportName] GetMobileCategoriesResponse SportName
     * @property {Array.<IMobileCategory>|null} [Categories] GetMobileCategoriesResponse Categories
     */

    /**
     * Constructs a new GetMobileCategoriesResponse.
     * @exports GetMobileCategoriesResponse
     * @classdesc Represents a GetMobileCategoriesResponse.
     * @implements IGetMobileCategoriesResponse
     * @constructor
     * @param {IGetMobileCategoriesResponse=} [properties] Properties to set
     */
    function GetMobileCategoriesResponse(properties) {
        this.Categories = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * GetMobileCategoriesResponse GraphicsPresentationId.
     * @member {number} GraphicsPresentationId
     * @memberof GetMobileCategoriesResponse
     * @instance
     */
    GetMobileCategoriesResponse.prototype.GraphicsPresentationId = 0;

    /**
     * GetMobileCategoriesResponse SportName.
     * @member {string} SportName
     * @memberof GetMobileCategoriesResponse
     * @instance
     */
    GetMobileCategoriesResponse.prototype.SportName = "";

    /**
     * GetMobileCategoriesResponse Categories.
     * @member {Array.<IMobileCategory>} Categories
     * @memberof GetMobileCategoriesResponse
     * @instance
     */
    GetMobileCategoriesResponse.prototype.Categories = $util.emptyArray;

    /**
     * Creates a new GetMobileCategoriesResponse instance using the specified properties.
     * @function create
     * @memberof GetMobileCategoriesResponse
     * @static
     * @param {IGetMobileCategoriesResponse=} [properties] Properties to set
     * @returns {GetMobileCategoriesResponse} GetMobileCategoriesResponse instance
     */
    GetMobileCategoriesResponse.create = function create(properties) {
        return new GetMobileCategoriesResponse(properties);
    };

    /**
     * Encodes the specified GetMobileCategoriesResponse message. Does not implicitly {@link GetMobileCategoriesResponse.verify|verify} messages.
     * @function encode
     * @memberof GetMobileCategoriesResponse
     * @static
     * @param {IGetMobileCategoriesResponse} message GetMobileCategoriesResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetMobileCategoriesResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.GraphicsPresentationId != null && message.hasOwnProperty("GraphicsPresentationId"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.GraphicsPresentationId);
        if (message.SportName != null && message.hasOwnProperty("SportName"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.SportName);
        if (message.Categories != null && message.Categories.length)
            for (var i = 0; i < message.Categories.length; ++i)
                $root.MobileCategory.encode(message.Categories[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified GetMobileCategoriesResponse message, length delimited. Does not implicitly {@link GetMobileCategoriesResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof GetMobileCategoriesResponse
     * @static
     * @param {IGetMobileCategoriesResponse} message GetMobileCategoriesResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    GetMobileCategoriesResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a GetMobileCategoriesResponse message from the specified reader or buffer.
     * @function decode
     * @memberof GetMobileCategoriesResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {GetMobileCategoriesResponse} GetMobileCategoriesResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetMobileCategoriesResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.GetMobileCategoriesResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.GraphicsPresentationId = reader.int32();
                break;
            case 2:
                message.SportName = reader.string();
                break;
            case 3:
                if (!(message.Categories && message.Categories.length))
                    message.Categories = [];
                message.Categories.push($root.MobileCategory.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a GetMobileCategoriesResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof GetMobileCategoriesResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {GetMobileCategoriesResponse} GetMobileCategoriesResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    GetMobileCategoriesResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a GetMobileCategoriesResponse message.
     * @function verify
     * @memberof GetMobileCategoriesResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    GetMobileCategoriesResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.GraphicsPresentationId != null && message.hasOwnProperty("GraphicsPresentationId"))
            if (!$util.isInteger(message.GraphicsPresentationId))
                return "GraphicsPresentationId: integer expected";
        if (message.SportName != null && message.hasOwnProperty("SportName"))
            if (!$util.isString(message.SportName))
                return "SportName: string expected";
        if (message.Categories != null && message.hasOwnProperty("Categories")) {
            if (!Array.isArray(message.Categories))
                return "Categories: array expected";
            for (var i = 0; i < message.Categories.length; ++i) {
                var error = $root.MobileCategory.verify(message.Categories[i]);
                if (error)
                    return "Categories." + error;
            }
        }
        return null;
    };

    /**
     * Creates a GetMobileCategoriesResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof GetMobileCategoriesResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {GetMobileCategoriesResponse} GetMobileCategoriesResponse
     */
    GetMobileCategoriesResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.GetMobileCategoriesResponse)
            return object;
        var message = new $root.GetMobileCategoriesResponse();
        if (object.GraphicsPresentationId != null)
            message.GraphicsPresentationId = object.GraphicsPresentationId | 0;
        if (object.SportName != null)
            message.SportName = String(object.SportName);
        if (object.Categories) {
            if (!Array.isArray(object.Categories))
                throw TypeError(".GetMobileCategoriesResponse.Categories: array expected");
            message.Categories = [];
            for (var i = 0; i < object.Categories.length; ++i) {
                if (typeof object.Categories[i] !== "object")
                    throw TypeError(".GetMobileCategoriesResponse.Categories: object expected");
                message.Categories[i] = $root.MobileCategory.fromObject(object.Categories[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a GetMobileCategoriesResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof GetMobileCategoriesResponse
     * @static
     * @param {GetMobileCategoriesResponse} message GetMobileCategoriesResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    GetMobileCategoriesResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.Categories = [];
        if (options.defaults) {
            object.GraphicsPresentationId = 0;
            object.SportName = "";
        }
        if (message.GraphicsPresentationId != null && message.hasOwnProperty("GraphicsPresentationId"))
            object.GraphicsPresentationId = message.GraphicsPresentationId;
        if (message.SportName != null && message.hasOwnProperty("SportName"))
            object.SportName = message.SportName;
        if (message.Categories && message.Categories.length) {
            object.Categories = [];
            for (var j = 0; j < message.Categories.length; ++j)
                object.Categories[j] = $root.MobileCategory.toObject(message.Categories[j], options);
        }
        return object;
    };

    /**
     * Converts this GetMobileCategoriesResponse to JSON.
     * @function toJSON
     * @memberof GetMobileCategoriesResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    GetMobileCategoriesResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return GetMobileCategoriesResponse;
})();

$root.WebTopBets = (function() {

    /**
     * Properties of a WebTopBets.
     * @exports IWebTopBets
     * @interface IWebTopBets
     * @property {Array.<IWebTopBetCategory>|null} [Categories] WebTopBets Categories
     * @property {Array.<number>|null} [Stakes] WebTopBets Stakes
     * @property {Array.<number>|null} [PotentialWinnings] WebTopBets PotentialWinnings
     * @property {number|null} [TicketOfDayRate] WebTopBets TicketOfDayRate
     */

    /**
     * Constructs a new WebTopBets.
     * @exports WebTopBets
     * @classdesc Represents a WebTopBets.
     * @implements IWebTopBets
     * @constructor
     * @param {IWebTopBets=} [properties] Properties to set
     */
    function WebTopBets(properties) {
        this.Categories = [];
        this.Stakes = [];
        this.PotentialWinnings = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * WebTopBets Categories.
     * @member {Array.<IWebTopBetCategory>} Categories
     * @memberof WebTopBets
     * @instance
     */
    WebTopBets.prototype.Categories = $util.emptyArray;

    /**
     * WebTopBets Stakes.
     * @member {Array.<number>} Stakes
     * @memberof WebTopBets
     * @instance
     */
    WebTopBets.prototype.Stakes = $util.emptyArray;

    /**
     * WebTopBets PotentialWinnings.
     * @member {Array.<number>} PotentialWinnings
     * @memberof WebTopBets
     * @instance
     */
    WebTopBets.prototype.PotentialWinnings = $util.emptyArray;

    /**
     * WebTopBets TicketOfDayRate.
     * @member {number} TicketOfDayRate
     * @memberof WebTopBets
     * @instance
     */
    WebTopBets.prototype.TicketOfDayRate = 0;

    /**
     * Creates a new WebTopBets instance using the specified properties.
     * @function create
     * @memberof WebTopBets
     * @static
     * @param {IWebTopBets=} [properties] Properties to set
     * @returns {WebTopBets} WebTopBets instance
     */
    WebTopBets.create = function create(properties) {
        return new WebTopBets(properties);
    };

    /**
     * Encodes the specified WebTopBets message. Does not implicitly {@link WebTopBets.verify|verify} messages.
     * @function encode
     * @memberof WebTopBets
     * @static
     * @param {IWebTopBets} message WebTopBets message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    WebTopBets.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Categories != null && message.Categories.length)
            for (var i = 0; i < message.Categories.length; ++i)
                $root.WebTopBetCategory.encode(message.Categories[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.Stakes != null && message.Stakes.length) {
            writer.uint32(/* id 2, wireType 2 =*/18).fork();
            for (var i = 0; i < message.Stakes.length; ++i)
                writer.float(message.Stakes[i]);
            writer.ldelim();
        }
        if (message.PotentialWinnings != null && message.PotentialWinnings.length) {
            writer.uint32(/* id 3, wireType 2 =*/26).fork();
            for (var i = 0; i < message.PotentialWinnings.length; ++i)
                writer.float(message.PotentialWinnings[i]);
            writer.ldelim();
        }
        if (message.TicketOfDayRate != null && message.hasOwnProperty("TicketOfDayRate"))
            writer.uint32(/* id 4, wireType 5 =*/37).float(message.TicketOfDayRate);
        return writer;
    };

    /**
     * Encodes the specified WebTopBets message, length delimited. Does not implicitly {@link WebTopBets.verify|verify} messages.
     * @function encodeDelimited
     * @memberof WebTopBets
     * @static
     * @param {IWebTopBets} message WebTopBets message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    WebTopBets.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a WebTopBets message from the specified reader or buffer.
     * @function decode
     * @memberof WebTopBets
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {WebTopBets} WebTopBets
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    WebTopBets.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.WebTopBets();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.Categories && message.Categories.length))
                    message.Categories = [];
                message.Categories.push($root.WebTopBetCategory.decode(reader, reader.uint32()));
                break;
            case 2:
                if (!(message.Stakes && message.Stakes.length))
                    message.Stakes = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.Stakes.push(reader.float());
                } else
                    message.Stakes.push(reader.float());
                break;
            case 3:
                if (!(message.PotentialWinnings && message.PotentialWinnings.length))
                    message.PotentialWinnings = [];
                if ((tag & 7) === 2) {
                    var end2 = reader.uint32() + reader.pos;
                    while (reader.pos < end2)
                        message.PotentialWinnings.push(reader.float());
                } else
                    message.PotentialWinnings.push(reader.float());
                break;
            case 4:
                message.TicketOfDayRate = reader.float();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a WebTopBets message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof WebTopBets
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {WebTopBets} WebTopBets
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    WebTopBets.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a WebTopBets message.
     * @function verify
     * @memberof WebTopBets
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    WebTopBets.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Categories != null && message.hasOwnProperty("Categories")) {
            if (!Array.isArray(message.Categories))
                return "Categories: array expected";
            for (var i = 0; i < message.Categories.length; ++i) {
                var error = $root.WebTopBetCategory.verify(message.Categories[i]);
                if (error)
                    return "Categories." + error;
            }
        }
        if (message.Stakes != null && message.hasOwnProperty("Stakes")) {
            if (!Array.isArray(message.Stakes))
                return "Stakes: array expected";
            for (var i = 0; i < message.Stakes.length; ++i)
                if (typeof message.Stakes[i] !== "number")
                    return "Stakes: number[] expected";
        }
        if (message.PotentialWinnings != null && message.hasOwnProperty("PotentialWinnings")) {
            if (!Array.isArray(message.PotentialWinnings))
                return "PotentialWinnings: array expected";
            for (var i = 0; i < message.PotentialWinnings.length; ++i)
                if (typeof message.PotentialWinnings[i] !== "number")
                    return "PotentialWinnings: number[] expected";
        }
        if (message.TicketOfDayRate != null && message.hasOwnProperty("TicketOfDayRate"))
            if (typeof message.TicketOfDayRate !== "number")
                return "TicketOfDayRate: number expected";
        return null;
    };

    /**
     * Creates a WebTopBets message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof WebTopBets
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {WebTopBets} WebTopBets
     */
    WebTopBets.fromObject = function fromObject(object) {
        if (object instanceof $root.WebTopBets)
            return object;
        var message = new $root.WebTopBets();
        if (object.Categories) {
            if (!Array.isArray(object.Categories))
                throw TypeError(".WebTopBets.Categories: array expected");
            message.Categories = [];
            for (var i = 0; i < object.Categories.length; ++i) {
                if (typeof object.Categories[i] !== "object")
                    throw TypeError(".WebTopBets.Categories: object expected");
                message.Categories[i] = $root.WebTopBetCategory.fromObject(object.Categories[i]);
            }
        }
        if (object.Stakes) {
            if (!Array.isArray(object.Stakes))
                throw TypeError(".WebTopBets.Stakes: array expected");
            message.Stakes = [];
            for (var i = 0; i < object.Stakes.length; ++i)
                message.Stakes[i] = Number(object.Stakes[i]);
        }
        if (object.PotentialWinnings) {
            if (!Array.isArray(object.PotentialWinnings))
                throw TypeError(".WebTopBets.PotentialWinnings: array expected");
            message.PotentialWinnings = [];
            for (var i = 0; i < object.PotentialWinnings.length; ++i)
                message.PotentialWinnings[i] = Number(object.PotentialWinnings[i]);
        }
        if (object.TicketOfDayRate != null)
            message.TicketOfDayRate = Number(object.TicketOfDayRate);
        return message;
    };

    /**
     * Creates a plain object from a WebTopBets message. Also converts values to other types if specified.
     * @function toObject
     * @memberof WebTopBets
     * @static
     * @param {WebTopBets} message WebTopBets
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    WebTopBets.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.Categories = [];
            object.Stakes = [];
            object.PotentialWinnings = [];
        }
        if (options.defaults)
            object.TicketOfDayRate = 0;
        if (message.Categories && message.Categories.length) {
            object.Categories = [];
            for (var j = 0; j < message.Categories.length; ++j)
                object.Categories[j] = $root.WebTopBetCategory.toObject(message.Categories[j], options);
        }
        if (message.Stakes && message.Stakes.length) {
            object.Stakes = [];
            for (var j = 0; j < message.Stakes.length; ++j)
                object.Stakes[j] = options.json && !isFinite(message.Stakes[j]) ? String(message.Stakes[j]) : message.Stakes[j];
        }
        if (message.PotentialWinnings && message.PotentialWinnings.length) {
            object.PotentialWinnings = [];
            for (var j = 0; j < message.PotentialWinnings.length; ++j)
                object.PotentialWinnings[j] = options.json && !isFinite(message.PotentialWinnings[j]) ? String(message.PotentialWinnings[j]) : message.PotentialWinnings[j];
        }
        if (message.TicketOfDayRate != null && message.hasOwnProperty("TicketOfDayRate"))
            object.TicketOfDayRate = options.json && !isFinite(message.TicketOfDayRate) ? String(message.TicketOfDayRate) : message.TicketOfDayRate;
        return object;
    };

    /**
     * Converts this WebTopBets to JSON.
     * @function toJSON
     * @memberof WebTopBets
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    WebTopBets.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return WebTopBets;
})();

$root.WebTopBetsWithTs = (function() {

    /**
     * Properties of a WebTopBetsWithTs.
     * @exports IWebTopBetsWithTs
     * @interface IWebTopBetsWithTs
     * @property {IWebTopBets|null} [TopBets] WebTopBetsWithTs TopBets
     * @property {number|null} [Timestamp] WebTopBetsWithTs Timestamp
     */

    /**
     * Constructs a new WebTopBetsWithTs.
     * @exports WebTopBetsWithTs
     * @classdesc Represents a WebTopBetsWithTs.
     * @implements IWebTopBetsWithTs
     * @constructor
     * @param {IWebTopBetsWithTs=} [properties] Properties to set
     */
    function WebTopBetsWithTs(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * WebTopBetsWithTs TopBets.
     * @member {IWebTopBets|null|undefined} TopBets
     * @memberof WebTopBetsWithTs
     * @instance
     */
    WebTopBetsWithTs.prototype.TopBets = null;

    /**
     * WebTopBetsWithTs Timestamp.
     * @member {number} Timestamp
     * @memberof WebTopBetsWithTs
     * @instance
     */
    WebTopBetsWithTs.prototype.Timestamp = 0;

    /**
     * Creates a new WebTopBetsWithTs instance using the specified properties.
     * @function create
     * @memberof WebTopBetsWithTs
     * @static
     * @param {IWebTopBetsWithTs=} [properties] Properties to set
     * @returns {WebTopBetsWithTs} WebTopBetsWithTs instance
     */
    WebTopBetsWithTs.create = function create(properties) {
        return new WebTopBetsWithTs(properties);
    };

    /**
     * Encodes the specified WebTopBetsWithTs message. Does not implicitly {@link WebTopBetsWithTs.verify|verify} messages.
     * @function encode
     * @memberof WebTopBetsWithTs
     * @static
     * @param {IWebTopBetsWithTs} message WebTopBetsWithTs message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    WebTopBetsWithTs.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.TopBets != null && message.hasOwnProperty("TopBets"))
            $root.WebTopBets.encode(message.TopBets, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.Timestamp != null && message.hasOwnProperty("Timestamp"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.Timestamp);
        return writer;
    };

    /**
     * Encodes the specified WebTopBetsWithTs message, length delimited. Does not implicitly {@link WebTopBetsWithTs.verify|verify} messages.
     * @function encodeDelimited
     * @memberof WebTopBetsWithTs
     * @static
     * @param {IWebTopBetsWithTs} message WebTopBetsWithTs message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    WebTopBetsWithTs.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a WebTopBetsWithTs message from the specified reader or buffer.
     * @function decode
     * @memberof WebTopBetsWithTs
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {WebTopBetsWithTs} WebTopBetsWithTs
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    WebTopBetsWithTs.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.WebTopBetsWithTs();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.TopBets = $root.WebTopBets.decode(reader, reader.uint32());
                break;
            case 2:
                message.Timestamp = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a WebTopBetsWithTs message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof WebTopBetsWithTs
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {WebTopBetsWithTs} WebTopBetsWithTs
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    WebTopBetsWithTs.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a WebTopBetsWithTs message.
     * @function verify
     * @memberof WebTopBetsWithTs
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    WebTopBetsWithTs.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.TopBets != null && message.hasOwnProperty("TopBets")) {
            var error = $root.WebTopBets.verify(message.TopBets);
            if (error)
                return "TopBets." + error;
        }
        if (message.Timestamp != null && message.hasOwnProperty("Timestamp"))
            if (!$util.isInteger(message.Timestamp))
                return "Timestamp: integer expected";
        return null;
    };

    /**
     * Creates a WebTopBetsWithTs message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof WebTopBetsWithTs
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {WebTopBetsWithTs} WebTopBetsWithTs
     */
    WebTopBetsWithTs.fromObject = function fromObject(object) {
        if (object instanceof $root.WebTopBetsWithTs)
            return object;
        var message = new $root.WebTopBetsWithTs();
        if (object.TopBets != null) {
            if (typeof object.TopBets !== "object")
                throw TypeError(".WebTopBetsWithTs.TopBets: object expected");
            message.TopBets = $root.WebTopBets.fromObject(object.TopBets);
        }
        if (object.Timestamp != null)
            message.Timestamp = object.Timestamp | 0;
        return message;
    };

    /**
     * Creates a plain object from a WebTopBetsWithTs message. Also converts values to other types if specified.
     * @function toObject
     * @memberof WebTopBetsWithTs
     * @static
     * @param {WebTopBetsWithTs} message WebTopBetsWithTs
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    WebTopBetsWithTs.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.TopBets = null;
            object.Timestamp = 0;
        }
        if (message.TopBets != null && message.hasOwnProperty("TopBets"))
            object.TopBets = $root.WebTopBets.toObject(message.TopBets, options);
        if (message.Timestamp != null && message.hasOwnProperty("Timestamp"))
            object.Timestamp = message.Timestamp;
        return object;
    };

    /**
     * Converts this WebTopBetsWithTs to JSON.
     * @function toJSON
     * @memberof WebTopBetsWithTs
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    WebTopBetsWithTs.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return WebTopBetsWithTs;
})();

$root.MobileTopBetsGrouped = (function() {

    /**
     * Properties of a MobileTopBetsGrouped.
     * @exports IMobileTopBetsGrouped
     * @interface IMobileTopBetsGrouped
     * @property {IWebTopBets|null} [TopBets] MobileTopBetsGrouped TopBets
     * @property {IWebTopBets|null} [HotBets] MobileTopBetsGrouped HotBets
     * @property {number|null} [TopBetsTimestamp] MobileTopBetsGrouped TopBetsTimestamp
     * @property {number|null} [HotBetsTimestamp] MobileTopBetsGrouped HotBetsTimestamp
     * @property {IWebTopBets|null} [Top5PerDay] MobileTopBetsGrouped Top5PerDay
     * @property {IWebTopBets|null} [Top10PerDay] MobileTopBetsGrouped Top10PerDay
     * @property {number|null} [Top5PerDayTimestamp] MobileTopBetsGrouped Top5PerDayTimestamp
     * @property {number|null} [Top10PerDayTimestamp] MobileTopBetsGrouped Top10PerDayTimestamp
     */

    /**
     * Constructs a new MobileTopBetsGrouped.
     * @exports MobileTopBetsGrouped
     * @classdesc Represents a MobileTopBetsGrouped.
     * @implements IMobileTopBetsGrouped
     * @constructor
     * @param {IMobileTopBetsGrouped=} [properties] Properties to set
     */
    function MobileTopBetsGrouped(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * MobileTopBetsGrouped TopBets.
     * @member {IWebTopBets|null|undefined} TopBets
     * @memberof MobileTopBetsGrouped
     * @instance
     */
    MobileTopBetsGrouped.prototype.TopBets = null;

    /**
     * MobileTopBetsGrouped HotBets.
     * @member {IWebTopBets|null|undefined} HotBets
     * @memberof MobileTopBetsGrouped
     * @instance
     */
    MobileTopBetsGrouped.prototype.HotBets = null;

    /**
     * MobileTopBetsGrouped TopBetsTimestamp.
     * @member {number} TopBetsTimestamp
     * @memberof MobileTopBetsGrouped
     * @instance
     */
    MobileTopBetsGrouped.prototype.TopBetsTimestamp = 0;

    /**
     * MobileTopBetsGrouped HotBetsTimestamp.
     * @member {number} HotBetsTimestamp
     * @memberof MobileTopBetsGrouped
     * @instance
     */
    MobileTopBetsGrouped.prototype.HotBetsTimestamp = 0;

    /**
     * MobileTopBetsGrouped Top5PerDay.
     * @member {IWebTopBets|null|undefined} Top5PerDay
     * @memberof MobileTopBetsGrouped
     * @instance
     */
    MobileTopBetsGrouped.prototype.Top5PerDay = null;

    /**
     * MobileTopBetsGrouped Top10PerDay.
     * @member {IWebTopBets|null|undefined} Top10PerDay
     * @memberof MobileTopBetsGrouped
     * @instance
     */
    MobileTopBetsGrouped.prototype.Top10PerDay = null;

    /**
     * MobileTopBetsGrouped Top5PerDayTimestamp.
     * @member {number} Top5PerDayTimestamp
     * @memberof MobileTopBetsGrouped
     * @instance
     */
    MobileTopBetsGrouped.prototype.Top5PerDayTimestamp = 0;

    /**
     * MobileTopBetsGrouped Top10PerDayTimestamp.
     * @member {number} Top10PerDayTimestamp
     * @memberof MobileTopBetsGrouped
     * @instance
     */
    MobileTopBetsGrouped.prototype.Top10PerDayTimestamp = 0;

    /**
     * Creates a new MobileTopBetsGrouped instance using the specified properties.
     * @function create
     * @memberof MobileTopBetsGrouped
     * @static
     * @param {IMobileTopBetsGrouped=} [properties] Properties to set
     * @returns {MobileTopBetsGrouped} MobileTopBetsGrouped instance
     */
    MobileTopBetsGrouped.create = function create(properties) {
        return new MobileTopBetsGrouped(properties);
    };

    /**
     * Encodes the specified MobileTopBetsGrouped message. Does not implicitly {@link MobileTopBetsGrouped.verify|verify} messages.
     * @function encode
     * @memberof MobileTopBetsGrouped
     * @static
     * @param {IMobileTopBetsGrouped} message MobileTopBetsGrouped message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MobileTopBetsGrouped.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.TopBets != null && message.hasOwnProperty("TopBets"))
            $root.WebTopBets.encode(message.TopBets, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.HotBets != null && message.hasOwnProperty("HotBets"))
            $root.WebTopBets.encode(message.HotBets, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.TopBetsTimestamp != null && message.hasOwnProperty("TopBetsTimestamp"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.TopBetsTimestamp);
        if (message.HotBetsTimestamp != null && message.hasOwnProperty("HotBetsTimestamp"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.HotBetsTimestamp);
        if (message.Top5PerDay != null && message.hasOwnProperty("Top5PerDay"))
            $root.WebTopBets.encode(message.Top5PerDay, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
        if (message.Top10PerDay != null && message.hasOwnProperty("Top10PerDay"))
            $root.WebTopBets.encode(message.Top10PerDay, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
        if (message.Top5PerDayTimestamp != null && message.hasOwnProperty("Top5PerDayTimestamp"))
            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.Top5PerDayTimestamp);
        if (message.Top10PerDayTimestamp != null && message.hasOwnProperty("Top10PerDayTimestamp"))
            writer.uint32(/* id 8, wireType 0 =*/64).int32(message.Top10PerDayTimestamp);
        return writer;
    };

    /**
     * Encodes the specified MobileTopBetsGrouped message, length delimited. Does not implicitly {@link MobileTopBetsGrouped.verify|verify} messages.
     * @function encodeDelimited
     * @memberof MobileTopBetsGrouped
     * @static
     * @param {IMobileTopBetsGrouped} message MobileTopBetsGrouped message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MobileTopBetsGrouped.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a MobileTopBetsGrouped message from the specified reader or buffer.
     * @function decode
     * @memberof MobileTopBetsGrouped
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {MobileTopBetsGrouped} MobileTopBetsGrouped
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MobileTopBetsGrouped.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MobileTopBetsGrouped();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.TopBets = $root.WebTopBets.decode(reader, reader.uint32());
                break;
            case 2:
                message.HotBets = $root.WebTopBets.decode(reader, reader.uint32());
                break;
            case 3:
                message.TopBetsTimestamp = reader.int32();
                break;
            case 4:
                message.HotBetsTimestamp = reader.int32();
                break;
            case 5:
                message.Top5PerDay = $root.WebTopBets.decode(reader, reader.uint32());
                break;
            case 6:
                message.Top10PerDay = $root.WebTopBets.decode(reader, reader.uint32());
                break;
            case 7:
                message.Top5PerDayTimestamp = reader.int32();
                break;
            case 8:
                message.Top10PerDayTimestamp = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a MobileTopBetsGrouped message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof MobileTopBetsGrouped
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {MobileTopBetsGrouped} MobileTopBetsGrouped
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MobileTopBetsGrouped.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a MobileTopBetsGrouped message.
     * @function verify
     * @memberof MobileTopBetsGrouped
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    MobileTopBetsGrouped.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.TopBets != null && message.hasOwnProperty("TopBets")) {
            var error = $root.WebTopBets.verify(message.TopBets);
            if (error)
                return "TopBets." + error;
        }
        if (message.HotBets != null && message.hasOwnProperty("HotBets")) {
            var error = $root.WebTopBets.verify(message.HotBets);
            if (error)
                return "HotBets." + error;
        }
        if (message.TopBetsTimestamp != null && message.hasOwnProperty("TopBetsTimestamp"))
            if (!$util.isInteger(message.TopBetsTimestamp))
                return "TopBetsTimestamp: integer expected";
        if (message.HotBetsTimestamp != null && message.hasOwnProperty("HotBetsTimestamp"))
            if (!$util.isInteger(message.HotBetsTimestamp))
                return "HotBetsTimestamp: integer expected";
        if (message.Top5PerDay != null && message.hasOwnProperty("Top5PerDay")) {
            var error = $root.WebTopBets.verify(message.Top5PerDay);
            if (error)
                return "Top5PerDay." + error;
        }
        if (message.Top10PerDay != null && message.hasOwnProperty("Top10PerDay")) {
            var error = $root.WebTopBets.verify(message.Top10PerDay);
            if (error)
                return "Top10PerDay." + error;
        }
        if (message.Top5PerDayTimestamp != null && message.hasOwnProperty("Top5PerDayTimestamp"))
            if (!$util.isInteger(message.Top5PerDayTimestamp))
                return "Top5PerDayTimestamp: integer expected";
        if (message.Top10PerDayTimestamp != null && message.hasOwnProperty("Top10PerDayTimestamp"))
            if (!$util.isInteger(message.Top10PerDayTimestamp))
                return "Top10PerDayTimestamp: integer expected";
        return null;
    };

    /**
     * Creates a MobileTopBetsGrouped message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof MobileTopBetsGrouped
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {MobileTopBetsGrouped} MobileTopBetsGrouped
     */
    MobileTopBetsGrouped.fromObject = function fromObject(object) {
        if (object instanceof $root.MobileTopBetsGrouped)
            return object;
        var message = new $root.MobileTopBetsGrouped();
        if (object.TopBets != null) {
            if (typeof object.TopBets !== "object")
                throw TypeError(".MobileTopBetsGrouped.TopBets: object expected");
            message.TopBets = $root.WebTopBets.fromObject(object.TopBets);
        }
        if (object.HotBets != null) {
            if (typeof object.HotBets !== "object")
                throw TypeError(".MobileTopBetsGrouped.HotBets: object expected");
            message.HotBets = $root.WebTopBets.fromObject(object.HotBets);
        }
        if (object.TopBetsTimestamp != null)
            message.TopBetsTimestamp = object.TopBetsTimestamp | 0;
        if (object.HotBetsTimestamp != null)
            message.HotBetsTimestamp = object.HotBetsTimestamp | 0;
        if (object.Top5PerDay != null) {
            if (typeof object.Top5PerDay !== "object")
                throw TypeError(".MobileTopBetsGrouped.Top5PerDay: object expected");
            message.Top5PerDay = $root.WebTopBets.fromObject(object.Top5PerDay);
        }
        if (object.Top10PerDay != null) {
            if (typeof object.Top10PerDay !== "object")
                throw TypeError(".MobileTopBetsGrouped.Top10PerDay: object expected");
            message.Top10PerDay = $root.WebTopBets.fromObject(object.Top10PerDay);
        }
        if (object.Top5PerDayTimestamp != null)
            message.Top5PerDayTimestamp = object.Top5PerDayTimestamp | 0;
        if (object.Top10PerDayTimestamp != null)
            message.Top10PerDayTimestamp = object.Top10PerDayTimestamp | 0;
        return message;
    };

    /**
     * Creates a plain object from a MobileTopBetsGrouped message. Also converts values to other types if specified.
     * @function toObject
     * @memberof MobileTopBetsGrouped
     * @static
     * @param {MobileTopBetsGrouped} message MobileTopBetsGrouped
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MobileTopBetsGrouped.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.TopBets = null;
            object.HotBets = null;
            object.TopBetsTimestamp = 0;
            object.HotBetsTimestamp = 0;
            object.Top5PerDay = null;
            object.Top10PerDay = null;
            object.Top5PerDayTimestamp = 0;
            object.Top10PerDayTimestamp = 0;
        }
        if (message.TopBets != null && message.hasOwnProperty("TopBets"))
            object.TopBets = $root.WebTopBets.toObject(message.TopBets, options);
        if (message.HotBets != null && message.hasOwnProperty("HotBets"))
            object.HotBets = $root.WebTopBets.toObject(message.HotBets, options);
        if (message.TopBetsTimestamp != null && message.hasOwnProperty("TopBetsTimestamp"))
            object.TopBetsTimestamp = message.TopBetsTimestamp;
        if (message.HotBetsTimestamp != null && message.hasOwnProperty("HotBetsTimestamp"))
            object.HotBetsTimestamp = message.HotBetsTimestamp;
        if (message.Top5PerDay != null && message.hasOwnProperty("Top5PerDay"))
            object.Top5PerDay = $root.WebTopBets.toObject(message.Top5PerDay, options);
        if (message.Top10PerDay != null && message.hasOwnProperty("Top10PerDay"))
            object.Top10PerDay = $root.WebTopBets.toObject(message.Top10PerDay, options);
        if (message.Top5PerDayTimestamp != null && message.hasOwnProperty("Top5PerDayTimestamp"))
            object.Top5PerDayTimestamp = message.Top5PerDayTimestamp;
        if (message.Top10PerDayTimestamp != null && message.hasOwnProperty("Top10PerDayTimestamp"))
            object.Top10PerDayTimestamp = message.Top10PerDayTimestamp;
        return object;
    };

    /**
     * Converts this MobileTopBetsGrouped to JSON.
     * @function toJSON
     * @memberof MobileTopBetsGrouped
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MobileTopBetsGrouped.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MobileTopBetsGrouped;
})();

$root.TechnicalInformation = (function() {

    /**
     * Properties of a TechnicalInformation.
     * @exports ITechnicalInformation
     * @interface ITechnicalInformation
     * @property {number|null} [Id] TechnicalInformation Id
     * @property {string|null} [Text] TechnicalInformation Text
     */

    /**
     * Constructs a new TechnicalInformation.
     * @exports TechnicalInformation
     * @classdesc Represents a TechnicalInformation.
     * @implements ITechnicalInformation
     * @constructor
     * @param {ITechnicalInformation=} [properties] Properties to set
     */
    function TechnicalInformation(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * TechnicalInformation Id.
     * @member {number} Id
     * @memberof TechnicalInformation
     * @instance
     */
    TechnicalInformation.prototype.Id = 0;

    /**
     * TechnicalInformation Text.
     * @member {string} Text
     * @memberof TechnicalInformation
     * @instance
     */
    TechnicalInformation.prototype.Text = "";

    /**
     * Creates a new TechnicalInformation instance using the specified properties.
     * @function create
     * @memberof TechnicalInformation
     * @static
     * @param {ITechnicalInformation=} [properties] Properties to set
     * @returns {TechnicalInformation} TechnicalInformation instance
     */
    TechnicalInformation.create = function create(properties) {
        return new TechnicalInformation(properties);
    };

    /**
     * Encodes the specified TechnicalInformation message. Does not implicitly {@link TechnicalInformation.verify|verify} messages.
     * @function encode
     * @memberof TechnicalInformation
     * @static
     * @param {ITechnicalInformation} message TechnicalInformation message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TechnicalInformation.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Id != null && message.hasOwnProperty("Id"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Id);
        if (message.Text != null && message.hasOwnProperty("Text"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.Text);
        return writer;
    };

    /**
     * Encodes the specified TechnicalInformation message, length delimited. Does not implicitly {@link TechnicalInformation.verify|verify} messages.
     * @function encodeDelimited
     * @memberof TechnicalInformation
     * @static
     * @param {ITechnicalInformation} message TechnicalInformation message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TechnicalInformation.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TechnicalInformation message from the specified reader or buffer.
     * @function decode
     * @memberof TechnicalInformation
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TechnicalInformation} TechnicalInformation
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TechnicalInformation.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TechnicalInformation();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Id = reader.int32();
                break;
            case 2:
                message.Text = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a TechnicalInformation message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof TechnicalInformation
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {TechnicalInformation} TechnicalInformation
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TechnicalInformation.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TechnicalInformation message.
     * @function verify
     * @memberof TechnicalInformation
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TechnicalInformation.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Id != null && message.hasOwnProperty("Id"))
            if (!$util.isInteger(message.Id))
                return "Id: integer expected";
        if (message.Text != null && message.hasOwnProperty("Text"))
            if (!$util.isString(message.Text))
                return "Text: string expected";
        return null;
    };

    /**
     * Creates a TechnicalInformation message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TechnicalInformation
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TechnicalInformation} TechnicalInformation
     */
    TechnicalInformation.fromObject = function fromObject(object) {
        if (object instanceof $root.TechnicalInformation)
            return object;
        var message = new $root.TechnicalInformation();
        if (object.Id != null)
            message.Id = object.Id | 0;
        if (object.Text != null)
            message.Text = String(object.Text);
        return message;
    };

    /**
     * Creates a plain object from a TechnicalInformation message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TechnicalInformation
     * @static
     * @param {TechnicalInformation} message TechnicalInformation
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TechnicalInformation.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.Id = 0;
            object.Text = "";
        }
        if (message.Id != null && message.hasOwnProperty("Id"))
            object.Id = message.Id;
        if (message.Text != null && message.hasOwnProperty("Text"))
            object.Text = message.Text;
        return object;
    };

    /**
     * Converts this TechnicalInformation to JSON.
     * @function toJSON
     * @memberof TechnicalInformation
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TechnicalInformation.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TechnicalInformation;
})();

$root.BannerOdds = (function() {

    /**
     * Properties of a BannerOdds.
     * @exports IBannerOdds
     * @interface IBannerOdds
     * @property {number|Long|null} [EventId] BannerOdds EventId
     * @property {string|null} [EventName] BannerOdds EventName
     * @property {ITimestamp|null} [EventDate] BannerOdds EventDate
     * @property {IGame|null} [Game] BannerOdds Game
     * @property {boolean|null} [IsLiveAvailable] BannerOdds IsLiveAvailable
     * @property {OfferType|null} [OfferType] BannerOdds OfferType
     */

    /**
     * Constructs a new BannerOdds.
     * @exports BannerOdds
     * @classdesc Represents a BannerOdds.
     * @implements IBannerOdds
     * @constructor
     * @param {IBannerOdds=} [properties] Properties to set
     */
    function BannerOdds(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * BannerOdds EventId.
     * @member {number|Long} EventId
     * @memberof BannerOdds
     * @instance
     */
    BannerOdds.prototype.EventId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * BannerOdds EventName.
     * @member {string} EventName
     * @memberof BannerOdds
     * @instance
     */
    BannerOdds.prototype.EventName = "";

    /**
     * BannerOdds EventDate.
     * @member {ITimestamp|null|undefined} EventDate
     * @memberof BannerOdds
     * @instance
     */
    BannerOdds.prototype.EventDate = null;

    /**
     * BannerOdds Game.
     * @member {IGame|null|undefined} Game
     * @memberof BannerOdds
     * @instance
     */
    BannerOdds.prototype.Game = null;

    /**
     * BannerOdds IsLiveAvailable.
     * @member {boolean} IsLiveAvailable
     * @memberof BannerOdds
     * @instance
     */
    BannerOdds.prototype.IsLiveAvailable = false;

    /**
     * BannerOdds OfferType.
     * @member {OfferType} OfferType
     * @memberof BannerOdds
     * @instance
     */
    BannerOdds.prototype.OfferType = 0;

    /**
     * Creates a new BannerOdds instance using the specified properties.
     * @function create
     * @memberof BannerOdds
     * @static
     * @param {IBannerOdds=} [properties] Properties to set
     * @returns {BannerOdds} BannerOdds instance
     */
    BannerOdds.create = function create(properties) {
        return new BannerOdds(properties);
    };

    /**
     * Encodes the specified BannerOdds message. Does not implicitly {@link BannerOdds.verify|verify} messages.
     * @function encode
     * @memberof BannerOdds
     * @static
     * @param {IBannerOdds} message BannerOdds message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BannerOdds.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.EventId != null && message.hasOwnProperty("EventId"))
            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.EventId);
        if (message.EventName != null && message.hasOwnProperty("EventName"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.EventName);
        if (message.EventDate != null && message.hasOwnProperty("EventDate"))
            $root.Timestamp.encode(message.EventDate, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        if (message.Game != null && message.hasOwnProperty("Game"))
            $root.Game.encode(message.Game, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        if (message.IsLiveAvailable != null && message.hasOwnProperty("IsLiveAvailable"))
            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.IsLiveAvailable);
        if (message.OfferType != null && message.hasOwnProperty("OfferType"))
            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.OfferType);
        return writer;
    };

    /**
     * Encodes the specified BannerOdds message, length delimited. Does not implicitly {@link BannerOdds.verify|verify} messages.
     * @function encodeDelimited
     * @memberof BannerOdds
     * @static
     * @param {IBannerOdds} message BannerOdds message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BannerOdds.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a BannerOdds message from the specified reader or buffer.
     * @function decode
     * @memberof BannerOdds
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {BannerOdds} BannerOdds
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BannerOdds.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BannerOdds();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.EventId = reader.int64();
                break;
            case 2:
                message.EventName = reader.string();
                break;
            case 3:
                message.EventDate = $root.Timestamp.decode(reader, reader.uint32());
                break;
            case 4:
                message.Game = $root.Game.decode(reader, reader.uint32());
                break;
            case 5:
                message.IsLiveAvailable = reader.bool();
                break;
            case 6:
                message.OfferType = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a BannerOdds message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof BannerOdds
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {BannerOdds} BannerOdds
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BannerOdds.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a BannerOdds message.
     * @function verify
     * @memberof BannerOdds
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    BannerOdds.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.EventId != null && message.hasOwnProperty("EventId"))
            if (!$util.isInteger(message.EventId) && !(message.EventId && $util.isInteger(message.EventId.low) && $util.isInteger(message.EventId.high)))
                return "EventId: integer|Long expected";
        if (message.EventName != null && message.hasOwnProperty("EventName"))
            if (!$util.isString(message.EventName))
                return "EventName: string expected";
        if (message.EventDate != null && message.hasOwnProperty("EventDate")) {
            var error = $root.Timestamp.verify(message.EventDate);
            if (error)
                return "EventDate." + error;
        }
        if (message.Game != null && message.hasOwnProperty("Game")) {
            var error = $root.Game.verify(message.Game);
            if (error)
                return "Game." + error;
        }
        if (message.IsLiveAvailable != null && message.hasOwnProperty("IsLiveAvailable"))
            if (typeof message.IsLiveAvailable !== "boolean")
                return "IsLiveAvailable: boolean expected";
        if (message.OfferType != null && message.hasOwnProperty("OfferType"))
            switch (message.OfferType) {
            default:
                return "OfferType: enum value expected";
            case 0:
            case 1:
                break;
            }
        return null;
    };

    /**
     * Creates a BannerOdds message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof BannerOdds
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {BannerOdds} BannerOdds
     */
    BannerOdds.fromObject = function fromObject(object) {
        if (object instanceof $root.BannerOdds)
            return object;
        var message = new $root.BannerOdds();
        if (object.EventId != null)
            if ($util.Long)
                (message.EventId = $util.Long.fromValue(object.EventId)).unsigned = false;
            else if (typeof object.EventId === "string")
                message.EventId = parseInt(object.EventId, 10);
            else if (typeof object.EventId === "number")
                message.EventId = object.EventId;
            else if (typeof object.EventId === "object")
                message.EventId = new $util.LongBits(object.EventId.low >>> 0, object.EventId.high >>> 0).toNumber();
        if (object.EventName != null)
            message.EventName = String(object.EventName);
        if (object.EventDate != null) {
            if (typeof object.EventDate !== "object")
                throw TypeError(".BannerOdds.EventDate: object expected");
            message.EventDate = $root.Timestamp.fromObject(object.EventDate);
        }
        if (object.Game != null) {
            if (typeof object.Game !== "object")
                throw TypeError(".BannerOdds.Game: object expected");
            message.Game = $root.Game.fromObject(object.Game);
        }
        if (object.IsLiveAvailable != null)
            message.IsLiveAvailable = Boolean(object.IsLiveAvailable);
        switch (object.OfferType) {
        case "Prematch":
        case 0:
            message.OfferType = 0;
            break;
        case "Live":
        case 1:
            message.OfferType = 1;
            break;
        }
        return message;
    };

    /**
     * Creates a plain object from a BannerOdds message. Also converts values to other types if specified.
     * @function toObject
     * @memberof BannerOdds
     * @static
     * @param {BannerOdds} message BannerOdds
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    BannerOdds.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.EventId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.EventId = options.longs === String ? "0" : 0;
            object.EventName = "";
            object.EventDate = null;
            object.Game = null;
            object.IsLiveAvailable = false;
            object.OfferType = options.enums === String ? "Prematch" : 0;
        }
        if (message.EventId != null && message.hasOwnProperty("EventId"))
            if (typeof message.EventId === "number")
                object.EventId = options.longs === String ? String(message.EventId) : message.EventId;
            else
                object.EventId = options.longs === String ? $util.Long.prototype.toString.call(message.EventId) : options.longs === Number ? new $util.LongBits(message.EventId.low >>> 0, message.EventId.high >>> 0).toNumber() : message.EventId;
        if (message.EventName != null && message.hasOwnProperty("EventName"))
            object.EventName = message.EventName;
        if (message.EventDate != null && message.hasOwnProperty("EventDate"))
            object.EventDate = $root.Timestamp.toObject(message.EventDate, options);
        if (message.Game != null && message.hasOwnProperty("Game"))
            object.Game = $root.Game.toObject(message.Game, options);
        if (message.IsLiveAvailable != null && message.hasOwnProperty("IsLiveAvailable"))
            object.IsLiveAvailable = message.IsLiveAvailable;
        if (message.OfferType != null && message.hasOwnProperty("OfferType"))
            object.OfferType = options.enums === String ? $root.OfferType[message.OfferType] : message.OfferType;
        return object;
    };

    /**
     * Converts this BannerOdds to JSON.
     * @function toJSON
     * @memberof BannerOdds
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    BannerOdds.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BannerOdds;
})();

$root.Banner = (function() {

    /**
     * Properties of a Banner.
     * @exports IBanner
     * @interface IBanner
     * @property {number|null} [Id] Banner Id
     * @property {string|null} [Title] Banner Title
     * @property {string|null} [LinkUrl] Banner LinkUrl
     * @property {string|null} [FullImgUrl] Banner FullImgUrl
     * @property {IBannerOdds|null} [Odds] Banner Odds
     * @property {string|null} [FullWebPImgUrl] Banner FullWebPImgUrl
     */

    /**
     * Constructs a new Banner.
     * @exports Banner
     * @classdesc Represents a Banner.
     * @implements IBanner
     * @constructor
     * @param {IBanner=} [properties] Properties to set
     */
    function Banner(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * Banner Id.
     * @member {number} Id
     * @memberof Banner
     * @instance
     */
    Banner.prototype.Id = 0;

    /**
     * Banner Title.
     * @member {string} Title
     * @memberof Banner
     * @instance
     */
    Banner.prototype.Title = "";

    /**
     * Banner LinkUrl.
     * @member {string} LinkUrl
     * @memberof Banner
     * @instance
     */
    Banner.prototype.LinkUrl = "";

    /**
     * Banner FullImgUrl.
     * @member {string} FullImgUrl
     * @memberof Banner
     * @instance
     */
    Banner.prototype.FullImgUrl = "";

    /**
     * Banner Odds.
     * @member {IBannerOdds|null|undefined} Odds
     * @memberof Banner
     * @instance
     */
    Banner.prototype.Odds = null;

    /**
     * Banner FullWebPImgUrl.
     * @member {string} FullWebPImgUrl
     * @memberof Banner
     * @instance
     */
    Banner.prototype.FullWebPImgUrl = "";

    /**
     * Creates a new Banner instance using the specified properties.
     * @function create
     * @memberof Banner
     * @static
     * @param {IBanner=} [properties] Properties to set
     * @returns {Banner} Banner instance
     */
    Banner.create = function create(properties) {
        return new Banner(properties);
    };

    /**
     * Encodes the specified Banner message. Does not implicitly {@link Banner.verify|verify} messages.
     * @function encode
     * @memberof Banner
     * @static
     * @param {IBanner} message Banner message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Banner.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Id != null && message.hasOwnProperty("Id"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Id);
        if (message.Title != null && message.hasOwnProperty("Title"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.Title);
        if (message.LinkUrl != null && message.hasOwnProperty("LinkUrl"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.LinkUrl);
        if (message.FullImgUrl != null && message.hasOwnProperty("FullImgUrl"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.FullImgUrl);
        if (message.Odds != null && message.hasOwnProperty("Odds"))
            $root.BannerOdds.encode(message.Odds, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
        if (message.FullWebPImgUrl != null && message.hasOwnProperty("FullWebPImgUrl"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.FullWebPImgUrl);
        return writer;
    };

    /**
     * Encodes the specified Banner message, length delimited. Does not implicitly {@link Banner.verify|verify} messages.
     * @function encodeDelimited
     * @memberof Banner
     * @static
     * @param {IBanner} message Banner message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    Banner.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a Banner message from the specified reader or buffer.
     * @function decode
     * @memberof Banner
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {Banner} Banner
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Banner.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.Banner();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Id = reader.int32();
                break;
            case 2:
                message.Title = reader.string();
                break;
            case 3:
                message.LinkUrl = reader.string();
                break;
            case 4:
                message.FullImgUrl = reader.string();
                break;
            case 5:
                message.Odds = $root.BannerOdds.decode(reader, reader.uint32());
                break;
            case 6:
                message.FullWebPImgUrl = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a Banner message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof Banner
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {Banner} Banner
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    Banner.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a Banner message.
     * @function verify
     * @memberof Banner
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    Banner.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Id != null && message.hasOwnProperty("Id"))
            if (!$util.isInteger(message.Id))
                return "Id: integer expected";
        if (message.Title != null && message.hasOwnProperty("Title"))
            if (!$util.isString(message.Title))
                return "Title: string expected";
        if (message.LinkUrl != null && message.hasOwnProperty("LinkUrl"))
            if (!$util.isString(message.LinkUrl))
                return "LinkUrl: string expected";
        if (message.FullImgUrl != null && message.hasOwnProperty("FullImgUrl"))
            if (!$util.isString(message.FullImgUrl))
                return "FullImgUrl: string expected";
        if (message.Odds != null && message.hasOwnProperty("Odds")) {
            var error = $root.BannerOdds.verify(message.Odds);
            if (error)
                return "Odds." + error;
        }
        if (message.FullWebPImgUrl != null && message.hasOwnProperty("FullWebPImgUrl"))
            if (!$util.isString(message.FullWebPImgUrl))
                return "FullWebPImgUrl: string expected";
        return null;
    };

    /**
     * Creates a Banner message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof Banner
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {Banner} Banner
     */
    Banner.fromObject = function fromObject(object) {
        if (object instanceof $root.Banner)
            return object;
        var message = new $root.Banner();
        if (object.Id != null)
            message.Id = object.Id | 0;
        if (object.Title != null)
            message.Title = String(object.Title);
        if (object.LinkUrl != null)
            message.LinkUrl = String(object.LinkUrl);
        if (object.FullImgUrl != null)
            message.FullImgUrl = String(object.FullImgUrl);
        if (object.Odds != null) {
            if (typeof object.Odds !== "object")
                throw TypeError(".Banner.Odds: object expected");
            message.Odds = $root.BannerOdds.fromObject(object.Odds);
        }
        if (object.FullWebPImgUrl != null)
            message.FullWebPImgUrl = String(object.FullWebPImgUrl);
        return message;
    };

    /**
     * Creates a plain object from a Banner message. Also converts values to other types if specified.
     * @function toObject
     * @memberof Banner
     * @static
     * @param {Banner} message Banner
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    Banner.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.Id = 0;
            object.Title = "";
            object.LinkUrl = "";
            object.FullImgUrl = "";
            object.Odds = null;
            object.FullWebPImgUrl = "";
        }
        if (message.Id != null && message.hasOwnProperty("Id"))
            object.Id = message.Id;
        if (message.Title != null && message.hasOwnProperty("Title"))
            object.Title = message.Title;
        if (message.LinkUrl != null && message.hasOwnProperty("LinkUrl"))
            object.LinkUrl = message.LinkUrl;
        if (message.FullImgUrl != null && message.hasOwnProperty("FullImgUrl"))
            object.FullImgUrl = message.FullImgUrl;
        if (message.Odds != null && message.hasOwnProperty("Odds"))
            object.Odds = $root.BannerOdds.toObject(message.Odds, options);
        if (message.FullWebPImgUrl != null && message.hasOwnProperty("FullWebPImgUrl"))
            object.FullWebPImgUrl = message.FullWebPImgUrl;
        return object;
    };

    /**
     * Converts this Banner to JSON.
     * @function toJSON
     * @memberof Banner
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    Banner.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return Banner;
})();

$root.BannersList = (function() {

    /**
     * Properties of a BannersList.
     * @exports IBannersList
     * @interface IBannersList
     * @property {Array.<IBanner>|null} [Banners] BannersList Banners
     * @property {number|null} [RotationIntervalInSec] BannersList RotationIntervalInSec
     * @property {IBannersGTMDataLayer|null} [GTMDataLayer] BannersList GTMDataLayer
     */

    /**
     * Constructs a new BannersList.
     * @exports BannersList
     * @classdesc Represents a BannersList.
     * @implements IBannersList
     * @constructor
     * @param {IBannersList=} [properties] Properties to set
     */
    function BannersList(properties) {
        this.Banners = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * BannersList Banners.
     * @member {Array.<IBanner>} Banners
     * @memberof BannersList
     * @instance
     */
    BannersList.prototype.Banners = $util.emptyArray;

    /**
     * BannersList RotationIntervalInSec.
     * @member {number} RotationIntervalInSec
     * @memberof BannersList
     * @instance
     */
    BannersList.prototype.RotationIntervalInSec = 0;

    /**
     * BannersList GTMDataLayer.
     * @member {IBannersGTMDataLayer|null|undefined} GTMDataLayer
     * @memberof BannersList
     * @instance
     */
    BannersList.prototype.GTMDataLayer = null;

    /**
     * Creates a new BannersList instance using the specified properties.
     * @function create
     * @memberof BannersList
     * @static
     * @param {IBannersList=} [properties] Properties to set
     * @returns {BannersList} BannersList instance
     */
    BannersList.create = function create(properties) {
        return new BannersList(properties);
    };

    /**
     * Encodes the specified BannersList message. Does not implicitly {@link BannersList.verify|verify} messages.
     * @function encode
     * @memberof BannersList
     * @static
     * @param {IBannersList} message BannersList message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BannersList.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Banners != null && message.Banners.length)
            for (var i = 0; i < message.Banners.length; ++i)
                $root.Banner.encode(message.Banners[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.RotationIntervalInSec != null && message.hasOwnProperty("RotationIntervalInSec"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.RotationIntervalInSec);
        if (message.GTMDataLayer != null && message.hasOwnProperty("GTMDataLayer"))
            $root.BannersGTMDataLayer.encode(message.GTMDataLayer, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified BannersList message, length delimited. Does not implicitly {@link BannersList.verify|verify} messages.
     * @function encodeDelimited
     * @memberof BannersList
     * @static
     * @param {IBannersList} message BannersList message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BannersList.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a BannersList message from the specified reader or buffer.
     * @function decode
     * @memberof BannersList
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {BannersList} BannersList
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BannersList.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BannersList();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.Banners && message.Banners.length))
                    message.Banners = [];
                message.Banners.push($root.Banner.decode(reader, reader.uint32()));
                break;
            case 2:
                message.RotationIntervalInSec = reader.int32();
                break;
            case 3:
                message.GTMDataLayer = $root.BannersGTMDataLayer.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a BannersList message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof BannersList
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {BannersList} BannersList
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BannersList.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a BannersList message.
     * @function verify
     * @memberof BannersList
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    BannersList.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Banners != null && message.hasOwnProperty("Banners")) {
            if (!Array.isArray(message.Banners))
                return "Banners: array expected";
            for (var i = 0; i < message.Banners.length; ++i) {
                var error = $root.Banner.verify(message.Banners[i]);
                if (error)
                    return "Banners." + error;
            }
        }
        if (message.RotationIntervalInSec != null && message.hasOwnProperty("RotationIntervalInSec"))
            if (!$util.isInteger(message.RotationIntervalInSec))
                return "RotationIntervalInSec: integer expected";
        if (message.GTMDataLayer != null && message.hasOwnProperty("GTMDataLayer")) {
            var error = $root.BannersGTMDataLayer.verify(message.GTMDataLayer);
            if (error)
                return "GTMDataLayer." + error;
        }
        return null;
    };

    /**
     * Creates a BannersList message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof BannersList
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {BannersList} BannersList
     */
    BannersList.fromObject = function fromObject(object) {
        if (object instanceof $root.BannersList)
            return object;
        var message = new $root.BannersList();
        if (object.Banners) {
            if (!Array.isArray(object.Banners))
                throw TypeError(".BannersList.Banners: array expected");
            message.Banners = [];
            for (var i = 0; i < object.Banners.length; ++i) {
                if (typeof object.Banners[i] !== "object")
                    throw TypeError(".BannersList.Banners: object expected");
                message.Banners[i] = $root.Banner.fromObject(object.Banners[i]);
            }
        }
        if (object.RotationIntervalInSec != null)
            message.RotationIntervalInSec = object.RotationIntervalInSec | 0;
        if (object.GTMDataLayer != null) {
            if (typeof object.GTMDataLayer !== "object")
                throw TypeError(".BannersList.GTMDataLayer: object expected");
            message.GTMDataLayer = $root.BannersGTMDataLayer.fromObject(object.GTMDataLayer);
        }
        return message;
    };

    /**
     * Creates a plain object from a BannersList message. Also converts values to other types if specified.
     * @function toObject
     * @memberof BannersList
     * @static
     * @param {BannersList} message BannersList
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    BannersList.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.Banners = [];
        if (options.defaults) {
            object.RotationIntervalInSec = 0;
            object.GTMDataLayer = null;
        }
        if (message.Banners && message.Banners.length) {
            object.Banners = [];
            for (var j = 0; j < message.Banners.length; ++j)
                object.Banners[j] = $root.Banner.toObject(message.Banners[j], options);
        }
        if (message.RotationIntervalInSec != null && message.hasOwnProperty("RotationIntervalInSec"))
            object.RotationIntervalInSec = message.RotationIntervalInSec;
        if (message.GTMDataLayer != null && message.hasOwnProperty("GTMDataLayer"))
            object.GTMDataLayer = $root.BannersGTMDataLayer.toObject(message.GTMDataLayer, options);
        return object;
    };

    /**
     * Converts this BannersList to JSON.
     * @function toJSON
     * @memberof BannersList
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    BannersList.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BannersList;
})();

$root.BannersGTMDataLayer = (function() {

    /**
     * Properties of a BannersGTMDataLayer.
     * @exports IBannersGTMDataLayer
     * @interface IBannersGTMDataLayer
     * @property {string|null} [ViewPromotionAsJson] BannersGTMDataLayer ViewPromotionAsJson
     * @property {string|null} [ViewItemListAsJson] BannersGTMDataLayer ViewItemListAsJson
     */

    /**
     * Constructs a new BannersGTMDataLayer.
     * @exports BannersGTMDataLayer
     * @classdesc Represents a BannersGTMDataLayer.
     * @implements IBannersGTMDataLayer
     * @constructor
     * @param {IBannersGTMDataLayer=} [properties] Properties to set
     */
    function BannersGTMDataLayer(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * BannersGTMDataLayer ViewPromotionAsJson.
     * @member {string} ViewPromotionAsJson
     * @memberof BannersGTMDataLayer
     * @instance
     */
    BannersGTMDataLayer.prototype.ViewPromotionAsJson = "";

    /**
     * BannersGTMDataLayer ViewItemListAsJson.
     * @member {string} ViewItemListAsJson
     * @memberof BannersGTMDataLayer
     * @instance
     */
    BannersGTMDataLayer.prototype.ViewItemListAsJson = "";

    /**
     * Creates a new BannersGTMDataLayer instance using the specified properties.
     * @function create
     * @memberof BannersGTMDataLayer
     * @static
     * @param {IBannersGTMDataLayer=} [properties] Properties to set
     * @returns {BannersGTMDataLayer} BannersGTMDataLayer instance
     */
    BannersGTMDataLayer.create = function create(properties) {
        return new BannersGTMDataLayer(properties);
    };

    /**
     * Encodes the specified BannersGTMDataLayer message. Does not implicitly {@link BannersGTMDataLayer.verify|verify} messages.
     * @function encode
     * @memberof BannersGTMDataLayer
     * @static
     * @param {IBannersGTMDataLayer} message BannersGTMDataLayer message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BannersGTMDataLayer.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ViewPromotionAsJson != null && message.hasOwnProperty("ViewPromotionAsJson"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.ViewPromotionAsJson);
        if (message.ViewItemListAsJson != null && message.hasOwnProperty("ViewItemListAsJson"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.ViewItemListAsJson);
        return writer;
    };

    /**
     * Encodes the specified BannersGTMDataLayer message, length delimited. Does not implicitly {@link BannersGTMDataLayer.verify|verify} messages.
     * @function encodeDelimited
     * @memberof BannersGTMDataLayer
     * @static
     * @param {IBannersGTMDataLayer} message BannersGTMDataLayer message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    BannersGTMDataLayer.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a BannersGTMDataLayer message from the specified reader or buffer.
     * @function decode
     * @memberof BannersGTMDataLayer
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {BannersGTMDataLayer} BannersGTMDataLayer
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BannersGTMDataLayer.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.BannersGTMDataLayer();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.ViewPromotionAsJson = reader.string();
                break;
            case 2:
                message.ViewItemListAsJson = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a BannersGTMDataLayer message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof BannersGTMDataLayer
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {BannersGTMDataLayer} BannersGTMDataLayer
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    BannersGTMDataLayer.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a BannersGTMDataLayer message.
     * @function verify
     * @memberof BannersGTMDataLayer
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    BannersGTMDataLayer.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ViewPromotionAsJson != null && message.hasOwnProperty("ViewPromotionAsJson"))
            if (!$util.isString(message.ViewPromotionAsJson))
                return "ViewPromotionAsJson: string expected";
        if (message.ViewItemListAsJson != null && message.hasOwnProperty("ViewItemListAsJson"))
            if (!$util.isString(message.ViewItemListAsJson))
                return "ViewItemListAsJson: string expected";
        return null;
    };

    /**
     * Creates a BannersGTMDataLayer message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof BannersGTMDataLayer
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {BannersGTMDataLayer} BannersGTMDataLayer
     */
    BannersGTMDataLayer.fromObject = function fromObject(object) {
        if (object instanceof $root.BannersGTMDataLayer)
            return object;
        var message = new $root.BannersGTMDataLayer();
        if (object.ViewPromotionAsJson != null)
            message.ViewPromotionAsJson = String(object.ViewPromotionAsJson);
        if (object.ViewItemListAsJson != null)
            message.ViewItemListAsJson = String(object.ViewItemListAsJson);
        return message;
    };

    /**
     * Creates a plain object from a BannersGTMDataLayer message. Also converts values to other types if specified.
     * @function toObject
     * @memberof BannersGTMDataLayer
     * @static
     * @param {BannersGTMDataLayer} message BannersGTMDataLayer
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    BannersGTMDataLayer.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.ViewPromotionAsJson = "";
            object.ViewItemListAsJson = "";
        }
        if (message.ViewPromotionAsJson != null && message.hasOwnProperty("ViewPromotionAsJson"))
            object.ViewPromotionAsJson = message.ViewPromotionAsJson;
        if (message.ViewItemListAsJson != null && message.hasOwnProperty("ViewItemListAsJson"))
            object.ViewItemListAsJson = message.ViewItemListAsJson;
        return object;
    };

    /**
     * Converts this BannersGTMDataLayer to JSON.
     * @function toJSON
     * @memberof BannersGTMDataLayer
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    BannersGTMDataLayer.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return BannersGTMDataLayer;
})();

$root.WebMobileHomeData = (function() {

    /**
     * Properties of a WebMobileHomeData.
     * @exports IWebMobileHomeData
     * @interface IWebMobileHomeData
     * @property {ITechnicalInformation|null} [TechnicalInformation] WebMobileHomeData TechnicalInformation
     * @property {IBannersList|null} [Banners] WebMobileHomeData Banners
     * @property {IMobileTopBetsGrouped|null} [TopBets] WebMobileHomeData TopBets
     */

    /**
     * Constructs a new WebMobileHomeData.
     * @exports WebMobileHomeData
     * @classdesc Represents a WebMobileHomeData.
     * @implements IWebMobileHomeData
     * @constructor
     * @param {IWebMobileHomeData=} [properties] Properties to set
     */
    function WebMobileHomeData(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * WebMobileHomeData TechnicalInformation.
     * @member {ITechnicalInformation|null|undefined} TechnicalInformation
     * @memberof WebMobileHomeData
     * @instance
     */
    WebMobileHomeData.prototype.TechnicalInformation = null;

    /**
     * WebMobileHomeData Banners.
     * @member {IBannersList|null|undefined} Banners
     * @memberof WebMobileHomeData
     * @instance
     */
    WebMobileHomeData.prototype.Banners = null;

    /**
     * WebMobileHomeData TopBets.
     * @member {IMobileTopBetsGrouped|null|undefined} TopBets
     * @memberof WebMobileHomeData
     * @instance
     */
    WebMobileHomeData.prototype.TopBets = null;

    /**
     * Creates a new WebMobileHomeData instance using the specified properties.
     * @function create
     * @memberof WebMobileHomeData
     * @static
     * @param {IWebMobileHomeData=} [properties] Properties to set
     * @returns {WebMobileHomeData} WebMobileHomeData instance
     */
    WebMobileHomeData.create = function create(properties) {
        return new WebMobileHomeData(properties);
    };

    /**
     * Encodes the specified WebMobileHomeData message. Does not implicitly {@link WebMobileHomeData.verify|verify} messages.
     * @function encode
     * @memberof WebMobileHomeData
     * @static
     * @param {IWebMobileHomeData} message WebMobileHomeData message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    WebMobileHomeData.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.TechnicalInformation != null && message.hasOwnProperty("TechnicalInformation"))
            $root.TechnicalInformation.encode(message.TechnicalInformation, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.Banners != null && message.hasOwnProperty("Banners"))
            $root.BannersList.encode(message.Banners, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.TopBets != null && message.hasOwnProperty("TopBets"))
            $root.MobileTopBetsGrouped.encode(message.TopBets, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified WebMobileHomeData message, length delimited. Does not implicitly {@link WebMobileHomeData.verify|verify} messages.
     * @function encodeDelimited
     * @memberof WebMobileHomeData
     * @static
     * @param {IWebMobileHomeData} message WebMobileHomeData message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    WebMobileHomeData.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a WebMobileHomeData message from the specified reader or buffer.
     * @function decode
     * @memberof WebMobileHomeData
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {WebMobileHomeData} WebMobileHomeData
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    WebMobileHomeData.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.WebMobileHomeData();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.TechnicalInformation = $root.TechnicalInformation.decode(reader, reader.uint32());
                break;
            case 2:
                message.Banners = $root.BannersList.decode(reader, reader.uint32());
                break;
            case 3:
                message.TopBets = $root.MobileTopBetsGrouped.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a WebMobileHomeData message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof WebMobileHomeData
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {WebMobileHomeData} WebMobileHomeData
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    WebMobileHomeData.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a WebMobileHomeData message.
     * @function verify
     * @memberof WebMobileHomeData
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    WebMobileHomeData.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.TechnicalInformation != null && message.hasOwnProperty("TechnicalInformation")) {
            var error = $root.TechnicalInformation.verify(message.TechnicalInformation);
            if (error)
                return "TechnicalInformation." + error;
        }
        if (message.Banners != null && message.hasOwnProperty("Banners")) {
            var error = $root.BannersList.verify(message.Banners);
            if (error)
                return "Banners." + error;
        }
        if (message.TopBets != null && message.hasOwnProperty("TopBets")) {
            var error = $root.MobileTopBetsGrouped.verify(message.TopBets);
            if (error)
                return "TopBets." + error;
        }
        return null;
    };

    /**
     * Creates a WebMobileHomeData message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof WebMobileHomeData
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {WebMobileHomeData} WebMobileHomeData
     */
    WebMobileHomeData.fromObject = function fromObject(object) {
        if (object instanceof $root.WebMobileHomeData)
            return object;
        var message = new $root.WebMobileHomeData();
        if (object.TechnicalInformation != null) {
            if (typeof object.TechnicalInformation !== "object")
                throw TypeError(".WebMobileHomeData.TechnicalInformation: object expected");
            message.TechnicalInformation = $root.TechnicalInformation.fromObject(object.TechnicalInformation);
        }
        if (object.Banners != null) {
            if (typeof object.Banners !== "object")
                throw TypeError(".WebMobileHomeData.Banners: object expected");
            message.Banners = $root.BannersList.fromObject(object.Banners);
        }
        if (object.TopBets != null) {
            if (typeof object.TopBets !== "object")
                throw TypeError(".WebMobileHomeData.TopBets: object expected");
            message.TopBets = $root.MobileTopBetsGrouped.fromObject(object.TopBets);
        }
        return message;
    };

    /**
     * Creates a plain object from a WebMobileHomeData message. Also converts values to other types if specified.
     * @function toObject
     * @memberof WebMobileHomeData
     * @static
     * @param {WebMobileHomeData} message WebMobileHomeData
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    WebMobileHomeData.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.TechnicalInformation = null;
            object.Banners = null;
            object.TopBets = null;
        }
        if (message.TechnicalInformation != null && message.hasOwnProperty("TechnicalInformation"))
            object.TechnicalInformation = $root.TechnicalInformation.toObject(message.TechnicalInformation, options);
        if (message.Banners != null && message.hasOwnProperty("Banners"))
            object.Banners = $root.BannersList.toObject(message.Banners, options);
        if (message.TopBets != null && message.hasOwnProperty("TopBets"))
            object.TopBets = $root.MobileTopBetsGrouped.toObject(message.TopBets, options);
        return object;
    };

    /**
     * Converts this WebMobileHomeData to JSON.
     * @function toJSON
     * @memberof WebMobileHomeData
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    WebMobileHomeData.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return WebMobileHomeData;
})();

$root.WebHomeData = (function() {

    /**
     * Properties of a WebHomeData.
     * @exports IWebHomeData
     * @interface IWebHomeData
     * @property {ITechnicalInformation|null} [TechnicalInformation] WebHomeData TechnicalInformation
     * @property {INewsList|null} [Recommended] WebHomeData Recommended
     * @property {IHomeTabList|null} [HomeTabs] WebHomeData HomeTabs
     * @property {IBannersList|null} [Banners] WebHomeData Banners
     */

    /**
     * Constructs a new WebHomeData.
     * @exports WebHomeData
     * @classdesc Represents a WebHomeData.
     * @implements IWebHomeData
     * @constructor
     * @param {IWebHomeData=} [properties] Properties to set
     */
    function WebHomeData(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * WebHomeData TechnicalInformation.
     * @member {ITechnicalInformation|null|undefined} TechnicalInformation
     * @memberof WebHomeData
     * @instance
     */
    WebHomeData.prototype.TechnicalInformation = null;

    /**
     * WebHomeData Recommended.
     * @member {INewsList|null|undefined} Recommended
     * @memberof WebHomeData
     * @instance
     */
    WebHomeData.prototype.Recommended = null;

    /**
     * WebHomeData HomeTabs.
     * @member {IHomeTabList|null|undefined} HomeTabs
     * @memberof WebHomeData
     * @instance
     */
    WebHomeData.prototype.HomeTabs = null;

    /**
     * WebHomeData Banners.
     * @member {IBannersList|null|undefined} Banners
     * @memberof WebHomeData
     * @instance
     */
    WebHomeData.prototype.Banners = null;

    /**
     * Creates a new WebHomeData instance using the specified properties.
     * @function create
     * @memberof WebHomeData
     * @static
     * @param {IWebHomeData=} [properties] Properties to set
     * @returns {WebHomeData} WebHomeData instance
     */
    WebHomeData.create = function create(properties) {
        return new WebHomeData(properties);
    };

    /**
     * Encodes the specified WebHomeData message. Does not implicitly {@link WebHomeData.verify|verify} messages.
     * @function encode
     * @memberof WebHomeData
     * @static
     * @param {IWebHomeData} message WebHomeData message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    WebHomeData.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.TechnicalInformation != null && message.hasOwnProperty("TechnicalInformation"))
            $root.TechnicalInformation.encode(message.TechnicalInformation, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.Recommended != null && message.hasOwnProperty("Recommended"))
            $root.NewsList.encode(message.Recommended, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.HomeTabs != null && message.hasOwnProperty("HomeTabs"))
            $root.HomeTabList.encode(message.HomeTabs, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        if (message.Banners != null && message.hasOwnProperty("Banners"))
            $root.BannersList.encode(message.Banners, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified WebHomeData message, length delimited. Does not implicitly {@link WebHomeData.verify|verify} messages.
     * @function encodeDelimited
     * @memberof WebHomeData
     * @static
     * @param {IWebHomeData} message WebHomeData message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    WebHomeData.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a WebHomeData message from the specified reader or buffer.
     * @function decode
     * @memberof WebHomeData
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {WebHomeData} WebHomeData
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    WebHomeData.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.WebHomeData();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.TechnicalInformation = $root.TechnicalInformation.decode(reader, reader.uint32());
                break;
            case 2:
                message.Recommended = $root.NewsList.decode(reader, reader.uint32());
                break;
            case 3:
                message.HomeTabs = $root.HomeTabList.decode(reader, reader.uint32());
                break;
            case 4:
                message.Banners = $root.BannersList.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a WebHomeData message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof WebHomeData
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {WebHomeData} WebHomeData
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    WebHomeData.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a WebHomeData message.
     * @function verify
     * @memberof WebHomeData
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    WebHomeData.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.TechnicalInformation != null && message.hasOwnProperty("TechnicalInformation")) {
            var error = $root.TechnicalInformation.verify(message.TechnicalInformation);
            if (error)
                return "TechnicalInformation." + error;
        }
        if (message.Recommended != null && message.hasOwnProperty("Recommended")) {
            var error = $root.NewsList.verify(message.Recommended);
            if (error)
                return "Recommended." + error;
        }
        if (message.HomeTabs != null && message.hasOwnProperty("HomeTabs")) {
            var error = $root.HomeTabList.verify(message.HomeTabs);
            if (error)
                return "HomeTabs." + error;
        }
        if (message.Banners != null && message.hasOwnProperty("Banners")) {
            var error = $root.BannersList.verify(message.Banners);
            if (error)
                return "Banners." + error;
        }
        return null;
    };

    /**
     * Creates a WebHomeData message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof WebHomeData
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {WebHomeData} WebHomeData
     */
    WebHomeData.fromObject = function fromObject(object) {
        if (object instanceof $root.WebHomeData)
            return object;
        var message = new $root.WebHomeData();
        if (object.TechnicalInformation != null) {
            if (typeof object.TechnicalInformation !== "object")
                throw TypeError(".WebHomeData.TechnicalInformation: object expected");
            message.TechnicalInformation = $root.TechnicalInformation.fromObject(object.TechnicalInformation);
        }
        if (object.Recommended != null) {
            if (typeof object.Recommended !== "object")
                throw TypeError(".WebHomeData.Recommended: object expected");
            message.Recommended = $root.NewsList.fromObject(object.Recommended);
        }
        if (object.HomeTabs != null) {
            if (typeof object.HomeTabs !== "object")
                throw TypeError(".WebHomeData.HomeTabs: object expected");
            message.HomeTabs = $root.HomeTabList.fromObject(object.HomeTabs);
        }
        if (object.Banners != null) {
            if (typeof object.Banners !== "object")
                throw TypeError(".WebHomeData.Banners: object expected");
            message.Banners = $root.BannersList.fromObject(object.Banners);
        }
        return message;
    };

    /**
     * Creates a plain object from a WebHomeData message. Also converts values to other types if specified.
     * @function toObject
     * @memberof WebHomeData
     * @static
     * @param {WebHomeData} message WebHomeData
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    WebHomeData.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.TechnicalInformation = null;
            object.Recommended = null;
            object.HomeTabs = null;
            object.Banners = null;
        }
        if (message.TechnicalInformation != null && message.hasOwnProperty("TechnicalInformation"))
            object.TechnicalInformation = $root.TechnicalInformation.toObject(message.TechnicalInformation, options);
        if (message.Recommended != null && message.hasOwnProperty("Recommended"))
            object.Recommended = $root.NewsList.toObject(message.Recommended, options);
        if (message.HomeTabs != null && message.hasOwnProperty("HomeTabs"))
            object.HomeTabs = $root.HomeTabList.toObject(message.HomeTabs, options);
        if (message.Banners != null && message.hasOwnProperty("Banners"))
            object.Banners = $root.BannersList.toObject(message.Banners, options);
        return object;
    };

    /**
     * Converts this WebHomeData to JSON.
     * @function toJSON
     * @memberof WebHomeData
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    WebHomeData.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return WebHomeData;
})();

$root.News = (function() {

    /**
     * Properties of a News.
     * @exports INews
     * @interface INews
     * @property {number|null} [Id] News Id
     * @property {string|null} [Title] News Title
     * @property {string|null} [Text] News Text
     * @property {string|null} [ImgUrl] News ImgUrl
     * @property {IBannerOdds|null} [Odds] News Odds
     * @property {number|null} [Sequence] News Sequence
     */

    /**
     * Constructs a new News.
     * @exports News
     * @classdesc Represents a News.
     * @implements INews
     * @constructor
     * @param {INews=} [properties] Properties to set
     */
    function News(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * News Id.
     * @member {number} Id
     * @memberof News
     * @instance
     */
    News.prototype.Id = 0;

    /**
     * News Title.
     * @member {string} Title
     * @memberof News
     * @instance
     */
    News.prototype.Title = "";

    /**
     * News Text.
     * @member {string} Text
     * @memberof News
     * @instance
     */
    News.prototype.Text = "";

    /**
     * News ImgUrl.
     * @member {string} ImgUrl
     * @memberof News
     * @instance
     */
    News.prototype.ImgUrl = "";

    /**
     * News Odds.
     * @member {IBannerOdds|null|undefined} Odds
     * @memberof News
     * @instance
     */
    News.prototype.Odds = null;

    /**
     * News Sequence.
     * @member {number} Sequence
     * @memberof News
     * @instance
     */
    News.prototype.Sequence = 0;

    /**
     * Creates a new News instance using the specified properties.
     * @function create
     * @memberof News
     * @static
     * @param {INews=} [properties] Properties to set
     * @returns {News} News instance
     */
    News.create = function create(properties) {
        return new News(properties);
    };

    /**
     * Encodes the specified News message. Does not implicitly {@link News.verify|verify} messages.
     * @function encode
     * @memberof News
     * @static
     * @param {INews} message News message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    News.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Id != null && message.hasOwnProperty("Id"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Id);
        if (message.Title != null && message.hasOwnProperty("Title"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.Title);
        if (message.Text != null && message.hasOwnProperty("Text"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.Text);
        if (message.ImgUrl != null && message.hasOwnProperty("ImgUrl"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.ImgUrl);
        if (message.Odds != null && message.hasOwnProperty("Odds"))
            $root.BannerOdds.encode(message.Odds, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
        if (message.Sequence != null && message.hasOwnProperty("Sequence"))
            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.Sequence);
        return writer;
    };

    /**
     * Encodes the specified News message, length delimited. Does not implicitly {@link News.verify|verify} messages.
     * @function encodeDelimited
     * @memberof News
     * @static
     * @param {INews} message News message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    News.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a News message from the specified reader or buffer.
     * @function decode
     * @memberof News
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {News} News
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    News.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.News();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Id = reader.int32();
                break;
            case 2:
                message.Title = reader.string();
                break;
            case 3:
                message.Text = reader.string();
                break;
            case 4:
                message.ImgUrl = reader.string();
                break;
            case 5:
                message.Odds = $root.BannerOdds.decode(reader, reader.uint32());
                break;
            case 6:
                message.Sequence = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a News message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof News
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {News} News
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    News.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a News message.
     * @function verify
     * @memberof News
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    News.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Id != null && message.hasOwnProperty("Id"))
            if (!$util.isInteger(message.Id))
                return "Id: integer expected";
        if (message.Title != null && message.hasOwnProperty("Title"))
            if (!$util.isString(message.Title))
                return "Title: string expected";
        if (message.Text != null && message.hasOwnProperty("Text"))
            if (!$util.isString(message.Text))
                return "Text: string expected";
        if (message.ImgUrl != null && message.hasOwnProperty("ImgUrl"))
            if (!$util.isString(message.ImgUrl))
                return "ImgUrl: string expected";
        if (message.Odds != null && message.hasOwnProperty("Odds")) {
            var error = $root.BannerOdds.verify(message.Odds);
            if (error)
                return "Odds." + error;
        }
        if (message.Sequence != null && message.hasOwnProperty("Sequence"))
            if (!$util.isInteger(message.Sequence))
                return "Sequence: integer expected";
        return null;
    };

    /**
     * Creates a News message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof News
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {News} News
     */
    News.fromObject = function fromObject(object) {
        if (object instanceof $root.News)
            return object;
        var message = new $root.News();
        if (object.Id != null)
            message.Id = object.Id | 0;
        if (object.Title != null)
            message.Title = String(object.Title);
        if (object.Text != null)
            message.Text = String(object.Text);
        if (object.ImgUrl != null)
            message.ImgUrl = String(object.ImgUrl);
        if (object.Odds != null) {
            if (typeof object.Odds !== "object")
                throw TypeError(".News.Odds: object expected");
            message.Odds = $root.BannerOdds.fromObject(object.Odds);
        }
        if (object.Sequence != null)
            message.Sequence = object.Sequence | 0;
        return message;
    };

    /**
     * Creates a plain object from a News message. Also converts values to other types if specified.
     * @function toObject
     * @memberof News
     * @static
     * @param {News} message News
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    News.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.Id = 0;
            object.Title = "";
            object.Text = "";
            object.ImgUrl = "";
            object.Odds = null;
            object.Sequence = 0;
        }
        if (message.Id != null && message.hasOwnProperty("Id"))
            object.Id = message.Id;
        if (message.Title != null && message.hasOwnProperty("Title"))
            object.Title = message.Title;
        if (message.Text != null && message.hasOwnProperty("Text"))
            object.Text = message.Text;
        if (message.ImgUrl != null && message.hasOwnProperty("ImgUrl"))
            object.ImgUrl = message.ImgUrl;
        if (message.Odds != null && message.hasOwnProperty("Odds"))
            object.Odds = $root.BannerOdds.toObject(message.Odds, options);
        if (message.Sequence != null && message.hasOwnProperty("Sequence"))
            object.Sequence = message.Sequence;
        return object;
    };

    /**
     * Converts this News to JSON.
     * @function toJSON
     * @memberof News
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    News.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return News;
})();

$root.NewsList = (function() {

    /**
     * Properties of a NewsList.
     * @exports INewsList
     * @interface INewsList
     * @property {Array.<INews>|null} [News] NewsList News
     */

    /**
     * Constructs a new NewsList.
     * @exports NewsList
     * @classdesc Represents a NewsList.
     * @implements INewsList
     * @constructor
     * @param {INewsList=} [properties] Properties to set
     */
    function NewsList(properties) {
        this.News = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * NewsList News.
     * @member {Array.<INews>} News
     * @memberof NewsList
     * @instance
     */
    NewsList.prototype.News = $util.emptyArray;

    /**
     * Creates a new NewsList instance using the specified properties.
     * @function create
     * @memberof NewsList
     * @static
     * @param {INewsList=} [properties] Properties to set
     * @returns {NewsList} NewsList instance
     */
    NewsList.create = function create(properties) {
        return new NewsList(properties);
    };

    /**
     * Encodes the specified NewsList message. Does not implicitly {@link NewsList.verify|verify} messages.
     * @function encode
     * @memberof NewsList
     * @static
     * @param {INewsList} message NewsList message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    NewsList.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.News != null && message.News.length)
            for (var i = 0; i < message.News.length; ++i)
                $root.News.encode(message.News[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified NewsList message, length delimited. Does not implicitly {@link NewsList.verify|verify} messages.
     * @function encodeDelimited
     * @memberof NewsList
     * @static
     * @param {INewsList} message NewsList message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    NewsList.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a NewsList message from the specified reader or buffer.
     * @function decode
     * @memberof NewsList
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {NewsList} NewsList
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    NewsList.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.NewsList();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.News && message.News.length))
                    message.News = [];
                message.News.push($root.News.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a NewsList message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof NewsList
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {NewsList} NewsList
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    NewsList.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a NewsList message.
     * @function verify
     * @memberof NewsList
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    NewsList.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.News != null && message.hasOwnProperty("News")) {
            if (!Array.isArray(message.News))
                return "News: array expected";
            for (var i = 0; i < message.News.length; ++i) {
                var error = $root.News.verify(message.News[i]);
                if (error)
                    return "News." + error;
            }
        }
        return null;
    };

    /**
     * Creates a NewsList message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof NewsList
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {NewsList} NewsList
     */
    NewsList.fromObject = function fromObject(object) {
        if (object instanceof $root.NewsList)
            return object;
        var message = new $root.NewsList();
        if (object.News) {
            if (!Array.isArray(object.News))
                throw TypeError(".NewsList.News: array expected");
            message.News = [];
            for (var i = 0; i < object.News.length; ++i) {
                if (typeof object.News[i] !== "object")
                    throw TypeError(".NewsList.News: object expected");
                message.News[i] = $root.News.fromObject(object.News[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a NewsList message. Also converts values to other types if specified.
     * @function toObject
     * @memberof NewsList
     * @static
     * @param {NewsList} message NewsList
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    NewsList.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.News = [];
        if (message.News && message.News.length) {
            object.News = [];
            for (var j = 0; j < message.News.length; ++j)
                object.News[j] = $root.News.toObject(message.News[j], options);
        }
        return object;
    };

    /**
     * Converts this NewsList to JSON.
     * @function toJSON
     * @memberof NewsList
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    NewsList.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return NewsList;
})();

$root.HomeTab = (function() {

    /**
     * Properties of a HomeTab.
     * @exports IHomeTab
     * @interface IHomeTab
     * @property {number|null} [Id] HomeTab Id
     * @property {string|null} [Title] HomeTab Title
     * @property {TopOfferTypePB|null} [TopOfferType] HomeTab TopOfferType
     * @property {string|null} [TypeAdditionalData] HomeTab TypeAdditionalData
     */

    /**
     * Constructs a new HomeTab.
     * @exports HomeTab
     * @classdesc Represents a HomeTab.
     * @implements IHomeTab
     * @constructor
     * @param {IHomeTab=} [properties] Properties to set
     */
    function HomeTab(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * HomeTab Id.
     * @member {number} Id
     * @memberof HomeTab
     * @instance
     */
    HomeTab.prototype.Id = 0;

    /**
     * HomeTab Title.
     * @member {string} Title
     * @memberof HomeTab
     * @instance
     */
    HomeTab.prototype.Title = "";

    /**
     * HomeTab TopOfferType.
     * @member {TopOfferTypePB} TopOfferType
     * @memberof HomeTab
     * @instance
     */
    HomeTab.prototype.TopOfferType = 0;

    /**
     * HomeTab TypeAdditionalData.
     * @member {string} TypeAdditionalData
     * @memberof HomeTab
     * @instance
     */
    HomeTab.prototype.TypeAdditionalData = "";

    /**
     * Creates a new HomeTab instance using the specified properties.
     * @function create
     * @memberof HomeTab
     * @static
     * @param {IHomeTab=} [properties] Properties to set
     * @returns {HomeTab} HomeTab instance
     */
    HomeTab.create = function create(properties) {
        return new HomeTab(properties);
    };

    /**
     * Encodes the specified HomeTab message. Does not implicitly {@link HomeTab.verify|verify} messages.
     * @function encode
     * @memberof HomeTab
     * @static
     * @param {IHomeTab} message HomeTab message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    HomeTab.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Id != null && message.hasOwnProperty("Id"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Id);
        if (message.Title != null && message.hasOwnProperty("Title"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.Title);
        if (message.TopOfferType != null && message.hasOwnProperty("TopOfferType"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.TopOfferType);
        if (message.TypeAdditionalData != null && message.hasOwnProperty("TypeAdditionalData"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.TypeAdditionalData);
        return writer;
    };

    /**
     * Encodes the specified HomeTab message, length delimited. Does not implicitly {@link HomeTab.verify|verify} messages.
     * @function encodeDelimited
     * @memberof HomeTab
     * @static
     * @param {IHomeTab} message HomeTab message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    HomeTab.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a HomeTab message from the specified reader or buffer.
     * @function decode
     * @memberof HomeTab
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {HomeTab} HomeTab
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    HomeTab.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.HomeTab();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Id = reader.int32();
                break;
            case 2:
                message.Title = reader.string();
                break;
            case 3:
                message.TopOfferType = reader.int32();
                break;
            case 4:
                message.TypeAdditionalData = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a HomeTab message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof HomeTab
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {HomeTab} HomeTab
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    HomeTab.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a HomeTab message.
     * @function verify
     * @memberof HomeTab
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    HomeTab.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Id != null && message.hasOwnProperty("Id"))
            if (!$util.isInteger(message.Id))
                return "Id: integer expected";
        if (message.Title != null && message.hasOwnProperty("Title"))
            if (!$util.isString(message.Title))
                return "Title: string expected";
        if (message.TopOfferType != null && message.hasOwnProperty("TopOfferType"))
            switch (message.TopOfferType) {
            default:
                return "TopOfferType: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 8:
            case 9:
                break;
            }
        if (message.TypeAdditionalData != null && message.hasOwnProperty("TypeAdditionalData"))
            if (!$util.isString(message.TypeAdditionalData))
                return "TypeAdditionalData: string expected";
        return null;
    };

    /**
     * Creates a HomeTab message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof HomeTab
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {HomeTab} HomeTab
     */
    HomeTab.fromObject = function fromObject(object) {
        if (object instanceof $root.HomeTab)
            return object;
        var message = new $root.HomeTab();
        if (object.Id != null)
            message.Id = object.Id | 0;
        if (object.Title != null)
            message.Title = String(object.Title);
        switch (object.TopOfferType) {
        case "None":
        case 0:
            message.TopOfferType = 0;
            break;
        case "TopPonuka":
        case 1:
            message.TopOfferType = 1;
            break;
        case "TopBets":
        case 2:
            message.TopOfferType = 2;
            break;
        case "HotBets":
        case 3:
            message.TopOfferType = 3;
            break;
        case "EventTopTips":
        case 4:
            message.TopOfferType = 4;
            break;
        case "TicketOfDay":
        case 5:
            message.TopOfferType = 5;
            break;
        case "TopLive":
        case 6:
            message.TopOfferType = 6;
            break;
        case "CustomCategory":
        case 7:
            message.TopOfferType = 7;
            break;
        case "Top5PerDay":
        case 8:
            message.TopOfferType = 8;
            break;
        case "Top10PerDay":
        case 9:
            message.TopOfferType = 9;
            break;
        }
        if (object.TypeAdditionalData != null)
            message.TypeAdditionalData = String(object.TypeAdditionalData);
        return message;
    };

    /**
     * Creates a plain object from a HomeTab message. Also converts values to other types if specified.
     * @function toObject
     * @memberof HomeTab
     * @static
     * @param {HomeTab} message HomeTab
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    HomeTab.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.Id = 0;
            object.Title = "";
            object.TopOfferType = options.enums === String ? "None" : 0;
            object.TypeAdditionalData = "";
        }
        if (message.Id != null && message.hasOwnProperty("Id"))
            object.Id = message.Id;
        if (message.Title != null && message.hasOwnProperty("Title"))
            object.Title = message.Title;
        if (message.TopOfferType != null && message.hasOwnProperty("TopOfferType"))
            object.TopOfferType = options.enums === String ? $root.TopOfferTypePB[message.TopOfferType] : message.TopOfferType;
        if (message.TypeAdditionalData != null && message.hasOwnProperty("TypeAdditionalData"))
            object.TypeAdditionalData = message.TypeAdditionalData;
        return object;
    };

    /**
     * Converts this HomeTab to JSON.
     * @function toJSON
     * @memberof HomeTab
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    HomeTab.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return HomeTab;
})();

$root.HomeTabList = (function() {

    /**
     * Properties of a HomeTabList.
     * @exports IHomeTabList
     * @interface IHomeTabList
     * @property {Array.<IHomeTab>|null} [HomeTabs] HomeTabList HomeTabs
     */

    /**
     * Constructs a new HomeTabList.
     * @exports HomeTabList
     * @classdesc Represents a HomeTabList.
     * @implements IHomeTabList
     * @constructor
     * @param {IHomeTabList=} [properties] Properties to set
     */
    function HomeTabList(properties) {
        this.HomeTabs = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * HomeTabList HomeTabs.
     * @member {Array.<IHomeTab>} HomeTabs
     * @memberof HomeTabList
     * @instance
     */
    HomeTabList.prototype.HomeTabs = $util.emptyArray;

    /**
     * Creates a new HomeTabList instance using the specified properties.
     * @function create
     * @memberof HomeTabList
     * @static
     * @param {IHomeTabList=} [properties] Properties to set
     * @returns {HomeTabList} HomeTabList instance
     */
    HomeTabList.create = function create(properties) {
        return new HomeTabList(properties);
    };

    /**
     * Encodes the specified HomeTabList message. Does not implicitly {@link HomeTabList.verify|verify} messages.
     * @function encode
     * @memberof HomeTabList
     * @static
     * @param {IHomeTabList} message HomeTabList message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    HomeTabList.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.HomeTabs != null && message.HomeTabs.length)
            for (var i = 0; i < message.HomeTabs.length; ++i)
                $root.HomeTab.encode(message.HomeTabs[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified HomeTabList message, length delimited. Does not implicitly {@link HomeTabList.verify|verify} messages.
     * @function encodeDelimited
     * @memberof HomeTabList
     * @static
     * @param {IHomeTabList} message HomeTabList message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    HomeTabList.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a HomeTabList message from the specified reader or buffer.
     * @function decode
     * @memberof HomeTabList
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {HomeTabList} HomeTabList
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    HomeTabList.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.HomeTabList();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.HomeTabs && message.HomeTabs.length))
                    message.HomeTabs = [];
                message.HomeTabs.push($root.HomeTab.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a HomeTabList message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof HomeTabList
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {HomeTabList} HomeTabList
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    HomeTabList.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a HomeTabList message.
     * @function verify
     * @memberof HomeTabList
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    HomeTabList.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.HomeTabs != null && message.hasOwnProperty("HomeTabs")) {
            if (!Array.isArray(message.HomeTabs))
                return "HomeTabs: array expected";
            for (var i = 0; i < message.HomeTabs.length; ++i) {
                var error = $root.HomeTab.verify(message.HomeTabs[i]);
                if (error)
                    return "HomeTabs." + error;
            }
        }
        return null;
    };

    /**
     * Creates a HomeTabList message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof HomeTabList
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {HomeTabList} HomeTabList
     */
    HomeTabList.fromObject = function fromObject(object) {
        if (object instanceof $root.HomeTabList)
            return object;
        var message = new $root.HomeTabList();
        if (object.HomeTabs) {
            if (!Array.isArray(object.HomeTabs))
                throw TypeError(".HomeTabList.HomeTabs: array expected");
            message.HomeTabs = [];
            for (var i = 0; i < object.HomeTabs.length; ++i) {
                if (typeof object.HomeTabs[i] !== "object")
                    throw TypeError(".HomeTabList.HomeTabs: object expected");
                message.HomeTabs[i] = $root.HomeTab.fromObject(object.HomeTabs[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a HomeTabList message. Also converts values to other types if specified.
     * @function toObject
     * @memberof HomeTabList
     * @static
     * @param {HomeTabList} message HomeTabList
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    HomeTabList.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.HomeTabs = [];
        if (message.HomeTabs && message.HomeTabs.length) {
            object.HomeTabs = [];
            for (var j = 0; j < message.HomeTabs.length; ++j)
                object.HomeTabs[j] = $root.HomeTab.toObject(message.HomeTabs[j], options);
        }
        return object;
    };

    /**
     * Converts this HomeTabList to JSON.
     * @function toJSON
     * @memberof HomeTabList
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    HomeTabList.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return HomeTabList;
})();

/**
 * TopOfferTypePB enum.
 * @exports TopOfferTypePB
 * @enum {string}
 * @property {number} None=0 None value
 * @property {number} TopPonuka=1 TopPonuka value
 * @property {number} TopBets=2 TopBets value
 * @property {number} HotBets=3 HotBets value
 * @property {number} EventTopTips=4 EventTopTips value
 * @property {number} TicketOfDay=5 TicketOfDay value
 * @property {number} TopLive=6 TopLive value
 * @property {number} CustomCategory=7 CustomCategory value
 * @property {number} Top5PerDay=8 Top5PerDay value
 * @property {number} Top10PerDay=9 Top10PerDay value
 */
$root.TopOfferTypePB = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "None"] = 0;
    values[valuesById[1] = "TopPonuka"] = 1;
    values[valuesById[2] = "TopBets"] = 2;
    values[valuesById[3] = "HotBets"] = 3;
    values[valuesById[4] = "EventTopTips"] = 4;
    values[valuesById[5] = "TicketOfDay"] = 5;
    values[valuesById[6] = "TopLive"] = 6;
    values[valuesById[7] = "CustomCategory"] = 7;
    values[valuesById[8] = "Top5PerDay"] = 8;
    values[valuesById[9] = "Top10PerDay"] = 9;
    return values;
})();

/**
 * OfferType enum.
 * @exports OfferType
 * @enum {string}
 * @property {number} Prematch=0 Prematch value
 * @property {number} Live=1 Live value
 */
$root.OfferType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "Prematch"] = 0;
    values[valuesById[1] = "Live"] = 1;
    return values;
})();

/**
 * BetType enum.
 * @exports BetType
 * @enum {string}
 * @property {number} None=0 None value
 * @property {number} Prematch=1 Prematch value
 * @property {number} Live=2 Live value
 */
$root.BetType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "None"] = 0;
    values[valuesById[1] = "Prematch"] = 1;
    values[valuesById[2] = "Live"] = 2;
    return values;
})();

/**
 * TicketType enum.
 * @exports TicketType
 * @enum {string}
 * @property {number} None=0 None value
 * @property {number} Simple=1 Simple value
 * @property {number} System=2 System value
 */
$root.TicketType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "None"] = 0;
    values[valuesById[1] = "Simple"] = 1;
    values[valuesById[2] = "System"] = 2;
    return values;
})();

/**
 * OddsChangeType enum.
 * @exports OddsChangeType
 * @enum {string}
 * @property {number} None=0 None value
 * @property {number} Any=1 Any value
 * @property {number} Higher=2 Higher value
 */
$root.OddsChangeType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "None"] = 0;
    values[valuesById[1] = "Any"] = 1;
    values[valuesById[2] = "Higher"] = 2;
    return values;
})();

/**
 * CashoutAcceptedChangeType enum.
 * @exports CashoutAcceptedChangeType
 * @enum {string}
 * @property {number} None=0 None value
 * @property {number} Any=1 Any value
 * @property {number} Higher=2 Higher value
 */
$root.CashoutAcceptedChangeType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "None"] = 0;
    values[valuesById[1] = "Any"] = 1;
    values[valuesById[2] = "Higher"] = 2;
    return values;
})();

/**
 * StakeType enum.
 * @exports StakeType
 * @enum {string}
 * @property {number} All=0 All value
 * @property {number} Total=1 Total value
 * @property {number} Unit=2 Unit value
 */
$root.StakeType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "All"] = 0;
    values[valuesById[1] = "Total"] = 1;
    values[valuesById[2] = "Unit"] = 2;
    return values;
})();

/**
 * EvalState enum.
 * @exports EvalState
 * @enum {string}
 * @property {number} None=0 None value
 * @property {number} Win=1 Win value
 * @property {number} Loss=2 Loss value
 * @property {number} Cancel=3 Cancel value
 * @property {number} CancelWithHandlingFee=4 CancelWithHandlingFee value
 * @property {number} Cashout=5 Cashout value
 */
$root.EvalState = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "None"] = 0;
    values[valuesById[1] = "Win"] = 1;
    values[valuesById[2] = "Loss"] = 2;
    values[valuesById[3] = "Cancel"] = 3;
    values[valuesById[4] = "CancelWithHandlingFee"] = 4;
    values[valuesById[5] = "Cashout"] = 5;
    return values;
})();

/**
 * TicketState enum.
 * @exports TicketState
 * @enum {string}
 * @property {number} None=0 None value
 * @property {number} Created=1 Created value
 * @property {number} Paid=2 Paid value
 * @property {number} Accepted=3 Accepted value
 * @property {number} Settled=4 Settled value
 * @property {number} Evaluated=5 Evaluated value
 * @property {number} Storno=6 Storno value
 * @property {number} StornoBySystem=7 StornoBySystem value
 * @property {number} StornoByCustomer=9 StornoByCustomer value
 * @property {number} StornoByMts=10 StornoByMts value
 */
$root.TicketState = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "None"] = 0;
    values[valuesById[1] = "Created"] = 1;
    values[valuesById[2] = "Paid"] = 2;
    values[valuesById[3] = "Accepted"] = 3;
    values[valuesById[4] = "Settled"] = 4;
    values[valuesById[5] = "Evaluated"] = 5;
    values[valuesById[6] = "Storno"] = 6;
    values[valuesById[7] = "StornoBySystem"] = 7;
    values[valuesById[9] = "StornoByCustomer"] = 9;
    values[valuesById[10] = "StornoByMts"] = 10;
    return values;
})();

/**
 * TicketSelectionEvalState enum.
 * @exports TicketSelectionEvalState
 * @enum {string}
 * @property {number} None=0 None value
 * @property {number} Win=1 Win value
 * @property {number} Loss=2 Loss value
 * @property {number} Cancel=3 Cancel value
 * @property {number} Cashout=4 Cashout value
 * @property {number} Storno=5 Storno value
 */
$root.TicketSelectionEvalState = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "None"] = 0;
    values[valuesById[1] = "Win"] = 1;
    values[valuesById[2] = "Loss"] = 2;
    values[valuesById[3] = "Cancel"] = 3;
    values[valuesById[4] = "Cashout"] = 4;
    values[valuesById[5] = "Storno"] = 5;
    return values;
})();

/**
 * OddsEvalType enum.
 * @exports OddsEvalType
 * @enum {string}
 * @property {number} Lost=0 Lost value
 * @property {number} Win=1 Win value
 * @property {number} TerminatedWithMP=2 TerminatedWithMP value
 * @property {number} Terminated=3 Terminated value
 * @property {number} Compensation=4 Compensation value
 */
$root.OddsEvalType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "Lost"] = 0;
    values[valuesById[1] = "Win"] = 1;
    values[valuesById[2] = "TerminatedWithMP"] = 2;
    values[valuesById[3] = "Terminated"] = 3;
    values[valuesById[4] = "Compensation"] = 4;
    return values;
})();

/**
 * ResultType enum.
 * @exports ResultType
 * @enum {string}
 * @property {number} None=0 None value
 * @property {number} Fail=1 Fail value
 * @property {number} FailWithHint=2 FailWithHint value
 * @property {number} Success=3 Success value
 */
$root.ResultType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "None"] = 0;
    values[valuesById[1] = "Fail"] = 1;
    values[valuesById[2] = "FailWithHint"] = 2;
    values[valuesById[3] = "Success"] = 3;
    return values;
})();

/**
 * CalendarEventFlag enum.
 * @exports CalendarEventFlag
 * @enum {string}
 * @property {number} None=0 None value
 * @property {number} HasActivePrematch=1 HasActivePrematch value
 */
$root.CalendarEventFlag = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "None"] = 0;
    values[valuesById[1] = "HasActivePrematch"] = 1;
    return values;
})();

$root.TicketSelectionBase = (function() {

    /**
     * Properties of a TicketSelectionBase.
     * @exports ITicketSelectionBase
     * @interface ITicketSelectionBase
     * @property {number|Long|null} [Id] TicketSelectionBase Id
     * @property {number|null} [Rate] TicketSelectionBase Rate
     * @property {boolean|null} [IsBanker] TicketSelectionBase IsBanker
     * @property {ISelectionOfferText|null} [Text] TicketSelectionBase Text
     * @property {string|null} [Symbol] TicketSelectionBase Symbol
     * @property {OfferType|null} [OfferType] TicketSelectionBase OfferType
     * @property {number|Long|null} [FixtureId] TicketSelectionBase FixtureId
     */

    /**
     * Constructs a new TicketSelectionBase.
     * @exports TicketSelectionBase
     * @classdesc Represents a TicketSelectionBase.
     * @implements ITicketSelectionBase
     * @constructor
     * @param {ITicketSelectionBase=} [properties] Properties to set
     */
    function TicketSelectionBase(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * TicketSelectionBase Id.
     * @member {number|Long} Id
     * @memberof TicketSelectionBase
     * @instance
     */
    TicketSelectionBase.prototype.Id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * TicketSelectionBase Rate.
     * @member {number} Rate
     * @memberof TicketSelectionBase
     * @instance
     */
    TicketSelectionBase.prototype.Rate = 0;

    /**
     * TicketSelectionBase IsBanker.
     * @member {boolean} IsBanker
     * @memberof TicketSelectionBase
     * @instance
     */
    TicketSelectionBase.prototype.IsBanker = false;

    /**
     * TicketSelectionBase Text.
     * @member {ISelectionOfferText|null|undefined} Text
     * @memberof TicketSelectionBase
     * @instance
     */
    TicketSelectionBase.prototype.Text = null;

    /**
     * TicketSelectionBase Symbol.
     * @member {string} Symbol
     * @memberof TicketSelectionBase
     * @instance
     */
    TicketSelectionBase.prototype.Symbol = "";

    /**
     * TicketSelectionBase OfferType.
     * @member {OfferType} OfferType
     * @memberof TicketSelectionBase
     * @instance
     */
    TicketSelectionBase.prototype.OfferType = 0;

    /**
     * TicketSelectionBase FixtureId.
     * @member {number|Long} FixtureId
     * @memberof TicketSelectionBase
     * @instance
     */
    TicketSelectionBase.prototype.FixtureId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * Creates a new TicketSelectionBase instance using the specified properties.
     * @function create
     * @memberof TicketSelectionBase
     * @static
     * @param {ITicketSelectionBase=} [properties] Properties to set
     * @returns {TicketSelectionBase} TicketSelectionBase instance
     */
    TicketSelectionBase.create = function create(properties) {
        return new TicketSelectionBase(properties);
    };

    /**
     * Encodes the specified TicketSelectionBase message. Does not implicitly {@link TicketSelectionBase.verify|verify} messages.
     * @function encode
     * @memberof TicketSelectionBase
     * @static
     * @param {ITicketSelectionBase} message TicketSelectionBase message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TicketSelectionBase.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Id != null && message.hasOwnProperty("Id"))
            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.Id);
        if (message.Rate != null && message.hasOwnProperty("Rate"))
            writer.uint32(/* id 2, wireType 1 =*/17).double(message.Rate);
        if (message.IsBanker != null && message.hasOwnProperty("IsBanker"))
            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.IsBanker);
        if (message.Text != null && message.hasOwnProperty("Text"))
            $root.SelectionOfferText.encode(message.Text, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        if (message.Symbol != null && message.hasOwnProperty("Symbol"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.Symbol);
        if (message.OfferType != null && message.hasOwnProperty("OfferType"))
            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.OfferType);
        if (message.FixtureId != null && message.hasOwnProperty("FixtureId"))
            writer.uint32(/* id 7, wireType 0 =*/56).int64(message.FixtureId);
        return writer;
    };

    /**
     * Encodes the specified TicketSelectionBase message, length delimited. Does not implicitly {@link TicketSelectionBase.verify|verify} messages.
     * @function encodeDelimited
     * @memberof TicketSelectionBase
     * @static
     * @param {ITicketSelectionBase} message TicketSelectionBase message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TicketSelectionBase.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TicketSelectionBase message from the specified reader or buffer.
     * @function decode
     * @memberof TicketSelectionBase
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TicketSelectionBase} TicketSelectionBase
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TicketSelectionBase.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TicketSelectionBase();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Id = reader.int64();
                break;
            case 2:
                message.Rate = reader.double();
                break;
            case 3:
                message.IsBanker = reader.bool();
                break;
            case 4:
                message.Text = $root.SelectionOfferText.decode(reader, reader.uint32());
                break;
            case 5:
                message.Symbol = reader.string();
                break;
            case 6:
                message.OfferType = reader.int32();
                break;
            case 7:
                message.FixtureId = reader.int64();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a TicketSelectionBase message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof TicketSelectionBase
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {TicketSelectionBase} TicketSelectionBase
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TicketSelectionBase.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TicketSelectionBase message.
     * @function verify
     * @memberof TicketSelectionBase
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TicketSelectionBase.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Id != null && message.hasOwnProperty("Id"))
            if (!$util.isInteger(message.Id) && !(message.Id && $util.isInteger(message.Id.low) && $util.isInteger(message.Id.high)))
                return "Id: integer|Long expected";
        if (message.Rate != null && message.hasOwnProperty("Rate"))
            if (typeof message.Rate !== "number")
                return "Rate: number expected";
        if (message.IsBanker != null && message.hasOwnProperty("IsBanker"))
            if (typeof message.IsBanker !== "boolean")
                return "IsBanker: boolean expected";
        if (message.Text != null && message.hasOwnProperty("Text")) {
            var error = $root.SelectionOfferText.verify(message.Text);
            if (error)
                return "Text." + error;
        }
        if (message.Symbol != null && message.hasOwnProperty("Symbol"))
            if (!$util.isString(message.Symbol))
                return "Symbol: string expected";
        if (message.OfferType != null && message.hasOwnProperty("OfferType"))
            switch (message.OfferType) {
            default:
                return "OfferType: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.FixtureId != null && message.hasOwnProperty("FixtureId"))
            if (!$util.isInteger(message.FixtureId) && !(message.FixtureId && $util.isInteger(message.FixtureId.low) && $util.isInteger(message.FixtureId.high)))
                return "FixtureId: integer|Long expected";
        return null;
    };

    /**
     * Creates a TicketSelectionBase message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TicketSelectionBase
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TicketSelectionBase} TicketSelectionBase
     */
    TicketSelectionBase.fromObject = function fromObject(object) {
        if (object instanceof $root.TicketSelectionBase)
            return object;
        var message = new $root.TicketSelectionBase();
        if (object.Id != null)
            if ($util.Long)
                (message.Id = $util.Long.fromValue(object.Id)).unsigned = false;
            else if (typeof object.Id === "string")
                message.Id = parseInt(object.Id, 10);
            else if (typeof object.Id === "number")
                message.Id = object.Id;
            else if (typeof object.Id === "object")
                message.Id = new $util.LongBits(object.Id.low >>> 0, object.Id.high >>> 0).toNumber();
        if (object.Rate != null)
            message.Rate = Number(object.Rate);
        if (object.IsBanker != null)
            message.IsBanker = Boolean(object.IsBanker);
        if (object.Text != null) {
            if (typeof object.Text !== "object")
                throw TypeError(".TicketSelectionBase.Text: object expected");
            message.Text = $root.SelectionOfferText.fromObject(object.Text);
        }
        if (object.Symbol != null)
            message.Symbol = String(object.Symbol);
        switch (object.OfferType) {
        case "Prematch":
        case 0:
            message.OfferType = 0;
            break;
        case "Live":
        case 1:
            message.OfferType = 1;
            break;
        }
        if (object.FixtureId != null)
            if ($util.Long)
                (message.FixtureId = $util.Long.fromValue(object.FixtureId)).unsigned = false;
            else if (typeof object.FixtureId === "string")
                message.FixtureId = parseInt(object.FixtureId, 10);
            else if (typeof object.FixtureId === "number")
                message.FixtureId = object.FixtureId;
            else if (typeof object.FixtureId === "object")
                message.FixtureId = new $util.LongBits(object.FixtureId.low >>> 0, object.FixtureId.high >>> 0).toNumber();
        return message;
    };

    /**
     * Creates a plain object from a TicketSelectionBase message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TicketSelectionBase
     * @static
     * @param {TicketSelectionBase} message TicketSelectionBase
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TicketSelectionBase.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.Id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.Id = options.longs === String ? "0" : 0;
            object.Rate = 0;
            object.IsBanker = false;
            object.Text = null;
            object.Symbol = "";
            object.OfferType = options.enums === String ? "Prematch" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.FixtureId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.FixtureId = options.longs === String ? "0" : 0;
        }
        if (message.Id != null && message.hasOwnProperty("Id"))
            if (typeof message.Id === "number")
                object.Id = options.longs === String ? String(message.Id) : message.Id;
            else
                object.Id = options.longs === String ? $util.Long.prototype.toString.call(message.Id) : options.longs === Number ? new $util.LongBits(message.Id.low >>> 0, message.Id.high >>> 0).toNumber() : message.Id;
        if (message.Rate != null && message.hasOwnProperty("Rate"))
            object.Rate = options.json && !isFinite(message.Rate) ? String(message.Rate) : message.Rate;
        if (message.IsBanker != null && message.hasOwnProperty("IsBanker"))
            object.IsBanker = message.IsBanker;
        if (message.Text != null && message.hasOwnProperty("Text"))
            object.Text = $root.SelectionOfferText.toObject(message.Text, options);
        if (message.Symbol != null && message.hasOwnProperty("Symbol"))
            object.Symbol = message.Symbol;
        if (message.OfferType != null && message.hasOwnProperty("OfferType"))
            object.OfferType = options.enums === String ? $root.OfferType[message.OfferType] : message.OfferType;
        if (message.FixtureId != null && message.hasOwnProperty("FixtureId"))
            if (typeof message.FixtureId === "number")
                object.FixtureId = options.longs === String ? String(message.FixtureId) : message.FixtureId;
            else
                object.FixtureId = options.longs === String ? $util.Long.prototype.toString.call(message.FixtureId) : options.longs === Number ? new $util.LongBits(message.FixtureId.low >>> 0, message.FixtureId.high >>> 0).toNumber() : message.FixtureId;
        return object;
    };

    /**
     * Converts this TicketSelectionBase to JSON.
     * @function toJSON
     * @memberof TicketSelectionBase
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TicketSelectionBase.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TicketSelectionBase;
})();

$root.TicketSelectionResponse = (function() {

    /**
     * Properties of a TicketSelectionResponse.
     * @exports ITicketSelectionResponse
     * @interface ITicketSelectionResponse
     * @property {ITicketSelectionBase|null} [Base] TicketSelectionResponse Base
     * @property {number|null} [RateCurrent] TicketSelectionResponse RateCurrent
     */

    /**
     * Constructs a new TicketSelectionResponse.
     * @exports TicketSelectionResponse
     * @classdesc Represents a TicketSelectionResponse.
     * @implements ITicketSelectionResponse
     * @constructor
     * @param {ITicketSelectionResponse=} [properties] Properties to set
     */
    function TicketSelectionResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * TicketSelectionResponse Base.
     * @member {ITicketSelectionBase|null|undefined} Base
     * @memberof TicketSelectionResponse
     * @instance
     */
    TicketSelectionResponse.prototype.Base = null;

    /**
     * TicketSelectionResponse RateCurrent.
     * @member {number} RateCurrent
     * @memberof TicketSelectionResponse
     * @instance
     */
    TicketSelectionResponse.prototype.RateCurrent = 0;

    /**
     * Creates a new TicketSelectionResponse instance using the specified properties.
     * @function create
     * @memberof TicketSelectionResponse
     * @static
     * @param {ITicketSelectionResponse=} [properties] Properties to set
     * @returns {TicketSelectionResponse} TicketSelectionResponse instance
     */
    TicketSelectionResponse.create = function create(properties) {
        return new TicketSelectionResponse(properties);
    };

    /**
     * Encodes the specified TicketSelectionResponse message. Does not implicitly {@link TicketSelectionResponse.verify|verify} messages.
     * @function encode
     * @memberof TicketSelectionResponse
     * @static
     * @param {ITicketSelectionResponse} message TicketSelectionResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TicketSelectionResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Base != null && message.hasOwnProperty("Base"))
            $root.TicketSelectionBase.encode(message.Base, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.RateCurrent != null && message.hasOwnProperty("RateCurrent"))
            writer.uint32(/* id 2, wireType 1 =*/17).double(message.RateCurrent);
        return writer;
    };

    /**
     * Encodes the specified TicketSelectionResponse message, length delimited. Does not implicitly {@link TicketSelectionResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof TicketSelectionResponse
     * @static
     * @param {ITicketSelectionResponse} message TicketSelectionResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TicketSelectionResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TicketSelectionResponse message from the specified reader or buffer.
     * @function decode
     * @memberof TicketSelectionResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TicketSelectionResponse} TicketSelectionResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TicketSelectionResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TicketSelectionResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Base = $root.TicketSelectionBase.decode(reader, reader.uint32());
                break;
            case 2:
                message.RateCurrent = reader.double();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a TicketSelectionResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof TicketSelectionResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {TicketSelectionResponse} TicketSelectionResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TicketSelectionResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TicketSelectionResponse message.
     * @function verify
     * @memberof TicketSelectionResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TicketSelectionResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Base != null && message.hasOwnProperty("Base")) {
            var error = $root.TicketSelectionBase.verify(message.Base);
            if (error)
                return "Base." + error;
        }
        if (message.RateCurrent != null && message.hasOwnProperty("RateCurrent"))
            if (typeof message.RateCurrent !== "number")
                return "RateCurrent: number expected";
        return null;
    };

    /**
     * Creates a TicketSelectionResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TicketSelectionResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TicketSelectionResponse} TicketSelectionResponse
     */
    TicketSelectionResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.TicketSelectionResponse)
            return object;
        var message = new $root.TicketSelectionResponse();
        if (object.Base != null) {
            if (typeof object.Base !== "object")
                throw TypeError(".TicketSelectionResponse.Base: object expected");
            message.Base = $root.TicketSelectionBase.fromObject(object.Base);
        }
        if (object.RateCurrent != null)
            message.RateCurrent = Number(object.RateCurrent);
        return message;
    };

    /**
     * Creates a plain object from a TicketSelectionResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TicketSelectionResponse
     * @static
     * @param {TicketSelectionResponse} message TicketSelectionResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TicketSelectionResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.Base = null;
            object.RateCurrent = 0;
        }
        if (message.Base != null && message.hasOwnProperty("Base"))
            object.Base = $root.TicketSelectionBase.toObject(message.Base, options);
        if (message.RateCurrent != null && message.hasOwnProperty("RateCurrent"))
            object.RateCurrent = options.json && !isFinite(message.RateCurrent) ? String(message.RateCurrent) : message.RateCurrent;
        return object;
    };

    /**
     * Converts this TicketSelectionResponse to JSON.
     * @function toJSON
     * @memberof TicketSelectionResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TicketSelectionResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TicketSelectionResponse;
})();

$root.TicketSelectionScore = (function() {

    /**
     * Properties of a TicketSelectionScore.
     * @exports ITicketSelectionScore
     * @interface ITicketSelectionScore
     * @property {string|null} [Score] TicketSelectionScore Score
     */

    /**
     * Constructs a new TicketSelectionScore.
     * @exports TicketSelectionScore
     * @classdesc Represents a TicketSelectionScore.
     * @implements ITicketSelectionScore
     * @constructor
     * @param {ITicketSelectionScore=} [properties] Properties to set
     */
    function TicketSelectionScore(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * TicketSelectionScore Score.
     * @member {string} Score
     * @memberof TicketSelectionScore
     * @instance
     */
    TicketSelectionScore.prototype.Score = "";

    /**
     * Creates a new TicketSelectionScore instance using the specified properties.
     * @function create
     * @memberof TicketSelectionScore
     * @static
     * @param {ITicketSelectionScore=} [properties] Properties to set
     * @returns {TicketSelectionScore} TicketSelectionScore instance
     */
    TicketSelectionScore.create = function create(properties) {
        return new TicketSelectionScore(properties);
    };

    /**
     * Encodes the specified TicketSelectionScore message. Does not implicitly {@link TicketSelectionScore.verify|verify} messages.
     * @function encode
     * @memberof TicketSelectionScore
     * @static
     * @param {ITicketSelectionScore} message TicketSelectionScore message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TicketSelectionScore.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Score != null && message.hasOwnProperty("Score"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.Score);
        return writer;
    };

    /**
     * Encodes the specified TicketSelectionScore message, length delimited. Does not implicitly {@link TicketSelectionScore.verify|verify} messages.
     * @function encodeDelimited
     * @memberof TicketSelectionScore
     * @static
     * @param {ITicketSelectionScore} message TicketSelectionScore message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TicketSelectionScore.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TicketSelectionScore message from the specified reader or buffer.
     * @function decode
     * @memberof TicketSelectionScore
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TicketSelectionScore} TicketSelectionScore
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TicketSelectionScore.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TicketSelectionScore();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Score = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a TicketSelectionScore message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof TicketSelectionScore
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {TicketSelectionScore} TicketSelectionScore
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TicketSelectionScore.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TicketSelectionScore message.
     * @function verify
     * @memberof TicketSelectionScore
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TicketSelectionScore.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Score != null && message.hasOwnProperty("Score"))
            if (!$util.isString(message.Score))
                return "Score: string expected";
        return null;
    };

    /**
     * Creates a TicketSelectionScore message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TicketSelectionScore
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TicketSelectionScore} TicketSelectionScore
     */
    TicketSelectionScore.fromObject = function fromObject(object) {
        if (object instanceof $root.TicketSelectionScore)
            return object;
        var message = new $root.TicketSelectionScore();
        if (object.Score != null)
            message.Score = String(object.Score);
        return message;
    };

    /**
     * Creates a plain object from a TicketSelectionScore message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TicketSelectionScore
     * @static
     * @param {TicketSelectionScore} message TicketSelectionScore
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TicketSelectionScore.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.Score = "";
        if (message.Score != null && message.hasOwnProperty("Score"))
            object.Score = message.Score;
        return object;
    };

    /**
     * Converts this TicketSelectionScore to JSON.
     * @function toJSON
     * @memberof TicketSelectionScore
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TicketSelectionScore.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TicketSelectionScore;
})();

$root.TicketSelectionDetailResponse = (function() {

    /**
     * Properties of a TicketSelectionDetailResponse.
     * @exports ITicketSelectionDetailResponse
     * @interface ITicketSelectionDetailResponse
     * @property {ITicketSelectionBase|null} [Base] TicketSelectionDetailResponse Base
     * @property {string|null} [ResultNote] TicketSelectionDetailResponse ResultNote
     * @property {TicketSelectionEvalState|null} [EvalState] TicketSelectionDetailResponse EvalState
     * @property {number|null} [EvalRate] TicketSelectionDetailResponse EvalRate
     * @property {Array.<string>|null} [CorrectSelectionNames] TicketSelectionDetailResponse CorrectSelectionNames
     * @property {ShowResultStyle|null} [ShowResultStyle] TicketSelectionDetailResponse ShowResultStyle
     * @property {Array.<ITicketSelectionScore>|null} [Scores] TicketSelectionDetailResponse Scores
     * @property {ITicketSelectionDetailEventStatus|null} [LiveEventStatus] TicketSelectionDetailResponse LiveEventStatus
     */

    /**
     * Constructs a new TicketSelectionDetailResponse.
     * @exports TicketSelectionDetailResponse
     * @classdesc Represents a TicketSelectionDetailResponse.
     * @implements ITicketSelectionDetailResponse
     * @constructor
     * @param {ITicketSelectionDetailResponse=} [properties] Properties to set
     */
    function TicketSelectionDetailResponse(properties) {
        this.CorrectSelectionNames = [];
        this.Scores = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * TicketSelectionDetailResponse Base.
     * @member {ITicketSelectionBase|null|undefined} Base
     * @memberof TicketSelectionDetailResponse
     * @instance
     */
    TicketSelectionDetailResponse.prototype.Base = null;

    /**
     * TicketSelectionDetailResponse ResultNote.
     * @member {string} ResultNote
     * @memberof TicketSelectionDetailResponse
     * @instance
     */
    TicketSelectionDetailResponse.prototype.ResultNote = "";

    /**
     * TicketSelectionDetailResponse EvalState.
     * @member {TicketSelectionEvalState} EvalState
     * @memberof TicketSelectionDetailResponse
     * @instance
     */
    TicketSelectionDetailResponse.prototype.EvalState = 0;

    /**
     * TicketSelectionDetailResponse EvalRate.
     * @member {number} EvalRate
     * @memberof TicketSelectionDetailResponse
     * @instance
     */
    TicketSelectionDetailResponse.prototype.EvalRate = 0;

    /**
     * TicketSelectionDetailResponse CorrectSelectionNames.
     * @member {Array.<string>} CorrectSelectionNames
     * @memberof TicketSelectionDetailResponse
     * @instance
     */
    TicketSelectionDetailResponse.prototype.CorrectSelectionNames = $util.emptyArray;

    /**
     * TicketSelectionDetailResponse ShowResultStyle.
     * @member {ShowResultStyle} ShowResultStyle
     * @memberof TicketSelectionDetailResponse
     * @instance
     */
    TicketSelectionDetailResponse.prototype.ShowResultStyle = 0;

    /**
     * TicketSelectionDetailResponse Scores.
     * @member {Array.<ITicketSelectionScore>} Scores
     * @memberof TicketSelectionDetailResponse
     * @instance
     */
    TicketSelectionDetailResponse.prototype.Scores = $util.emptyArray;

    /**
     * TicketSelectionDetailResponse LiveEventStatus.
     * @member {ITicketSelectionDetailEventStatus|null|undefined} LiveEventStatus
     * @memberof TicketSelectionDetailResponse
     * @instance
     */
    TicketSelectionDetailResponse.prototype.LiveEventStatus = null;

    /**
     * Creates a new TicketSelectionDetailResponse instance using the specified properties.
     * @function create
     * @memberof TicketSelectionDetailResponse
     * @static
     * @param {ITicketSelectionDetailResponse=} [properties] Properties to set
     * @returns {TicketSelectionDetailResponse} TicketSelectionDetailResponse instance
     */
    TicketSelectionDetailResponse.create = function create(properties) {
        return new TicketSelectionDetailResponse(properties);
    };

    /**
     * Encodes the specified TicketSelectionDetailResponse message. Does not implicitly {@link TicketSelectionDetailResponse.verify|verify} messages.
     * @function encode
     * @memberof TicketSelectionDetailResponse
     * @static
     * @param {ITicketSelectionDetailResponse} message TicketSelectionDetailResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TicketSelectionDetailResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Base != null && message.hasOwnProperty("Base"))
            $root.TicketSelectionBase.encode(message.Base, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.ResultNote != null && message.hasOwnProperty("ResultNote"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.ResultNote);
        if (message.EvalState != null && message.hasOwnProperty("EvalState"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.EvalState);
        if (message.EvalRate != null && message.hasOwnProperty("EvalRate"))
            writer.uint32(/* id 5, wireType 1 =*/41).double(message.EvalRate);
        if (message.CorrectSelectionNames != null && message.CorrectSelectionNames.length)
            for (var i = 0; i < message.CorrectSelectionNames.length; ++i)
                writer.uint32(/* id 6, wireType 2 =*/50).string(message.CorrectSelectionNames[i]);
        if (message.ShowResultStyle != null && message.hasOwnProperty("ShowResultStyle"))
            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.ShowResultStyle);
        if (message.Scores != null && message.Scores.length)
            for (var i = 0; i < message.Scores.length; ++i)
                $root.TicketSelectionScore.encode(message.Scores[i], writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
        if (message.LiveEventStatus != null && message.hasOwnProperty("LiveEventStatus"))
            $root.TicketSelectionDetailEventStatus.encode(message.LiveEventStatus, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified TicketSelectionDetailResponse message, length delimited. Does not implicitly {@link TicketSelectionDetailResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof TicketSelectionDetailResponse
     * @static
     * @param {ITicketSelectionDetailResponse} message TicketSelectionDetailResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TicketSelectionDetailResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TicketSelectionDetailResponse message from the specified reader or buffer.
     * @function decode
     * @memberof TicketSelectionDetailResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TicketSelectionDetailResponse} TicketSelectionDetailResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TicketSelectionDetailResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TicketSelectionDetailResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Base = $root.TicketSelectionBase.decode(reader, reader.uint32());
                break;
            case 3:
                message.ResultNote = reader.string();
                break;
            case 4:
                message.EvalState = reader.int32();
                break;
            case 5:
                message.EvalRate = reader.double();
                break;
            case 6:
                if (!(message.CorrectSelectionNames && message.CorrectSelectionNames.length))
                    message.CorrectSelectionNames = [];
                message.CorrectSelectionNames.push(reader.string());
                break;
            case 7:
                message.ShowResultStyle = reader.int32();
                break;
            case 8:
                if (!(message.Scores && message.Scores.length))
                    message.Scores = [];
                message.Scores.push($root.TicketSelectionScore.decode(reader, reader.uint32()));
                break;
            case 9:
                message.LiveEventStatus = $root.TicketSelectionDetailEventStatus.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a TicketSelectionDetailResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof TicketSelectionDetailResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {TicketSelectionDetailResponse} TicketSelectionDetailResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TicketSelectionDetailResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TicketSelectionDetailResponse message.
     * @function verify
     * @memberof TicketSelectionDetailResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TicketSelectionDetailResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Base != null && message.hasOwnProperty("Base")) {
            var error = $root.TicketSelectionBase.verify(message.Base);
            if (error)
                return "Base." + error;
        }
        if (message.ResultNote != null && message.hasOwnProperty("ResultNote"))
            if (!$util.isString(message.ResultNote))
                return "ResultNote: string expected";
        if (message.EvalState != null && message.hasOwnProperty("EvalState"))
            switch (message.EvalState) {
            default:
                return "EvalState: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.EvalRate != null && message.hasOwnProperty("EvalRate"))
            if (typeof message.EvalRate !== "number")
                return "EvalRate: number expected";
        if (message.CorrectSelectionNames != null && message.hasOwnProperty("CorrectSelectionNames")) {
            if (!Array.isArray(message.CorrectSelectionNames))
                return "CorrectSelectionNames: array expected";
            for (var i = 0; i < message.CorrectSelectionNames.length; ++i)
                if (!$util.isString(message.CorrectSelectionNames[i]))
                    return "CorrectSelectionNames: string[] expected";
        }
        if (message.ShowResultStyle != null && message.hasOwnProperty("ShowResultStyle"))
            switch (message.ShowResultStyle) {
            default:
                return "ShowResultStyle: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.Scores != null && message.hasOwnProperty("Scores")) {
            if (!Array.isArray(message.Scores))
                return "Scores: array expected";
            for (var i = 0; i < message.Scores.length; ++i) {
                var error = $root.TicketSelectionScore.verify(message.Scores[i]);
                if (error)
                    return "Scores." + error;
            }
        }
        if (message.LiveEventStatus != null && message.hasOwnProperty("LiveEventStatus")) {
            var error = $root.TicketSelectionDetailEventStatus.verify(message.LiveEventStatus);
            if (error)
                return "LiveEventStatus." + error;
        }
        return null;
    };

    /**
     * Creates a TicketSelectionDetailResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TicketSelectionDetailResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TicketSelectionDetailResponse} TicketSelectionDetailResponse
     */
    TicketSelectionDetailResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.TicketSelectionDetailResponse)
            return object;
        var message = new $root.TicketSelectionDetailResponse();
        if (object.Base != null) {
            if (typeof object.Base !== "object")
                throw TypeError(".TicketSelectionDetailResponse.Base: object expected");
            message.Base = $root.TicketSelectionBase.fromObject(object.Base);
        }
        if (object.ResultNote != null)
            message.ResultNote = String(object.ResultNote);
        switch (object.EvalState) {
        case "None":
        case 0:
            message.EvalState = 0;
            break;
        case "Win":
        case 1:
            message.EvalState = 1;
            break;
        case "Loss":
        case 2:
            message.EvalState = 2;
            break;
        case "Cancel":
        case 3:
            message.EvalState = 3;
            break;
        case "Cashout":
        case 4:
            message.EvalState = 4;
            break;
        case "Storno":
        case 5:
            message.EvalState = 5;
            break;
        }
        if (object.EvalRate != null)
            message.EvalRate = Number(object.EvalRate);
        if (object.CorrectSelectionNames) {
            if (!Array.isArray(object.CorrectSelectionNames))
                throw TypeError(".TicketSelectionDetailResponse.CorrectSelectionNames: array expected");
            message.CorrectSelectionNames = [];
            for (var i = 0; i < object.CorrectSelectionNames.length; ++i)
                message.CorrectSelectionNames[i] = String(object.CorrectSelectionNames[i]);
        }
        switch (object.ShowResultStyle) {
        case "WinTips":
        case 0:
            message.ShowResultStyle = 0;
            break;
        case "SelectedResults":
        case 1:
            message.ShowResultStyle = 1;
            break;
        }
        if (object.Scores) {
            if (!Array.isArray(object.Scores))
                throw TypeError(".TicketSelectionDetailResponse.Scores: array expected");
            message.Scores = [];
            for (var i = 0; i < object.Scores.length; ++i) {
                if (typeof object.Scores[i] !== "object")
                    throw TypeError(".TicketSelectionDetailResponse.Scores: object expected");
                message.Scores[i] = $root.TicketSelectionScore.fromObject(object.Scores[i]);
            }
        }
        if (object.LiveEventStatus != null) {
            if (typeof object.LiveEventStatus !== "object")
                throw TypeError(".TicketSelectionDetailResponse.LiveEventStatus: object expected");
            message.LiveEventStatus = $root.TicketSelectionDetailEventStatus.fromObject(object.LiveEventStatus);
        }
        return message;
    };

    /**
     * Creates a plain object from a TicketSelectionDetailResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TicketSelectionDetailResponse
     * @static
     * @param {TicketSelectionDetailResponse} message TicketSelectionDetailResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TicketSelectionDetailResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.CorrectSelectionNames = [];
            object.Scores = [];
        }
        if (options.defaults) {
            object.Base = null;
            object.ResultNote = "";
            object.EvalState = options.enums === String ? "None" : 0;
            object.EvalRate = 0;
            object.ShowResultStyle = options.enums === String ? "WinTips" : 0;
            object.LiveEventStatus = null;
        }
        if (message.Base != null && message.hasOwnProperty("Base"))
            object.Base = $root.TicketSelectionBase.toObject(message.Base, options);
        if (message.ResultNote != null && message.hasOwnProperty("ResultNote"))
            object.ResultNote = message.ResultNote;
        if (message.EvalState != null && message.hasOwnProperty("EvalState"))
            object.EvalState = options.enums === String ? $root.TicketSelectionEvalState[message.EvalState] : message.EvalState;
        if (message.EvalRate != null && message.hasOwnProperty("EvalRate"))
            object.EvalRate = options.json && !isFinite(message.EvalRate) ? String(message.EvalRate) : message.EvalRate;
        if (message.CorrectSelectionNames && message.CorrectSelectionNames.length) {
            object.CorrectSelectionNames = [];
            for (var j = 0; j < message.CorrectSelectionNames.length; ++j)
                object.CorrectSelectionNames[j] = message.CorrectSelectionNames[j];
        }
        if (message.ShowResultStyle != null && message.hasOwnProperty("ShowResultStyle"))
            object.ShowResultStyle = options.enums === String ? $root.ShowResultStyle[message.ShowResultStyle] : message.ShowResultStyle;
        if (message.Scores && message.Scores.length) {
            object.Scores = [];
            for (var j = 0; j < message.Scores.length; ++j)
                object.Scores[j] = $root.TicketSelectionScore.toObject(message.Scores[j], options);
        }
        if (message.LiveEventStatus != null && message.hasOwnProperty("LiveEventStatus"))
            object.LiveEventStatus = $root.TicketSelectionDetailEventStatus.toObject(message.LiveEventStatus, options);
        return object;
    };

    /**
     * Converts this TicketSelectionDetailResponse to JSON.
     * @function toJSON
     * @memberof TicketSelectionDetailResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TicketSelectionDetailResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TicketSelectionDetailResponse;
})();

$root.TicketSelectionDetailEventStatus = (function() {

    /**
     * Properties of a TicketSelectionDetailEventStatus.
     * @exports ITicketSelectionDetailEventStatus
     * @interface ITicketSelectionDetailEventStatus
     * @property {string|null} [MainScore] TicketSelectionDetailEventStatus MainScore
     * @property {string|null} [StateName] TicketSelectionDetailEventStatus StateName
     * @property {INullableInt64|null} [StateTime] TicketSelectionDetailEventStatus StateTime
     * @property {Array.<IEventResult>|null} [ImportantResults] TicketSelectionDetailEventStatus ImportantResults
     */

    /**
     * Constructs a new TicketSelectionDetailEventStatus.
     * @exports TicketSelectionDetailEventStatus
     * @classdesc Represents a TicketSelectionDetailEventStatus.
     * @implements ITicketSelectionDetailEventStatus
     * @constructor
     * @param {ITicketSelectionDetailEventStatus=} [properties] Properties to set
     */
    function TicketSelectionDetailEventStatus(properties) {
        this.ImportantResults = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * TicketSelectionDetailEventStatus MainScore.
     * @member {string} MainScore
     * @memberof TicketSelectionDetailEventStatus
     * @instance
     */
    TicketSelectionDetailEventStatus.prototype.MainScore = "";

    /**
     * TicketSelectionDetailEventStatus StateName.
     * @member {string} StateName
     * @memberof TicketSelectionDetailEventStatus
     * @instance
     */
    TicketSelectionDetailEventStatus.prototype.StateName = "";

    /**
     * TicketSelectionDetailEventStatus StateTime.
     * @member {INullableInt64|null|undefined} StateTime
     * @memberof TicketSelectionDetailEventStatus
     * @instance
     */
    TicketSelectionDetailEventStatus.prototype.StateTime = null;

    /**
     * TicketSelectionDetailEventStatus ImportantResults.
     * @member {Array.<IEventResult>} ImportantResults
     * @memberof TicketSelectionDetailEventStatus
     * @instance
     */
    TicketSelectionDetailEventStatus.prototype.ImportantResults = $util.emptyArray;

    /**
     * Creates a new TicketSelectionDetailEventStatus instance using the specified properties.
     * @function create
     * @memberof TicketSelectionDetailEventStatus
     * @static
     * @param {ITicketSelectionDetailEventStatus=} [properties] Properties to set
     * @returns {TicketSelectionDetailEventStatus} TicketSelectionDetailEventStatus instance
     */
    TicketSelectionDetailEventStatus.create = function create(properties) {
        return new TicketSelectionDetailEventStatus(properties);
    };

    /**
     * Encodes the specified TicketSelectionDetailEventStatus message. Does not implicitly {@link TicketSelectionDetailEventStatus.verify|verify} messages.
     * @function encode
     * @memberof TicketSelectionDetailEventStatus
     * @static
     * @param {ITicketSelectionDetailEventStatus} message TicketSelectionDetailEventStatus message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TicketSelectionDetailEventStatus.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.MainScore != null && message.hasOwnProperty("MainScore"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.MainScore);
        if (message.StateName != null && message.hasOwnProperty("StateName"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.StateName);
        if (message.StateTime != null && message.hasOwnProperty("StateTime"))
            $root.NullableInt64.encode(message.StateTime, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        if (message.ImportantResults != null && message.ImportantResults.length)
            for (var i = 0; i < message.ImportantResults.length; ++i)
                $root.EventResult.encode(message.ImportantResults[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified TicketSelectionDetailEventStatus message, length delimited. Does not implicitly {@link TicketSelectionDetailEventStatus.verify|verify} messages.
     * @function encodeDelimited
     * @memberof TicketSelectionDetailEventStatus
     * @static
     * @param {ITicketSelectionDetailEventStatus} message TicketSelectionDetailEventStatus message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TicketSelectionDetailEventStatus.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TicketSelectionDetailEventStatus message from the specified reader or buffer.
     * @function decode
     * @memberof TicketSelectionDetailEventStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TicketSelectionDetailEventStatus} TicketSelectionDetailEventStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TicketSelectionDetailEventStatus.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TicketSelectionDetailEventStatus();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.MainScore = reader.string();
                break;
            case 2:
                message.StateName = reader.string();
                break;
            case 3:
                message.StateTime = $root.NullableInt64.decode(reader, reader.uint32());
                break;
            case 4:
                if (!(message.ImportantResults && message.ImportantResults.length))
                    message.ImportantResults = [];
                message.ImportantResults.push($root.EventResult.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a TicketSelectionDetailEventStatus message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof TicketSelectionDetailEventStatus
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {TicketSelectionDetailEventStatus} TicketSelectionDetailEventStatus
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TicketSelectionDetailEventStatus.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TicketSelectionDetailEventStatus message.
     * @function verify
     * @memberof TicketSelectionDetailEventStatus
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TicketSelectionDetailEventStatus.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.MainScore != null && message.hasOwnProperty("MainScore"))
            if (!$util.isString(message.MainScore))
                return "MainScore: string expected";
        if (message.StateName != null && message.hasOwnProperty("StateName"))
            if (!$util.isString(message.StateName))
                return "StateName: string expected";
        if (message.StateTime != null && message.hasOwnProperty("StateTime")) {
            var error = $root.NullableInt64.verify(message.StateTime);
            if (error)
                return "StateTime." + error;
        }
        if (message.ImportantResults != null && message.hasOwnProperty("ImportantResults")) {
            if (!Array.isArray(message.ImportantResults))
                return "ImportantResults: array expected";
            for (var i = 0; i < message.ImportantResults.length; ++i) {
                var error = $root.EventResult.verify(message.ImportantResults[i]);
                if (error)
                    return "ImportantResults." + error;
            }
        }
        return null;
    };

    /**
     * Creates a TicketSelectionDetailEventStatus message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TicketSelectionDetailEventStatus
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TicketSelectionDetailEventStatus} TicketSelectionDetailEventStatus
     */
    TicketSelectionDetailEventStatus.fromObject = function fromObject(object) {
        if (object instanceof $root.TicketSelectionDetailEventStatus)
            return object;
        var message = new $root.TicketSelectionDetailEventStatus();
        if (object.MainScore != null)
            message.MainScore = String(object.MainScore);
        if (object.StateName != null)
            message.StateName = String(object.StateName);
        if (object.StateTime != null) {
            if (typeof object.StateTime !== "object")
                throw TypeError(".TicketSelectionDetailEventStatus.StateTime: object expected");
            message.StateTime = $root.NullableInt64.fromObject(object.StateTime);
        }
        if (object.ImportantResults) {
            if (!Array.isArray(object.ImportantResults))
                throw TypeError(".TicketSelectionDetailEventStatus.ImportantResults: array expected");
            message.ImportantResults = [];
            for (var i = 0; i < object.ImportantResults.length; ++i) {
                if (typeof object.ImportantResults[i] !== "object")
                    throw TypeError(".TicketSelectionDetailEventStatus.ImportantResults: object expected");
                message.ImportantResults[i] = $root.EventResult.fromObject(object.ImportantResults[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a TicketSelectionDetailEventStatus message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TicketSelectionDetailEventStatus
     * @static
     * @param {TicketSelectionDetailEventStatus} message TicketSelectionDetailEventStatus
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TicketSelectionDetailEventStatus.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.ImportantResults = [];
        if (options.defaults) {
            object.MainScore = "";
            object.StateName = "";
            object.StateTime = null;
        }
        if (message.MainScore != null && message.hasOwnProperty("MainScore"))
            object.MainScore = message.MainScore;
        if (message.StateName != null && message.hasOwnProperty("StateName"))
            object.StateName = message.StateName;
        if (message.StateTime != null && message.hasOwnProperty("StateTime"))
            object.StateTime = $root.NullableInt64.toObject(message.StateTime, options);
        if (message.ImportantResults && message.ImportantResults.length) {
            object.ImportantResults = [];
            for (var j = 0; j < message.ImportantResults.length; ++j)
                object.ImportantResults[j] = $root.EventResult.toObject(message.ImportantResults[j], options);
        }
        return object;
    };

    /**
     * Converts this TicketSelectionDetailEventStatus to JSON.
     * @function toJSON
     * @memberof TicketSelectionDetailEventStatus
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TicketSelectionDetailEventStatus.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TicketSelectionDetailEventStatus;
})();

$root.EventResult = (function() {

    /**
     * Properties of an EventResult.
     * @exports IEventResult
     * @interface IEventResult
     * @property {number|null} [ID] EventResult ID
     * @property {string|null} [Name] EventResult Name
     * @property {string|null} [Score] EventResult Score
     * @property {number|null} [Flags] EventResult Flags
     */

    /**
     * Constructs a new EventResult.
     * @exports EventResult
     * @classdesc Represents an EventResult.
     * @implements IEventResult
     * @constructor
     * @param {IEventResult=} [properties] Properties to set
     */
    function EventResult(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * EventResult ID.
     * @member {number} ID
     * @memberof EventResult
     * @instance
     */
    EventResult.prototype.ID = 0;

    /**
     * EventResult Name.
     * @member {string} Name
     * @memberof EventResult
     * @instance
     */
    EventResult.prototype.Name = "";

    /**
     * EventResult Score.
     * @member {string} Score
     * @memberof EventResult
     * @instance
     */
    EventResult.prototype.Score = "";

    /**
     * EventResult Flags.
     * @member {number} Flags
     * @memberof EventResult
     * @instance
     */
    EventResult.prototype.Flags = 0;

    /**
     * Creates a new EventResult instance using the specified properties.
     * @function create
     * @memberof EventResult
     * @static
     * @param {IEventResult=} [properties] Properties to set
     * @returns {EventResult} EventResult instance
     */
    EventResult.create = function create(properties) {
        return new EventResult(properties);
    };

    /**
     * Encodes the specified EventResult message. Does not implicitly {@link EventResult.verify|verify} messages.
     * @function encode
     * @memberof EventResult
     * @static
     * @param {IEventResult} message EventResult message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    EventResult.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ID != null && message.hasOwnProperty("ID"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.ID);
        if (message.Name != null && message.hasOwnProperty("Name"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.Name);
        if (message.Score != null && message.hasOwnProperty("Score"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.Score);
        if (message.Flags != null && message.hasOwnProperty("Flags"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.Flags);
        return writer;
    };

    /**
     * Encodes the specified EventResult message, length delimited. Does not implicitly {@link EventResult.verify|verify} messages.
     * @function encodeDelimited
     * @memberof EventResult
     * @static
     * @param {IEventResult} message EventResult message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    EventResult.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an EventResult message from the specified reader or buffer.
     * @function decode
     * @memberof EventResult
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {EventResult} EventResult
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    EventResult.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.EventResult();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.ID = reader.int32();
                break;
            case 2:
                message.Name = reader.string();
                break;
            case 3:
                message.Score = reader.string();
                break;
            case 4:
                message.Flags = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an EventResult message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof EventResult
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {EventResult} EventResult
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    EventResult.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an EventResult message.
     * @function verify
     * @memberof EventResult
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    EventResult.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ID != null && message.hasOwnProperty("ID"))
            if (!$util.isInteger(message.ID))
                return "ID: integer expected";
        if (message.Name != null && message.hasOwnProperty("Name"))
            if (!$util.isString(message.Name))
                return "Name: string expected";
        if (message.Score != null && message.hasOwnProperty("Score"))
            if (!$util.isString(message.Score))
                return "Score: string expected";
        if (message.Flags != null && message.hasOwnProperty("Flags"))
            if (!$util.isInteger(message.Flags))
                return "Flags: integer expected";
        return null;
    };

    /**
     * Creates an EventResult message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof EventResult
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {EventResult} EventResult
     */
    EventResult.fromObject = function fromObject(object) {
        if (object instanceof $root.EventResult)
            return object;
        var message = new $root.EventResult();
        if (object.ID != null)
            message.ID = object.ID | 0;
        if (object.Name != null)
            message.Name = String(object.Name);
        if (object.Score != null)
            message.Score = String(object.Score);
        if (object.Flags != null)
            message.Flags = object.Flags | 0;
        return message;
    };

    /**
     * Creates a plain object from an EventResult message. Also converts values to other types if specified.
     * @function toObject
     * @memberof EventResult
     * @static
     * @param {EventResult} message EventResult
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    EventResult.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.ID = 0;
            object.Name = "";
            object.Score = "";
            object.Flags = 0;
        }
        if (message.ID != null && message.hasOwnProperty("ID"))
            object.ID = message.ID;
        if (message.Name != null && message.hasOwnProperty("Name"))
            object.Name = message.Name;
        if (message.Score != null && message.hasOwnProperty("Score"))
            object.Score = message.Score;
        if (message.Flags != null && message.hasOwnProperty("Flags"))
            object.Flags = message.Flags;
        return object;
    };

    /**
     * Converts this EventResult to JSON.
     * @function toJSON
     * @memberof EventResult
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    EventResult.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return EventResult;
})();

/**
 * ShowResultStyle enum.
 * @exports ShowResultStyle
 * @enum {string}
 * @property {number} WinTips=0 WinTips value
 * @property {number} SelectedResults=1 SelectedResults value
 */
$root.ShowResultStyle = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "WinTips"] = 0;
    values[valuesById[1] = "SelectedResults"] = 1;
    return values;
})();

$root.TicketResponseBase = (function() {

    /**
     * Properties of a TicketResponseBase.
     * @exports ITicketResponseBase
     * @interface ITicketResponseBase
     * @property {number|Long|null} [Id] TicketResponseBase Id
     * @property {TicketType|null} [TicketType] TicketResponseBase TicketType
     * @property {StakeType|null} [StakeType] TicketResponseBase StakeType
     * @property {OddsChangeType|null} [RateChangeType] TicketResponseBase RateChangeType
     * @property {number|null} [Rate] TicketResponseBase Rate
     * @property {number|null} [PrizeEvalPotentionalValue] TicketResponseBase PrizeEvalPotentionalValue
     * @property {Array.<ITicketBetResponse>|null} [Bets] TicketResponseBase Bets
     * @property {Array.<ITicketError>|null} [Errors] TicketResponseBase Errors
     * @property {string|null} [Number] TicketResponseBase Number
     * @property {number|null} [Stake] TicketResponseBase Stake
     * @property {INullableDouble|null} [StakePoints] TicketResponseBase StakePoints
     * @property {IMoneyOrPoints|null} [ProductFee] TicketResponseBase ProductFee
     * @property {INullableDouble|null} [OddsRateAdvantage] TicketResponseBase OddsRateAdvantage
     * @property {INullableDouble|null} [RateAdvantageFactor] TicketResponseBase RateAdvantageFactor
     * @property {number|null} [HandlingFeeValue] TicketResponseBase HandlingFeeValue
     * @property {number|null} [HandlingFeePointsValue] TicketResponseBase HandlingFeePointsValue
     * @property {INullableDouble|null} [StakeMax] TicketResponseBase StakeMax
     */

    /**
     * Constructs a new TicketResponseBase.
     * @exports TicketResponseBase
     * @classdesc Represents a TicketResponseBase.
     * @implements ITicketResponseBase
     * @constructor
     * @param {ITicketResponseBase=} [properties] Properties to set
     */
    function TicketResponseBase(properties) {
        this.Bets = [];
        this.Errors = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * TicketResponseBase Id.
     * @member {number|Long} Id
     * @memberof TicketResponseBase
     * @instance
     */
    TicketResponseBase.prototype.Id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * TicketResponseBase TicketType.
     * @member {TicketType} TicketType
     * @memberof TicketResponseBase
     * @instance
     */
    TicketResponseBase.prototype.TicketType = 0;

    /**
     * TicketResponseBase StakeType.
     * @member {StakeType} StakeType
     * @memberof TicketResponseBase
     * @instance
     */
    TicketResponseBase.prototype.StakeType = 0;

    /**
     * TicketResponseBase RateChangeType.
     * @member {OddsChangeType} RateChangeType
     * @memberof TicketResponseBase
     * @instance
     */
    TicketResponseBase.prototype.RateChangeType = 0;

    /**
     * TicketResponseBase Rate.
     * @member {number} Rate
     * @memberof TicketResponseBase
     * @instance
     */
    TicketResponseBase.prototype.Rate = 0;

    /**
     * TicketResponseBase PrizeEvalPotentionalValue.
     * @member {number} PrizeEvalPotentionalValue
     * @memberof TicketResponseBase
     * @instance
     */
    TicketResponseBase.prototype.PrizeEvalPotentionalValue = 0;

    /**
     * TicketResponseBase Bets.
     * @member {Array.<ITicketBetResponse>} Bets
     * @memberof TicketResponseBase
     * @instance
     */
    TicketResponseBase.prototype.Bets = $util.emptyArray;

    /**
     * TicketResponseBase Errors.
     * @member {Array.<ITicketError>} Errors
     * @memberof TicketResponseBase
     * @instance
     */
    TicketResponseBase.prototype.Errors = $util.emptyArray;

    /**
     * TicketResponseBase Number.
     * @member {string} Number
     * @memberof TicketResponseBase
     * @instance
     */
    TicketResponseBase.prototype.Number = "";

    /**
     * TicketResponseBase Stake.
     * @member {number} Stake
     * @memberof TicketResponseBase
     * @instance
     */
    TicketResponseBase.prototype.Stake = 0;

    /**
     * TicketResponseBase StakePoints.
     * @member {INullableDouble|null|undefined} StakePoints
     * @memberof TicketResponseBase
     * @instance
     */
    TicketResponseBase.prototype.StakePoints = null;

    /**
     * TicketResponseBase ProductFee.
     * @member {IMoneyOrPoints|null|undefined} ProductFee
     * @memberof TicketResponseBase
     * @instance
     */
    TicketResponseBase.prototype.ProductFee = null;

    /**
     * TicketResponseBase OddsRateAdvantage.
     * @member {INullableDouble|null|undefined} OddsRateAdvantage
     * @memberof TicketResponseBase
     * @instance
     */
    TicketResponseBase.prototype.OddsRateAdvantage = null;

    /**
     * TicketResponseBase RateAdvantageFactor.
     * @member {INullableDouble|null|undefined} RateAdvantageFactor
     * @memberof TicketResponseBase
     * @instance
     */
    TicketResponseBase.prototype.RateAdvantageFactor = null;

    /**
     * TicketResponseBase HandlingFeeValue.
     * @member {number} HandlingFeeValue
     * @memberof TicketResponseBase
     * @instance
     */
    TicketResponseBase.prototype.HandlingFeeValue = 0;

    /**
     * TicketResponseBase HandlingFeePointsValue.
     * @member {number} HandlingFeePointsValue
     * @memberof TicketResponseBase
     * @instance
     */
    TicketResponseBase.prototype.HandlingFeePointsValue = 0;

    /**
     * TicketResponseBase StakeMax.
     * @member {INullableDouble|null|undefined} StakeMax
     * @memberof TicketResponseBase
     * @instance
     */
    TicketResponseBase.prototype.StakeMax = null;

    /**
     * Creates a new TicketResponseBase instance using the specified properties.
     * @function create
     * @memberof TicketResponseBase
     * @static
     * @param {ITicketResponseBase=} [properties] Properties to set
     * @returns {TicketResponseBase} TicketResponseBase instance
     */
    TicketResponseBase.create = function create(properties) {
        return new TicketResponseBase(properties);
    };

    /**
     * Encodes the specified TicketResponseBase message. Does not implicitly {@link TicketResponseBase.verify|verify} messages.
     * @function encode
     * @memberof TicketResponseBase
     * @static
     * @param {ITicketResponseBase} message TicketResponseBase message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TicketResponseBase.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Id != null && message.hasOwnProperty("Id"))
            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.Id);
        if (message.TicketType != null && message.hasOwnProperty("TicketType"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.TicketType);
        if (message.StakeType != null && message.hasOwnProperty("StakeType"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.StakeType);
        if (message.RateChangeType != null && message.hasOwnProperty("RateChangeType"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.RateChangeType);
        if (message.Rate != null && message.hasOwnProperty("Rate"))
            writer.uint32(/* id 5, wireType 1 =*/41).double(message.Rate);
        if (message.PrizeEvalPotentionalValue != null && message.hasOwnProperty("PrizeEvalPotentionalValue"))
            writer.uint32(/* id 6, wireType 1 =*/49).double(message.PrizeEvalPotentionalValue);
        if (message.Bets != null && message.Bets.length)
            for (var i = 0; i < message.Bets.length; ++i)
                $root.TicketBetResponse.encode(message.Bets[i], writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
        if (message.Errors != null && message.Errors.length)
            for (var i = 0; i < message.Errors.length; ++i)
                $root.TicketError.encode(message.Errors[i], writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
        if (message.Number != null && message.hasOwnProperty("Number"))
            writer.uint32(/* id 9, wireType 2 =*/74).string(message.Number);
        if (message.Stake != null && message.hasOwnProperty("Stake"))
            writer.uint32(/* id 10, wireType 1 =*/81).double(message.Stake);
        if (message.StakePoints != null && message.hasOwnProperty("StakePoints"))
            $root.NullableDouble.encode(message.StakePoints, writer.uint32(/* id 11, wireType 2 =*/90).fork()).ldelim();
        if (message.ProductFee != null && message.hasOwnProperty("ProductFee"))
            $root.MoneyOrPoints.encode(message.ProductFee, writer.uint32(/* id 12, wireType 2 =*/98).fork()).ldelim();
        if (message.OddsRateAdvantage != null && message.hasOwnProperty("OddsRateAdvantage"))
            $root.NullableDouble.encode(message.OddsRateAdvantage, writer.uint32(/* id 13, wireType 2 =*/106).fork()).ldelim();
        if (message.RateAdvantageFactor != null && message.hasOwnProperty("RateAdvantageFactor"))
            $root.NullableDouble.encode(message.RateAdvantageFactor, writer.uint32(/* id 14, wireType 2 =*/114).fork()).ldelim();
        if (message.HandlingFeeValue != null && message.hasOwnProperty("HandlingFeeValue"))
            writer.uint32(/* id 15, wireType 1 =*/121).double(message.HandlingFeeValue);
        if (message.HandlingFeePointsValue != null && message.hasOwnProperty("HandlingFeePointsValue"))
            writer.uint32(/* id 16, wireType 1 =*/129).double(message.HandlingFeePointsValue);
        if (message.StakeMax != null && message.hasOwnProperty("StakeMax"))
            $root.NullableDouble.encode(message.StakeMax, writer.uint32(/* id 17, wireType 2 =*/138).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified TicketResponseBase message, length delimited. Does not implicitly {@link TicketResponseBase.verify|verify} messages.
     * @function encodeDelimited
     * @memberof TicketResponseBase
     * @static
     * @param {ITicketResponseBase} message TicketResponseBase message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TicketResponseBase.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TicketResponseBase message from the specified reader or buffer.
     * @function decode
     * @memberof TicketResponseBase
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TicketResponseBase} TicketResponseBase
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TicketResponseBase.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TicketResponseBase();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Id = reader.int64();
                break;
            case 2:
                message.TicketType = reader.int32();
                break;
            case 3:
                message.StakeType = reader.int32();
                break;
            case 4:
                message.RateChangeType = reader.int32();
                break;
            case 5:
                message.Rate = reader.double();
                break;
            case 6:
                message.PrizeEvalPotentionalValue = reader.double();
                break;
            case 7:
                if (!(message.Bets && message.Bets.length))
                    message.Bets = [];
                message.Bets.push($root.TicketBetResponse.decode(reader, reader.uint32()));
                break;
            case 8:
                if (!(message.Errors && message.Errors.length))
                    message.Errors = [];
                message.Errors.push($root.TicketError.decode(reader, reader.uint32()));
                break;
            case 9:
                message.Number = reader.string();
                break;
            case 10:
                message.Stake = reader.double();
                break;
            case 11:
                message.StakePoints = $root.NullableDouble.decode(reader, reader.uint32());
                break;
            case 12:
                message.ProductFee = $root.MoneyOrPoints.decode(reader, reader.uint32());
                break;
            case 13:
                message.OddsRateAdvantage = $root.NullableDouble.decode(reader, reader.uint32());
                break;
            case 14:
                message.RateAdvantageFactor = $root.NullableDouble.decode(reader, reader.uint32());
                break;
            case 15:
                message.HandlingFeeValue = reader.double();
                break;
            case 16:
                message.HandlingFeePointsValue = reader.double();
                break;
            case 17:
                message.StakeMax = $root.NullableDouble.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a TicketResponseBase message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof TicketResponseBase
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {TicketResponseBase} TicketResponseBase
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TicketResponseBase.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TicketResponseBase message.
     * @function verify
     * @memberof TicketResponseBase
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TicketResponseBase.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Id != null && message.hasOwnProperty("Id"))
            if (!$util.isInteger(message.Id) && !(message.Id && $util.isInteger(message.Id.low) && $util.isInteger(message.Id.high)))
                return "Id: integer|Long expected";
        if (message.TicketType != null && message.hasOwnProperty("TicketType"))
            switch (message.TicketType) {
            default:
                return "TicketType: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.StakeType != null && message.hasOwnProperty("StakeType"))
            switch (message.StakeType) {
            default:
                return "StakeType: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.RateChangeType != null && message.hasOwnProperty("RateChangeType"))
            switch (message.RateChangeType) {
            default:
                return "RateChangeType: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.Rate != null && message.hasOwnProperty("Rate"))
            if (typeof message.Rate !== "number")
                return "Rate: number expected";
        if (message.PrizeEvalPotentionalValue != null && message.hasOwnProperty("PrizeEvalPotentionalValue"))
            if (typeof message.PrizeEvalPotentionalValue !== "number")
                return "PrizeEvalPotentionalValue: number expected";
        if (message.Bets != null && message.hasOwnProperty("Bets")) {
            if (!Array.isArray(message.Bets))
                return "Bets: array expected";
            for (var i = 0; i < message.Bets.length; ++i) {
                var error = $root.TicketBetResponse.verify(message.Bets[i]);
                if (error)
                    return "Bets." + error;
            }
        }
        if (message.Errors != null && message.hasOwnProperty("Errors")) {
            if (!Array.isArray(message.Errors))
                return "Errors: array expected";
            for (var i = 0; i < message.Errors.length; ++i) {
                var error = $root.TicketError.verify(message.Errors[i]);
                if (error)
                    return "Errors." + error;
            }
        }
        if (message.Number != null && message.hasOwnProperty("Number"))
            if (!$util.isString(message.Number))
                return "Number: string expected";
        if (message.Stake != null && message.hasOwnProperty("Stake"))
            if (typeof message.Stake !== "number")
                return "Stake: number expected";
        if (message.StakePoints != null && message.hasOwnProperty("StakePoints")) {
            var error = $root.NullableDouble.verify(message.StakePoints);
            if (error)
                return "StakePoints." + error;
        }
        if (message.ProductFee != null && message.hasOwnProperty("ProductFee")) {
            var error = $root.MoneyOrPoints.verify(message.ProductFee);
            if (error)
                return "ProductFee." + error;
        }
        if (message.OddsRateAdvantage != null && message.hasOwnProperty("OddsRateAdvantage")) {
            var error = $root.NullableDouble.verify(message.OddsRateAdvantage);
            if (error)
                return "OddsRateAdvantage." + error;
        }
        if (message.RateAdvantageFactor != null && message.hasOwnProperty("RateAdvantageFactor")) {
            var error = $root.NullableDouble.verify(message.RateAdvantageFactor);
            if (error)
                return "RateAdvantageFactor." + error;
        }
        if (message.HandlingFeeValue != null && message.hasOwnProperty("HandlingFeeValue"))
            if (typeof message.HandlingFeeValue !== "number")
                return "HandlingFeeValue: number expected";
        if (message.HandlingFeePointsValue != null && message.hasOwnProperty("HandlingFeePointsValue"))
            if (typeof message.HandlingFeePointsValue !== "number")
                return "HandlingFeePointsValue: number expected";
        if (message.StakeMax != null && message.hasOwnProperty("StakeMax")) {
            var error = $root.NullableDouble.verify(message.StakeMax);
            if (error)
                return "StakeMax." + error;
        }
        return null;
    };

    /**
     * Creates a TicketResponseBase message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TicketResponseBase
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TicketResponseBase} TicketResponseBase
     */
    TicketResponseBase.fromObject = function fromObject(object) {
        if (object instanceof $root.TicketResponseBase)
            return object;
        var message = new $root.TicketResponseBase();
        if (object.Id != null)
            if ($util.Long)
                (message.Id = $util.Long.fromValue(object.Id)).unsigned = false;
            else if (typeof object.Id === "string")
                message.Id = parseInt(object.Id, 10);
            else if (typeof object.Id === "number")
                message.Id = object.Id;
            else if (typeof object.Id === "object")
                message.Id = new $util.LongBits(object.Id.low >>> 0, object.Id.high >>> 0).toNumber();
        switch (object.TicketType) {
        case "None":
        case 0:
            message.TicketType = 0;
            break;
        case "Simple":
        case 1:
            message.TicketType = 1;
            break;
        case "System":
        case 2:
            message.TicketType = 2;
            break;
        }
        switch (object.StakeType) {
        case "All":
        case 0:
            message.StakeType = 0;
            break;
        case "Total":
        case 1:
            message.StakeType = 1;
            break;
        case "Unit":
        case 2:
            message.StakeType = 2;
            break;
        }
        switch (object.RateChangeType) {
        case "None":
        case 0:
            message.RateChangeType = 0;
            break;
        case "Any":
        case 1:
            message.RateChangeType = 1;
            break;
        case "Higher":
        case 2:
            message.RateChangeType = 2;
            break;
        }
        if (object.Rate != null)
            message.Rate = Number(object.Rate);
        if (object.PrizeEvalPotentionalValue != null)
            message.PrizeEvalPotentionalValue = Number(object.PrizeEvalPotentionalValue);
        if (object.Bets) {
            if (!Array.isArray(object.Bets))
                throw TypeError(".TicketResponseBase.Bets: array expected");
            message.Bets = [];
            for (var i = 0; i < object.Bets.length; ++i) {
                if (typeof object.Bets[i] !== "object")
                    throw TypeError(".TicketResponseBase.Bets: object expected");
                message.Bets[i] = $root.TicketBetResponse.fromObject(object.Bets[i]);
            }
        }
        if (object.Errors) {
            if (!Array.isArray(object.Errors))
                throw TypeError(".TicketResponseBase.Errors: array expected");
            message.Errors = [];
            for (var i = 0; i < object.Errors.length; ++i) {
                if (typeof object.Errors[i] !== "object")
                    throw TypeError(".TicketResponseBase.Errors: object expected");
                message.Errors[i] = $root.TicketError.fromObject(object.Errors[i]);
            }
        }
        if (object.Number != null)
            message.Number = String(object.Number);
        if (object.Stake != null)
            message.Stake = Number(object.Stake);
        if (object.StakePoints != null) {
            if (typeof object.StakePoints !== "object")
                throw TypeError(".TicketResponseBase.StakePoints: object expected");
            message.StakePoints = $root.NullableDouble.fromObject(object.StakePoints);
        }
        if (object.ProductFee != null) {
            if (typeof object.ProductFee !== "object")
                throw TypeError(".TicketResponseBase.ProductFee: object expected");
            message.ProductFee = $root.MoneyOrPoints.fromObject(object.ProductFee);
        }
        if (object.OddsRateAdvantage != null) {
            if (typeof object.OddsRateAdvantage !== "object")
                throw TypeError(".TicketResponseBase.OddsRateAdvantage: object expected");
            message.OddsRateAdvantage = $root.NullableDouble.fromObject(object.OddsRateAdvantage);
        }
        if (object.RateAdvantageFactor != null) {
            if (typeof object.RateAdvantageFactor !== "object")
                throw TypeError(".TicketResponseBase.RateAdvantageFactor: object expected");
            message.RateAdvantageFactor = $root.NullableDouble.fromObject(object.RateAdvantageFactor);
        }
        if (object.HandlingFeeValue != null)
            message.HandlingFeeValue = Number(object.HandlingFeeValue);
        if (object.HandlingFeePointsValue != null)
            message.HandlingFeePointsValue = Number(object.HandlingFeePointsValue);
        if (object.StakeMax != null) {
            if (typeof object.StakeMax !== "object")
                throw TypeError(".TicketResponseBase.StakeMax: object expected");
            message.StakeMax = $root.NullableDouble.fromObject(object.StakeMax);
        }
        return message;
    };

    /**
     * Creates a plain object from a TicketResponseBase message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TicketResponseBase
     * @static
     * @param {TicketResponseBase} message TicketResponseBase
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TicketResponseBase.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.Bets = [];
            object.Errors = [];
        }
        if (options.defaults) {
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.Id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.Id = options.longs === String ? "0" : 0;
            object.TicketType = options.enums === String ? "None" : 0;
            object.StakeType = options.enums === String ? "All" : 0;
            object.RateChangeType = options.enums === String ? "None" : 0;
            object.Rate = 0;
            object.PrizeEvalPotentionalValue = 0;
            object.Number = "";
            object.Stake = 0;
            object.StakePoints = null;
            object.ProductFee = null;
            object.OddsRateAdvantage = null;
            object.RateAdvantageFactor = null;
            object.HandlingFeeValue = 0;
            object.HandlingFeePointsValue = 0;
            object.StakeMax = null;
        }
        if (message.Id != null && message.hasOwnProperty("Id"))
            if (typeof message.Id === "number")
                object.Id = options.longs === String ? String(message.Id) : message.Id;
            else
                object.Id = options.longs === String ? $util.Long.prototype.toString.call(message.Id) : options.longs === Number ? new $util.LongBits(message.Id.low >>> 0, message.Id.high >>> 0).toNumber() : message.Id;
        if (message.TicketType != null && message.hasOwnProperty("TicketType"))
            object.TicketType = options.enums === String ? $root.TicketType[message.TicketType] : message.TicketType;
        if (message.StakeType != null && message.hasOwnProperty("StakeType"))
            object.StakeType = options.enums === String ? $root.StakeType[message.StakeType] : message.StakeType;
        if (message.RateChangeType != null && message.hasOwnProperty("RateChangeType"))
            object.RateChangeType = options.enums === String ? $root.OddsChangeType[message.RateChangeType] : message.RateChangeType;
        if (message.Rate != null && message.hasOwnProperty("Rate"))
            object.Rate = options.json && !isFinite(message.Rate) ? String(message.Rate) : message.Rate;
        if (message.PrizeEvalPotentionalValue != null && message.hasOwnProperty("PrizeEvalPotentionalValue"))
            object.PrizeEvalPotentionalValue = options.json && !isFinite(message.PrizeEvalPotentionalValue) ? String(message.PrizeEvalPotentionalValue) : message.PrizeEvalPotentionalValue;
        if (message.Bets && message.Bets.length) {
            object.Bets = [];
            for (var j = 0; j < message.Bets.length; ++j)
                object.Bets[j] = $root.TicketBetResponse.toObject(message.Bets[j], options);
        }
        if (message.Errors && message.Errors.length) {
            object.Errors = [];
            for (var j = 0; j < message.Errors.length; ++j)
                object.Errors[j] = $root.TicketError.toObject(message.Errors[j], options);
        }
        if (message.Number != null && message.hasOwnProperty("Number"))
            object.Number = message.Number;
        if (message.Stake != null && message.hasOwnProperty("Stake"))
            object.Stake = options.json && !isFinite(message.Stake) ? String(message.Stake) : message.Stake;
        if (message.StakePoints != null && message.hasOwnProperty("StakePoints"))
            object.StakePoints = $root.NullableDouble.toObject(message.StakePoints, options);
        if (message.ProductFee != null && message.hasOwnProperty("ProductFee"))
            object.ProductFee = $root.MoneyOrPoints.toObject(message.ProductFee, options);
        if (message.OddsRateAdvantage != null && message.hasOwnProperty("OddsRateAdvantage"))
            object.OddsRateAdvantage = $root.NullableDouble.toObject(message.OddsRateAdvantage, options);
        if (message.RateAdvantageFactor != null && message.hasOwnProperty("RateAdvantageFactor"))
            object.RateAdvantageFactor = $root.NullableDouble.toObject(message.RateAdvantageFactor, options);
        if (message.HandlingFeeValue != null && message.hasOwnProperty("HandlingFeeValue"))
            object.HandlingFeeValue = options.json && !isFinite(message.HandlingFeeValue) ? String(message.HandlingFeeValue) : message.HandlingFeeValue;
        if (message.HandlingFeePointsValue != null && message.hasOwnProperty("HandlingFeePointsValue"))
            object.HandlingFeePointsValue = options.json && !isFinite(message.HandlingFeePointsValue) ? String(message.HandlingFeePointsValue) : message.HandlingFeePointsValue;
        if (message.StakeMax != null && message.hasOwnProperty("StakeMax"))
            object.StakeMax = $root.NullableDouble.toObject(message.StakeMax, options);
        return object;
    };

    /**
     * Converts this TicketResponseBase to JSON.
     * @function toJSON
     * @memberof TicketResponseBase
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TicketResponseBase.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TicketResponseBase;
})();

$root.AccountType = (function() {

    /**
     * Properties of an AccountType.
     * @exports IAccountType
     * @interface IAccountType
     * @property {string|null} [Id] AccountType Id
     * @property {string|null} [Name] AccountType Name
     * @property {boolean|null} [IsMoney] AccountType IsMoney
     * @property {IMoneyOrPoints|null} [ProductFee] AccountType ProductFee
     * @property {INullableDouble|null} [RateAdvantageFactor] AccountType RateAdvantageFactor
     * @property {IFreeTicketData|null} [FreeTickets] AccountType FreeTickets
     */

    /**
     * Constructs a new AccountType.
     * @exports AccountType
     * @classdesc Represents an AccountType.
     * @implements IAccountType
     * @constructor
     * @param {IAccountType=} [properties] Properties to set
     */
    function AccountType(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * AccountType Id.
     * @member {string} Id
     * @memberof AccountType
     * @instance
     */
    AccountType.prototype.Id = "";

    /**
     * AccountType Name.
     * @member {string} Name
     * @memberof AccountType
     * @instance
     */
    AccountType.prototype.Name = "";

    /**
     * AccountType IsMoney.
     * @member {boolean} IsMoney
     * @memberof AccountType
     * @instance
     */
    AccountType.prototype.IsMoney = false;

    /**
     * AccountType ProductFee.
     * @member {IMoneyOrPoints|null|undefined} ProductFee
     * @memberof AccountType
     * @instance
     */
    AccountType.prototype.ProductFee = null;

    /**
     * AccountType RateAdvantageFactor.
     * @member {INullableDouble|null|undefined} RateAdvantageFactor
     * @memberof AccountType
     * @instance
     */
    AccountType.prototype.RateAdvantageFactor = null;

    /**
     * AccountType FreeTickets.
     * @member {IFreeTicketData|null|undefined} FreeTickets
     * @memberof AccountType
     * @instance
     */
    AccountType.prototype.FreeTickets = null;

    /**
     * Creates a new AccountType instance using the specified properties.
     * @function create
     * @memberof AccountType
     * @static
     * @param {IAccountType=} [properties] Properties to set
     * @returns {AccountType} AccountType instance
     */
    AccountType.create = function create(properties) {
        return new AccountType(properties);
    };

    /**
     * Encodes the specified AccountType message. Does not implicitly {@link AccountType.verify|verify} messages.
     * @function encode
     * @memberof AccountType
     * @static
     * @param {IAccountType} message AccountType message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AccountType.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Id != null && message.hasOwnProperty("Id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.Id);
        if (message.Name != null && message.hasOwnProperty("Name"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.Name);
        if (message.IsMoney != null && message.hasOwnProperty("IsMoney"))
            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.IsMoney);
        if (message.ProductFee != null && message.hasOwnProperty("ProductFee"))
            $root.MoneyOrPoints.encode(message.ProductFee, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        if (message.RateAdvantageFactor != null && message.hasOwnProperty("RateAdvantageFactor"))
            $root.NullableDouble.encode(message.RateAdvantageFactor, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
        if (message.FreeTickets != null && message.hasOwnProperty("FreeTickets"))
            $root.FreeTicketData.encode(message.FreeTickets, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified AccountType message, length delimited. Does not implicitly {@link AccountType.verify|verify} messages.
     * @function encodeDelimited
     * @memberof AccountType
     * @static
     * @param {IAccountType} message AccountType message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AccountType.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes an AccountType message from the specified reader or buffer.
     * @function decode
     * @memberof AccountType
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {AccountType} AccountType
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AccountType.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AccountType();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Id = reader.string();
                break;
            case 2:
                message.Name = reader.string();
                break;
            case 3:
                message.IsMoney = reader.bool();
                break;
            case 4:
                message.ProductFee = $root.MoneyOrPoints.decode(reader, reader.uint32());
                break;
            case 5:
                message.RateAdvantageFactor = $root.NullableDouble.decode(reader, reader.uint32());
                break;
            case 6:
                message.FreeTickets = $root.FreeTicketData.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes an AccountType message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof AccountType
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {AccountType} AccountType
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AccountType.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies an AccountType message.
     * @function verify
     * @memberof AccountType
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    AccountType.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Id != null && message.hasOwnProperty("Id"))
            if (!$util.isString(message.Id))
                return "Id: string expected";
        if (message.Name != null && message.hasOwnProperty("Name"))
            if (!$util.isString(message.Name))
                return "Name: string expected";
        if (message.IsMoney != null && message.hasOwnProperty("IsMoney"))
            if (typeof message.IsMoney !== "boolean")
                return "IsMoney: boolean expected";
        if (message.ProductFee != null && message.hasOwnProperty("ProductFee")) {
            var error = $root.MoneyOrPoints.verify(message.ProductFee);
            if (error)
                return "ProductFee." + error;
        }
        if (message.RateAdvantageFactor != null && message.hasOwnProperty("RateAdvantageFactor")) {
            var error = $root.NullableDouble.verify(message.RateAdvantageFactor);
            if (error)
                return "RateAdvantageFactor." + error;
        }
        if (message.FreeTickets != null && message.hasOwnProperty("FreeTickets")) {
            var error = $root.FreeTicketData.verify(message.FreeTickets);
            if (error)
                return "FreeTickets." + error;
        }
        return null;
    };

    /**
     * Creates an AccountType message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof AccountType
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {AccountType} AccountType
     */
    AccountType.fromObject = function fromObject(object) {
        if (object instanceof $root.AccountType)
            return object;
        var message = new $root.AccountType();
        if (object.Id != null)
            message.Id = String(object.Id);
        if (object.Name != null)
            message.Name = String(object.Name);
        if (object.IsMoney != null)
            message.IsMoney = Boolean(object.IsMoney);
        if (object.ProductFee != null) {
            if (typeof object.ProductFee !== "object")
                throw TypeError(".AccountType.ProductFee: object expected");
            message.ProductFee = $root.MoneyOrPoints.fromObject(object.ProductFee);
        }
        if (object.RateAdvantageFactor != null) {
            if (typeof object.RateAdvantageFactor !== "object")
                throw TypeError(".AccountType.RateAdvantageFactor: object expected");
            message.RateAdvantageFactor = $root.NullableDouble.fromObject(object.RateAdvantageFactor);
        }
        if (object.FreeTickets != null) {
            if (typeof object.FreeTickets !== "object")
                throw TypeError(".AccountType.FreeTickets: object expected");
            message.FreeTickets = $root.FreeTicketData.fromObject(object.FreeTickets);
        }
        return message;
    };

    /**
     * Creates a plain object from an AccountType message. Also converts values to other types if specified.
     * @function toObject
     * @memberof AccountType
     * @static
     * @param {AccountType} message AccountType
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AccountType.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.Id = "";
            object.Name = "";
            object.IsMoney = false;
            object.ProductFee = null;
            object.RateAdvantageFactor = null;
            object.FreeTickets = null;
        }
        if (message.Id != null && message.hasOwnProperty("Id"))
            object.Id = message.Id;
        if (message.Name != null && message.hasOwnProperty("Name"))
            object.Name = message.Name;
        if (message.IsMoney != null && message.hasOwnProperty("IsMoney"))
            object.IsMoney = message.IsMoney;
        if (message.ProductFee != null && message.hasOwnProperty("ProductFee"))
            object.ProductFee = $root.MoneyOrPoints.toObject(message.ProductFee, options);
        if (message.RateAdvantageFactor != null && message.hasOwnProperty("RateAdvantageFactor"))
            object.RateAdvantageFactor = $root.NullableDouble.toObject(message.RateAdvantageFactor, options);
        if (message.FreeTickets != null && message.hasOwnProperty("FreeTickets"))
            object.FreeTickets = $root.FreeTicketData.toObject(message.FreeTickets, options);
        return object;
    };

    /**
     * Converts this AccountType to JSON.
     * @function toJSON
     * @memberof AccountType
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AccountType.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AccountType;
})();

$root.FreeTicketData = (function() {

    /**
     * Properties of a FreeTicketData.
     * @exports IFreeTicketData
     * @interface IFreeTicketData
     * @property {Array.<IFreeTicketItem>|null} [Items] FreeTicketData Items
     */

    /**
     * Constructs a new FreeTicketData.
     * @exports FreeTicketData
     * @classdesc Represents a FreeTicketData.
     * @implements IFreeTicketData
     * @constructor
     * @param {IFreeTicketData=} [properties] Properties to set
     */
    function FreeTicketData(properties) {
        this.Items = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * FreeTicketData Items.
     * @member {Array.<IFreeTicketItem>} Items
     * @memberof FreeTicketData
     * @instance
     */
    FreeTicketData.prototype.Items = $util.emptyArray;

    /**
     * Creates a new FreeTicketData instance using the specified properties.
     * @function create
     * @memberof FreeTicketData
     * @static
     * @param {IFreeTicketData=} [properties] Properties to set
     * @returns {FreeTicketData} FreeTicketData instance
     */
    FreeTicketData.create = function create(properties) {
        return new FreeTicketData(properties);
    };

    /**
     * Encodes the specified FreeTicketData message. Does not implicitly {@link FreeTicketData.verify|verify} messages.
     * @function encode
     * @memberof FreeTicketData
     * @static
     * @param {IFreeTicketData} message FreeTicketData message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FreeTicketData.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Items != null && message.Items.length)
            for (var i = 0; i < message.Items.length; ++i)
                $root.FreeTicketItem.encode(message.Items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified FreeTicketData message, length delimited. Does not implicitly {@link FreeTicketData.verify|verify} messages.
     * @function encodeDelimited
     * @memberof FreeTicketData
     * @static
     * @param {IFreeTicketData} message FreeTicketData message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FreeTicketData.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a FreeTicketData message from the specified reader or buffer.
     * @function decode
     * @memberof FreeTicketData
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {FreeTicketData} FreeTicketData
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FreeTicketData.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FreeTicketData();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.Items && message.Items.length))
                    message.Items = [];
                message.Items.push($root.FreeTicketItem.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a FreeTicketData message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof FreeTicketData
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {FreeTicketData} FreeTicketData
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FreeTicketData.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a FreeTicketData message.
     * @function verify
     * @memberof FreeTicketData
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    FreeTicketData.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Items != null && message.hasOwnProperty("Items")) {
            if (!Array.isArray(message.Items))
                return "Items: array expected";
            for (var i = 0; i < message.Items.length; ++i) {
                var error = $root.FreeTicketItem.verify(message.Items[i]);
                if (error)
                    return "Items." + error;
            }
        }
        return null;
    };

    /**
     * Creates a FreeTicketData message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof FreeTicketData
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {FreeTicketData} FreeTicketData
     */
    FreeTicketData.fromObject = function fromObject(object) {
        if (object instanceof $root.FreeTicketData)
            return object;
        var message = new $root.FreeTicketData();
        if (object.Items) {
            if (!Array.isArray(object.Items))
                throw TypeError(".FreeTicketData.Items: array expected");
            message.Items = [];
            for (var i = 0; i < object.Items.length; ++i) {
                if (typeof object.Items[i] !== "object")
                    throw TypeError(".FreeTicketData.Items: object expected");
                message.Items[i] = $root.FreeTicketItem.fromObject(object.Items[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a FreeTicketData message. Also converts values to other types if specified.
     * @function toObject
     * @memberof FreeTicketData
     * @static
     * @param {FreeTicketData} message FreeTicketData
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    FreeTicketData.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.Items = [];
        if (message.Items && message.Items.length) {
            object.Items = [];
            for (var j = 0; j < message.Items.length; ++j)
                object.Items[j] = $root.FreeTicketItem.toObject(message.Items[j], options);
        }
        return object;
    };

    /**
     * Converts this FreeTicketData to JSON.
     * @function toJSON
     * @memberof FreeTicketData
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    FreeTicketData.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FreeTicketData;
})();

$root.FreeTicketItem = (function() {

    /**
     * Properties of a FreeTicketItem.
     * @exports IFreeTicketItem
     * @interface IFreeTicketItem
     * @property {number|Long|null} [Id] FreeTicketItem Id
     * @property {string|null} [Name] FreeTicketItem Name
     * @property {string|null} [Hint] FreeTicketItem Hint
     * @property {number|null} [StakeValue] FreeTicketItem StakeValue
     * @property {boolean|null} [CanBeUsedByPlayer] FreeTicketItem CanBeUsedByPlayer
     */

    /**
     * Constructs a new FreeTicketItem.
     * @exports FreeTicketItem
     * @classdesc Represents a FreeTicketItem.
     * @implements IFreeTicketItem
     * @constructor
     * @param {IFreeTicketItem=} [properties] Properties to set
     */
    function FreeTicketItem(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * FreeTicketItem Id.
     * @member {number|Long} Id
     * @memberof FreeTicketItem
     * @instance
     */
    FreeTicketItem.prototype.Id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * FreeTicketItem Name.
     * @member {string} Name
     * @memberof FreeTicketItem
     * @instance
     */
    FreeTicketItem.prototype.Name = "";

    /**
     * FreeTicketItem Hint.
     * @member {string} Hint
     * @memberof FreeTicketItem
     * @instance
     */
    FreeTicketItem.prototype.Hint = "";

    /**
     * FreeTicketItem StakeValue.
     * @member {number} StakeValue
     * @memberof FreeTicketItem
     * @instance
     */
    FreeTicketItem.prototype.StakeValue = 0;

    /**
     * FreeTicketItem CanBeUsedByPlayer.
     * @member {boolean} CanBeUsedByPlayer
     * @memberof FreeTicketItem
     * @instance
     */
    FreeTicketItem.prototype.CanBeUsedByPlayer = false;

    /**
     * Creates a new FreeTicketItem instance using the specified properties.
     * @function create
     * @memberof FreeTicketItem
     * @static
     * @param {IFreeTicketItem=} [properties] Properties to set
     * @returns {FreeTicketItem} FreeTicketItem instance
     */
    FreeTicketItem.create = function create(properties) {
        return new FreeTicketItem(properties);
    };

    /**
     * Encodes the specified FreeTicketItem message. Does not implicitly {@link FreeTicketItem.verify|verify} messages.
     * @function encode
     * @memberof FreeTicketItem
     * @static
     * @param {IFreeTicketItem} message FreeTicketItem message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FreeTicketItem.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Id != null && message.hasOwnProperty("Id"))
            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.Id);
        if (message.Name != null && message.hasOwnProperty("Name"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.Name);
        if (message.Hint != null && message.hasOwnProperty("Hint"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.Hint);
        if (message.StakeValue != null && message.hasOwnProperty("StakeValue"))
            writer.uint32(/* id 4, wireType 1 =*/33).double(message.StakeValue);
        if (message.CanBeUsedByPlayer != null && message.hasOwnProperty("CanBeUsedByPlayer"))
            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.CanBeUsedByPlayer);
        return writer;
    };

    /**
     * Encodes the specified FreeTicketItem message, length delimited. Does not implicitly {@link FreeTicketItem.verify|verify} messages.
     * @function encodeDelimited
     * @memberof FreeTicketItem
     * @static
     * @param {IFreeTicketItem} message FreeTicketItem message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FreeTicketItem.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a FreeTicketItem message from the specified reader or buffer.
     * @function decode
     * @memberof FreeTicketItem
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {FreeTicketItem} FreeTicketItem
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FreeTicketItem.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FreeTicketItem();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Id = reader.int64();
                break;
            case 2:
                message.Name = reader.string();
                break;
            case 3:
                message.Hint = reader.string();
                break;
            case 4:
                message.StakeValue = reader.double();
                break;
            case 5:
                message.CanBeUsedByPlayer = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a FreeTicketItem message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof FreeTicketItem
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {FreeTicketItem} FreeTicketItem
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FreeTicketItem.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a FreeTicketItem message.
     * @function verify
     * @memberof FreeTicketItem
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    FreeTicketItem.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Id != null && message.hasOwnProperty("Id"))
            if (!$util.isInteger(message.Id) && !(message.Id && $util.isInteger(message.Id.low) && $util.isInteger(message.Id.high)))
                return "Id: integer|Long expected";
        if (message.Name != null && message.hasOwnProperty("Name"))
            if (!$util.isString(message.Name))
                return "Name: string expected";
        if (message.Hint != null && message.hasOwnProperty("Hint"))
            if (!$util.isString(message.Hint))
                return "Hint: string expected";
        if (message.StakeValue != null && message.hasOwnProperty("StakeValue"))
            if (typeof message.StakeValue !== "number")
                return "StakeValue: number expected";
        if (message.CanBeUsedByPlayer != null && message.hasOwnProperty("CanBeUsedByPlayer"))
            if (typeof message.CanBeUsedByPlayer !== "boolean")
                return "CanBeUsedByPlayer: boolean expected";
        return null;
    };

    /**
     * Creates a FreeTicketItem message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof FreeTicketItem
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {FreeTicketItem} FreeTicketItem
     */
    FreeTicketItem.fromObject = function fromObject(object) {
        if (object instanceof $root.FreeTicketItem)
            return object;
        var message = new $root.FreeTicketItem();
        if (object.Id != null)
            if ($util.Long)
                (message.Id = $util.Long.fromValue(object.Id)).unsigned = false;
            else if (typeof object.Id === "string")
                message.Id = parseInt(object.Id, 10);
            else if (typeof object.Id === "number")
                message.Id = object.Id;
            else if (typeof object.Id === "object")
                message.Id = new $util.LongBits(object.Id.low >>> 0, object.Id.high >>> 0).toNumber();
        if (object.Name != null)
            message.Name = String(object.Name);
        if (object.Hint != null)
            message.Hint = String(object.Hint);
        if (object.StakeValue != null)
            message.StakeValue = Number(object.StakeValue);
        if (object.CanBeUsedByPlayer != null)
            message.CanBeUsedByPlayer = Boolean(object.CanBeUsedByPlayer);
        return message;
    };

    /**
     * Creates a plain object from a FreeTicketItem message. Also converts values to other types if specified.
     * @function toObject
     * @memberof FreeTicketItem
     * @static
     * @param {FreeTicketItem} message FreeTicketItem
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    FreeTicketItem.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.Id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.Id = options.longs === String ? "0" : 0;
            object.Name = "";
            object.Hint = "";
            object.StakeValue = 0;
            object.CanBeUsedByPlayer = false;
        }
        if (message.Id != null && message.hasOwnProperty("Id"))
            if (typeof message.Id === "number")
                object.Id = options.longs === String ? String(message.Id) : message.Id;
            else
                object.Id = options.longs === String ? $util.Long.prototype.toString.call(message.Id) : options.longs === Number ? new $util.LongBits(message.Id.low >>> 0, message.Id.high >>> 0).toNumber() : message.Id;
        if (message.Name != null && message.hasOwnProperty("Name"))
            object.Name = message.Name;
        if (message.Hint != null && message.hasOwnProperty("Hint"))
            object.Hint = message.Hint;
        if (message.StakeValue != null && message.hasOwnProperty("StakeValue"))
            object.StakeValue = options.json && !isFinite(message.StakeValue) ? String(message.StakeValue) : message.StakeValue;
        if (message.CanBeUsedByPlayer != null && message.hasOwnProperty("CanBeUsedByPlayer"))
            object.CanBeUsedByPlayer = message.CanBeUsedByPlayer;
        return object;
    };

    /**
     * Converts this FreeTicketItem to JSON.
     * @function toJSON
     * @memberof FreeTicketItem
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    FreeTicketItem.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FreeTicketItem;
})();

$root.TicketResponse = (function() {

    /**
     * Properties of a TicketResponse.
     * @exports ITicketResponse
     * @interface ITicketResponse
     * @property {ITicketResponseBase|null} [Base] TicketResponse Base
     * @property {Array.<ITicketSelectionResponse>|null} [Selections] TicketResponse Selections
     * @property {Array.<IAccountType>|null} [AvailableAccountTypes] TicketResponse AvailableAccountTypes
     * @property {Array.<IAMLOption>|null} [AMLOptions] TicketResponse AMLOptions
     */

    /**
     * Constructs a new TicketResponse.
     * @exports TicketResponse
     * @classdesc Represents a TicketResponse.
     * @implements ITicketResponse
     * @constructor
     * @param {ITicketResponse=} [properties] Properties to set
     */
    function TicketResponse(properties) {
        this.Selections = [];
        this.AvailableAccountTypes = [];
        this.AMLOptions = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * TicketResponse Base.
     * @member {ITicketResponseBase|null|undefined} Base
     * @memberof TicketResponse
     * @instance
     */
    TicketResponse.prototype.Base = null;

    /**
     * TicketResponse Selections.
     * @member {Array.<ITicketSelectionResponse>} Selections
     * @memberof TicketResponse
     * @instance
     */
    TicketResponse.prototype.Selections = $util.emptyArray;

    /**
     * TicketResponse AvailableAccountTypes.
     * @member {Array.<IAccountType>} AvailableAccountTypes
     * @memberof TicketResponse
     * @instance
     */
    TicketResponse.prototype.AvailableAccountTypes = $util.emptyArray;

    /**
     * TicketResponse AMLOptions.
     * @member {Array.<IAMLOption>} AMLOptions
     * @memberof TicketResponse
     * @instance
     */
    TicketResponse.prototype.AMLOptions = $util.emptyArray;

    /**
     * Creates a new TicketResponse instance using the specified properties.
     * @function create
     * @memberof TicketResponse
     * @static
     * @param {ITicketResponse=} [properties] Properties to set
     * @returns {TicketResponse} TicketResponse instance
     */
    TicketResponse.create = function create(properties) {
        return new TicketResponse(properties);
    };

    /**
     * Encodes the specified TicketResponse message. Does not implicitly {@link TicketResponse.verify|verify} messages.
     * @function encode
     * @memberof TicketResponse
     * @static
     * @param {ITicketResponse} message TicketResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TicketResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Base != null && message.hasOwnProperty("Base"))
            $root.TicketResponseBase.encode(message.Base, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.Selections != null && message.Selections.length)
            for (var i = 0; i < message.Selections.length; ++i)
                $root.TicketSelectionResponse.encode(message.Selections[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.AvailableAccountTypes != null && message.AvailableAccountTypes.length)
            for (var i = 0; i < message.AvailableAccountTypes.length; ++i)
                $root.AccountType.encode(message.AvailableAccountTypes[i], writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        if (message.AMLOptions != null && message.AMLOptions.length)
            for (var i = 0; i < message.AMLOptions.length; ++i)
                $root.AMLOption.encode(message.AMLOptions[i], writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified TicketResponse message, length delimited. Does not implicitly {@link TicketResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof TicketResponse
     * @static
     * @param {ITicketResponse} message TicketResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TicketResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TicketResponse message from the specified reader or buffer.
     * @function decode
     * @memberof TicketResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TicketResponse} TicketResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TicketResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TicketResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Base = $root.TicketResponseBase.decode(reader, reader.uint32());
                break;
            case 2:
                if (!(message.Selections && message.Selections.length))
                    message.Selections = [];
                message.Selections.push($root.TicketSelectionResponse.decode(reader, reader.uint32()));
                break;
            case 3:
                if (!(message.AvailableAccountTypes && message.AvailableAccountTypes.length))
                    message.AvailableAccountTypes = [];
                message.AvailableAccountTypes.push($root.AccountType.decode(reader, reader.uint32()));
                break;
            case 4:
                if (!(message.AMLOptions && message.AMLOptions.length))
                    message.AMLOptions = [];
                message.AMLOptions.push($root.AMLOption.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a TicketResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof TicketResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {TicketResponse} TicketResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TicketResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TicketResponse message.
     * @function verify
     * @memberof TicketResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TicketResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Base != null && message.hasOwnProperty("Base")) {
            var error = $root.TicketResponseBase.verify(message.Base);
            if (error)
                return "Base." + error;
        }
        if (message.Selections != null && message.hasOwnProperty("Selections")) {
            if (!Array.isArray(message.Selections))
                return "Selections: array expected";
            for (var i = 0; i < message.Selections.length; ++i) {
                var error = $root.TicketSelectionResponse.verify(message.Selections[i]);
                if (error)
                    return "Selections." + error;
            }
        }
        if (message.AvailableAccountTypes != null && message.hasOwnProperty("AvailableAccountTypes")) {
            if (!Array.isArray(message.AvailableAccountTypes))
                return "AvailableAccountTypes: array expected";
            for (var i = 0; i < message.AvailableAccountTypes.length; ++i) {
                var error = $root.AccountType.verify(message.AvailableAccountTypes[i]);
                if (error)
                    return "AvailableAccountTypes." + error;
            }
        }
        if (message.AMLOptions != null && message.hasOwnProperty("AMLOptions")) {
            if (!Array.isArray(message.AMLOptions))
                return "AMLOptions: array expected";
            for (var i = 0; i < message.AMLOptions.length; ++i) {
                var error = $root.AMLOption.verify(message.AMLOptions[i]);
                if (error)
                    return "AMLOptions." + error;
            }
        }
        return null;
    };

    /**
     * Creates a TicketResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TicketResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TicketResponse} TicketResponse
     */
    TicketResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.TicketResponse)
            return object;
        var message = new $root.TicketResponse();
        if (object.Base != null) {
            if (typeof object.Base !== "object")
                throw TypeError(".TicketResponse.Base: object expected");
            message.Base = $root.TicketResponseBase.fromObject(object.Base);
        }
        if (object.Selections) {
            if (!Array.isArray(object.Selections))
                throw TypeError(".TicketResponse.Selections: array expected");
            message.Selections = [];
            for (var i = 0; i < object.Selections.length; ++i) {
                if (typeof object.Selections[i] !== "object")
                    throw TypeError(".TicketResponse.Selections: object expected");
                message.Selections[i] = $root.TicketSelectionResponse.fromObject(object.Selections[i]);
            }
        }
        if (object.AvailableAccountTypes) {
            if (!Array.isArray(object.AvailableAccountTypes))
                throw TypeError(".TicketResponse.AvailableAccountTypes: array expected");
            message.AvailableAccountTypes = [];
            for (var i = 0; i < object.AvailableAccountTypes.length; ++i) {
                if (typeof object.AvailableAccountTypes[i] !== "object")
                    throw TypeError(".TicketResponse.AvailableAccountTypes: object expected");
                message.AvailableAccountTypes[i] = $root.AccountType.fromObject(object.AvailableAccountTypes[i]);
            }
        }
        if (object.AMLOptions) {
            if (!Array.isArray(object.AMLOptions))
                throw TypeError(".TicketResponse.AMLOptions: array expected");
            message.AMLOptions = [];
            for (var i = 0; i < object.AMLOptions.length; ++i) {
                if (typeof object.AMLOptions[i] !== "object")
                    throw TypeError(".TicketResponse.AMLOptions: object expected");
                message.AMLOptions[i] = $root.AMLOption.fromObject(object.AMLOptions[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a TicketResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TicketResponse
     * @static
     * @param {TicketResponse} message TicketResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TicketResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.Selections = [];
            object.AvailableAccountTypes = [];
            object.AMLOptions = [];
        }
        if (options.defaults)
            object.Base = null;
        if (message.Base != null && message.hasOwnProperty("Base"))
            object.Base = $root.TicketResponseBase.toObject(message.Base, options);
        if (message.Selections && message.Selections.length) {
            object.Selections = [];
            for (var j = 0; j < message.Selections.length; ++j)
                object.Selections[j] = $root.TicketSelectionResponse.toObject(message.Selections[j], options);
        }
        if (message.AvailableAccountTypes && message.AvailableAccountTypes.length) {
            object.AvailableAccountTypes = [];
            for (var j = 0; j < message.AvailableAccountTypes.length; ++j)
                object.AvailableAccountTypes[j] = $root.AccountType.toObject(message.AvailableAccountTypes[j], options);
        }
        if (message.AMLOptions && message.AMLOptions.length) {
            object.AMLOptions = [];
            for (var j = 0; j < message.AMLOptions.length; ++j)
                object.AMLOptions[j] = $root.AMLOption.toObject(message.AMLOptions[j], options);
        }
        return object;
    };

    /**
     * Converts this TicketResponse to JSON.
     * @function toJSON
     * @memberof TicketResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TicketResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TicketResponse;
})();

$root.TicketDetailResponse = (function() {

    /**
     * Properties of a TicketDetailResponse.
     * @exports ITicketDetailResponse
     * @interface ITicketDetailResponse
     * @property {ITicketResponseBase|null} [Base] TicketDetailResponse Base
     * @property {string|null} [SecureId] TicketDetailResponse SecureId
     * @property {OfferType|null} [OfferType] TicketDetailResponse OfferType
     * @property {number|null} [PrizeEvalValue] TicketDetailResponse PrizeEvalValue
     * @property {number|null} [ToPay] TicketDetailResponse ToPay
     * @property {ITimestamp|null} [PlacementDate] TicketDetailResponse PlacementDate
     * @property {Array.<ITicketSelectionDetailResponse>|null} [Selections] TicketDetailResponse Selections
     * @property {EvalState|null} [EvalState] TicketDetailResponse EvalState
     * @property {TicketState|null} [State] TicketDetailResponse State
     * @property {number|null} [EvalRate] TicketDetailResponse EvalRate
     * @property {number|null} [CashOut] TicketDetailResponse CashOut
     * @property {string|null} [AccountType] TicketDetailResponse AccountType
     * @property {INullableInt32|null} [CustomerId] TicketDetailResponse CustomerId
     * @property {string|null} [PublicUrl] TicketDetailResponse PublicUrl
     * @property {string|null} [AccountTypeName] TicketDetailResponse AccountTypeName
     * @property {string|null} [MessageForCustomer] TicketDetailResponse MessageForCustomer
     * @property {string|null} [CustomerNickName] TicketDetailResponse CustomerNickName
     * @property {ITimestamp|null} [PrizePaidDate] TicketDetailResponse PrizePaidDate
     * @property {ITimestamp|null} [CustomerStornoTicketLimit] TicketDetailResponse CustomerStornoTicketLimit
     */

    /**
     * Constructs a new TicketDetailResponse.
     * @exports TicketDetailResponse
     * @classdesc Represents a TicketDetailResponse.
     * @implements ITicketDetailResponse
     * @constructor
     * @param {ITicketDetailResponse=} [properties] Properties to set
     */
    function TicketDetailResponse(properties) {
        this.Selections = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * TicketDetailResponse Base.
     * @member {ITicketResponseBase|null|undefined} Base
     * @memberof TicketDetailResponse
     * @instance
     */
    TicketDetailResponse.prototype.Base = null;

    /**
     * TicketDetailResponse SecureId.
     * @member {string} SecureId
     * @memberof TicketDetailResponse
     * @instance
     */
    TicketDetailResponse.prototype.SecureId = "";

    /**
     * TicketDetailResponse OfferType.
     * @member {OfferType} OfferType
     * @memberof TicketDetailResponse
     * @instance
     */
    TicketDetailResponse.prototype.OfferType = 0;

    /**
     * TicketDetailResponse PrizeEvalValue.
     * @member {number} PrizeEvalValue
     * @memberof TicketDetailResponse
     * @instance
     */
    TicketDetailResponse.prototype.PrizeEvalValue = 0;

    /**
     * TicketDetailResponse ToPay.
     * @member {number} ToPay
     * @memberof TicketDetailResponse
     * @instance
     */
    TicketDetailResponse.prototype.ToPay = 0;

    /**
     * TicketDetailResponse PlacementDate.
     * @member {ITimestamp|null|undefined} PlacementDate
     * @memberof TicketDetailResponse
     * @instance
     */
    TicketDetailResponse.prototype.PlacementDate = null;

    /**
     * TicketDetailResponse Selections.
     * @member {Array.<ITicketSelectionDetailResponse>} Selections
     * @memberof TicketDetailResponse
     * @instance
     */
    TicketDetailResponse.prototype.Selections = $util.emptyArray;

    /**
     * TicketDetailResponse EvalState.
     * @member {EvalState} EvalState
     * @memberof TicketDetailResponse
     * @instance
     */
    TicketDetailResponse.prototype.EvalState = 0;

    /**
     * TicketDetailResponse State.
     * @member {TicketState} State
     * @memberof TicketDetailResponse
     * @instance
     */
    TicketDetailResponse.prototype.State = 0;

    /**
     * TicketDetailResponse EvalRate.
     * @member {number} EvalRate
     * @memberof TicketDetailResponse
     * @instance
     */
    TicketDetailResponse.prototype.EvalRate = 0;

    /**
     * TicketDetailResponse CashOut.
     * @member {number} CashOut
     * @memberof TicketDetailResponse
     * @instance
     */
    TicketDetailResponse.prototype.CashOut = 0;

    /**
     * TicketDetailResponse AccountType.
     * @member {string} AccountType
     * @memberof TicketDetailResponse
     * @instance
     */
    TicketDetailResponse.prototype.AccountType = "";

    /**
     * TicketDetailResponse CustomerId.
     * @member {INullableInt32|null|undefined} CustomerId
     * @memberof TicketDetailResponse
     * @instance
     */
    TicketDetailResponse.prototype.CustomerId = null;

    /**
     * TicketDetailResponse PublicUrl.
     * @member {string} PublicUrl
     * @memberof TicketDetailResponse
     * @instance
     */
    TicketDetailResponse.prototype.PublicUrl = "";

    /**
     * TicketDetailResponse AccountTypeName.
     * @member {string} AccountTypeName
     * @memberof TicketDetailResponse
     * @instance
     */
    TicketDetailResponse.prototype.AccountTypeName = "";

    /**
     * TicketDetailResponse MessageForCustomer.
     * @member {string} MessageForCustomer
     * @memberof TicketDetailResponse
     * @instance
     */
    TicketDetailResponse.prototype.MessageForCustomer = "";

    /**
     * TicketDetailResponse CustomerNickName.
     * @member {string} CustomerNickName
     * @memberof TicketDetailResponse
     * @instance
     */
    TicketDetailResponse.prototype.CustomerNickName = "";

    /**
     * TicketDetailResponse PrizePaidDate.
     * @member {ITimestamp|null|undefined} PrizePaidDate
     * @memberof TicketDetailResponse
     * @instance
     */
    TicketDetailResponse.prototype.PrizePaidDate = null;

    /**
     * TicketDetailResponse CustomerStornoTicketLimit.
     * @member {ITimestamp|null|undefined} CustomerStornoTicketLimit
     * @memberof TicketDetailResponse
     * @instance
     */
    TicketDetailResponse.prototype.CustomerStornoTicketLimit = null;

    /**
     * Creates a new TicketDetailResponse instance using the specified properties.
     * @function create
     * @memberof TicketDetailResponse
     * @static
     * @param {ITicketDetailResponse=} [properties] Properties to set
     * @returns {TicketDetailResponse} TicketDetailResponse instance
     */
    TicketDetailResponse.create = function create(properties) {
        return new TicketDetailResponse(properties);
    };

    /**
     * Encodes the specified TicketDetailResponse message. Does not implicitly {@link TicketDetailResponse.verify|verify} messages.
     * @function encode
     * @memberof TicketDetailResponse
     * @static
     * @param {ITicketDetailResponse} message TicketDetailResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TicketDetailResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Base != null && message.hasOwnProperty("Base"))
            $root.TicketResponseBase.encode(message.Base, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.SecureId != null && message.hasOwnProperty("SecureId"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.SecureId);
        if (message.OfferType != null && message.hasOwnProperty("OfferType"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.OfferType);
        if (message.PrizeEvalValue != null && message.hasOwnProperty("PrizeEvalValue"))
            writer.uint32(/* id 4, wireType 1 =*/33).double(message.PrizeEvalValue);
        if (message.ToPay != null && message.hasOwnProperty("ToPay"))
            writer.uint32(/* id 5, wireType 1 =*/41).double(message.ToPay);
        if (message.PlacementDate != null && message.hasOwnProperty("PlacementDate"))
            $root.Timestamp.encode(message.PlacementDate, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
        if (message.Selections != null && message.Selections.length)
            for (var i = 0; i < message.Selections.length; ++i)
                $root.TicketSelectionDetailResponse.encode(message.Selections[i], writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
        if (message.EvalState != null && message.hasOwnProperty("EvalState"))
            writer.uint32(/* id 8, wireType 0 =*/64).int32(message.EvalState);
        if (message.State != null && message.hasOwnProperty("State"))
            writer.uint32(/* id 9, wireType 0 =*/72).int32(message.State);
        if (message.EvalRate != null && message.hasOwnProperty("EvalRate"))
            writer.uint32(/* id 10, wireType 1 =*/81).double(message.EvalRate);
        if (message.CashOut != null && message.hasOwnProperty("CashOut"))
            writer.uint32(/* id 11, wireType 1 =*/89).double(message.CashOut);
        if (message.AccountType != null && message.hasOwnProperty("AccountType"))
            writer.uint32(/* id 14, wireType 2 =*/114).string(message.AccountType);
        if (message.CustomerId != null && message.hasOwnProperty("CustomerId"))
            $root.NullableInt32.encode(message.CustomerId, writer.uint32(/* id 15, wireType 2 =*/122).fork()).ldelim();
        if (message.PublicUrl != null && message.hasOwnProperty("PublicUrl"))
            writer.uint32(/* id 16, wireType 2 =*/130).string(message.PublicUrl);
        if (message.AccountTypeName != null && message.hasOwnProperty("AccountTypeName"))
            writer.uint32(/* id 17, wireType 2 =*/138).string(message.AccountTypeName);
        if (message.MessageForCustomer != null && message.hasOwnProperty("MessageForCustomer"))
            writer.uint32(/* id 18, wireType 2 =*/146).string(message.MessageForCustomer);
        if (message.CustomerNickName != null && message.hasOwnProperty("CustomerNickName"))
            writer.uint32(/* id 19, wireType 2 =*/154).string(message.CustomerNickName);
        if (message.PrizePaidDate != null && message.hasOwnProperty("PrizePaidDate"))
            $root.Timestamp.encode(message.PrizePaidDate, writer.uint32(/* id 20, wireType 2 =*/162).fork()).ldelim();
        if (message.CustomerStornoTicketLimit != null && message.hasOwnProperty("CustomerStornoTicketLimit"))
            $root.Timestamp.encode(message.CustomerStornoTicketLimit, writer.uint32(/* id 21, wireType 2 =*/170).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified TicketDetailResponse message, length delimited. Does not implicitly {@link TicketDetailResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof TicketDetailResponse
     * @static
     * @param {ITicketDetailResponse} message TicketDetailResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TicketDetailResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TicketDetailResponse message from the specified reader or buffer.
     * @function decode
     * @memberof TicketDetailResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TicketDetailResponse} TicketDetailResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TicketDetailResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TicketDetailResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Base = $root.TicketResponseBase.decode(reader, reader.uint32());
                break;
            case 2:
                message.SecureId = reader.string();
                break;
            case 3:
                message.OfferType = reader.int32();
                break;
            case 4:
                message.PrizeEvalValue = reader.double();
                break;
            case 5:
                message.ToPay = reader.double();
                break;
            case 6:
                message.PlacementDate = $root.Timestamp.decode(reader, reader.uint32());
                break;
            case 7:
                if (!(message.Selections && message.Selections.length))
                    message.Selections = [];
                message.Selections.push($root.TicketSelectionDetailResponse.decode(reader, reader.uint32()));
                break;
            case 8:
                message.EvalState = reader.int32();
                break;
            case 9:
                message.State = reader.int32();
                break;
            case 10:
                message.EvalRate = reader.double();
                break;
            case 11:
                message.CashOut = reader.double();
                break;
            case 14:
                message.AccountType = reader.string();
                break;
            case 15:
                message.CustomerId = $root.NullableInt32.decode(reader, reader.uint32());
                break;
            case 16:
                message.PublicUrl = reader.string();
                break;
            case 17:
                message.AccountTypeName = reader.string();
                break;
            case 18:
                message.MessageForCustomer = reader.string();
                break;
            case 19:
                message.CustomerNickName = reader.string();
                break;
            case 20:
                message.PrizePaidDate = $root.Timestamp.decode(reader, reader.uint32());
                break;
            case 21:
                message.CustomerStornoTicketLimit = $root.Timestamp.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a TicketDetailResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof TicketDetailResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {TicketDetailResponse} TicketDetailResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TicketDetailResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TicketDetailResponse message.
     * @function verify
     * @memberof TicketDetailResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TicketDetailResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Base != null && message.hasOwnProperty("Base")) {
            var error = $root.TicketResponseBase.verify(message.Base);
            if (error)
                return "Base." + error;
        }
        if (message.SecureId != null && message.hasOwnProperty("SecureId"))
            if (!$util.isString(message.SecureId))
                return "SecureId: string expected";
        if (message.OfferType != null && message.hasOwnProperty("OfferType"))
            switch (message.OfferType) {
            default:
                return "OfferType: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.PrizeEvalValue != null && message.hasOwnProperty("PrizeEvalValue"))
            if (typeof message.PrizeEvalValue !== "number")
                return "PrizeEvalValue: number expected";
        if (message.ToPay != null && message.hasOwnProperty("ToPay"))
            if (typeof message.ToPay !== "number")
                return "ToPay: number expected";
        if (message.PlacementDate != null && message.hasOwnProperty("PlacementDate")) {
            var error = $root.Timestamp.verify(message.PlacementDate);
            if (error)
                return "PlacementDate." + error;
        }
        if (message.Selections != null && message.hasOwnProperty("Selections")) {
            if (!Array.isArray(message.Selections))
                return "Selections: array expected";
            for (var i = 0; i < message.Selections.length; ++i) {
                var error = $root.TicketSelectionDetailResponse.verify(message.Selections[i]);
                if (error)
                    return "Selections." + error;
            }
        }
        if (message.EvalState != null && message.hasOwnProperty("EvalState"))
            switch (message.EvalState) {
            default:
                return "EvalState: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.State != null && message.hasOwnProperty("State"))
            switch (message.State) {
            default:
                return "State: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 9:
            case 10:
                break;
            }
        if (message.EvalRate != null && message.hasOwnProperty("EvalRate"))
            if (typeof message.EvalRate !== "number")
                return "EvalRate: number expected";
        if (message.CashOut != null && message.hasOwnProperty("CashOut"))
            if (typeof message.CashOut !== "number")
                return "CashOut: number expected";
        if (message.AccountType != null && message.hasOwnProperty("AccountType"))
            if (!$util.isString(message.AccountType))
                return "AccountType: string expected";
        if (message.CustomerId != null && message.hasOwnProperty("CustomerId")) {
            var error = $root.NullableInt32.verify(message.CustomerId);
            if (error)
                return "CustomerId." + error;
        }
        if (message.PublicUrl != null && message.hasOwnProperty("PublicUrl"))
            if (!$util.isString(message.PublicUrl))
                return "PublicUrl: string expected";
        if (message.AccountTypeName != null && message.hasOwnProperty("AccountTypeName"))
            if (!$util.isString(message.AccountTypeName))
                return "AccountTypeName: string expected";
        if (message.MessageForCustomer != null && message.hasOwnProperty("MessageForCustomer"))
            if (!$util.isString(message.MessageForCustomer))
                return "MessageForCustomer: string expected";
        if (message.CustomerNickName != null && message.hasOwnProperty("CustomerNickName"))
            if (!$util.isString(message.CustomerNickName))
                return "CustomerNickName: string expected";
        if (message.PrizePaidDate != null && message.hasOwnProperty("PrizePaidDate")) {
            var error = $root.Timestamp.verify(message.PrizePaidDate);
            if (error)
                return "PrizePaidDate." + error;
        }
        if (message.CustomerStornoTicketLimit != null && message.hasOwnProperty("CustomerStornoTicketLimit")) {
            var error = $root.Timestamp.verify(message.CustomerStornoTicketLimit);
            if (error)
                return "CustomerStornoTicketLimit." + error;
        }
        return null;
    };

    /**
     * Creates a TicketDetailResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TicketDetailResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TicketDetailResponse} TicketDetailResponse
     */
    TicketDetailResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.TicketDetailResponse)
            return object;
        var message = new $root.TicketDetailResponse();
        if (object.Base != null) {
            if (typeof object.Base !== "object")
                throw TypeError(".TicketDetailResponse.Base: object expected");
            message.Base = $root.TicketResponseBase.fromObject(object.Base);
        }
        if (object.SecureId != null)
            message.SecureId = String(object.SecureId);
        switch (object.OfferType) {
        case "Prematch":
        case 0:
            message.OfferType = 0;
            break;
        case "Live":
        case 1:
            message.OfferType = 1;
            break;
        }
        if (object.PrizeEvalValue != null)
            message.PrizeEvalValue = Number(object.PrizeEvalValue);
        if (object.ToPay != null)
            message.ToPay = Number(object.ToPay);
        if (object.PlacementDate != null) {
            if (typeof object.PlacementDate !== "object")
                throw TypeError(".TicketDetailResponse.PlacementDate: object expected");
            message.PlacementDate = $root.Timestamp.fromObject(object.PlacementDate);
        }
        if (object.Selections) {
            if (!Array.isArray(object.Selections))
                throw TypeError(".TicketDetailResponse.Selections: array expected");
            message.Selections = [];
            for (var i = 0; i < object.Selections.length; ++i) {
                if (typeof object.Selections[i] !== "object")
                    throw TypeError(".TicketDetailResponse.Selections: object expected");
                message.Selections[i] = $root.TicketSelectionDetailResponse.fromObject(object.Selections[i]);
            }
        }
        switch (object.EvalState) {
        case "None":
        case 0:
            message.EvalState = 0;
            break;
        case "Win":
        case 1:
            message.EvalState = 1;
            break;
        case "Loss":
        case 2:
            message.EvalState = 2;
            break;
        case "Cancel":
        case 3:
            message.EvalState = 3;
            break;
        case "CancelWithHandlingFee":
        case 4:
            message.EvalState = 4;
            break;
        case "Cashout":
        case 5:
            message.EvalState = 5;
            break;
        }
        switch (object.State) {
        case "None":
        case 0:
            message.State = 0;
            break;
        case "Created":
        case 1:
            message.State = 1;
            break;
        case "Paid":
        case 2:
            message.State = 2;
            break;
        case "Accepted":
        case 3:
            message.State = 3;
            break;
        case "Settled":
        case 4:
            message.State = 4;
            break;
        case "Evaluated":
        case 5:
            message.State = 5;
            break;
        case "Storno":
        case 6:
            message.State = 6;
            break;
        case "StornoBySystem":
        case 7:
            message.State = 7;
            break;
        case "StornoByCustomer":
        case 9:
            message.State = 9;
            break;
        case "StornoByMts":
        case 10:
            message.State = 10;
            break;
        }
        if (object.EvalRate != null)
            message.EvalRate = Number(object.EvalRate);
        if (object.CashOut != null)
            message.CashOut = Number(object.CashOut);
        if (object.AccountType != null)
            message.AccountType = String(object.AccountType);
        if (object.CustomerId != null) {
            if (typeof object.CustomerId !== "object")
                throw TypeError(".TicketDetailResponse.CustomerId: object expected");
            message.CustomerId = $root.NullableInt32.fromObject(object.CustomerId);
        }
        if (object.PublicUrl != null)
            message.PublicUrl = String(object.PublicUrl);
        if (object.AccountTypeName != null)
            message.AccountTypeName = String(object.AccountTypeName);
        if (object.MessageForCustomer != null)
            message.MessageForCustomer = String(object.MessageForCustomer);
        if (object.CustomerNickName != null)
            message.CustomerNickName = String(object.CustomerNickName);
        if (object.PrizePaidDate != null) {
            if (typeof object.PrizePaidDate !== "object")
                throw TypeError(".TicketDetailResponse.PrizePaidDate: object expected");
            message.PrizePaidDate = $root.Timestamp.fromObject(object.PrizePaidDate);
        }
        if (object.CustomerStornoTicketLimit != null) {
            if (typeof object.CustomerStornoTicketLimit !== "object")
                throw TypeError(".TicketDetailResponse.CustomerStornoTicketLimit: object expected");
            message.CustomerStornoTicketLimit = $root.Timestamp.fromObject(object.CustomerStornoTicketLimit);
        }
        return message;
    };

    /**
     * Creates a plain object from a TicketDetailResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TicketDetailResponse
     * @static
     * @param {TicketDetailResponse} message TicketDetailResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TicketDetailResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.Selections = [];
        if (options.defaults) {
            object.Base = null;
            object.SecureId = "";
            object.OfferType = options.enums === String ? "Prematch" : 0;
            object.PrizeEvalValue = 0;
            object.ToPay = 0;
            object.PlacementDate = null;
            object.EvalState = options.enums === String ? "None" : 0;
            object.State = options.enums === String ? "None" : 0;
            object.EvalRate = 0;
            object.CashOut = 0;
            object.AccountType = "";
            object.CustomerId = null;
            object.PublicUrl = "";
            object.AccountTypeName = "";
            object.MessageForCustomer = "";
            object.CustomerNickName = "";
            object.PrizePaidDate = null;
            object.CustomerStornoTicketLimit = null;
        }
        if (message.Base != null && message.hasOwnProperty("Base"))
            object.Base = $root.TicketResponseBase.toObject(message.Base, options);
        if (message.SecureId != null && message.hasOwnProperty("SecureId"))
            object.SecureId = message.SecureId;
        if (message.OfferType != null && message.hasOwnProperty("OfferType"))
            object.OfferType = options.enums === String ? $root.OfferType[message.OfferType] : message.OfferType;
        if (message.PrizeEvalValue != null && message.hasOwnProperty("PrizeEvalValue"))
            object.PrizeEvalValue = options.json && !isFinite(message.PrizeEvalValue) ? String(message.PrizeEvalValue) : message.PrizeEvalValue;
        if (message.ToPay != null && message.hasOwnProperty("ToPay"))
            object.ToPay = options.json && !isFinite(message.ToPay) ? String(message.ToPay) : message.ToPay;
        if (message.PlacementDate != null && message.hasOwnProperty("PlacementDate"))
            object.PlacementDate = $root.Timestamp.toObject(message.PlacementDate, options);
        if (message.Selections && message.Selections.length) {
            object.Selections = [];
            for (var j = 0; j < message.Selections.length; ++j)
                object.Selections[j] = $root.TicketSelectionDetailResponse.toObject(message.Selections[j], options);
        }
        if (message.EvalState != null && message.hasOwnProperty("EvalState"))
            object.EvalState = options.enums === String ? $root.EvalState[message.EvalState] : message.EvalState;
        if (message.State != null && message.hasOwnProperty("State"))
            object.State = options.enums === String ? $root.TicketState[message.State] : message.State;
        if (message.EvalRate != null && message.hasOwnProperty("EvalRate"))
            object.EvalRate = options.json && !isFinite(message.EvalRate) ? String(message.EvalRate) : message.EvalRate;
        if (message.CashOut != null && message.hasOwnProperty("CashOut"))
            object.CashOut = options.json && !isFinite(message.CashOut) ? String(message.CashOut) : message.CashOut;
        if (message.AccountType != null && message.hasOwnProperty("AccountType"))
            object.AccountType = message.AccountType;
        if (message.CustomerId != null && message.hasOwnProperty("CustomerId"))
            object.CustomerId = $root.NullableInt32.toObject(message.CustomerId, options);
        if (message.PublicUrl != null && message.hasOwnProperty("PublicUrl"))
            object.PublicUrl = message.PublicUrl;
        if (message.AccountTypeName != null && message.hasOwnProperty("AccountTypeName"))
            object.AccountTypeName = message.AccountTypeName;
        if (message.MessageForCustomer != null && message.hasOwnProperty("MessageForCustomer"))
            object.MessageForCustomer = message.MessageForCustomer;
        if (message.CustomerNickName != null && message.hasOwnProperty("CustomerNickName"))
            object.CustomerNickName = message.CustomerNickName;
        if (message.PrizePaidDate != null && message.hasOwnProperty("PrizePaidDate"))
            object.PrizePaidDate = $root.Timestamp.toObject(message.PrizePaidDate, options);
        if (message.CustomerStornoTicketLimit != null && message.hasOwnProperty("CustomerStornoTicketLimit"))
            object.CustomerStornoTicketLimit = $root.Timestamp.toObject(message.CustomerStornoTicketLimit, options);
        return object;
    };

    /**
     * Converts this TicketDetailResponse to JSON.
     * @function toJSON
     * @memberof TicketDetailResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TicketDetailResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TicketDetailResponse;
})();

$root.TicketBetResponse = (function() {

    /**
     * Properties of a TicketBetResponse.
     * @exports ITicketBetResponse
     * @interface ITicketBetResponse
     * @property {number|null} [CombinationCount] TicketBetResponse CombinationCount
     * @property {number|null} [SelectedSystem] TicketBetResponse SelectedSystem
     * @property {number|null} [SystemStake] TicketBetResponse SystemStake
     * @property {number|null} [UnitStake] TicketBetResponse UnitStake
     */

    /**
     * Constructs a new TicketBetResponse.
     * @exports TicketBetResponse
     * @classdesc Represents a TicketBetResponse.
     * @implements ITicketBetResponse
     * @constructor
     * @param {ITicketBetResponse=} [properties] Properties to set
     */
    function TicketBetResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * TicketBetResponse CombinationCount.
     * @member {number} CombinationCount
     * @memberof TicketBetResponse
     * @instance
     */
    TicketBetResponse.prototype.CombinationCount = 0;

    /**
     * TicketBetResponse SelectedSystem.
     * @member {number} SelectedSystem
     * @memberof TicketBetResponse
     * @instance
     */
    TicketBetResponse.prototype.SelectedSystem = 0;

    /**
     * TicketBetResponse SystemStake.
     * @member {number} SystemStake
     * @memberof TicketBetResponse
     * @instance
     */
    TicketBetResponse.prototype.SystemStake = 0;

    /**
     * TicketBetResponse UnitStake.
     * @member {number} UnitStake
     * @memberof TicketBetResponse
     * @instance
     */
    TicketBetResponse.prototype.UnitStake = 0;

    /**
     * Creates a new TicketBetResponse instance using the specified properties.
     * @function create
     * @memberof TicketBetResponse
     * @static
     * @param {ITicketBetResponse=} [properties] Properties to set
     * @returns {TicketBetResponse} TicketBetResponse instance
     */
    TicketBetResponse.create = function create(properties) {
        return new TicketBetResponse(properties);
    };

    /**
     * Encodes the specified TicketBetResponse message. Does not implicitly {@link TicketBetResponse.verify|verify} messages.
     * @function encode
     * @memberof TicketBetResponse
     * @static
     * @param {ITicketBetResponse} message TicketBetResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TicketBetResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.CombinationCount != null && message.hasOwnProperty("CombinationCount"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.CombinationCount);
        if (message.SelectedSystem != null && message.hasOwnProperty("SelectedSystem"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.SelectedSystem);
        if (message.SystemStake != null && message.hasOwnProperty("SystemStake"))
            writer.uint32(/* id 5, wireType 1 =*/41).double(message.SystemStake);
        if (message.UnitStake != null && message.hasOwnProperty("UnitStake"))
            writer.uint32(/* id 6, wireType 1 =*/49).double(message.UnitStake);
        return writer;
    };

    /**
     * Encodes the specified TicketBetResponse message, length delimited. Does not implicitly {@link TicketBetResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof TicketBetResponse
     * @static
     * @param {ITicketBetResponse} message TicketBetResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TicketBetResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TicketBetResponse message from the specified reader or buffer.
     * @function decode
     * @memberof TicketBetResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TicketBetResponse} TicketBetResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TicketBetResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TicketBetResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.CombinationCount = reader.int32();
                break;
            case 4:
                message.SelectedSystem = reader.int32();
                break;
            case 5:
                message.SystemStake = reader.double();
                break;
            case 6:
                message.UnitStake = reader.double();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a TicketBetResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof TicketBetResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {TicketBetResponse} TicketBetResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TicketBetResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TicketBetResponse message.
     * @function verify
     * @memberof TicketBetResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TicketBetResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.CombinationCount != null && message.hasOwnProperty("CombinationCount"))
            if (!$util.isInteger(message.CombinationCount))
                return "CombinationCount: integer expected";
        if (message.SelectedSystem != null && message.hasOwnProperty("SelectedSystem"))
            if (!$util.isInteger(message.SelectedSystem))
                return "SelectedSystem: integer expected";
        if (message.SystemStake != null && message.hasOwnProperty("SystemStake"))
            if (typeof message.SystemStake !== "number")
                return "SystemStake: number expected";
        if (message.UnitStake != null && message.hasOwnProperty("UnitStake"))
            if (typeof message.UnitStake !== "number")
                return "UnitStake: number expected";
        return null;
    };

    /**
     * Creates a TicketBetResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TicketBetResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TicketBetResponse} TicketBetResponse
     */
    TicketBetResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.TicketBetResponse)
            return object;
        var message = new $root.TicketBetResponse();
        if (object.CombinationCount != null)
            message.CombinationCount = object.CombinationCount | 0;
        if (object.SelectedSystem != null)
            message.SelectedSystem = object.SelectedSystem | 0;
        if (object.SystemStake != null)
            message.SystemStake = Number(object.SystemStake);
        if (object.UnitStake != null)
            message.UnitStake = Number(object.UnitStake);
        return message;
    };

    /**
     * Creates a plain object from a TicketBetResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TicketBetResponse
     * @static
     * @param {TicketBetResponse} message TicketBetResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TicketBetResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.CombinationCount = 0;
            object.SelectedSystem = 0;
            object.SystemStake = 0;
            object.UnitStake = 0;
        }
        if (message.CombinationCount != null && message.hasOwnProperty("CombinationCount"))
            object.CombinationCount = message.CombinationCount;
        if (message.SelectedSystem != null && message.hasOwnProperty("SelectedSystem"))
            object.SelectedSystem = message.SelectedSystem;
        if (message.SystemStake != null && message.hasOwnProperty("SystemStake"))
            object.SystemStake = options.json && !isFinite(message.SystemStake) ? String(message.SystemStake) : message.SystemStake;
        if (message.UnitStake != null && message.hasOwnProperty("UnitStake"))
            object.UnitStake = options.json && !isFinite(message.UnitStake) ? String(message.UnitStake) : message.UnitStake;
        return object;
    };

    /**
     * Converts this TicketBetResponse to JSON.
     * @function toJSON
     * @memberof TicketBetResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TicketBetResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TicketBetResponse;
})();

$root.TicketBetDetailResponse = (function() {

    /**
     * Properties of a TicketBetDetailResponse.
     * @exports ITicketBetDetailResponse
     * @interface ITicketBetDetailResponse
     * @property {number|null} [CombinationCount] TicketBetDetailResponse CombinationCount
     * @property {number|null} [PrizeEvalPotentionalValueMin] TicketBetDetailResponse PrizeEvalPotentionalValueMin
     * @property {number|null} [PrizeEvalPotentionalValueMax] TicketBetDetailResponse PrizeEvalPotentionalValueMax
     * @property {number|null} [SelectedSystem] TicketBetDetailResponse SelectedSystem
     * @property {number|null} [SystemStake] TicketBetDetailResponse SystemStake
     * @property {number|null} [UnitStake] TicketBetDetailResponse UnitStake
     * @property {Array.<ITicketCombination>|null} [Combinations] TicketBetDetailResponse Combinations
     * @property {number|null} [SystemOutOf] TicketBetDetailResponse SystemOutOf
     */

    /**
     * Constructs a new TicketBetDetailResponse.
     * @exports TicketBetDetailResponse
     * @classdesc Represents a TicketBetDetailResponse.
     * @implements ITicketBetDetailResponse
     * @constructor
     * @param {ITicketBetDetailResponse=} [properties] Properties to set
     */
    function TicketBetDetailResponse(properties) {
        this.Combinations = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * TicketBetDetailResponse CombinationCount.
     * @member {number} CombinationCount
     * @memberof TicketBetDetailResponse
     * @instance
     */
    TicketBetDetailResponse.prototype.CombinationCount = 0;

    /**
     * TicketBetDetailResponse PrizeEvalPotentionalValueMin.
     * @member {number} PrizeEvalPotentionalValueMin
     * @memberof TicketBetDetailResponse
     * @instance
     */
    TicketBetDetailResponse.prototype.PrizeEvalPotentionalValueMin = 0;

    /**
     * TicketBetDetailResponse PrizeEvalPotentionalValueMax.
     * @member {number} PrizeEvalPotentionalValueMax
     * @memberof TicketBetDetailResponse
     * @instance
     */
    TicketBetDetailResponse.prototype.PrizeEvalPotentionalValueMax = 0;

    /**
     * TicketBetDetailResponse SelectedSystem.
     * @member {number} SelectedSystem
     * @memberof TicketBetDetailResponse
     * @instance
     */
    TicketBetDetailResponse.prototype.SelectedSystem = 0;

    /**
     * TicketBetDetailResponse SystemStake.
     * @member {number} SystemStake
     * @memberof TicketBetDetailResponse
     * @instance
     */
    TicketBetDetailResponse.prototype.SystemStake = 0;

    /**
     * TicketBetDetailResponse UnitStake.
     * @member {number} UnitStake
     * @memberof TicketBetDetailResponse
     * @instance
     */
    TicketBetDetailResponse.prototype.UnitStake = 0;

    /**
     * TicketBetDetailResponse Combinations.
     * @member {Array.<ITicketCombination>} Combinations
     * @memberof TicketBetDetailResponse
     * @instance
     */
    TicketBetDetailResponse.prototype.Combinations = $util.emptyArray;

    /**
     * TicketBetDetailResponse SystemOutOf.
     * @member {number} SystemOutOf
     * @memberof TicketBetDetailResponse
     * @instance
     */
    TicketBetDetailResponse.prototype.SystemOutOf = 0;

    /**
     * Creates a new TicketBetDetailResponse instance using the specified properties.
     * @function create
     * @memberof TicketBetDetailResponse
     * @static
     * @param {ITicketBetDetailResponse=} [properties] Properties to set
     * @returns {TicketBetDetailResponse} TicketBetDetailResponse instance
     */
    TicketBetDetailResponse.create = function create(properties) {
        return new TicketBetDetailResponse(properties);
    };

    /**
     * Encodes the specified TicketBetDetailResponse message. Does not implicitly {@link TicketBetDetailResponse.verify|verify} messages.
     * @function encode
     * @memberof TicketBetDetailResponse
     * @static
     * @param {ITicketBetDetailResponse} message TicketBetDetailResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TicketBetDetailResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.CombinationCount != null && message.hasOwnProperty("CombinationCount"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.CombinationCount);
        if (message.PrizeEvalPotentionalValueMin != null && message.hasOwnProperty("PrizeEvalPotentionalValueMin"))
            writer.uint32(/* id 2, wireType 1 =*/17).double(message.PrizeEvalPotentionalValueMin);
        if (message.PrizeEvalPotentionalValueMax != null && message.hasOwnProperty("PrizeEvalPotentionalValueMax"))
            writer.uint32(/* id 3, wireType 1 =*/25).double(message.PrizeEvalPotentionalValueMax);
        if (message.SelectedSystem != null && message.hasOwnProperty("SelectedSystem"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.SelectedSystem);
        if (message.SystemStake != null && message.hasOwnProperty("SystemStake"))
            writer.uint32(/* id 5, wireType 1 =*/41).double(message.SystemStake);
        if (message.UnitStake != null && message.hasOwnProperty("UnitStake"))
            writer.uint32(/* id 6, wireType 1 =*/49).double(message.UnitStake);
        if (message.Combinations != null && message.Combinations.length)
            for (var i = 0; i < message.Combinations.length; ++i)
                $root.TicketCombination.encode(message.Combinations[i], writer.uint32(/* id 7, wireType 2 =*/58).fork()).ldelim();
        if (message.SystemOutOf != null && message.hasOwnProperty("SystemOutOf"))
            writer.uint32(/* id 8, wireType 0 =*/64).int32(message.SystemOutOf);
        return writer;
    };

    /**
     * Encodes the specified TicketBetDetailResponse message, length delimited. Does not implicitly {@link TicketBetDetailResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof TicketBetDetailResponse
     * @static
     * @param {ITicketBetDetailResponse} message TicketBetDetailResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TicketBetDetailResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TicketBetDetailResponse message from the specified reader or buffer.
     * @function decode
     * @memberof TicketBetDetailResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TicketBetDetailResponse} TicketBetDetailResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TicketBetDetailResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TicketBetDetailResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.CombinationCount = reader.int32();
                break;
            case 2:
                message.PrizeEvalPotentionalValueMin = reader.double();
                break;
            case 3:
                message.PrizeEvalPotentionalValueMax = reader.double();
                break;
            case 4:
                message.SelectedSystem = reader.int32();
                break;
            case 5:
                message.SystemStake = reader.double();
                break;
            case 6:
                message.UnitStake = reader.double();
                break;
            case 7:
                if (!(message.Combinations && message.Combinations.length))
                    message.Combinations = [];
                message.Combinations.push($root.TicketCombination.decode(reader, reader.uint32()));
                break;
            case 8:
                message.SystemOutOf = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a TicketBetDetailResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof TicketBetDetailResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {TicketBetDetailResponse} TicketBetDetailResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TicketBetDetailResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TicketBetDetailResponse message.
     * @function verify
     * @memberof TicketBetDetailResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TicketBetDetailResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.CombinationCount != null && message.hasOwnProperty("CombinationCount"))
            if (!$util.isInteger(message.CombinationCount))
                return "CombinationCount: integer expected";
        if (message.PrizeEvalPotentionalValueMin != null && message.hasOwnProperty("PrizeEvalPotentionalValueMin"))
            if (typeof message.PrizeEvalPotentionalValueMin !== "number")
                return "PrizeEvalPotentionalValueMin: number expected";
        if (message.PrizeEvalPotentionalValueMax != null && message.hasOwnProperty("PrizeEvalPotentionalValueMax"))
            if (typeof message.PrizeEvalPotentionalValueMax !== "number")
                return "PrizeEvalPotentionalValueMax: number expected";
        if (message.SelectedSystem != null && message.hasOwnProperty("SelectedSystem"))
            if (!$util.isInteger(message.SelectedSystem))
                return "SelectedSystem: integer expected";
        if (message.SystemStake != null && message.hasOwnProperty("SystemStake"))
            if (typeof message.SystemStake !== "number")
                return "SystemStake: number expected";
        if (message.UnitStake != null && message.hasOwnProperty("UnitStake"))
            if (typeof message.UnitStake !== "number")
                return "UnitStake: number expected";
        if (message.Combinations != null && message.hasOwnProperty("Combinations")) {
            if (!Array.isArray(message.Combinations))
                return "Combinations: array expected";
            for (var i = 0; i < message.Combinations.length; ++i) {
                var error = $root.TicketCombination.verify(message.Combinations[i]);
                if (error)
                    return "Combinations." + error;
            }
        }
        if (message.SystemOutOf != null && message.hasOwnProperty("SystemOutOf"))
            if (!$util.isInteger(message.SystemOutOf))
                return "SystemOutOf: integer expected";
        return null;
    };

    /**
     * Creates a TicketBetDetailResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TicketBetDetailResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TicketBetDetailResponse} TicketBetDetailResponse
     */
    TicketBetDetailResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.TicketBetDetailResponse)
            return object;
        var message = new $root.TicketBetDetailResponse();
        if (object.CombinationCount != null)
            message.CombinationCount = object.CombinationCount | 0;
        if (object.PrizeEvalPotentionalValueMin != null)
            message.PrizeEvalPotentionalValueMin = Number(object.PrizeEvalPotentionalValueMin);
        if (object.PrizeEvalPotentionalValueMax != null)
            message.PrizeEvalPotentionalValueMax = Number(object.PrizeEvalPotentionalValueMax);
        if (object.SelectedSystem != null)
            message.SelectedSystem = object.SelectedSystem | 0;
        if (object.SystemStake != null)
            message.SystemStake = Number(object.SystemStake);
        if (object.UnitStake != null)
            message.UnitStake = Number(object.UnitStake);
        if (object.Combinations) {
            if (!Array.isArray(object.Combinations))
                throw TypeError(".TicketBetDetailResponse.Combinations: array expected");
            message.Combinations = [];
            for (var i = 0; i < object.Combinations.length; ++i) {
                if (typeof object.Combinations[i] !== "object")
                    throw TypeError(".TicketBetDetailResponse.Combinations: object expected");
                message.Combinations[i] = $root.TicketCombination.fromObject(object.Combinations[i]);
            }
        }
        if (object.SystemOutOf != null)
            message.SystemOutOf = object.SystemOutOf | 0;
        return message;
    };

    /**
     * Creates a plain object from a TicketBetDetailResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TicketBetDetailResponse
     * @static
     * @param {TicketBetDetailResponse} message TicketBetDetailResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TicketBetDetailResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.Combinations = [];
        if (options.defaults) {
            object.CombinationCount = 0;
            object.PrizeEvalPotentionalValueMin = 0;
            object.PrizeEvalPotentionalValueMax = 0;
            object.SelectedSystem = 0;
            object.SystemStake = 0;
            object.UnitStake = 0;
            object.SystemOutOf = 0;
        }
        if (message.CombinationCount != null && message.hasOwnProperty("CombinationCount"))
            object.CombinationCount = message.CombinationCount;
        if (message.PrizeEvalPotentionalValueMin != null && message.hasOwnProperty("PrizeEvalPotentionalValueMin"))
            object.PrizeEvalPotentionalValueMin = options.json && !isFinite(message.PrizeEvalPotentionalValueMin) ? String(message.PrizeEvalPotentionalValueMin) : message.PrizeEvalPotentionalValueMin;
        if (message.PrizeEvalPotentionalValueMax != null && message.hasOwnProperty("PrizeEvalPotentionalValueMax"))
            object.PrizeEvalPotentionalValueMax = options.json && !isFinite(message.PrizeEvalPotentionalValueMax) ? String(message.PrizeEvalPotentionalValueMax) : message.PrizeEvalPotentionalValueMax;
        if (message.SelectedSystem != null && message.hasOwnProperty("SelectedSystem"))
            object.SelectedSystem = message.SelectedSystem;
        if (message.SystemStake != null && message.hasOwnProperty("SystemStake"))
            object.SystemStake = options.json && !isFinite(message.SystemStake) ? String(message.SystemStake) : message.SystemStake;
        if (message.UnitStake != null && message.hasOwnProperty("UnitStake"))
            object.UnitStake = options.json && !isFinite(message.UnitStake) ? String(message.UnitStake) : message.UnitStake;
        if (message.Combinations && message.Combinations.length) {
            object.Combinations = [];
            for (var j = 0; j < message.Combinations.length; ++j)
                object.Combinations[j] = $root.TicketCombination.toObject(message.Combinations[j], options);
        }
        if (message.SystemOutOf != null && message.hasOwnProperty("SystemOutOf"))
            object.SystemOutOf = message.SystemOutOf;
        return object;
    };

    /**
     * Converts this TicketBetDetailResponse to JSON.
     * @function toJSON
     * @memberof TicketBetDetailResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TicketBetDetailResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TicketBetDetailResponse;
})();

$root.TicketCombination = (function() {

    /**
     * Properties of a TicketCombination.
     * @exports ITicketCombination
     * @interface ITicketCombination
     * @property {string|null} [Name] TicketCombination Name
     * @property {number|null} [Rate] TicketCombination Rate
     * @property {number|null} [Stake] TicketCombination Stake
     * @property {number|null} [PotentialWin] TicketCombination PotentialWin
     */

    /**
     * Constructs a new TicketCombination.
     * @exports TicketCombination
     * @classdesc Represents a TicketCombination.
     * @implements ITicketCombination
     * @constructor
     * @param {ITicketCombination=} [properties] Properties to set
     */
    function TicketCombination(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * TicketCombination Name.
     * @member {string} Name
     * @memberof TicketCombination
     * @instance
     */
    TicketCombination.prototype.Name = "";

    /**
     * TicketCombination Rate.
     * @member {number} Rate
     * @memberof TicketCombination
     * @instance
     */
    TicketCombination.prototype.Rate = 0;

    /**
     * TicketCombination Stake.
     * @member {number} Stake
     * @memberof TicketCombination
     * @instance
     */
    TicketCombination.prototype.Stake = 0;

    /**
     * TicketCombination PotentialWin.
     * @member {number} PotentialWin
     * @memberof TicketCombination
     * @instance
     */
    TicketCombination.prototype.PotentialWin = 0;

    /**
     * Creates a new TicketCombination instance using the specified properties.
     * @function create
     * @memberof TicketCombination
     * @static
     * @param {ITicketCombination=} [properties] Properties to set
     * @returns {TicketCombination} TicketCombination instance
     */
    TicketCombination.create = function create(properties) {
        return new TicketCombination(properties);
    };

    /**
     * Encodes the specified TicketCombination message. Does not implicitly {@link TicketCombination.verify|verify} messages.
     * @function encode
     * @memberof TicketCombination
     * @static
     * @param {ITicketCombination} message TicketCombination message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TicketCombination.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Name != null && message.hasOwnProperty("Name"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.Name);
        if (message.Rate != null && message.hasOwnProperty("Rate"))
            writer.uint32(/* id 2, wireType 1 =*/17).double(message.Rate);
        if (message.Stake != null && message.hasOwnProperty("Stake"))
            writer.uint32(/* id 3, wireType 1 =*/25).double(message.Stake);
        if (message.PotentialWin != null && message.hasOwnProperty("PotentialWin"))
            writer.uint32(/* id 4, wireType 1 =*/33).double(message.PotentialWin);
        return writer;
    };

    /**
     * Encodes the specified TicketCombination message, length delimited. Does not implicitly {@link TicketCombination.verify|verify} messages.
     * @function encodeDelimited
     * @memberof TicketCombination
     * @static
     * @param {ITicketCombination} message TicketCombination message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TicketCombination.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TicketCombination message from the specified reader or buffer.
     * @function decode
     * @memberof TicketCombination
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TicketCombination} TicketCombination
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TicketCombination.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TicketCombination();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Name = reader.string();
                break;
            case 2:
                message.Rate = reader.double();
                break;
            case 3:
                message.Stake = reader.double();
                break;
            case 4:
                message.PotentialWin = reader.double();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a TicketCombination message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof TicketCombination
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {TicketCombination} TicketCombination
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TicketCombination.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TicketCombination message.
     * @function verify
     * @memberof TicketCombination
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TicketCombination.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Name != null && message.hasOwnProperty("Name"))
            if (!$util.isString(message.Name))
                return "Name: string expected";
        if (message.Rate != null && message.hasOwnProperty("Rate"))
            if (typeof message.Rate !== "number")
                return "Rate: number expected";
        if (message.Stake != null && message.hasOwnProperty("Stake"))
            if (typeof message.Stake !== "number")
                return "Stake: number expected";
        if (message.PotentialWin != null && message.hasOwnProperty("PotentialWin"))
            if (typeof message.PotentialWin !== "number")
                return "PotentialWin: number expected";
        return null;
    };

    /**
     * Creates a TicketCombination message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TicketCombination
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TicketCombination} TicketCombination
     */
    TicketCombination.fromObject = function fromObject(object) {
        if (object instanceof $root.TicketCombination)
            return object;
        var message = new $root.TicketCombination();
        if (object.Name != null)
            message.Name = String(object.Name);
        if (object.Rate != null)
            message.Rate = Number(object.Rate);
        if (object.Stake != null)
            message.Stake = Number(object.Stake);
        if (object.PotentialWin != null)
            message.PotentialWin = Number(object.PotentialWin);
        return message;
    };

    /**
     * Creates a plain object from a TicketCombination message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TicketCombination
     * @static
     * @param {TicketCombination} message TicketCombination
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TicketCombination.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.Name = "";
            object.Rate = 0;
            object.Stake = 0;
            object.PotentialWin = 0;
        }
        if (message.Name != null && message.hasOwnProperty("Name"))
            object.Name = message.Name;
        if (message.Rate != null && message.hasOwnProperty("Rate"))
            object.Rate = options.json && !isFinite(message.Rate) ? String(message.Rate) : message.Rate;
        if (message.Stake != null && message.hasOwnProperty("Stake"))
            object.Stake = options.json && !isFinite(message.Stake) ? String(message.Stake) : message.Stake;
        if (message.PotentialWin != null && message.hasOwnProperty("PotentialWin"))
            object.PotentialWin = options.json && !isFinite(message.PotentialWin) ? String(message.PotentialWin) : message.PotentialWin;
        return object;
    };

    /**
     * Converts this TicketCombination to JSON.
     * @function toJSON
     * @memberof TicketCombination
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TicketCombination.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TicketCombination;
})();

$root.PrizePotentialWithMistakes = (function() {

    /**
     * Properties of a PrizePotentialWithMistakes.
     * @exports IPrizePotentialWithMistakes
     * @interface IPrizePotentialWithMistakes
     * @property {number|null} [NumberOfMistakes] PrizePotentialWithMistakes NumberOfMistakes
     * @property {number|null} [PrizePotentialMin] PrizePotentialWithMistakes PrizePotentialMin
     * @property {number|null} [PrizePotentialMax] PrizePotentialWithMistakes PrizePotentialMax
     */

    /**
     * Constructs a new PrizePotentialWithMistakes.
     * @exports PrizePotentialWithMistakes
     * @classdesc Represents a PrizePotentialWithMistakes.
     * @implements IPrizePotentialWithMistakes
     * @constructor
     * @param {IPrizePotentialWithMistakes=} [properties] Properties to set
     */
    function PrizePotentialWithMistakes(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PrizePotentialWithMistakes NumberOfMistakes.
     * @member {number} NumberOfMistakes
     * @memberof PrizePotentialWithMistakes
     * @instance
     */
    PrizePotentialWithMistakes.prototype.NumberOfMistakes = 0;

    /**
     * PrizePotentialWithMistakes PrizePotentialMin.
     * @member {number} PrizePotentialMin
     * @memberof PrizePotentialWithMistakes
     * @instance
     */
    PrizePotentialWithMistakes.prototype.PrizePotentialMin = 0;

    /**
     * PrizePotentialWithMistakes PrizePotentialMax.
     * @member {number} PrizePotentialMax
     * @memberof PrizePotentialWithMistakes
     * @instance
     */
    PrizePotentialWithMistakes.prototype.PrizePotentialMax = 0;

    /**
     * Creates a new PrizePotentialWithMistakes instance using the specified properties.
     * @function create
     * @memberof PrizePotentialWithMistakes
     * @static
     * @param {IPrizePotentialWithMistakes=} [properties] Properties to set
     * @returns {PrizePotentialWithMistakes} PrizePotentialWithMistakes instance
     */
    PrizePotentialWithMistakes.create = function create(properties) {
        return new PrizePotentialWithMistakes(properties);
    };

    /**
     * Encodes the specified PrizePotentialWithMistakes message. Does not implicitly {@link PrizePotentialWithMistakes.verify|verify} messages.
     * @function encode
     * @memberof PrizePotentialWithMistakes
     * @static
     * @param {IPrizePotentialWithMistakes} message PrizePotentialWithMistakes message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PrizePotentialWithMistakes.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.NumberOfMistakes != null && message.hasOwnProperty("NumberOfMistakes"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.NumberOfMistakes);
        if (message.PrizePotentialMin != null && message.hasOwnProperty("PrizePotentialMin"))
            writer.uint32(/* id 2, wireType 1 =*/17).double(message.PrizePotentialMin);
        if (message.PrizePotentialMax != null && message.hasOwnProperty("PrizePotentialMax"))
            writer.uint32(/* id 3, wireType 1 =*/25).double(message.PrizePotentialMax);
        return writer;
    };

    /**
     * Encodes the specified PrizePotentialWithMistakes message, length delimited. Does not implicitly {@link PrizePotentialWithMistakes.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PrizePotentialWithMistakes
     * @static
     * @param {IPrizePotentialWithMistakes} message PrizePotentialWithMistakes message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PrizePotentialWithMistakes.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PrizePotentialWithMistakes message from the specified reader or buffer.
     * @function decode
     * @memberof PrizePotentialWithMistakes
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PrizePotentialWithMistakes} PrizePotentialWithMistakes
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PrizePotentialWithMistakes.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PrizePotentialWithMistakes();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.NumberOfMistakes = reader.int32();
                break;
            case 2:
                message.PrizePotentialMin = reader.double();
                break;
            case 3:
                message.PrizePotentialMax = reader.double();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PrizePotentialWithMistakes message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PrizePotentialWithMistakes
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PrizePotentialWithMistakes} PrizePotentialWithMistakes
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PrizePotentialWithMistakes.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PrizePotentialWithMistakes message.
     * @function verify
     * @memberof PrizePotentialWithMistakes
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PrizePotentialWithMistakes.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.NumberOfMistakes != null && message.hasOwnProperty("NumberOfMistakes"))
            if (!$util.isInteger(message.NumberOfMistakes))
                return "NumberOfMistakes: integer expected";
        if (message.PrizePotentialMin != null && message.hasOwnProperty("PrizePotentialMin"))
            if (typeof message.PrizePotentialMin !== "number")
                return "PrizePotentialMin: number expected";
        if (message.PrizePotentialMax != null && message.hasOwnProperty("PrizePotentialMax"))
            if (typeof message.PrizePotentialMax !== "number")
                return "PrizePotentialMax: number expected";
        return null;
    };

    /**
     * Creates a PrizePotentialWithMistakes message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PrizePotentialWithMistakes
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PrizePotentialWithMistakes} PrizePotentialWithMistakes
     */
    PrizePotentialWithMistakes.fromObject = function fromObject(object) {
        if (object instanceof $root.PrizePotentialWithMistakes)
            return object;
        var message = new $root.PrizePotentialWithMistakes();
        if (object.NumberOfMistakes != null)
            message.NumberOfMistakes = object.NumberOfMistakes | 0;
        if (object.PrizePotentialMin != null)
            message.PrizePotentialMin = Number(object.PrizePotentialMin);
        if (object.PrizePotentialMax != null)
            message.PrizePotentialMax = Number(object.PrizePotentialMax);
        return message;
    };

    /**
     * Creates a plain object from a PrizePotentialWithMistakes message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PrizePotentialWithMistakes
     * @static
     * @param {PrizePotentialWithMistakes} message PrizePotentialWithMistakes
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PrizePotentialWithMistakes.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.NumberOfMistakes = 0;
            object.PrizePotentialMin = 0;
            object.PrizePotentialMax = 0;
        }
        if (message.NumberOfMistakes != null && message.hasOwnProperty("NumberOfMistakes"))
            object.NumberOfMistakes = message.NumberOfMistakes;
        if (message.PrizePotentialMin != null && message.hasOwnProperty("PrizePotentialMin"))
            object.PrizePotentialMin = options.json && !isFinite(message.PrizePotentialMin) ? String(message.PrizePotentialMin) : message.PrizePotentialMin;
        if (message.PrizePotentialMax != null && message.hasOwnProperty("PrizePotentialMax"))
            object.PrizePotentialMax = options.json && !isFinite(message.PrizePotentialMax) ? String(message.PrizePotentialMax) : message.PrizePotentialMax;
        return object;
    };

    /**
     * Converts this PrizePotentialWithMistakes to JSON.
     * @function toJSON
     * @memberof PrizePotentialWithMistakes
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PrizePotentialWithMistakes.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PrizePotentialWithMistakes;
})();

$root.TicketSystemsAndCombinations = (function() {

    /**
     * Properties of a TicketSystemsAndCombinations.
     * @exports ITicketSystemsAndCombinations
     * @interface ITicketSystemsAndCombinations
     * @property {Array.<ITicketBetDetailResponse>|null} [Items] TicketSystemsAndCombinations Items
     * @property {Array.<IPrizePotentialWithMistakes>|null} [PrizePotentialWithMistakes] TicketSystemsAndCombinations PrizePotentialWithMistakes
     */

    /**
     * Constructs a new TicketSystemsAndCombinations.
     * @exports TicketSystemsAndCombinations
     * @classdesc Represents a TicketSystemsAndCombinations.
     * @implements ITicketSystemsAndCombinations
     * @constructor
     * @param {ITicketSystemsAndCombinations=} [properties] Properties to set
     */
    function TicketSystemsAndCombinations(properties) {
        this.Items = [];
        this.PrizePotentialWithMistakes = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * TicketSystemsAndCombinations Items.
     * @member {Array.<ITicketBetDetailResponse>} Items
     * @memberof TicketSystemsAndCombinations
     * @instance
     */
    TicketSystemsAndCombinations.prototype.Items = $util.emptyArray;

    /**
     * TicketSystemsAndCombinations PrizePotentialWithMistakes.
     * @member {Array.<IPrizePotentialWithMistakes>} PrizePotentialWithMistakes
     * @memberof TicketSystemsAndCombinations
     * @instance
     */
    TicketSystemsAndCombinations.prototype.PrizePotentialWithMistakes = $util.emptyArray;

    /**
     * Creates a new TicketSystemsAndCombinations instance using the specified properties.
     * @function create
     * @memberof TicketSystemsAndCombinations
     * @static
     * @param {ITicketSystemsAndCombinations=} [properties] Properties to set
     * @returns {TicketSystemsAndCombinations} TicketSystemsAndCombinations instance
     */
    TicketSystemsAndCombinations.create = function create(properties) {
        return new TicketSystemsAndCombinations(properties);
    };

    /**
     * Encodes the specified TicketSystemsAndCombinations message. Does not implicitly {@link TicketSystemsAndCombinations.verify|verify} messages.
     * @function encode
     * @memberof TicketSystemsAndCombinations
     * @static
     * @param {ITicketSystemsAndCombinations} message TicketSystemsAndCombinations message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TicketSystemsAndCombinations.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Items != null && message.Items.length)
            for (var i = 0; i < message.Items.length; ++i)
                $root.TicketBetDetailResponse.encode(message.Items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.PrizePotentialWithMistakes != null && message.PrizePotentialWithMistakes.length)
            for (var i = 0; i < message.PrizePotentialWithMistakes.length; ++i)
                $root.PrizePotentialWithMistakes.encode(message.PrizePotentialWithMistakes[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified TicketSystemsAndCombinations message, length delimited. Does not implicitly {@link TicketSystemsAndCombinations.verify|verify} messages.
     * @function encodeDelimited
     * @memberof TicketSystemsAndCombinations
     * @static
     * @param {ITicketSystemsAndCombinations} message TicketSystemsAndCombinations message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TicketSystemsAndCombinations.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TicketSystemsAndCombinations message from the specified reader or buffer.
     * @function decode
     * @memberof TicketSystemsAndCombinations
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TicketSystemsAndCombinations} TicketSystemsAndCombinations
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TicketSystemsAndCombinations.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TicketSystemsAndCombinations();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.Items && message.Items.length))
                    message.Items = [];
                message.Items.push($root.TicketBetDetailResponse.decode(reader, reader.uint32()));
                break;
            case 2:
                if (!(message.PrizePotentialWithMistakes && message.PrizePotentialWithMistakes.length))
                    message.PrizePotentialWithMistakes = [];
                message.PrizePotentialWithMistakes.push($root.PrizePotentialWithMistakes.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a TicketSystemsAndCombinations message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof TicketSystemsAndCombinations
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {TicketSystemsAndCombinations} TicketSystemsAndCombinations
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TicketSystemsAndCombinations.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TicketSystemsAndCombinations message.
     * @function verify
     * @memberof TicketSystemsAndCombinations
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TicketSystemsAndCombinations.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Items != null && message.hasOwnProperty("Items")) {
            if (!Array.isArray(message.Items))
                return "Items: array expected";
            for (var i = 0; i < message.Items.length; ++i) {
                var error = $root.TicketBetDetailResponse.verify(message.Items[i]);
                if (error)
                    return "Items." + error;
            }
        }
        if (message.PrizePotentialWithMistakes != null && message.hasOwnProperty("PrizePotentialWithMistakes")) {
            if (!Array.isArray(message.PrizePotentialWithMistakes))
                return "PrizePotentialWithMistakes: array expected";
            for (var i = 0; i < message.PrizePotentialWithMistakes.length; ++i) {
                var error = $root.PrizePotentialWithMistakes.verify(message.PrizePotentialWithMistakes[i]);
                if (error)
                    return "PrizePotentialWithMistakes." + error;
            }
        }
        return null;
    };

    /**
     * Creates a TicketSystemsAndCombinations message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TicketSystemsAndCombinations
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TicketSystemsAndCombinations} TicketSystemsAndCombinations
     */
    TicketSystemsAndCombinations.fromObject = function fromObject(object) {
        if (object instanceof $root.TicketSystemsAndCombinations)
            return object;
        var message = new $root.TicketSystemsAndCombinations();
        if (object.Items) {
            if (!Array.isArray(object.Items))
                throw TypeError(".TicketSystemsAndCombinations.Items: array expected");
            message.Items = [];
            for (var i = 0; i < object.Items.length; ++i) {
                if (typeof object.Items[i] !== "object")
                    throw TypeError(".TicketSystemsAndCombinations.Items: object expected");
                message.Items[i] = $root.TicketBetDetailResponse.fromObject(object.Items[i]);
            }
        }
        if (object.PrizePotentialWithMistakes) {
            if (!Array.isArray(object.PrizePotentialWithMistakes))
                throw TypeError(".TicketSystemsAndCombinations.PrizePotentialWithMistakes: array expected");
            message.PrizePotentialWithMistakes = [];
            for (var i = 0; i < object.PrizePotentialWithMistakes.length; ++i) {
                if (typeof object.PrizePotentialWithMistakes[i] !== "object")
                    throw TypeError(".TicketSystemsAndCombinations.PrizePotentialWithMistakes: object expected");
                message.PrizePotentialWithMistakes[i] = $root.PrizePotentialWithMistakes.fromObject(object.PrizePotentialWithMistakes[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a TicketSystemsAndCombinations message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TicketSystemsAndCombinations
     * @static
     * @param {TicketSystemsAndCombinations} message TicketSystemsAndCombinations
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TicketSystemsAndCombinations.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.Items = [];
            object.PrizePotentialWithMistakes = [];
        }
        if (message.Items && message.Items.length) {
            object.Items = [];
            for (var j = 0; j < message.Items.length; ++j)
                object.Items[j] = $root.TicketBetDetailResponse.toObject(message.Items[j], options);
        }
        if (message.PrizePotentialWithMistakes && message.PrizePotentialWithMistakes.length) {
            object.PrizePotentialWithMistakes = [];
            for (var j = 0; j < message.PrizePotentialWithMistakes.length; ++j)
                object.PrizePotentialWithMistakes[j] = $root.PrizePotentialWithMistakes.toObject(message.PrizePotentialWithMistakes[j], options);
        }
        return object;
    };

    /**
     * Converts this TicketSystemsAndCombinations to JSON.
     * @function toJSON
     * @memberof TicketSystemsAndCombinations
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TicketSystemsAndCombinations.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TicketSystemsAndCombinations;
})();

$root.SelectionOfferText = (function() {

    /**
     * Properties of a SelectionOfferText.
     * @exports ISelectionOfferText
     * @interface ISelectionOfferText
     * @property {number|Long|null} [Number] SelectionOfferText Number
     * @property {string|null} [SportName] SelectionOfferText SportName
     * @property {string|null} [FixtureName] SelectionOfferText FixtureName
     * @property {ITimestamp|null} [FixtureDate] SelectionOfferText FixtureDate
     * @property {string|null} [SelectionName] SelectionOfferText SelectionName
     * @property {string|null} [MarketName] SelectionOfferText MarketName
     * @property {string|null} [RegionName] SelectionOfferText RegionName
     * @property {string|null} [TournamentName] SelectionOfferText TournamentName
     */

    /**
     * Constructs a new SelectionOfferText.
     * @exports SelectionOfferText
     * @classdesc Represents a SelectionOfferText.
     * @implements ISelectionOfferText
     * @constructor
     * @param {ISelectionOfferText=} [properties] Properties to set
     */
    function SelectionOfferText(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * SelectionOfferText Number.
     * @member {number|Long} Number
     * @memberof SelectionOfferText
     * @instance
     */
    SelectionOfferText.prototype.Number = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * SelectionOfferText SportName.
     * @member {string} SportName
     * @memberof SelectionOfferText
     * @instance
     */
    SelectionOfferText.prototype.SportName = "";

    /**
     * SelectionOfferText FixtureName.
     * @member {string} FixtureName
     * @memberof SelectionOfferText
     * @instance
     */
    SelectionOfferText.prototype.FixtureName = "";

    /**
     * SelectionOfferText FixtureDate.
     * @member {ITimestamp|null|undefined} FixtureDate
     * @memberof SelectionOfferText
     * @instance
     */
    SelectionOfferText.prototype.FixtureDate = null;

    /**
     * SelectionOfferText SelectionName.
     * @member {string} SelectionName
     * @memberof SelectionOfferText
     * @instance
     */
    SelectionOfferText.prototype.SelectionName = "";

    /**
     * SelectionOfferText MarketName.
     * @member {string} MarketName
     * @memberof SelectionOfferText
     * @instance
     */
    SelectionOfferText.prototype.MarketName = "";

    /**
     * SelectionOfferText RegionName.
     * @member {string} RegionName
     * @memberof SelectionOfferText
     * @instance
     */
    SelectionOfferText.prototype.RegionName = "";

    /**
     * SelectionOfferText TournamentName.
     * @member {string} TournamentName
     * @memberof SelectionOfferText
     * @instance
     */
    SelectionOfferText.prototype.TournamentName = "";

    /**
     * Creates a new SelectionOfferText instance using the specified properties.
     * @function create
     * @memberof SelectionOfferText
     * @static
     * @param {ISelectionOfferText=} [properties] Properties to set
     * @returns {SelectionOfferText} SelectionOfferText instance
     */
    SelectionOfferText.create = function create(properties) {
        return new SelectionOfferText(properties);
    };

    /**
     * Encodes the specified SelectionOfferText message. Does not implicitly {@link SelectionOfferText.verify|verify} messages.
     * @function encode
     * @memberof SelectionOfferText
     * @static
     * @param {ISelectionOfferText} message SelectionOfferText message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SelectionOfferText.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Number != null && message.hasOwnProperty("Number"))
            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.Number);
        if (message.SportName != null && message.hasOwnProperty("SportName"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.SportName);
        if (message.FixtureName != null && message.hasOwnProperty("FixtureName"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.FixtureName);
        if (message.FixtureDate != null && message.hasOwnProperty("FixtureDate"))
            $root.Timestamp.encode(message.FixtureDate, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        if (message.SelectionName != null && message.hasOwnProperty("SelectionName"))
            writer.uint32(/* id 5, wireType 2 =*/42).string(message.SelectionName);
        if (message.MarketName != null && message.hasOwnProperty("MarketName"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.MarketName);
        if (message.RegionName != null && message.hasOwnProperty("RegionName"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.RegionName);
        if (message.TournamentName != null && message.hasOwnProperty("TournamentName"))
            writer.uint32(/* id 8, wireType 2 =*/66).string(message.TournamentName);
        return writer;
    };

    /**
     * Encodes the specified SelectionOfferText message, length delimited. Does not implicitly {@link SelectionOfferText.verify|verify} messages.
     * @function encodeDelimited
     * @memberof SelectionOfferText
     * @static
     * @param {ISelectionOfferText} message SelectionOfferText message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    SelectionOfferText.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a SelectionOfferText message from the specified reader or buffer.
     * @function decode
     * @memberof SelectionOfferText
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {SelectionOfferText} SelectionOfferText
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SelectionOfferText.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.SelectionOfferText();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Number = reader.int64();
                break;
            case 2:
                message.SportName = reader.string();
                break;
            case 3:
                message.FixtureName = reader.string();
                break;
            case 4:
                message.FixtureDate = $root.Timestamp.decode(reader, reader.uint32());
                break;
            case 5:
                message.SelectionName = reader.string();
                break;
            case 6:
                message.MarketName = reader.string();
                break;
            case 7:
                message.RegionName = reader.string();
                break;
            case 8:
                message.TournamentName = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a SelectionOfferText message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof SelectionOfferText
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {SelectionOfferText} SelectionOfferText
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    SelectionOfferText.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a SelectionOfferText message.
     * @function verify
     * @memberof SelectionOfferText
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    SelectionOfferText.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Number != null && message.hasOwnProperty("Number"))
            if (!$util.isInteger(message.Number) && !(message.Number && $util.isInteger(message.Number.low) && $util.isInteger(message.Number.high)))
                return "Number: integer|Long expected";
        if (message.SportName != null && message.hasOwnProperty("SportName"))
            if (!$util.isString(message.SportName))
                return "SportName: string expected";
        if (message.FixtureName != null && message.hasOwnProperty("FixtureName"))
            if (!$util.isString(message.FixtureName))
                return "FixtureName: string expected";
        if (message.FixtureDate != null && message.hasOwnProperty("FixtureDate")) {
            var error = $root.Timestamp.verify(message.FixtureDate);
            if (error)
                return "FixtureDate." + error;
        }
        if (message.SelectionName != null && message.hasOwnProperty("SelectionName"))
            if (!$util.isString(message.SelectionName))
                return "SelectionName: string expected";
        if (message.MarketName != null && message.hasOwnProperty("MarketName"))
            if (!$util.isString(message.MarketName))
                return "MarketName: string expected";
        if (message.RegionName != null && message.hasOwnProperty("RegionName"))
            if (!$util.isString(message.RegionName))
                return "RegionName: string expected";
        if (message.TournamentName != null && message.hasOwnProperty("TournamentName"))
            if (!$util.isString(message.TournamentName))
                return "TournamentName: string expected";
        return null;
    };

    /**
     * Creates a SelectionOfferText message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof SelectionOfferText
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {SelectionOfferText} SelectionOfferText
     */
    SelectionOfferText.fromObject = function fromObject(object) {
        if (object instanceof $root.SelectionOfferText)
            return object;
        var message = new $root.SelectionOfferText();
        if (object.Number != null)
            if ($util.Long)
                (message.Number = $util.Long.fromValue(object.Number)).unsigned = false;
            else if (typeof object.Number === "string")
                message.Number = parseInt(object.Number, 10);
            else if (typeof object.Number === "number")
                message.Number = object.Number;
            else if (typeof object.Number === "object")
                message.Number = new $util.LongBits(object.Number.low >>> 0, object.Number.high >>> 0).toNumber();
        if (object.SportName != null)
            message.SportName = String(object.SportName);
        if (object.FixtureName != null)
            message.FixtureName = String(object.FixtureName);
        if (object.FixtureDate != null) {
            if (typeof object.FixtureDate !== "object")
                throw TypeError(".SelectionOfferText.FixtureDate: object expected");
            message.FixtureDate = $root.Timestamp.fromObject(object.FixtureDate);
        }
        if (object.SelectionName != null)
            message.SelectionName = String(object.SelectionName);
        if (object.MarketName != null)
            message.MarketName = String(object.MarketName);
        if (object.RegionName != null)
            message.RegionName = String(object.RegionName);
        if (object.TournamentName != null)
            message.TournamentName = String(object.TournamentName);
        return message;
    };

    /**
     * Creates a plain object from a SelectionOfferText message. Also converts values to other types if specified.
     * @function toObject
     * @memberof SelectionOfferText
     * @static
     * @param {SelectionOfferText} message SelectionOfferText
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    SelectionOfferText.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.Number = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.Number = options.longs === String ? "0" : 0;
            object.SportName = "";
            object.FixtureName = "";
            object.FixtureDate = null;
            object.SelectionName = "";
            object.MarketName = "";
            object.RegionName = "";
            object.TournamentName = "";
        }
        if (message.Number != null && message.hasOwnProperty("Number"))
            if (typeof message.Number === "number")
                object.Number = options.longs === String ? String(message.Number) : message.Number;
            else
                object.Number = options.longs === String ? $util.Long.prototype.toString.call(message.Number) : options.longs === Number ? new $util.LongBits(message.Number.low >>> 0, message.Number.high >>> 0).toNumber() : message.Number;
        if (message.SportName != null && message.hasOwnProperty("SportName"))
            object.SportName = message.SportName;
        if (message.FixtureName != null && message.hasOwnProperty("FixtureName"))
            object.FixtureName = message.FixtureName;
        if (message.FixtureDate != null && message.hasOwnProperty("FixtureDate"))
            object.FixtureDate = $root.Timestamp.toObject(message.FixtureDate, options);
        if (message.SelectionName != null && message.hasOwnProperty("SelectionName"))
            object.SelectionName = message.SelectionName;
        if (message.MarketName != null && message.hasOwnProperty("MarketName"))
            object.MarketName = message.MarketName;
        if (message.RegionName != null && message.hasOwnProperty("RegionName"))
            object.RegionName = message.RegionName;
        if (message.TournamentName != null && message.hasOwnProperty("TournamentName"))
            object.TournamentName = message.TournamentName;
        return object;
    };

    /**
     * Converts this SelectionOfferText to JSON.
     * @function toJSON
     * @memberof SelectionOfferText
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    SelectionOfferText.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return SelectionOfferText;
})();

$root.TicketCashOutResponse = (function() {

    /**
     * Properties of a TicketCashOutResponse.
     * @exports ITicketCashOutResponse
     * @interface ITicketCashOutResponse
     * @property {ResultType|null} [ResultType] TicketCashOutResponse ResultType
     * @property {Array.<string>|null} [Errors] TicketCashOutResponse Errors
     * @property {INullableDouble|null} [CashOut] TicketCashOutResponse CashOut
     * @property {ITicketDetailResponse|null} [Detail] TicketCashOutResponse Detail
     */

    /**
     * Constructs a new TicketCashOutResponse.
     * @exports TicketCashOutResponse
     * @classdesc Represents a TicketCashOutResponse.
     * @implements ITicketCashOutResponse
     * @constructor
     * @param {ITicketCashOutResponse=} [properties] Properties to set
     */
    function TicketCashOutResponse(properties) {
        this.Errors = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * TicketCashOutResponse ResultType.
     * @member {ResultType} ResultType
     * @memberof TicketCashOutResponse
     * @instance
     */
    TicketCashOutResponse.prototype.ResultType = 0;

    /**
     * TicketCashOutResponse Errors.
     * @member {Array.<string>} Errors
     * @memberof TicketCashOutResponse
     * @instance
     */
    TicketCashOutResponse.prototype.Errors = $util.emptyArray;

    /**
     * TicketCashOutResponse CashOut.
     * @member {INullableDouble|null|undefined} CashOut
     * @memberof TicketCashOutResponse
     * @instance
     */
    TicketCashOutResponse.prototype.CashOut = null;

    /**
     * TicketCashOutResponse Detail.
     * @member {ITicketDetailResponse|null|undefined} Detail
     * @memberof TicketCashOutResponse
     * @instance
     */
    TicketCashOutResponse.prototype.Detail = null;

    /**
     * Creates a new TicketCashOutResponse instance using the specified properties.
     * @function create
     * @memberof TicketCashOutResponse
     * @static
     * @param {ITicketCashOutResponse=} [properties] Properties to set
     * @returns {TicketCashOutResponse} TicketCashOutResponse instance
     */
    TicketCashOutResponse.create = function create(properties) {
        return new TicketCashOutResponse(properties);
    };

    /**
     * Encodes the specified TicketCashOutResponse message. Does not implicitly {@link TicketCashOutResponse.verify|verify} messages.
     * @function encode
     * @memberof TicketCashOutResponse
     * @static
     * @param {ITicketCashOutResponse} message TicketCashOutResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TicketCashOutResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ResultType != null && message.hasOwnProperty("ResultType"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.ResultType);
        if (message.Errors != null && message.Errors.length)
            for (var i = 0; i < message.Errors.length; ++i)
                writer.uint32(/* id 2, wireType 2 =*/18).string(message.Errors[i]);
        if (message.CashOut != null && message.hasOwnProperty("CashOut"))
            $root.NullableDouble.encode(message.CashOut, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        if (message.Detail != null && message.hasOwnProperty("Detail"))
            $root.TicketDetailResponse.encode(message.Detail, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified TicketCashOutResponse message, length delimited. Does not implicitly {@link TicketCashOutResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof TicketCashOutResponse
     * @static
     * @param {ITicketCashOutResponse} message TicketCashOutResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TicketCashOutResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TicketCashOutResponse message from the specified reader or buffer.
     * @function decode
     * @memberof TicketCashOutResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TicketCashOutResponse} TicketCashOutResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TicketCashOutResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TicketCashOutResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.ResultType = reader.int32();
                break;
            case 2:
                if (!(message.Errors && message.Errors.length))
                    message.Errors = [];
                message.Errors.push(reader.string());
                break;
            case 3:
                message.CashOut = $root.NullableDouble.decode(reader, reader.uint32());
                break;
            case 4:
                message.Detail = $root.TicketDetailResponse.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a TicketCashOutResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof TicketCashOutResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {TicketCashOutResponse} TicketCashOutResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TicketCashOutResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TicketCashOutResponse message.
     * @function verify
     * @memberof TicketCashOutResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TicketCashOutResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ResultType != null && message.hasOwnProperty("ResultType"))
            switch (message.ResultType) {
            default:
                return "ResultType: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
                break;
            }
        if (message.Errors != null && message.hasOwnProperty("Errors")) {
            if (!Array.isArray(message.Errors))
                return "Errors: array expected";
            for (var i = 0; i < message.Errors.length; ++i)
                if (!$util.isString(message.Errors[i]))
                    return "Errors: string[] expected";
        }
        if (message.CashOut != null && message.hasOwnProperty("CashOut")) {
            var error = $root.NullableDouble.verify(message.CashOut);
            if (error)
                return "CashOut." + error;
        }
        if (message.Detail != null && message.hasOwnProperty("Detail")) {
            var error = $root.TicketDetailResponse.verify(message.Detail);
            if (error)
                return "Detail." + error;
        }
        return null;
    };

    /**
     * Creates a TicketCashOutResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TicketCashOutResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TicketCashOutResponse} TicketCashOutResponse
     */
    TicketCashOutResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.TicketCashOutResponse)
            return object;
        var message = new $root.TicketCashOutResponse();
        switch (object.ResultType) {
        case "None":
        case 0:
            message.ResultType = 0;
            break;
        case "Fail":
        case 1:
            message.ResultType = 1;
            break;
        case "FailWithHint":
        case 2:
            message.ResultType = 2;
            break;
        case "Success":
        case 3:
            message.ResultType = 3;
            break;
        }
        if (object.Errors) {
            if (!Array.isArray(object.Errors))
                throw TypeError(".TicketCashOutResponse.Errors: array expected");
            message.Errors = [];
            for (var i = 0; i < object.Errors.length; ++i)
                message.Errors[i] = String(object.Errors[i]);
        }
        if (object.CashOut != null) {
            if (typeof object.CashOut !== "object")
                throw TypeError(".TicketCashOutResponse.CashOut: object expected");
            message.CashOut = $root.NullableDouble.fromObject(object.CashOut);
        }
        if (object.Detail != null) {
            if (typeof object.Detail !== "object")
                throw TypeError(".TicketCashOutResponse.Detail: object expected");
            message.Detail = $root.TicketDetailResponse.fromObject(object.Detail);
        }
        return message;
    };

    /**
     * Creates a plain object from a TicketCashOutResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TicketCashOutResponse
     * @static
     * @param {TicketCashOutResponse} message TicketCashOutResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TicketCashOutResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.Errors = [];
        if (options.defaults) {
            object.ResultType = options.enums === String ? "None" : 0;
            object.CashOut = null;
            object.Detail = null;
        }
        if (message.ResultType != null && message.hasOwnProperty("ResultType"))
            object.ResultType = options.enums === String ? $root.ResultType[message.ResultType] : message.ResultType;
        if (message.Errors && message.Errors.length) {
            object.Errors = [];
            for (var j = 0; j < message.Errors.length; ++j)
                object.Errors[j] = message.Errors[j];
        }
        if (message.CashOut != null && message.hasOwnProperty("CashOut"))
            object.CashOut = $root.NullableDouble.toObject(message.CashOut, options);
        if (message.Detail != null && message.hasOwnProperty("Detail"))
            object.Detail = $root.TicketDetailResponse.toObject(message.Detail, options);
        return object;
    };

    /**
     * Converts this TicketCashOutResponse to JSON.
     * @function toJSON
     * @memberof TicketCashOutResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TicketCashOutResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TicketCashOutResponse;
})();

/**
 * TicketErrorType enum.
 * @exports TicketErrorType
 * @enum {string}
 * @property {number} Other=0 Other value
 * @property {number} SelectionInvalid=1 SelectionInvalid value
 * @property {number} NotPossibleToCombineSelection=2 NotPossibleToCombineSelection value
 * @property {number} SelectionRateChanged=3 SelectionRateChanged value
 */
$root.TicketErrorType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "Other"] = 0;
    values[valuesById[1] = "SelectionInvalid"] = 1;
    values[valuesById[2] = "NotPossibleToCombineSelection"] = 2;
    values[valuesById[3] = "SelectionRateChanged"] = 3;
    return values;
})();

$root.TicketError = (function() {

    /**
     * Properties of a TicketError.
     * @exports ITicketError
     * @interface ITicketError
     * @property {number|Long|null} [SelectionId] TicketError SelectionId
     * @property {string|null} [Text] TicketError Text
     * @property {TicketErrorType|null} [Type] TicketError Type
     */

    /**
     * Constructs a new TicketError.
     * @exports TicketError
     * @classdesc Represents a TicketError.
     * @implements ITicketError
     * @constructor
     * @param {ITicketError=} [properties] Properties to set
     */
    function TicketError(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * TicketError SelectionId.
     * @member {number|Long} SelectionId
     * @memberof TicketError
     * @instance
     */
    TicketError.prototype.SelectionId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * TicketError Text.
     * @member {string} Text
     * @memberof TicketError
     * @instance
     */
    TicketError.prototype.Text = "";

    /**
     * TicketError Type.
     * @member {TicketErrorType} Type
     * @memberof TicketError
     * @instance
     */
    TicketError.prototype.Type = 0;

    /**
     * Creates a new TicketError instance using the specified properties.
     * @function create
     * @memberof TicketError
     * @static
     * @param {ITicketError=} [properties] Properties to set
     * @returns {TicketError} TicketError instance
     */
    TicketError.create = function create(properties) {
        return new TicketError(properties);
    };

    /**
     * Encodes the specified TicketError message. Does not implicitly {@link TicketError.verify|verify} messages.
     * @function encode
     * @memberof TicketError
     * @static
     * @param {ITicketError} message TicketError message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TicketError.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.SelectionId != null && message.hasOwnProperty("SelectionId"))
            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.SelectionId);
        if (message.Text != null && message.hasOwnProperty("Text"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.Text);
        if (message.Type != null && message.hasOwnProperty("Type"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.Type);
        return writer;
    };

    /**
     * Encodes the specified TicketError message, length delimited. Does not implicitly {@link TicketError.verify|verify} messages.
     * @function encodeDelimited
     * @memberof TicketError
     * @static
     * @param {ITicketError} message TicketError message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TicketError.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TicketError message from the specified reader or buffer.
     * @function decode
     * @memberof TicketError
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TicketError} TicketError
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TicketError.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TicketError();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.SelectionId = reader.int64();
                break;
            case 2:
                message.Text = reader.string();
                break;
            case 3:
                message.Type = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a TicketError message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof TicketError
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {TicketError} TicketError
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TicketError.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TicketError message.
     * @function verify
     * @memberof TicketError
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TicketError.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.SelectionId != null && message.hasOwnProperty("SelectionId"))
            if (!$util.isInteger(message.SelectionId) && !(message.SelectionId && $util.isInteger(message.SelectionId.low) && $util.isInteger(message.SelectionId.high)))
                return "SelectionId: integer|Long expected";
        if (message.Text != null && message.hasOwnProperty("Text"))
            if (!$util.isString(message.Text))
                return "Text: string expected";
        if (message.Type != null && message.hasOwnProperty("Type"))
            switch (message.Type) {
            default:
                return "Type: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
                break;
            }
        return null;
    };

    /**
     * Creates a TicketError message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TicketError
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TicketError} TicketError
     */
    TicketError.fromObject = function fromObject(object) {
        if (object instanceof $root.TicketError)
            return object;
        var message = new $root.TicketError();
        if (object.SelectionId != null)
            if ($util.Long)
                (message.SelectionId = $util.Long.fromValue(object.SelectionId)).unsigned = false;
            else if (typeof object.SelectionId === "string")
                message.SelectionId = parseInt(object.SelectionId, 10);
            else if (typeof object.SelectionId === "number")
                message.SelectionId = object.SelectionId;
            else if (typeof object.SelectionId === "object")
                message.SelectionId = new $util.LongBits(object.SelectionId.low >>> 0, object.SelectionId.high >>> 0).toNumber();
        if (object.Text != null)
            message.Text = String(object.Text);
        switch (object.Type) {
        case "Other":
        case 0:
            message.Type = 0;
            break;
        case "SelectionInvalid":
        case 1:
            message.Type = 1;
            break;
        case "NotPossibleToCombineSelection":
        case 2:
            message.Type = 2;
            break;
        case "SelectionRateChanged":
        case 3:
            message.Type = 3;
            break;
        }
        return message;
    };

    /**
     * Creates a plain object from a TicketError message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TicketError
     * @static
     * @param {TicketError} message TicketError
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TicketError.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.SelectionId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.SelectionId = options.longs === String ? "0" : 0;
            object.Text = "";
            object.Type = options.enums === String ? "Other" : 0;
        }
        if (message.SelectionId != null && message.hasOwnProperty("SelectionId"))
            if (typeof message.SelectionId === "number")
                object.SelectionId = options.longs === String ? String(message.SelectionId) : message.SelectionId;
            else
                object.SelectionId = options.longs === String ? $util.Long.prototype.toString.call(message.SelectionId) : options.longs === Number ? new $util.LongBits(message.SelectionId.low >>> 0, message.SelectionId.high >>> 0).toNumber() : message.SelectionId;
        if (message.Text != null && message.hasOwnProperty("Text"))
            object.Text = message.Text;
        if (message.Type != null && message.hasOwnProperty("Type"))
            object.Type = options.enums === String ? $root.TicketErrorType[message.Type] : message.Type;
        return object;
    };

    /**
     * Converts this TicketError to JSON.
     * @function toJSON
     * @memberof TicketError
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TicketError.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TicketError;
})();

$root.TicketConfirmResponse = (function() {

    /**
     * Properties of a TicketConfirmResponse.
     * @exports ITicketConfirmResponse
     * @interface ITicketConfirmResponse
     * @property {ResultType|null} [ResultType] TicketConfirmResponse ResultType
     * @property {IMoneyOrPoints|null} [ProposedStake] TicketConfirmResponse ProposedStake
     * @property {IMoneyOrPoints|null} [ProposedStakeRounded] TicketConfirmResponse ProposedStakeRounded
     * @property {ITicketResponse|null} [Ticket] TicketConfirmResponse Ticket
     * @property {ITimestamp|null} [PlacementDate] TicketConfirmResponse PlacementDate
     * @property {number|null} [VoucherId] TicketConfirmResponse VoucherId
     */

    /**
     * Constructs a new TicketConfirmResponse.
     * @exports TicketConfirmResponse
     * @classdesc Represents a TicketConfirmResponse.
     * @implements ITicketConfirmResponse
     * @constructor
     * @param {ITicketConfirmResponse=} [properties] Properties to set
     */
    function TicketConfirmResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * TicketConfirmResponse ResultType.
     * @member {ResultType} ResultType
     * @memberof TicketConfirmResponse
     * @instance
     */
    TicketConfirmResponse.prototype.ResultType = 0;

    /**
     * TicketConfirmResponse ProposedStake.
     * @member {IMoneyOrPoints|null|undefined} ProposedStake
     * @memberof TicketConfirmResponse
     * @instance
     */
    TicketConfirmResponse.prototype.ProposedStake = null;

    /**
     * TicketConfirmResponse ProposedStakeRounded.
     * @member {IMoneyOrPoints|null|undefined} ProposedStakeRounded
     * @memberof TicketConfirmResponse
     * @instance
     */
    TicketConfirmResponse.prototype.ProposedStakeRounded = null;

    /**
     * TicketConfirmResponse Ticket.
     * @member {ITicketResponse|null|undefined} Ticket
     * @memberof TicketConfirmResponse
     * @instance
     */
    TicketConfirmResponse.prototype.Ticket = null;

    /**
     * TicketConfirmResponse PlacementDate.
     * @member {ITimestamp|null|undefined} PlacementDate
     * @memberof TicketConfirmResponse
     * @instance
     */
    TicketConfirmResponse.prototype.PlacementDate = null;

    /**
     * TicketConfirmResponse VoucherId.
     * @member {number} VoucherId
     * @memberof TicketConfirmResponse
     * @instance
     */
    TicketConfirmResponse.prototype.VoucherId = 0;

    /**
     * Creates a new TicketConfirmResponse instance using the specified properties.
     * @function create
     * @memberof TicketConfirmResponse
     * @static
     * @param {ITicketConfirmResponse=} [properties] Properties to set
     * @returns {TicketConfirmResponse} TicketConfirmResponse instance
     */
    TicketConfirmResponse.create = function create(properties) {
        return new TicketConfirmResponse(properties);
    };

    /**
     * Encodes the specified TicketConfirmResponse message. Does not implicitly {@link TicketConfirmResponse.verify|verify} messages.
     * @function encode
     * @memberof TicketConfirmResponse
     * @static
     * @param {ITicketConfirmResponse} message TicketConfirmResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TicketConfirmResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ResultType != null && message.hasOwnProperty("ResultType"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.ResultType);
        if (message.ProposedStake != null && message.hasOwnProperty("ProposedStake"))
            $root.MoneyOrPoints.encode(message.ProposedStake, writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        if (message.ProposedStakeRounded != null && message.hasOwnProperty("ProposedStakeRounded"))
            $root.MoneyOrPoints.encode(message.ProposedStakeRounded, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        if (message.Ticket != null && message.hasOwnProperty("Ticket"))
            $root.TicketResponse.encode(message.Ticket, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        if (message.PlacementDate != null && message.hasOwnProperty("PlacementDate"))
            $root.Timestamp.encode(message.PlacementDate, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
        if (message.VoucherId != null && message.hasOwnProperty("VoucherId"))
            writer.uint32(/* id 6, wireType 0 =*/48).int32(message.VoucherId);
        return writer;
    };

    /**
     * Encodes the specified TicketConfirmResponse message, length delimited. Does not implicitly {@link TicketConfirmResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof TicketConfirmResponse
     * @static
     * @param {ITicketConfirmResponse} message TicketConfirmResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TicketConfirmResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TicketConfirmResponse message from the specified reader or buffer.
     * @function decode
     * @memberof TicketConfirmResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TicketConfirmResponse} TicketConfirmResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TicketConfirmResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TicketConfirmResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.ResultType = reader.int32();
                break;
            case 2:
                message.ProposedStake = $root.MoneyOrPoints.decode(reader, reader.uint32());
                break;
            case 3:
                message.ProposedStakeRounded = $root.MoneyOrPoints.decode(reader, reader.uint32());
                break;
            case 4:
                message.Ticket = $root.TicketResponse.decode(reader, reader.uint32());
                break;
            case 5:
                message.PlacementDate = $root.Timestamp.decode(reader, reader.uint32());
                break;
            case 6:
                message.VoucherId = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a TicketConfirmResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof TicketConfirmResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {TicketConfirmResponse} TicketConfirmResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TicketConfirmResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TicketConfirmResponse message.
     * @function verify
     * @memberof TicketConfirmResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TicketConfirmResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ResultType != null && message.hasOwnProperty("ResultType"))
            switch (message.ResultType) {
            default:
                return "ResultType: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
                break;
            }
        if (message.ProposedStake != null && message.hasOwnProperty("ProposedStake")) {
            var error = $root.MoneyOrPoints.verify(message.ProposedStake);
            if (error)
                return "ProposedStake." + error;
        }
        if (message.ProposedStakeRounded != null && message.hasOwnProperty("ProposedStakeRounded")) {
            var error = $root.MoneyOrPoints.verify(message.ProposedStakeRounded);
            if (error)
                return "ProposedStakeRounded." + error;
        }
        if (message.Ticket != null && message.hasOwnProperty("Ticket")) {
            var error = $root.TicketResponse.verify(message.Ticket);
            if (error)
                return "Ticket." + error;
        }
        if (message.PlacementDate != null && message.hasOwnProperty("PlacementDate")) {
            var error = $root.Timestamp.verify(message.PlacementDate);
            if (error)
                return "PlacementDate." + error;
        }
        if (message.VoucherId != null && message.hasOwnProperty("VoucherId"))
            if (!$util.isInteger(message.VoucherId))
                return "VoucherId: integer expected";
        return null;
    };

    /**
     * Creates a TicketConfirmResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TicketConfirmResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TicketConfirmResponse} TicketConfirmResponse
     */
    TicketConfirmResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.TicketConfirmResponse)
            return object;
        var message = new $root.TicketConfirmResponse();
        switch (object.ResultType) {
        case "None":
        case 0:
            message.ResultType = 0;
            break;
        case "Fail":
        case 1:
            message.ResultType = 1;
            break;
        case "FailWithHint":
        case 2:
            message.ResultType = 2;
            break;
        case "Success":
        case 3:
            message.ResultType = 3;
            break;
        }
        if (object.ProposedStake != null) {
            if (typeof object.ProposedStake !== "object")
                throw TypeError(".TicketConfirmResponse.ProposedStake: object expected");
            message.ProposedStake = $root.MoneyOrPoints.fromObject(object.ProposedStake);
        }
        if (object.ProposedStakeRounded != null) {
            if (typeof object.ProposedStakeRounded !== "object")
                throw TypeError(".TicketConfirmResponse.ProposedStakeRounded: object expected");
            message.ProposedStakeRounded = $root.MoneyOrPoints.fromObject(object.ProposedStakeRounded);
        }
        if (object.Ticket != null) {
            if (typeof object.Ticket !== "object")
                throw TypeError(".TicketConfirmResponse.Ticket: object expected");
            message.Ticket = $root.TicketResponse.fromObject(object.Ticket);
        }
        if (object.PlacementDate != null) {
            if (typeof object.PlacementDate !== "object")
                throw TypeError(".TicketConfirmResponse.PlacementDate: object expected");
            message.PlacementDate = $root.Timestamp.fromObject(object.PlacementDate);
        }
        if (object.VoucherId != null)
            message.VoucherId = object.VoucherId | 0;
        return message;
    };

    /**
     * Creates a plain object from a TicketConfirmResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TicketConfirmResponse
     * @static
     * @param {TicketConfirmResponse} message TicketConfirmResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TicketConfirmResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.ResultType = options.enums === String ? "None" : 0;
            object.ProposedStake = null;
            object.ProposedStakeRounded = null;
            object.Ticket = null;
            object.PlacementDate = null;
            object.VoucherId = 0;
        }
        if (message.ResultType != null && message.hasOwnProperty("ResultType"))
            object.ResultType = options.enums === String ? $root.ResultType[message.ResultType] : message.ResultType;
        if (message.ProposedStake != null && message.hasOwnProperty("ProposedStake"))
            object.ProposedStake = $root.MoneyOrPoints.toObject(message.ProposedStake, options);
        if (message.ProposedStakeRounded != null && message.hasOwnProperty("ProposedStakeRounded"))
            object.ProposedStakeRounded = $root.MoneyOrPoints.toObject(message.ProposedStakeRounded, options);
        if (message.Ticket != null && message.hasOwnProperty("Ticket"))
            object.Ticket = $root.TicketResponse.toObject(message.Ticket, options);
        if (message.PlacementDate != null && message.hasOwnProperty("PlacementDate"))
            object.PlacementDate = $root.Timestamp.toObject(message.PlacementDate, options);
        if (message.VoucherId != null && message.hasOwnProperty("VoucherId"))
            object.VoucherId = message.VoucherId;
        return object;
    };

    /**
     * Converts this TicketConfirmResponse to JSON.
     * @function toJSON
     * @memberof TicketConfirmResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TicketConfirmResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TicketConfirmResponse;
})();

$root.TicketPrepareResponse = (function() {

    /**
     * Properties of a TicketPrepareResponse.
     * @exports ITicketPrepareResponse
     * @interface ITicketPrepareResponse
     * @property {ResultType|null} [ResultType] TicketPrepareResponse ResultType
     * @property {string|null} [Number] TicketPrepareResponse Number
     * @property {ITimestamp|null} [ExpirationDate] TicketPrepareResponse ExpirationDate
     * @property {ITicketResponse|null} [Ticket] TicketPrepareResponse Ticket
     */

    /**
     * Constructs a new TicketPrepareResponse.
     * @exports TicketPrepareResponse
     * @classdesc Represents a TicketPrepareResponse.
     * @implements ITicketPrepareResponse
     * @constructor
     * @param {ITicketPrepareResponse=} [properties] Properties to set
     */
    function TicketPrepareResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * TicketPrepareResponse ResultType.
     * @member {ResultType} ResultType
     * @memberof TicketPrepareResponse
     * @instance
     */
    TicketPrepareResponse.prototype.ResultType = 0;

    /**
     * TicketPrepareResponse Number.
     * @member {string} Number
     * @memberof TicketPrepareResponse
     * @instance
     */
    TicketPrepareResponse.prototype.Number = "";

    /**
     * TicketPrepareResponse ExpirationDate.
     * @member {ITimestamp|null|undefined} ExpirationDate
     * @memberof TicketPrepareResponse
     * @instance
     */
    TicketPrepareResponse.prototype.ExpirationDate = null;

    /**
     * TicketPrepareResponse Ticket.
     * @member {ITicketResponse|null|undefined} Ticket
     * @memberof TicketPrepareResponse
     * @instance
     */
    TicketPrepareResponse.prototype.Ticket = null;

    /**
     * Creates a new TicketPrepareResponse instance using the specified properties.
     * @function create
     * @memberof TicketPrepareResponse
     * @static
     * @param {ITicketPrepareResponse=} [properties] Properties to set
     * @returns {TicketPrepareResponse} TicketPrepareResponse instance
     */
    TicketPrepareResponse.create = function create(properties) {
        return new TicketPrepareResponse(properties);
    };

    /**
     * Encodes the specified TicketPrepareResponse message. Does not implicitly {@link TicketPrepareResponse.verify|verify} messages.
     * @function encode
     * @memberof TicketPrepareResponse
     * @static
     * @param {ITicketPrepareResponse} message TicketPrepareResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TicketPrepareResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ResultType != null && message.hasOwnProperty("ResultType"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.ResultType);
        if (message.Number != null && message.hasOwnProperty("Number"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.Number);
        if (message.ExpirationDate != null && message.hasOwnProperty("ExpirationDate"))
            $root.Timestamp.encode(message.ExpirationDate, writer.uint32(/* id 3, wireType 2 =*/26).fork()).ldelim();
        if (message.Ticket != null && message.hasOwnProperty("Ticket"))
            $root.TicketResponse.encode(message.Ticket, writer.uint32(/* id 4, wireType 2 =*/34).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified TicketPrepareResponse message, length delimited. Does not implicitly {@link TicketPrepareResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof TicketPrepareResponse
     * @static
     * @param {ITicketPrepareResponse} message TicketPrepareResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TicketPrepareResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TicketPrepareResponse message from the specified reader or buffer.
     * @function decode
     * @memberof TicketPrepareResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TicketPrepareResponse} TicketPrepareResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TicketPrepareResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TicketPrepareResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.ResultType = reader.int32();
                break;
            case 2:
                message.Number = reader.string();
                break;
            case 3:
                message.ExpirationDate = $root.Timestamp.decode(reader, reader.uint32());
                break;
            case 4:
                message.Ticket = $root.TicketResponse.decode(reader, reader.uint32());
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a TicketPrepareResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof TicketPrepareResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {TicketPrepareResponse} TicketPrepareResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TicketPrepareResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TicketPrepareResponse message.
     * @function verify
     * @memberof TicketPrepareResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TicketPrepareResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ResultType != null && message.hasOwnProperty("ResultType"))
            switch (message.ResultType) {
            default:
                return "ResultType: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
                break;
            }
        if (message.Number != null && message.hasOwnProperty("Number"))
            if (!$util.isString(message.Number))
                return "Number: string expected";
        if (message.ExpirationDate != null && message.hasOwnProperty("ExpirationDate")) {
            var error = $root.Timestamp.verify(message.ExpirationDate);
            if (error)
                return "ExpirationDate." + error;
        }
        if (message.Ticket != null && message.hasOwnProperty("Ticket")) {
            var error = $root.TicketResponse.verify(message.Ticket);
            if (error)
                return "Ticket." + error;
        }
        return null;
    };

    /**
     * Creates a TicketPrepareResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TicketPrepareResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TicketPrepareResponse} TicketPrepareResponse
     */
    TicketPrepareResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.TicketPrepareResponse)
            return object;
        var message = new $root.TicketPrepareResponse();
        switch (object.ResultType) {
        case "None":
        case 0:
            message.ResultType = 0;
            break;
        case "Fail":
        case 1:
            message.ResultType = 1;
            break;
        case "FailWithHint":
        case 2:
            message.ResultType = 2;
            break;
        case "Success":
        case 3:
            message.ResultType = 3;
            break;
        }
        if (object.Number != null)
            message.Number = String(object.Number);
        if (object.ExpirationDate != null) {
            if (typeof object.ExpirationDate !== "object")
                throw TypeError(".TicketPrepareResponse.ExpirationDate: object expected");
            message.ExpirationDate = $root.Timestamp.fromObject(object.ExpirationDate);
        }
        if (object.Ticket != null) {
            if (typeof object.Ticket !== "object")
                throw TypeError(".TicketPrepareResponse.Ticket: object expected");
            message.Ticket = $root.TicketResponse.fromObject(object.Ticket);
        }
        return message;
    };

    /**
     * Creates a plain object from a TicketPrepareResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TicketPrepareResponse
     * @static
     * @param {TicketPrepareResponse} message TicketPrepareResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TicketPrepareResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.ResultType = options.enums === String ? "None" : 0;
            object.Number = "";
            object.ExpirationDate = null;
            object.Ticket = null;
        }
        if (message.ResultType != null && message.hasOwnProperty("ResultType"))
            object.ResultType = options.enums === String ? $root.ResultType[message.ResultType] : message.ResultType;
        if (message.Number != null && message.hasOwnProperty("Number"))
            object.Number = message.Number;
        if (message.ExpirationDate != null && message.hasOwnProperty("ExpirationDate"))
            object.ExpirationDate = $root.Timestamp.toObject(message.ExpirationDate, options);
        if (message.Ticket != null && message.hasOwnProperty("Ticket"))
            object.Ticket = $root.TicketResponse.toObject(message.Ticket, options);
        return object;
    };

    /**
     * Converts this TicketPrepareResponse to JSON.
     * @function toJSON
     * @memberof TicketPrepareResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TicketPrepareResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TicketPrepareResponse;
})();

$root.PreparedSelection = (function() {

    /**
     * Properties of a PreparedSelection.
     * @exports IPreparedSelection
     * @interface IPreparedSelection
     * @property {boolean|null} [IsValid] PreparedSelection IsValid
     * @property {number|Long|null} [SelectionId] PreparedSelection SelectionId
     * @property {number|Long|null} [FixtureId] PreparedSelection FixtureId
     * @property {number|null} [OriginalRate] PreparedSelection OriginalRate
     * @property {number|null} [CurrentRate] PreparedSelection CurrentRate
     * @property {string|null} [FixtureName] PreparedSelection FixtureName
     * @property {number|Long|null} [Number] PreparedSelection Number
     * @property {string|null} [SportName] PreparedSelection SportName
     * @property {string|null} [RegionName] PreparedSelection RegionName
     * @property {string|null} [TournamentName] PreparedSelection TournamentName
     * @property {string|null} [SelectionName] PreparedSelection SelectionName
     * @property {string|null} [MarketName] PreparedSelection MarketName
     */

    /**
     * Constructs a new PreparedSelection.
     * @exports PreparedSelection
     * @classdesc Represents a PreparedSelection.
     * @implements IPreparedSelection
     * @constructor
     * @param {IPreparedSelection=} [properties] Properties to set
     */
    function PreparedSelection(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PreparedSelection IsValid.
     * @member {boolean} IsValid
     * @memberof PreparedSelection
     * @instance
     */
    PreparedSelection.prototype.IsValid = false;

    /**
     * PreparedSelection SelectionId.
     * @member {number|Long} SelectionId
     * @memberof PreparedSelection
     * @instance
     */
    PreparedSelection.prototype.SelectionId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * PreparedSelection FixtureId.
     * @member {number|Long} FixtureId
     * @memberof PreparedSelection
     * @instance
     */
    PreparedSelection.prototype.FixtureId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * PreparedSelection OriginalRate.
     * @member {number} OriginalRate
     * @memberof PreparedSelection
     * @instance
     */
    PreparedSelection.prototype.OriginalRate = 0;

    /**
     * PreparedSelection CurrentRate.
     * @member {number} CurrentRate
     * @memberof PreparedSelection
     * @instance
     */
    PreparedSelection.prototype.CurrentRate = 0;

    /**
     * PreparedSelection FixtureName.
     * @member {string} FixtureName
     * @memberof PreparedSelection
     * @instance
     */
    PreparedSelection.prototype.FixtureName = "";

    /**
     * PreparedSelection Number.
     * @member {number|Long} Number
     * @memberof PreparedSelection
     * @instance
     */
    PreparedSelection.prototype.Number = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * PreparedSelection SportName.
     * @member {string} SportName
     * @memberof PreparedSelection
     * @instance
     */
    PreparedSelection.prototype.SportName = "";

    /**
     * PreparedSelection RegionName.
     * @member {string} RegionName
     * @memberof PreparedSelection
     * @instance
     */
    PreparedSelection.prototype.RegionName = "";

    /**
     * PreparedSelection TournamentName.
     * @member {string} TournamentName
     * @memberof PreparedSelection
     * @instance
     */
    PreparedSelection.prototype.TournamentName = "";

    /**
     * PreparedSelection SelectionName.
     * @member {string} SelectionName
     * @memberof PreparedSelection
     * @instance
     */
    PreparedSelection.prototype.SelectionName = "";

    /**
     * PreparedSelection MarketName.
     * @member {string} MarketName
     * @memberof PreparedSelection
     * @instance
     */
    PreparedSelection.prototype.MarketName = "";

    /**
     * Creates a new PreparedSelection instance using the specified properties.
     * @function create
     * @memberof PreparedSelection
     * @static
     * @param {IPreparedSelection=} [properties] Properties to set
     * @returns {PreparedSelection} PreparedSelection instance
     */
    PreparedSelection.create = function create(properties) {
        return new PreparedSelection(properties);
    };

    /**
     * Encodes the specified PreparedSelection message. Does not implicitly {@link PreparedSelection.verify|verify} messages.
     * @function encode
     * @memberof PreparedSelection
     * @static
     * @param {IPreparedSelection} message PreparedSelection message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PreparedSelection.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.IsValid != null && message.hasOwnProperty("IsValid"))
            writer.uint32(/* id 1, wireType 0 =*/8).bool(message.IsValid);
        if (message.SelectionId != null && message.hasOwnProperty("SelectionId"))
            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.SelectionId);
        if (message.FixtureId != null && message.hasOwnProperty("FixtureId"))
            writer.uint32(/* id 3, wireType 0 =*/24).int64(message.FixtureId);
        if (message.OriginalRate != null && message.hasOwnProperty("OriginalRate"))
            writer.uint32(/* id 4, wireType 1 =*/33).double(message.OriginalRate);
        if (message.CurrentRate != null && message.hasOwnProperty("CurrentRate"))
            writer.uint32(/* id 5, wireType 1 =*/41).double(message.CurrentRate);
        if (message.FixtureName != null && message.hasOwnProperty("FixtureName"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.FixtureName);
        if (message.Number != null && message.hasOwnProperty("Number"))
            writer.uint32(/* id 7, wireType 0 =*/56).int64(message.Number);
        if (message.SportName != null && message.hasOwnProperty("SportName"))
            writer.uint32(/* id 8, wireType 2 =*/66).string(message.SportName);
        if (message.RegionName != null && message.hasOwnProperty("RegionName"))
            writer.uint32(/* id 9, wireType 2 =*/74).string(message.RegionName);
        if (message.TournamentName != null && message.hasOwnProperty("TournamentName"))
            writer.uint32(/* id 10, wireType 2 =*/82).string(message.TournamentName);
        if (message.SelectionName != null && message.hasOwnProperty("SelectionName"))
            writer.uint32(/* id 11, wireType 2 =*/90).string(message.SelectionName);
        if (message.MarketName != null && message.hasOwnProperty("MarketName"))
            writer.uint32(/* id 12, wireType 2 =*/98).string(message.MarketName);
        return writer;
    };

    /**
     * Encodes the specified PreparedSelection message, length delimited. Does not implicitly {@link PreparedSelection.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PreparedSelection
     * @static
     * @param {IPreparedSelection} message PreparedSelection message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PreparedSelection.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PreparedSelection message from the specified reader or buffer.
     * @function decode
     * @memberof PreparedSelection
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PreparedSelection} PreparedSelection
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PreparedSelection.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PreparedSelection();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.IsValid = reader.bool();
                break;
            case 2:
                message.SelectionId = reader.int64();
                break;
            case 3:
                message.FixtureId = reader.int64();
                break;
            case 4:
                message.OriginalRate = reader.double();
                break;
            case 5:
                message.CurrentRate = reader.double();
                break;
            case 6:
                message.FixtureName = reader.string();
                break;
            case 7:
                message.Number = reader.int64();
                break;
            case 8:
                message.SportName = reader.string();
                break;
            case 9:
                message.RegionName = reader.string();
                break;
            case 10:
                message.TournamentName = reader.string();
                break;
            case 11:
                message.SelectionName = reader.string();
                break;
            case 12:
                message.MarketName = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PreparedSelection message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PreparedSelection
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PreparedSelection} PreparedSelection
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PreparedSelection.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PreparedSelection message.
     * @function verify
     * @memberof PreparedSelection
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PreparedSelection.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.IsValid != null && message.hasOwnProperty("IsValid"))
            if (typeof message.IsValid !== "boolean")
                return "IsValid: boolean expected";
        if (message.SelectionId != null && message.hasOwnProperty("SelectionId"))
            if (!$util.isInteger(message.SelectionId) && !(message.SelectionId && $util.isInteger(message.SelectionId.low) && $util.isInteger(message.SelectionId.high)))
                return "SelectionId: integer|Long expected";
        if (message.FixtureId != null && message.hasOwnProperty("FixtureId"))
            if (!$util.isInteger(message.FixtureId) && !(message.FixtureId && $util.isInteger(message.FixtureId.low) && $util.isInteger(message.FixtureId.high)))
                return "FixtureId: integer|Long expected";
        if (message.OriginalRate != null && message.hasOwnProperty("OriginalRate"))
            if (typeof message.OriginalRate !== "number")
                return "OriginalRate: number expected";
        if (message.CurrentRate != null && message.hasOwnProperty("CurrentRate"))
            if (typeof message.CurrentRate !== "number")
                return "CurrentRate: number expected";
        if (message.FixtureName != null && message.hasOwnProperty("FixtureName"))
            if (!$util.isString(message.FixtureName))
                return "FixtureName: string expected";
        if (message.Number != null && message.hasOwnProperty("Number"))
            if (!$util.isInteger(message.Number) && !(message.Number && $util.isInteger(message.Number.low) && $util.isInteger(message.Number.high)))
                return "Number: integer|Long expected";
        if (message.SportName != null && message.hasOwnProperty("SportName"))
            if (!$util.isString(message.SportName))
                return "SportName: string expected";
        if (message.RegionName != null && message.hasOwnProperty("RegionName"))
            if (!$util.isString(message.RegionName))
                return "RegionName: string expected";
        if (message.TournamentName != null && message.hasOwnProperty("TournamentName"))
            if (!$util.isString(message.TournamentName))
                return "TournamentName: string expected";
        if (message.SelectionName != null && message.hasOwnProperty("SelectionName"))
            if (!$util.isString(message.SelectionName))
                return "SelectionName: string expected";
        if (message.MarketName != null && message.hasOwnProperty("MarketName"))
            if (!$util.isString(message.MarketName))
                return "MarketName: string expected";
        return null;
    };

    /**
     * Creates a PreparedSelection message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PreparedSelection
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PreparedSelection} PreparedSelection
     */
    PreparedSelection.fromObject = function fromObject(object) {
        if (object instanceof $root.PreparedSelection)
            return object;
        var message = new $root.PreparedSelection();
        if (object.IsValid != null)
            message.IsValid = Boolean(object.IsValid);
        if (object.SelectionId != null)
            if ($util.Long)
                (message.SelectionId = $util.Long.fromValue(object.SelectionId)).unsigned = false;
            else if (typeof object.SelectionId === "string")
                message.SelectionId = parseInt(object.SelectionId, 10);
            else if (typeof object.SelectionId === "number")
                message.SelectionId = object.SelectionId;
            else if (typeof object.SelectionId === "object")
                message.SelectionId = new $util.LongBits(object.SelectionId.low >>> 0, object.SelectionId.high >>> 0).toNumber();
        if (object.FixtureId != null)
            if ($util.Long)
                (message.FixtureId = $util.Long.fromValue(object.FixtureId)).unsigned = false;
            else if (typeof object.FixtureId === "string")
                message.FixtureId = parseInt(object.FixtureId, 10);
            else if (typeof object.FixtureId === "number")
                message.FixtureId = object.FixtureId;
            else if (typeof object.FixtureId === "object")
                message.FixtureId = new $util.LongBits(object.FixtureId.low >>> 0, object.FixtureId.high >>> 0).toNumber();
        if (object.OriginalRate != null)
            message.OriginalRate = Number(object.OriginalRate);
        if (object.CurrentRate != null)
            message.CurrentRate = Number(object.CurrentRate);
        if (object.FixtureName != null)
            message.FixtureName = String(object.FixtureName);
        if (object.Number != null)
            if ($util.Long)
                (message.Number = $util.Long.fromValue(object.Number)).unsigned = false;
            else if (typeof object.Number === "string")
                message.Number = parseInt(object.Number, 10);
            else if (typeof object.Number === "number")
                message.Number = object.Number;
            else if (typeof object.Number === "object")
                message.Number = new $util.LongBits(object.Number.low >>> 0, object.Number.high >>> 0).toNumber();
        if (object.SportName != null)
            message.SportName = String(object.SportName);
        if (object.RegionName != null)
            message.RegionName = String(object.RegionName);
        if (object.TournamentName != null)
            message.TournamentName = String(object.TournamentName);
        if (object.SelectionName != null)
            message.SelectionName = String(object.SelectionName);
        if (object.MarketName != null)
            message.MarketName = String(object.MarketName);
        return message;
    };

    /**
     * Creates a plain object from a PreparedSelection message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PreparedSelection
     * @static
     * @param {PreparedSelection} message PreparedSelection
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PreparedSelection.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.IsValid = false;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.SelectionId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.SelectionId = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.FixtureId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.FixtureId = options.longs === String ? "0" : 0;
            object.OriginalRate = 0;
            object.CurrentRate = 0;
            object.FixtureName = "";
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.Number = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.Number = options.longs === String ? "0" : 0;
            object.SportName = "";
            object.RegionName = "";
            object.TournamentName = "";
            object.SelectionName = "";
            object.MarketName = "";
        }
        if (message.IsValid != null && message.hasOwnProperty("IsValid"))
            object.IsValid = message.IsValid;
        if (message.SelectionId != null && message.hasOwnProperty("SelectionId"))
            if (typeof message.SelectionId === "number")
                object.SelectionId = options.longs === String ? String(message.SelectionId) : message.SelectionId;
            else
                object.SelectionId = options.longs === String ? $util.Long.prototype.toString.call(message.SelectionId) : options.longs === Number ? new $util.LongBits(message.SelectionId.low >>> 0, message.SelectionId.high >>> 0).toNumber() : message.SelectionId;
        if (message.FixtureId != null && message.hasOwnProperty("FixtureId"))
            if (typeof message.FixtureId === "number")
                object.FixtureId = options.longs === String ? String(message.FixtureId) : message.FixtureId;
            else
                object.FixtureId = options.longs === String ? $util.Long.prototype.toString.call(message.FixtureId) : options.longs === Number ? new $util.LongBits(message.FixtureId.low >>> 0, message.FixtureId.high >>> 0).toNumber() : message.FixtureId;
        if (message.OriginalRate != null && message.hasOwnProperty("OriginalRate"))
            object.OriginalRate = options.json && !isFinite(message.OriginalRate) ? String(message.OriginalRate) : message.OriginalRate;
        if (message.CurrentRate != null && message.hasOwnProperty("CurrentRate"))
            object.CurrentRate = options.json && !isFinite(message.CurrentRate) ? String(message.CurrentRate) : message.CurrentRate;
        if (message.FixtureName != null && message.hasOwnProperty("FixtureName"))
            object.FixtureName = message.FixtureName;
        if (message.Number != null && message.hasOwnProperty("Number"))
            if (typeof message.Number === "number")
                object.Number = options.longs === String ? String(message.Number) : message.Number;
            else
                object.Number = options.longs === String ? $util.Long.prototype.toString.call(message.Number) : options.longs === Number ? new $util.LongBits(message.Number.low >>> 0, message.Number.high >>> 0).toNumber() : message.Number;
        if (message.SportName != null && message.hasOwnProperty("SportName"))
            object.SportName = message.SportName;
        if (message.RegionName != null && message.hasOwnProperty("RegionName"))
            object.RegionName = message.RegionName;
        if (message.TournamentName != null && message.hasOwnProperty("TournamentName"))
            object.TournamentName = message.TournamentName;
        if (message.SelectionName != null && message.hasOwnProperty("SelectionName"))
            object.SelectionName = message.SelectionName;
        if (message.MarketName != null && message.hasOwnProperty("MarketName"))
            object.MarketName = message.MarketName;
        return object;
    };

    /**
     * Converts this PreparedSelection to JSON.
     * @function toJSON
     * @memberof PreparedSelection
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PreparedSelection.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PreparedSelection;
})();

$root.PreparedTicketResponse = (function() {

    /**
     * Properties of a PreparedTicketResponse.
     * @exports IPreparedTicketResponse
     * @interface IPreparedTicketResponse
     * @property {number|null} [Stake] PreparedTicketResponse Stake
     * @property {Array.<IPreparedSelection>|null} [Selections] PreparedTicketResponse Selections
     */

    /**
     * Constructs a new PreparedTicketResponse.
     * @exports PreparedTicketResponse
     * @classdesc Represents a PreparedTicketResponse.
     * @implements IPreparedTicketResponse
     * @constructor
     * @param {IPreparedTicketResponse=} [properties] Properties to set
     */
    function PreparedTicketResponse(properties) {
        this.Selections = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * PreparedTicketResponse Stake.
     * @member {number} Stake
     * @memberof PreparedTicketResponse
     * @instance
     */
    PreparedTicketResponse.prototype.Stake = 0;

    /**
     * PreparedTicketResponse Selections.
     * @member {Array.<IPreparedSelection>} Selections
     * @memberof PreparedTicketResponse
     * @instance
     */
    PreparedTicketResponse.prototype.Selections = $util.emptyArray;

    /**
     * Creates a new PreparedTicketResponse instance using the specified properties.
     * @function create
     * @memberof PreparedTicketResponse
     * @static
     * @param {IPreparedTicketResponse=} [properties] Properties to set
     * @returns {PreparedTicketResponse} PreparedTicketResponse instance
     */
    PreparedTicketResponse.create = function create(properties) {
        return new PreparedTicketResponse(properties);
    };

    /**
     * Encodes the specified PreparedTicketResponse message. Does not implicitly {@link PreparedTicketResponse.verify|verify} messages.
     * @function encode
     * @memberof PreparedTicketResponse
     * @static
     * @param {IPreparedTicketResponse} message PreparedTicketResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PreparedTicketResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Stake != null && message.hasOwnProperty("Stake"))
            writer.uint32(/* id 1, wireType 1 =*/9).double(message.Stake);
        if (message.Selections != null && message.Selections.length)
            for (var i = 0; i < message.Selections.length; ++i)
                $root.PreparedSelection.encode(message.Selections[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified PreparedTicketResponse message, length delimited. Does not implicitly {@link PreparedTicketResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof PreparedTicketResponse
     * @static
     * @param {IPreparedTicketResponse} message PreparedTicketResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    PreparedTicketResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a PreparedTicketResponse message from the specified reader or buffer.
     * @function decode
     * @memberof PreparedTicketResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {PreparedTicketResponse} PreparedTicketResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PreparedTicketResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.PreparedTicketResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Stake = reader.double();
                break;
            case 2:
                if (!(message.Selections && message.Selections.length))
                    message.Selections = [];
                message.Selections.push($root.PreparedSelection.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a PreparedTicketResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof PreparedTicketResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {PreparedTicketResponse} PreparedTicketResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    PreparedTicketResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a PreparedTicketResponse message.
     * @function verify
     * @memberof PreparedTicketResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    PreparedTicketResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Stake != null && message.hasOwnProperty("Stake"))
            if (typeof message.Stake !== "number")
                return "Stake: number expected";
        if (message.Selections != null && message.hasOwnProperty("Selections")) {
            if (!Array.isArray(message.Selections))
                return "Selections: array expected";
            for (var i = 0; i < message.Selections.length; ++i) {
                var error = $root.PreparedSelection.verify(message.Selections[i]);
                if (error)
                    return "Selections." + error;
            }
        }
        return null;
    };

    /**
     * Creates a PreparedTicketResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof PreparedTicketResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {PreparedTicketResponse} PreparedTicketResponse
     */
    PreparedTicketResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.PreparedTicketResponse)
            return object;
        var message = new $root.PreparedTicketResponse();
        if (object.Stake != null)
            message.Stake = Number(object.Stake);
        if (object.Selections) {
            if (!Array.isArray(object.Selections))
                throw TypeError(".PreparedTicketResponse.Selections: array expected");
            message.Selections = [];
            for (var i = 0; i < object.Selections.length; ++i) {
                if (typeof object.Selections[i] !== "object")
                    throw TypeError(".PreparedTicketResponse.Selections: object expected");
                message.Selections[i] = $root.PreparedSelection.fromObject(object.Selections[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a PreparedTicketResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof PreparedTicketResponse
     * @static
     * @param {PreparedTicketResponse} message PreparedTicketResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    PreparedTicketResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.Selections = [];
        if (options.defaults)
            object.Stake = 0;
        if (message.Stake != null && message.hasOwnProperty("Stake"))
            object.Stake = options.json && !isFinite(message.Stake) ? String(message.Stake) : message.Stake;
        if (message.Selections && message.Selections.length) {
            object.Selections = [];
            for (var j = 0; j < message.Selections.length; ++j)
                object.Selections[j] = $root.PreparedSelection.toObject(message.Selections[j], options);
        }
        return object;
    };

    /**
     * Converts this PreparedTicketResponse to JSON.
     * @function toJSON
     * @memberof PreparedTicketResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    PreparedTicketResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return PreparedTicketResponse;
})();

$root.TicketListItemResponse = (function() {

    /**
     * Properties of a TicketListItemResponse.
     * @exports ITicketListItemResponse
     * @interface ITicketListItemResponse
     * @property {number|Long|null} [Id] TicketListItemResponse Id
     * @property {string|null} [SecureId] TicketListItemResponse SecureId
     * @property {OfferType|null} [OfferType] TicketListItemResponse OfferType
     * @property {EvalState|null} [EvalState] TicketListItemResponse EvalState
     * @property {number|null} [StakeValue] TicketListItemResponse StakeValue
     * @property {INullableDouble|null} [StakePoints] TicketListItemResponse StakePoints
     * @property {number|null} [PrizeEvalValue] TicketListItemResponse PrizeEvalValue
     * @property {number|null} [PrizePaidValue] TicketListItemResponse PrizePaidValue
     * @property {ITimestamp|null} [PlacementDate] TicketListItemResponse PlacementDate
     * @property {TicketState|null} [State] TicketListItemResponse State
     * @property {TicketType|null} [TicketType] TicketListItemResponse TicketType
     * @property {number|null} [PrizePotentialValue] TicketListItemResponse PrizePotentialValue
     * @property {string|null} [Number] TicketListItemResponse Number
     */

    /**
     * Constructs a new TicketListItemResponse.
     * @exports TicketListItemResponse
     * @classdesc Represents a TicketListItemResponse.
     * @implements ITicketListItemResponse
     * @constructor
     * @param {ITicketListItemResponse=} [properties] Properties to set
     */
    function TicketListItemResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * TicketListItemResponse Id.
     * @member {number|Long} Id
     * @memberof TicketListItemResponse
     * @instance
     */
    TicketListItemResponse.prototype.Id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * TicketListItemResponse SecureId.
     * @member {string} SecureId
     * @memberof TicketListItemResponse
     * @instance
     */
    TicketListItemResponse.prototype.SecureId = "";

    /**
     * TicketListItemResponse OfferType.
     * @member {OfferType} OfferType
     * @memberof TicketListItemResponse
     * @instance
     */
    TicketListItemResponse.prototype.OfferType = 0;

    /**
     * TicketListItemResponse EvalState.
     * @member {EvalState} EvalState
     * @memberof TicketListItemResponse
     * @instance
     */
    TicketListItemResponse.prototype.EvalState = 0;

    /**
     * TicketListItemResponse StakeValue.
     * @member {number} StakeValue
     * @memberof TicketListItemResponse
     * @instance
     */
    TicketListItemResponse.prototype.StakeValue = 0;

    /**
     * TicketListItemResponse StakePoints.
     * @member {INullableDouble|null|undefined} StakePoints
     * @memberof TicketListItemResponse
     * @instance
     */
    TicketListItemResponse.prototype.StakePoints = null;

    /**
     * TicketListItemResponse PrizeEvalValue.
     * @member {number} PrizeEvalValue
     * @memberof TicketListItemResponse
     * @instance
     */
    TicketListItemResponse.prototype.PrizeEvalValue = 0;

    /**
     * TicketListItemResponse PrizePaidValue.
     * @member {number} PrizePaidValue
     * @memberof TicketListItemResponse
     * @instance
     */
    TicketListItemResponse.prototype.PrizePaidValue = 0;

    /**
     * TicketListItemResponse PlacementDate.
     * @member {ITimestamp|null|undefined} PlacementDate
     * @memberof TicketListItemResponse
     * @instance
     */
    TicketListItemResponse.prototype.PlacementDate = null;

    /**
     * TicketListItemResponse State.
     * @member {TicketState} State
     * @memberof TicketListItemResponse
     * @instance
     */
    TicketListItemResponse.prototype.State = 0;

    /**
     * TicketListItemResponse TicketType.
     * @member {TicketType} TicketType
     * @memberof TicketListItemResponse
     * @instance
     */
    TicketListItemResponse.prototype.TicketType = 0;

    /**
     * TicketListItemResponse PrizePotentialValue.
     * @member {number} PrizePotentialValue
     * @memberof TicketListItemResponse
     * @instance
     */
    TicketListItemResponse.prototype.PrizePotentialValue = 0;

    /**
     * TicketListItemResponse Number.
     * @member {string} Number
     * @memberof TicketListItemResponse
     * @instance
     */
    TicketListItemResponse.prototype.Number = "";

    /**
     * Creates a new TicketListItemResponse instance using the specified properties.
     * @function create
     * @memberof TicketListItemResponse
     * @static
     * @param {ITicketListItemResponse=} [properties] Properties to set
     * @returns {TicketListItemResponse} TicketListItemResponse instance
     */
    TicketListItemResponse.create = function create(properties) {
        return new TicketListItemResponse(properties);
    };

    /**
     * Encodes the specified TicketListItemResponse message. Does not implicitly {@link TicketListItemResponse.verify|verify} messages.
     * @function encode
     * @memberof TicketListItemResponse
     * @static
     * @param {ITicketListItemResponse} message TicketListItemResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TicketListItemResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Id != null && message.hasOwnProperty("Id"))
            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.Id);
        if (message.SecureId != null && message.hasOwnProperty("SecureId"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.SecureId);
        if (message.OfferType != null && message.hasOwnProperty("OfferType"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.OfferType);
        if (message.EvalState != null && message.hasOwnProperty("EvalState"))
            writer.uint32(/* id 4, wireType 0 =*/32).int32(message.EvalState);
        if (message.StakeValue != null && message.hasOwnProperty("StakeValue"))
            writer.uint32(/* id 5, wireType 1 =*/41).double(message.StakeValue);
        if (message.StakePoints != null && message.hasOwnProperty("StakePoints"))
            $root.NullableDouble.encode(message.StakePoints, writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
        if (message.PrizeEvalValue != null && message.hasOwnProperty("PrizeEvalValue"))
            writer.uint32(/* id 7, wireType 1 =*/57).double(message.PrizeEvalValue);
        if (message.PrizePaidValue != null && message.hasOwnProperty("PrizePaidValue"))
            writer.uint32(/* id 8, wireType 1 =*/65).double(message.PrizePaidValue);
        if (message.PlacementDate != null && message.hasOwnProperty("PlacementDate"))
            $root.Timestamp.encode(message.PlacementDate, writer.uint32(/* id 9, wireType 2 =*/74).fork()).ldelim();
        if (message.State != null && message.hasOwnProperty("State"))
            writer.uint32(/* id 10, wireType 0 =*/80).int32(message.State);
        if (message.TicketType != null && message.hasOwnProperty("TicketType"))
            writer.uint32(/* id 11, wireType 0 =*/88).int32(message.TicketType);
        if (message.PrizePotentialValue != null && message.hasOwnProperty("PrizePotentialValue"))
            writer.uint32(/* id 12, wireType 1 =*/97).double(message.PrizePotentialValue);
        if (message.Number != null && message.hasOwnProperty("Number"))
            writer.uint32(/* id 13, wireType 2 =*/106).string(message.Number);
        return writer;
    };

    /**
     * Encodes the specified TicketListItemResponse message, length delimited. Does not implicitly {@link TicketListItemResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof TicketListItemResponse
     * @static
     * @param {ITicketListItemResponse} message TicketListItemResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TicketListItemResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TicketListItemResponse message from the specified reader or buffer.
     * @function decode
     * @memberof TicketListItemResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TicketListItemResponse} TicketListItemResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TicketListItemResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TicketListItemResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Id = reader.int64();
                break;
            case 2:
                message.SecureId = reader.string();
                break;
            case 3:
                message.OfferType = reader.int32();
                break;
            case 4:
                message.EvalState = reader.int32();
                break;
            case 5:
                message.StakeValue = reader.double();
                break;
            case 6:
                message.StakePoints = $root.NullableDouble.decode(reader, reader.uint32());
                break;
            case 7:
                message.PrizeEvalValue = reader.double();
                break;
            case 8:
                message.PrizePaidValue = reader.double();
                break;
            case 9:
                message.PlacementDate = $root.Timestamp.decode(reader, reader.uint32());
                break;
            case 10:
                message.State = reader.int32();
                break;
            case 11:
                message.TicketType = reader.int32();
                break;
            case 12:
                message.PrizePotentialValue = reader.double();
                break;
            case 13:
                message.Number = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a TicketListItemResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof TicketListItemResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {TicketListItemResponse} TicketListItemResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TicketListItemResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TicketListItemResponse message.
     * @function verify
     * @memberof TicketListItemResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TicketListItemResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Id != null && message.hasOwnProperty("Id"))
            if (!$util.isInteger(message.Id) && !(message.Id && $util.isInteger(message.Id.low) && $util.isInteger(message.Id.high)))
                return "Id: integer|Long expected";
        if (message.SecureId != null && message.hasOwnProperty("SecureId"))
            if (!$util.isString(message.SecureId))
                return "SecureId: string expected";
        if (message.OfferType != null && message.hasOwnProperty("OfferType"))
            switch (message.OfferType) {
            default:
                return "OfferType: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.EvalState != null && message.hasOwnProperty("EvalState"))
            switch (message.EvalState) {
            default:
                return "EvalState: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
                break;
            }
        if (message.StakeValue != null && message.hasOwnProperty("StakeValue"))
            if (typeof message.StakeValue !== "number")
                return "StakeValue: number expected";
        if (message.StakePoints != null && message.hasOwnProperty("StakePoints")) {
            var error = $root.NullableDouble.verify(message.StakePoints);
            if (error)
                return "StakePoints." + error;
        }
        if (message.PrizeEvalValue != null && message.hasOwnProperty("PrizeEvalValue"))
            if (typeof message.PrizeEvalValue !== "number")
                return "PrizeEvalValue: number expected";
        if (message.PrizePaidValue != null && message.hasOwnProperty("PrizePaidValue"))
            if (typeof message.PrizePaidValue !== "number")
                return "PrizePaidValue: number expected";
        if (message.PlacementDate != null && message.hasOwnProperty("PlacementDate")) {
            var error = $root.Timestamp.verify(message.PlacementDate);
            if (error)
                return "PlacementDate." + error;
        }
        if (message.State != null && message.hasOwnProperty("State"))
            switch (message.State) {
            default:
                return "State: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
            case 5:
            case 6:
            case 7:
            case 9:
            case 10:
                break;
            }
        if (message.TicketType != null && message.hasOwnProperty("TicketType"))
            switch (message.TicketType) {
            default:
                return "TicketType: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.PrizePotentialValue != null && message.hasOwnProperty("PrizePotentialValue"))
            if (typeof message.PrizePotentialValue !== "number")
                return "PrizePotentialValue: number expected";
        if (message.Number != null && message.hasOwnProperty("Number"))
            if (!$util.isString(message.Number))
                return "Number: string expected";
        return null;
    };

    /**
     * Creates a TicketListItemResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TicketListItemResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TicketListItemResponse} TicketListItemResponse
     */
    TicketListItemResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.TicketListItemResponse)
            return object;
        var message = new $root.TicketListItemResponse();
        if (object.Id != null)
            if ($util.Long)
                (message.Id = $util.Long.fromValue(object.Id)).unsigned = false;
            else if (typeof object.Id === "string")
                message.Id = parseInt(object.Id, 10);
            else if (typeof object.Id === "number")
                message.Id = object.Id;
            else if (typeof object.Id === "object")
                message.Id = new $util.LongBits(object.Id.low >>> 0, object.Id.high >>> 0).toNumber();
        if (object.SecureId != null)
            message.SecureId = String(object.SecureId);
        switch (object.OfferType) {
        case "Prematch":
        case 0:
            message.OfferType = 0;
            break;
        case "Live":
        case 1:
            message.OfferType = 1;
            break;
        }
        switch (object.EvalState) {
        case "None":
        case 0:
            message.EvalState = 0;
            break;
        case "Win":
        case 1:
            message.EvalState = 1;
            break;
        case "Loss":
        case 2:
            message.EvalState = 2;
            break;
        case "Cancel":
        case 3:
            message.EvalState = 3;
            break;
        case "CancelWithHandlingFee":
        case 4:
            message.EvalState = 4;
            break;
        case "Cashout":
        case 5:
            message.EvalState = 5;
            break;
        }
        if (object.StakeValue != null)
            message.StakeValue = Number(object.StakeValue);
        if (object.StakePoints != null) {
            if (typeof object.StakePoints !== "object")
                throw TypeError(".TicketListItemResponse.StakePoints: object expected");
            message.StakePoints = $root.NullableDouble.fromObject(object.StakePoints);
        }
        if (object.PrizeEvalValue != null)
            message.PrizeEvalValue = Number(object.PrizeEvalValue);
        if (object.PrizePaidValue != null)
            message.PrizePaidValue = Number(object.PrizePaidValue);
        if (object.PlacementDate != null) {
            if (typeof object.PlacementDate !== "object")
                throw TypeError(".TicketListItemResponse.PlacementDate: object expected");
            message.PlacementDate = $root.Timestamp.fromObject(object.PlacementDate);
        }
        switch (object.State) {
        case "None":
        case 0:
            message.State = 0;
            break;
        case "Created":
        case 1:
            message.State = 1;
            break;
        case "Paid":
        case 2:
            message.State = 2;
            break;
        case "Accepted":
        case 3:
            message.State = 3;
            break;
        case "Settled":
        case 4:
            message.State = 4;
            break;
        case "Evaluated":
        case 5:
            message.State = 5;
            break;
        case "Storno":
        case 6:
            message.State = 6;
            break;
        case "StornoBySystem":
        case 7:
            message.State = 7;
            break;
        case "StornoByCustomer":
        case 9:
            message.State = 9;
            break;
        case "StornoByMts":
        case 10:
            message.State = 10;
            break;
        }
        switch (object.TicketType) {
        case "None":
        case 0:
            message.TicketType = 0;
            break;
        case "Simple":
        case 1:
            message.TicketType = 1;
            break;
        case "System":
        case 2:
            message.TicketType = 2;
            break;
        }
        if (object.PrizePotentialValue != null)
            message.PrizePotentialValue = Number(object.PrizePotentialValue);
        if (object.Number != null)
            message.Number = String(object.Number);
        return message;
    };

    /**
     * Creates a plain object from a TicketListItemResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TicketListItemResponse
     * @static
     * @param {TicketListItemResponse} message TicketListItemResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TicketListItemResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.Id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.Id = options.longs === String ? "0" : 0;
            object.SecureId = "";
            object.OfferType = options.enums === String ? "Prematch" : 0;
            object.EvalState = options.enums === String ? "None" : 0;
            object.StakeValue = 0;
            object.StakePoints = null;
            object.PrizeEvalValue = 0;
            object.PrizePaidValue = 0;
            object.PlacementDate = null;
            object.State = options.enums === String ? "None" : 0;
            object.TicketType = options.enums === String ? "None" : 0;
            object.PrizePotentialValue = 0;
            object.Number = "";
        }
        if (message.Id != null && message.hasOwnProperty("Id"))
            if (typeof message.Id === "number")
                object.Id = options.longs === String ? String(message.Id) : message.Id;
            else
                object.Id = options.longs === String ? $util.Long.prototype.toString.call(message.Id) : options.longs === Number ? new $util.LongBits(message.Id.low >>> 0, message.Id.high >>> 0).toNumber() : message.Id;
        if (message.SecureId != null && message.hasOwnProperty("SecureId"))
            object.SecureId = message.SecureId;
        if (message.OfferType != null && message.hasOwnProperty("OfferType"))
            object.OfferType = options.enums === String ? $root.OfferType[message.OfferType] : message.OfferType;
        if (message.EvalState != null && message.hasOwnProperty("EvalState"))
            object.EvalState = options.enums === String ? $root.EvalState[message.EvalState] : message.EvalState;
        if (message.StakeValue != null && message.hasOwnProperty("StakeValue"))
            object.StakeValue = options.json && !isFinite(message.StakeValue) ? String(message.StakeValue) : message.StakeValue;
        if (message.StakePoints != null && message.hasOwnProperty("StakePoints"))
            object.StakePoints = $root.NullableDouble.toObject(message.StakePoints, options);
        if (message.PrizeEvalValue != null && message.hasOwnProperty("PrizeEvalValue"))
            object.PrizeEvalValue = options.json && !isFinite(message.PrizeEvalValue) ? String(message.PrizeEvalValue) : message.PrizeEvalValue;
        if (message.PrizePaidValue != null && message.hasOwnProperty("PrizePaidValue"))
            object.PrizePaidValue = options.json && !isFinite(message.PrizePaidValue) ? String(message.PrizePaidValue) : message.PrizePaidValue;
        if (message.PlacementDate != null && message.hasOwnProperty("PlacementDate"))
            object.PlacementDate = $root.Timestamp.toObject(message.PlacementDate, options);
        if (message.State != null && message.hasOwnProperty("State"))
            object.State = options.enums === String ? $root.TicketState[message.State] : message.State;
        if (message.TicketType != null && message.hasOwnProperty("TicketType"))
            object.TicketType = options.enums === String ? $root.TicketType[message.TicketType] : message.TicketType;
        if (message.PrizePotentialValue != null && message.hasOwnProperty("PrizePotentialValue"))
            object.PrizePotentialValue = options.json && !isFinite(message.PrizePotentialValue) ? String(message.PrizePotentialValue) : message.PrizePotentialValue;
        if (message.Number != null && message.hasOwnProperty("Number"))
            object.Number = message.Number;
        return object;
    };

    /**
     * Converts this TicketListItemResponse to JSON.
     * @function toJSON
     * @memberof TicketListItemResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TicketListItemResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TicketListItemResponse;
})();

$root.TicketListResponse = (function() {

    /**
     * Properties of a TicketListResponse.
     * @exports ITicketListResponse
     * @interface ITicketListResponse
     * @property {Array.<ITicketListItemResponse>|null} [Items] TicketListResponse Items
     * @property {number|null} [TotalCount] TicketListResponse TotalCount
     */

    /**
     * Constructs a new TicketListResponse.
     * @exports TicketListResponse
     * @classdesc Represents a TicketListResponse.
     * @implements ITicketListResponse
     * @constructor
     * @param {ITicketListResponse=} [properties] Properties to set
     */
    function TicketListResponse(properties) {
        this.Items = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * TicketListResponse Items.
     * @member {Array.<ITicketListItemResponse>} Items
     * @memberof TicketListResponse
     * @instance
     */
    TicketListResponse.prototype.Items = $util.emptyArray;

    /**
     * TicketListResponse TotalCount.
     * @member {number} TotalCount
     * @memberof TicketListResponse
     * @instance
     */
    TicketListResponse.prototype.TotalCount = 0;

    /**
     * Creates a new TicketListResponse instance using the specified properties.
     * @function create
     * @memberof TicketListResponse
     * @static
     * @param {ITicketListResponse=} [properties] Properties to set
     * @returns {TicketListResponse} TicketListResponse instance
     */
    TicketListResponse.create = function create(properties) {
        return new TicketListResponse(properties);
    };

    /**
     * Encodes the specified TicketListResponse message. Does not implicitly {@link TicketListResponse.verify|verify} messages.
     * @function encode
     * @memberof TicketListResponse
     * @static
     * @param {ITicketListResponse} message TicketListResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TicketListResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Items != null && message.Items.length)
            for (var i = 0; i < message.Items.length; ++i)
                $root.TicketListItemResponse.encode(message.Items[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.TotalCount != null && message.hasOwnProperty("TotalCount"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.TotalCount);
        return writer;
    };

    /**
     * Encodes the specified TicketListResponse message, length delimited. Does not implicitly {@link TicketListResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof TicketListResponse
     * @static
     * @param {ITicketListResponse} message TicketListResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TicketListResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TicketListResponse message from the specified reader or buffer.
     * @function decode
     * @memberof TicketListResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TicketListResponse} TicketListResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TicketListResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TicketListResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.Items && message.Items.length))
                    message.Items = [];
                message.Items.push($root.TicketListItemResponse.decode(reader, reader.uint32()));
                break;
            case 2:
                message.TotalCount = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a TicketListResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof TicketListResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {TicketListResponse} TicketListResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TicketListResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TicketListResponse message.
     * @function verify
     * @memberof TicketListResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TicketListResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Items != null && message.hasOwnProperty("Items")) {
            if (!Array.isArray(message.Items))
                return "Items: array expected";
            for (var i = 0; i < message.Items.length; ++i) {
                var error = $root.TicketListItemResponse.verify(message.Items[i]);
                if (error)
                    return "Items." + error;
            }
        }
        if (message.TotalCount != null && message.hasOwnProperty("TotalCount"))
            if (!$util.isInteger(message.TotalCount))
                return "TotalCount: integer expected";
        return null;
    };

    /**
     * Creates a TicketListResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TicketListResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TicketListResponse} TicketListResponse
     */
    TicketListResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.TicketListResponse)
            return object;
        var message = new $root.TicketListResponse();
        if (object.Items) {
            if (!Array.isArray(object.Items))
                throw TypeError(".TicketListResponse.Items: array expected");
            message.Items = [];
            for (var i = 0; i < object.Items.length; ++i) {
                if (typeof object.Items[i] !== "object")
                    throw TypeError(".TicketListResponse.Items: object expected");
                message.Items[i] = $root.TicketListItemResponse.fromObject(object.Items[i]);
            }
        }
        if (object.TotalCount != null)
            message.TotalCount = object.TotalCount | 0;
        return message;
    };

    /**
     * Creates a plain object from a TicketListResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TicketListResponse
     * @static
     * @param {TicketListResponse} message TicketListResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TicketListResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.Items = [];
        if (options.defaults)
            object.TotalCount = 0;
        if (message.Items && message.Items.length) {
            object.Items = [];
            for (var j = 0; j < message.Items.length; ++j)
                object.Items[j] = $root.TicketListItemResponse.toObject(message.Items[j], options);
        }
        if (message.TotalCount != null && message.hasOwnProperty("TotalCount"))
            object.TotalCount = message.TotalCount;
        return object;
    };

    /**
     * Converts this TicketListResponse to JSON.
     * @function toJSON
     * @memberof TicketListResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TicketListResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TicketListResponse;
})();

$root.MoneyOrPoints = (function() {

    /**
     * Properties of a MoneyOrPoints.
     * @exports IMoneyOrPoints
     * @interface IMoneyOrPoints
     * @property {number|null} [Amount] MoneyOrPoints Amount
     * @property {boolean|null} [IsMoney] MoneyOrPoints IsMoney
     */

    /**
     * Constructs a new MoneyOrPoints.
     * @exports MoneyOrPoints
     * @classdesc Represents a MoneyOrPoints.
     * @implements IMoneyOrPoints
     * @constructor
     * @param {IMoneyOrPoints=} [properties] Properties to set
     */
    function MoneyOrPoints(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * MoneyOrPoints Amount.
     * @member {number} Amount
     * @memberof MoneyOrPoints
     * @instance
     */
    MoneyOrPoints.prototype.Amount = 0;

    /**
     * MoneyOrPoints IsMoney.
     * @member {boolean} IsMoney
     * @memberof MoneyOrPoints
     * @instance
     */
    MoneyOrPoints.prototype.IsMoney = false;

    /**
     * Creates a new MoneyOrPoints instance using the specified properties.
     * @function create
     * @memberof MoneyOrPoints
     * @static
     * @param {IMoneyOrPoints=} [properties] Properties to set
     * @returns {MoneyOrPoints} MoneyOrPoints instance
     */
    MoneyOrPoints.create = function create(properties) {
        return new MoneyOrPoints(properties);
    };

    /**
     * Encodes the specified MoneyOrPoints message. Does not implicitly {@link MoneyOrPoints.verify|verify} messages.
     * @function encode
     * @memberof MoneyOrPoints
     * @static
     * @param {IMoneyOrPoints} message MoneyOrPoints message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MoneyOrPoints.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Amount != null && message.hasOwnProperty("Amount"))
            writer.uint32(/* id 1, wireType 1 =*/9).double(message.Amount);
        if (message.IsMoney != null && message.hasOwnProperty("IsMoney"))
            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.IsMoney);
        return writer;
    };

    /**
     * Encodes the specified MoneyOrPoints message, length delimited. Does not implicitly {@link MoneyOrPoints.verify|verify} messages.
     * @function encodeDelimited
     * @memberof MoneyOrPoints
     * @static
     * @param {IMoneyOrPoints} message MoneyOrPoints message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    MoneyOrPoints.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a MoneyOrPoints message from the specified reader or buffer.
     * @function decode
     * @memberof MoneyOrPoints
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {MoneyOrPoints} MoneyOrPoints
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MoneyOrPoints.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.MoneyOrPoints();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Amount = reader.double();
                break;
            case 2:
                message.IsMoney = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a MoneyOrPoints message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof MoneyOrPoints
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {MoneyOrPoints} MoneyOrPoints
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    MoneyOrPoints.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a MoneyOrPoints message.
     * @function verify
     * @memberof MoneyOrPoints
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    MoneyOrPoints.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Amount != null && message.hasOwnProperty("Amount"))
            if (typeof message.Amount !== "number")
                return "Amount: number expected";
        if (message.IsMoney != null && message.hasOwnProperty("IsMoney"))
            if (typeof message.IsMoney !== "boolean")
                return "IsMoney: boolean expected";
        return null;
    };

    /**
     * Creates a MoneyOrPoints message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof MoneyOrPoints
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {MoneyOrPoints} MoneyOrPoints
     */
    MoneyOrPoints.fromObject = function fromObject(object) {
        if (object instanceof $root.MoneyOrPoints)
            return object;
        var message = new $root.MoneyOrPoints();
        if (object.Amount != null)
            message.Amount = Number(object.Amount);
        if (object.IsMoney != null)
            message.IsMoney = Boolean(object.IsMoney);
        return message;
    };

    /**
     * Creates a plain object from a MoneyOrPoints message. Also converts values to other types if specified.
     * @function toObject
     * @memberof MoneyOrPoints
     * @static
     * @param {MoneyOrPoints} message MoneyOrPoints
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    MoneyOrPoints.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.Amount = 0;
            object.IsMoney = false;
        }
        if (message.Amount != null && message.hasOwnProperty("Amount"))
            object.Amount = options.json && !isFinite(message.Amount) ? String(message.Amount) : message.Amount;
        if (message.IsMoney != null && message.hasOwnProperty("IsMoney"))
            object.IsMoney = message.IsMoney;
        return object;
    };

    /**
     * Converts this MoneyOrPoints to JSON.
     * @function toJSON
     * @memberof MoneyOrPoints
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    MoneyOrPoints.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return MoneyOrPoints;
})();

$root.AMLOption = (function() {

    /**
     * Properties of a AMLOption.
     * @exports IAMLOption
     * @interface IAMLOption
     * @property {number|null} [Id] AMLOption Id
     * @property {string|null} [Name] AMLOption Name
     * @property {string|null} [TextAtEnd] AMLOption TextAtEnd
     * @property {boolean|null} [IsSelected] AMLOption IsSelected
     * @property {IAMLOptionText|null} [Text] AMLOption Text
     * @property {Array.<IAMLOptionSubItem>|null} [Sub1OfN] AMLOption Sub1OfN
     * @property {AMLWidgetType|null} [WidgetType] AMLOption WidgetType
     * @property {Array.<string>|null} [DisabledIf] AMLOption DisabledIf
     * @property {boolean|null} [IsMandatory] AMLOption IsMandatory
     */

    /**
     * Constructs a new AMLOption.
     * @exports AMLOption
     * @classdesc Represents a AMLOption.
     * @implements IAMLOption
     * @constructor
     * @param {IAMLOption=} [properties] Properties to set
     */
    function AMLOption(properties) {
        this.Sub1OfN = [];
        this.DisabledIf = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * AMLOption Id.
     * @member {number} Id
     * @memberof AMLOption
     * @instance
     */
    AMLOption.prototype.Id = 0;

    /**
     * AMLOption Name.
     * @member {string} Name
     * @memberof AMLOption
     * @instance
     */
    AMLOption.prototype.Name = "";

    /**
     * AMLOption TextAtEnd.
     * @member {string} TextAtEnd
     * @memberof AMLOption
     * @instance
     */
    AMLOption.prototype.TextAtEnd = "";

    /**
     * AMLOption IsSelected.
     * @member {boolean} IsSelected
     * @memberof AMLOption
     * @instance
     */
    AMLOption.prototype.IsSelected = false;

    /**
     * AMLOption Text.
     * @member {IAMLOptionText|null|undefined} Text
     * @memberof AMLOption
     * @instance
     */
    AMLOption.prototype.Text = null;

    /**
     * AMLOption Sub1OfN.
     * @member {Array.<IAMLOptionSubItem>} Sub1OfN
     * @memberof AMLOption
     * @instance
     */
    AMLOption.prototype.Sub1OfN = $util.emptyArray;

    /**
     * AMLOption WidgetType.
     * @member {AMLWidgetType} WidgetType
     * @memberof AMLOption
     * @instance
     */
    AMLOption.prototype.WidgetType = 0;

    /**
     * AMLOption DisabledIf.
     * @member {Array.<string>} DisabledIf
     * @memberof AMLOption
     * @instance
     */
    AMLOption.prototype.DisabledIf = $util.emptyArray;

    /**
     * AMLOption IsMandatory.
     * @member {boolean} IsMandatory
     * @memberof AMLOption
     * @instance
     */
    AMLOption.prototype.IsMandatory = false;

    /**
     * Creates a new AMLOption instance using the specified properties.
     * @function create
     * @memberof AMLOption
     * @static
     * @param {IAMLOption=} [properties] Properties to set
     * @returns {AMLOption} AMLOption instance
     */
    AMLOption.create = function create(properties) {
        return new AMLOption(properties);
    };

    /**
     * Encodes the specified AMLOption message. Does not implicitly {@link AMLOption.verify|verify} messages.
     * @function encode
     * @memberof AMLOption
     * @static
     * @param {IAMLOption} message AMLOption message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AMLOption.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Id != null && message.hasOwnProperty("Id"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Id);
        if (message.Name != null && message.hasOwnProperty("Name"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.Name);
        if (message.TextAtEnd != null && message.hasOwnProperty("TextAtEnd"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.TextAtEnd);
        if (message.IsSelected != null && message.hasOwnProperty("IsSelected"))
            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.IsSelected);
        if (message.Text != null && message.hasOwnProperty("Text"))
            $root.AMLOptionText.encode(message.Text, writer.uint32(/* id 5, wireType 2 =*/42).fork()).ldelim();
        if (message.Sub1OfN != null && message.Sub1OfN.length)
            for (var i = 0; i < message.Sub1OfN.length; ++i)
                $root.AMLOptionSubItem.encode(message.Sub1OfN[i], writer.uint32(/* id 6, wireType 2 =*/50).fork()).ldelim();
        if (message.WidgetType != null && message.hasOwnProperty("WidgetType"))
            writer.uint32(/* id 7, wireType 0 =*/56).int32(message.WidgetType);
        if (message.DisabledIf != null && message.DisabledIf.length)
            for (var i = 0; i < message.DisabledIf.length; ++i)
                writer.uint32(/* id 8, wireType 2 =*/66).string(message.DisabledIf[i]);
        if (message.IsMandatory != null && message.hasOwnProperty("IsMandatory"))
            writer.uint32(/* id 9, wireType 0 =*/72).bool(message.IsMandatory);
        return writer;
    };

    /**
     * Encodes the specified AMLOption message, length delimited. Does not implicitly {@link AMLOption.verify|verify} messages.
     * @function encodeDelimited
     * @memberof AMLOption
     * @static
     * @param {IAMLOption} message AMLOption message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AMLOption.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a AMLOption message from the specified reader or buffer.
     * @function decode
     * @memberof AMLOption
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {AMLOption} AMLOption
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AMLOption.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AMLOption();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Id = reader.int32();
                break;
            case 2:
                message.Name = reader.string();
                break;
            case 3:
                message.TextAtEnd = reader.string();
                break;
            case 4:
                message.IsSelected = reader.bool();
                break;
            case 5:
                message.Text = $root.AMLOptionText.decode(reader, reader.uint32());
                break;
            case 6:
                if (!(message.Sub1OfN && message.Sub1OfN.length))
                    message.Sub1OfN = [];
                message.Sub1OfN.push($root.AMLOptionSubItem.decode(reader, reader.uint32()));
                break;
            case 7:
                message.WidgetType = reader.int32();
                break;
            case 8:
                if (!(message.DisabledIf && message.DisabledIf.length))
                    message.DisabledIf = [];
                message.DisabledIf.push(reader.string());
                break;
            case 9:
                message.IsMandatory = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a AMLOption message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof AMLOption
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {AMLOption} AMLOption
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AMLOption.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a AMLOption message.
     * @function verify
     * @memberof AMLOption
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    AMLOption.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Id != null && message.hasOwnProperty("Id"))
            if (!$util.isInteger(message.Id))
                return "Id: integer expected";
        if (message.Name != null && message.hasOwnProperty("Name"))
            if (!$util.isString(message.Name))
                return "Name: string expected";
        if (message.TextAtEnd != null && message.hasOwnProperty("TextAtEnd"))
            if (!$util.isString(message.TextAtEnd))
                return "TextAtEnd: string expected";
        if (message.IsSelected != null && message.hasOwnProperty("IsSelected"))
            if (typeof message.IsSelected !== "boolean")
                return "IsSelected: boolean expected";
        if (message.Text != null && message.hasOwnProperty("Text")) {
            var error = $root.AMLOptionText.verify(message.Text);
            if (error)
                return "Text." + error;
        }
        if (message.Sub1OfN != null && message.hasOwnProperty("Sub1OfN")) {
            if (!Array.isArray(message.Sub1OfN))
                return "Sub1OfN: array expected";
            for (var i = 0; i < message.Sub1OfN.length; ++i) {
                var error = $root.AMLOptionSubItem.verify(message.Sub1OfN[i]);
                if (error)
                    return "Sub1OfN." + error;
            }
        }
        if (message.WidgetType != null && message.hasOwnProperty("WidgetType"))
            switch (message.WidgetType) {
            default:
                return "WidgetType: enum value expected";
            case 0:
            case 1:
            case 2:
                break;
            }
        if (message.DisabledIf != null && message.hasOwnProperty("DisabledIf")) {
            if (!Array.isArray(message.DisabledIf))
                return "DisabledIf: array expected";
            for (var i = 0; i < message.DisabledIf.length; ++i)
                if (!$util.isString(message.DisabledIf[i]))
                    return "DisabledIf: string[] expected";
        }
        if (message.IsMandatory != null && message.hasOwnProperty("IsMandatory"))
            if (typeof message.IsMandatory !== "boolean")
                return "IsMandatory: boolean expected";
        return null;
    };

    /**
     * Creates a AMLOption message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof AMLOption
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {AMLOption} AMLOption
     */
    AMLOption.fromObject = function fromObject(object) {
        if (object instanceof $root.AMLOption)
            return object;
        var message = new $root.AMLOption();
        if (object.Id != null)
            message.Id = object.Id | 0;
        if (object.Name != null)
            message.Name = String(object.Name);
        if (object.TextAtEnd != null)
            message.TextAtEnd = String(object.TextAtEnd);
        if (object.IsSelected != null)
            message.IsSelected = Boolean(object.IsSelected);
        if (object.Text != null) {
            if (typeof object.Text !== "object")
                throw TypeError(".AMLOption.Text: object expected");
            message.Text = $root.AMLOptionText.fromObject(object.Text);
        }
        if (object.Sub1OfN) {
            if (!Array.isArray(object.Sub1OfN))
                throw TypeError(".AMLOption.Sub1OfN: array expected");
            message.Sub1OfN = [];
            for (var i = 0; i < object.Sub1OfN.length; ++i) {
                if (typeof object.Sub1OfN[i] !== "object")
                    throw TypeError(".AMLOption.Sub1OfN: object expected");
                message.Sub1OfN[i] = $root.AMLOptionSubItem.fromObject(object.Sub1OfN[i]);
            }
        }
        switch (object.WidgetType) {
        case "None":
        case 0:
            message.WidgetType = 0;
            break;
        case "Label":
        case 1:
            message.WidgetType = 1;
            break;
        case "Select":
        case 2:
            message.WidgetType = 2;
            break;
        }
        if (object.DisabledIf) {
            if (!Array.isArray(object.DisabledIf))
                throw TypeError(".AMLOption.DisabledIf: array expected");
            message.DisabledIf = [];
            for (var i = 0; i < object.DisabledIf.length; ++i)
                message.DisabledIf[i] = String(object.DisabledIf[i]);
        }
        if (object.IsMandatory != null)
            message.IsMandatory = Boolean(object.IsMandatory);
        return message;
    };

    /**
     * Creates a plain object from a AMLOption message. Also converts values to other types if specified.
     * @function toObject
     * @memberof AMLOption
     * @static
     * @param {AMLOption} message AMLOption
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AMLOption.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.Sub1OfN = [];
            object.DisabledIf = [];
        }
        if (options.defaults) {
            object.Id = 0;
            object.Name = "";
            object.TextAtEnd = "";
            object.IsSelected = false;
            object.Text = null;
            object.WidgetType = options.enums === String ? "None" : 0;
            object.IsMandatory = false;
        }
        if (message.Id != null && message.hasOwnProperty("Id"))
            object.Id = message.Id;
        if (message.Name != null && message.hasOwnProperty("Name"))
            object.Name = message.Name;
        if (message.TextAtEnd != null && message.hasOwnProperty("TextAtEnd"))
            object.TextAtEnd = message.TextAtEnd;
        if (message.IsSelected != null && message.hasOwnProperty("IsSelected"))
            object.IsSelected = message.IsSelected;
        if (message.Text != null && message.hasOwnProperty("Text"))
            object.Text = $root.AMLOptionText.toObject(message.Text, options);
        if (message.Sub1OfN && message.Sub1OfN.length) {
            object.Sub1OfN = [];
            for (var j = 0; j < message.Sub1OfN.length; ++j)
                object.Sub1OfN[j] = $root.AMLOptionSubItem.toObject(message.Sub1OfN[j], options);
        }
        if (message.WidgetType != null && message.hasOwnProperty("WidgetType"))
            object.WidgetType = options.enums === String ? $root.AMLWidgetType[message.WidgetType] : message.WidgetType;
        if (message.DisabledIf && message.DisabledIf.length) {
            object.DisabledIf = [];
            for (var j = 0; j < message.DisabledIf.length; ++j)
                object.DisabledIf[j] = message.DisabledIf[j];
        }
        if (message.IsMandatory != null && message.hasOwnProperty("IsMandatory"))
            object.IsMandatory = message.IsMandatory;
        return object;
    };

    /**
     * Converts this AMLOption to JSON.
     * @function toJSON
     * @memberof AMLOption
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AMLOption.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AMLOption;
})();

/**
 * AMLWidgetType enum.
 * @exports AMLWidgetType
 * @enum {string}
 * @property {number} None=0 None value
 * @property {number} Label=1 Label value
 * @property {number} Select=2 Select value
 */
$root.AMLWidgetType = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "None"] = 0;
    values[valuesById[1] = "Label"] = 1;
    values[valuesById[2] = "Select"] = 2;
    return values;
})();

$root.AMLOptionSubItem = (function() {

    /**
     * Properties of a AMLOptionSubItem.
     * @exports IAMLOptionSubItem
     * @interface IAMLOptionSubItem
     * @property {number|null} [Id] AMLOptionSubItem Id
     * @property {string|null} [Name] AMLOptionSubItem Name
     * @property {boolean|null} [IsSelected] AMLOptionSubItem IsSelected
     */

    /**
     * Constructs a new AMLOptionSubItem.
     * @exports AMLOptionSubItem
     * @classdesc Represents a AMLOptionSubItem.
     * @implements IAMLOptionSubItem
     * @constructor
     * @param {IAMLOptionSubItem=} [properties] Properties to set
     */
    function AMLOptionSubItem(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * AMLOptionSubItem Id.
     * @member {number} Id
     * @memberof AMLOptionSubItem
     * @instance
     */
    AMLOptionSubItem.prototype.Id = 0;

    /**
     * AMLOptionSubItem Name.
     * @member {string} Name
     * @memberof AMLOptionSubItem
     * @instance
     */
    AMLOptionSubItem.prototype.Name = "";

    /**
     * AMLOptionSubItem IsSelected.
     * @member {boolean} IsSelected
     * @memberof AMLOptionSubItem
     * @instance
     */
    AMLOptionSubItem.prototype.IsSelected = false;

    /**
     * Creates a new AMLOptionSubItem instance using the specified properties.
     * @function create
     * @memberof AMLOptionSubItem
     * @static
     * @param {IAMLOptionSubItem=} [properties] Properties to set
     * @returns {AMLOptionSubItem} AMLOptionSubItem instance
     */
    AMLOptionSubItem.create = function create(properties) {
        return new AMLOptionSubItem(properties);
    };

    /**
     * Encodes the specified AMLOptionSubItem message. Does not implicitly {@link AMLOptionSubItem.verify|verify} messages.
     * @function encode
     * @memberof AMLOptionSubItem
     * @static
     * @param {IAMLOptionSubItem} message AMLOptionSubItem message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AMLOptionSubItem.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Id != null && message.hasOwnProperty("Id"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.Id);
        if (message.Name != null && message.hasOwnProperty("Name"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.Name);
        if (message.IsSelected != null && message.hasOwnProperty("IsSelected"))
            writer.uint32(/* id 3, wireType 0 =*/24).bool(message.IsSelected);
        return writer;
    };

    /**
     * Encodes the specified AMLOptionSubItem message, length delimited. Does not implicitly {@link AMLOptionSubItem.verify|verify} messages.
     * @function encodeDelimited
     * @memberof AMLOptionSubItem
     * @static
     * @param {IAMLOptionSubItem} message AMLOptionSubItem message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AMLOptionSubItem.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a AMLOptionSubItem message from the specified reader or buffer.
     * @function decode
     * @memberof AMLOptionSubItem
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {AMLOptionSubItem} AMLOptionSubItem
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AMLOptionSubItem.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AMLOptionSubItem();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Id = reader.int32();
                break;
            case 2:
                message.Name = reader.string();
                break;
            case 3:
                message.IsSelected = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a AMLOptionSubItem message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof AMLOptionSubItem
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {AMLOptionSubItem} AMLOptionSubItem
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AMLOptionSubItem.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a AMLOptionSubItem message.
     * @function verify
     * @memberof AMLOptionSubItem
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    AMLOptionSubItem.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Id != null && message.hasOwnProperty("Id"))
            if (!$util.isInteger(message.Id))
                return "Id: integer expected";
        if (message.Name != null && message.hasOwnProperty("Name"))
            if (!$util.isString(message.Name))
                return "Name: string expected";
        if (message.IsSelected != null && message.hasOwnProperty("IsSelected"))
            if (typeof message.IsSelected !== "boolean")
                return "IsSelected: boolean expected";
        return null;
    };

    /**
     * Creates a AMLOptionSubItem message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof AMLOptionSubItem
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {AMLOptionSubItem} AMLOptionSubItem
     */
    AMLOptionSubItem.fromObject = function fromObject(object) {
        if (object instanceof $root.AMLOptionSubItem)
            return object;
        var message = new $root.AMLOptionSubItem();
        if (object.Id != null)
            message.Id = object.Id | 0;
        if (object.Name != null)
            message.Name = String(object.Name);
        if (object.IsSelected != null)
            message.IsSelected = Boolean(object.IsSelected);
        return message;
    };

    /**
     * Creates a plain object from a AMLOptionSubItem message. Also converts values to other types if specified.
     * @function toObject
     * @memberof AMLOptionSubItem
     * @static
     * @param {AMLOptionSubItem} message AMLOptionSubItem
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AMLOptionSubItem.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.Id = 0;
            object.Name = "";
            object.IsSelected = false;
        }
        if (message.Id != null && message.hasOwnProperty("Id"))
            object.Id = message.Id;
        if (message.Name != null && message.hasOwnProperty("Name"))
            object.Name = message.Name;
        if (message.IsSelected != null && message.hasOwnProperty("IsSelected"))
            object.IsSelected = message.IsSelected;
        return object;
    };

    /**
     * Converts this AMLOptionSubItem to JSON.
     * @function toJSON
     * @memberof AMLOptionSubItem
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AMLOptionSubItem.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AMLOptionSubItem;
})();

$root.AMLOptionText = (function() {

    /**
     * Properties of a AMLOptionText.
     * @exports IAMLOptionText
     * @interface IAMLOptionText
     * @property {string|null} [Title] AMLOptionText Title
     * @property {string|null} [Text] AMLOptionText Text
     */

    /**
     * Constructs a new AMLOptionText.
     * @exports AMLOptionText
     * @classdesc Represents a AMLOptionText.
     * @implements IAMLOptionText
     * @constructor
     * @param {IAMLOptionText=} [properties] Properties to set
     */
    function AMLOptionText(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * AMLOptionText Title.
     * @member {string} Title
     * @memberof AMLOptionText
     * @instance
     */
    AMLOptionText.prototype.Title = "";

    /**
     * AMLOptionText Text.
     * @member {string} Text
     * @memberof AMLOptionText
     * @instance
     */
    AMLOptionText.prototype.Text = "";

    /**
     * Creates a new AMLOptionText instance using the specified properties.
     * @function create
     * @memberof AMLOptionText
     * @static
     * @param {IAMLOptionText=} [properties] Properties to set
     * @returns {AMLOptionText} AMLOptionText instance
     */
    AMLOptionText.create = function create(properties) {
        return new AMLOptionText(properties);
    };

    /**
     * Encodes the specified AMLOptionText message. Does not implicitly {@link AMLOptionText.verify|verify} messages.
     * @function encode
     * @memberof AMLOptionText
     * @static
     * @param {IAMLOptionText} message AMLOptionText message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AMLOptionText.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Title != null && message.hasOwnProperty("Title"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.Title);
        if (message.Text != null && message.hasOwnProperty("Text"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.Text);
        return writer;
    };

    /**
     * Encodes the specified AMLOptionText message, length delimited. Does not implicitly {@link AMLOptionText.verify|verify} messages.
     * @function encodeDelimited
     * @memberof AMLOptionText
     * @static
     * @param {IAMLOptionText} message AMLOptionText message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    AMLOptionText.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a AMLOptionText message from the specified reader or buffer.
     * @function decode
     * @memberof AMLOptionText
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {AMLOptionText} AMLOptionText
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AMLOptionText.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.AMLOptionText();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Title = reader.string();
                break;
            case 2:
                message.Text = reader.string();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a AMLOptionText message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof AMLOptionText
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {AMLOptionText} AMLOptionText
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    AMLOptionText.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a AMLOptionText message.
     * @function verify
     * @memberof AMLOptionText
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    AMLOptionText.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Title != null && message.hasOwnProperty("Title"))
            if (!$util.isString(message.Title))
                return "Title: string expected";
        if (message.Text != null && message.hasOwnProperty("Text"))
            if (!$util.isString(message.Text))
                return "Text: string expected";
        return null;
    };

    /**
     * Creates a AMLOptionText message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof AMLOptionText
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {AMLOptionText} AMLOptionText
     */
    AMLOptionText.fromObject = function fromObject(object) {
        if (object instanceof $root.AMLOptionText)
            return object;
        var message = new $root.AMLOptionText();
        if (object.Title != null)
            message.Title = String(object.Title);
        if (object.Text != null)
            message.Text = String(object.Text);
        return message;
    };

    /**
     * Creates a plain object from a AMLOptionText message. Also converts values to other types if specified.
     * @function toObject
     * @memberof AMLOptionText
     * @static
     * @param {AMLOptionText} message AMLOptionText
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    AMLOptionText.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.Title = "";
            object.Text = "";
        }
        if (message.Title != null && message.hasOwnProperty("Title"))
            object.Title = message.Title;
        if (message.Text != null && message.hasOwnProperty("Text"))
            object.Text = message.Text;
        return object;
    };

    /**
     * Converts this AMLOptionText to JSON.
     * @function toJSON
     * @memberof AMLOptionText
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    AMLOptionText.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return AMLOptionText;
})();

$root.CalendarEvent = (function() {

    /**
     * Properties of a CalendarEvent.
     * @exports ICalendarEvent
     * @interface ICalendarEvent
     * @property {number|Long|null} [Id] CalendarEvent Id
     * @property {number|null} [GraphicsPresentationId] CalendarEvent GraphicsPresentationId
     * @property {string|null} [Name] CalendarEvent Name
     * @property {string|null} [Path] CalendarEvent Path
     * @property {boolean|null} [IsLive] CalendarEvent IsLive
     * @property {string|null} [SportCategoryId] CalendarEvent SportCategoryId
     * @property {string|null} [SportName] CalendarEvent SportName
     * @property {ITimestamp|null} [Date] CalendarEvent Date
     * @property {boolean|null} [IsVideoStreamAvailable] CalendarEvent IsVideoStreamAvailable
     * @property {number|null} [Flags] CalendarEvent Flags
     */

    /**
     * Constructs a new CalendarEvent.
     * @exports CalendarEvent
     * @classdesc Represents a CalendarEvent.
     * @implements ICalendarEvent
     * @constructor
     * @param {ICalendarEvent=} [properties] Properties to set
     */
    function CalendarEvent(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * CalendarEvent Id.
     * @member {number|Long} Id
     * @memberof CalendarEvent
     * @instance
     */
    CalendarEvent.prototype.Id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * CalendarEvent GraphicsPresentationId.
     * @member {number} GraphicsPresentationId
     * @memberof CalendarEvent
     * @instance
     */
    CalendarEvent.prototype.GraphicsPresentationId = 0;

    /**
     * CalendarEvent Name.
     * @member {string} Name
     * @memberof CalendarEvent
     * @instance
     */
    CalendarEvent.prototype.Name = "";

    /**
     * CalendarEvent Path.
     * @member {string} Path
     * @memberof CalendarEvent
     * @instance
     */
    CalendarEvent.prototype.Path = "";

    /**
     * CalendarEvent IsLive.
     * @member {boolean} IsLive
     * @memberof CalendarEvent
     * @instance
     */
    CalendarEvent.prototype.IsLive = false;

    /**
     * CalendarEvent SportCategoryId.
     * @member {string} SportCategoryId
     * @memberof CalendarEvent
     * @instance
     */
    CalendarEvent.prototype.SportCategoryId = "";

    /**
     * CalendarEvent SportName.
     * @member {string} SportName
     * @memberof CalendarEvent
     * @instance
     */
    CalendarEvent.prototype.SportName = "";

    /**
     * CalendarEvent Date.
     * @member {ITimestamp|null|undefined} Date
     * @memberof CalendarEvent
     * @instance
     */
    CalendarEvent.prototype.Date = null;

    /**
     * CalendarEvent IsVideoStreamAvailable.
     * @member {boolean} IsVideoStreamAvailable
     * @memberof CalendarEvent
     * @instance
     */
    CalendarEvent.prototype.IsVideoStreamAvailable = false;

    /**
     * CalendarEvent Flags.
     * @member {number} Flags
     * @memberof CalendarEvent
     * @instance
     */
    CalendarEvent.prototype.Flags = 0;

    /**
     * Creates a new CalendarEvent instance using the specified properties.
     * @function create
     * @memberof CalendarEvent
     * @static
     * @param {ICalendarEvent=} [properties] Properties to set
     * @returns {CalendarEvent} CalendarEvent instance
     */
    CalendarEvent.create = function create(properties) {
        return new CalendarEvent(properties);
    };

    /**
     * Encodes the specified CalendarEvent message. Does not implicitly {@link CalendarEvent.verify|verify} messages.
     * @function encode
     * @memberof CalendarEvent
     * @static
     * @param {ICalendarEvent} message CalendarEvent message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CalendarEvent.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Id != null && message.hasOwnProperty("Id"))
            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.Id);
        if (message.GraphicsPresentationId != null && message.hasOwnProperty("GraphicsPresentationId"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.GraphicsPresentationId);
        if (message.Name != null && message.hasOwnProperty("Name"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.Name);
        if (message.Path != null && message.hasOwnProperty("Path"))
            writer.uint32(/* id 4, wireType 2 =*/34).string(message.Path);
        if (message.IsLive != null && message.hasOwnProperty("IsLive"))
            writer.uint32(/* id 5, wireType 0 =*/40).bool(message.IsLive);
        if (message.SportCategoryId != null && message.hasOwnProperty("SportCategoryId"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.SportCategoryId);
        if (message.SportName != null && message.hasOwnProperty("SportName"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.SportName);
        if (message.Date != null && message.hasOwnProperty("Date"))
            $root.Timestamp.encode(message.Date, writer.uint32(/* id 8, wireType 2 =*/66).fork()).ldelim();
        if (message.IsVideoStreamAvailable != null && message.hasOwnProperty("IsVideoStreamAvailable"))
            writer.uint32(/* id 9, wireType 0 =*/72).bool(message.IsVideoStreamAvailable);
        if (message.Flags != null && message.hasOwnProperty("Flags"))
            writer.uint32(/* id 10, wireType 0 =*/80).uint32(message.Flags);
        return writer;
    };

    /**
     * Encodes the specified CalendarEvent message, length delimited. Does not implicitly {@link CalendarEvent.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CalendarEvent
     * @static
     * @param {ICalendarEvent} message CalendarEvent message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CalendarEvent.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CalendarEvent message from the specified reader or buffer.
     * @function decode
     * @memberof CalendarEvent
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CalendarEvent} CalendarEvent
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CalendarEvent.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CalendarEvent();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Id = reader.int64();
                break;
            case 2:
                message.GraphicsPresentationId = reader.int32();
                break;
            case 3:
                message.Name = reader.string();
                break;
            case 4:
                message.Path = reader.string();
                break;
            case 5:
                message.IsLive = reader.bool();
                break;
            case 6:
                message.SportCategoryId = reader.string();
                break;
            case 7:
                message.SportName = reader.string();
                break;
            case 8:
                message.Date = $root.Timestamp.decode(reader, reader.uint32());
                break;
            case 9:
                message.IsVideoStreamAvailable = reader.bool();
                break;
            case 10:
                message.Flags = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a CalendarEvent message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CalendarEvent
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CalendarEvent} CalendarEvent
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CalendarEvent.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CalendarEvent message.
     * @function verify
     * @memberof CalendarEvent
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CalendarEvent.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Id != null && message.hasOwnProperty("Id"))
            if (!$util.isInteger(message.Id) && !(message.Id && $util.isInteger(message.Id.low) && $util.isInteger(message.Id.high)))
                return "Id: integer|Long expected";
        if (message.GraphicsPresentationId != null && message.hasOwnProperty("GraphicsPresentationId"))
            if (!$util.isInteger(message.GraphicsPresentationId))
                return "GraphicsPresentationId: integer expected";
        if (message.Name != null && message.hasOwnProperty("Name"))
            if (!$util.isString(message.Name))
                return "Name: string expected";
        if (message.Path != null && message.hasOwnProperty("Path"))
            if (!$util.isString(message.Path))
                return "Path: string expected";
        if (message.IsLive != null && message.hasOwnProperty("IsLive"))
            if (typeof message.IsLive !== "boolean")
                return "IsLive: boolean expected";
        if (message.SportCategoryId != null && message.hasOwnProperty("SportCategoryId"))
            if (!$util.isString(message.SportCategoryId))
                return "SportCategoryId: string expected";
        if (message.SportName != null && message.hasOwnProperty("SportName"))
            if (!$util.isString(message.SportName))
                return "SportName: string expected";
        if (message.Date != null && message.hasOwnProperty("Date")) {
            var error = $root.Timestamp.verify(message.Date);
            if (error)
                return "Date." + error;
        }
        if (message.IsVideoStreamAvailable != null && message.hasOwnProperty("IsVideoStreamAvailable"))
            if (typeof message.IsVideoStreamAvailable !== "boolean")
                return "IsVideoStreamAvailable: boolean expected";
        if (message.Flags != null && message.hasOwnProperty("Flags"))
            if (!$util.isInteger(message.Flags))
                return "Flags: integer expected";
        return null;
    };

    /**
     * Creates a CalendarEvent message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CalendarEvent
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CalendarEvent} CalendarEvent
     */
    CalendarEvent.fromObject = function fromObject(object) {
        if (object instanceof $root.CalendarEvent)
            return object;
        var message = new $root.CalendarEvent();
        if (object.Id != null)
            if ($util.Long)
                (message.Id = $util.Long.fromValue(object.Id)).unsigned = false;
            else if (typeof object.Id === "string")
                message.Id = parseInt(object.Id, 10);
            else if (typeof object.Id === "number")
                message.Id = object.Id;
            else if (typeof object.Id === "object")
                message.Id = new $util.LongBits(object.Id.low >>> 0, object.Id.high >>> 0).toNumber();
        if (object.GraphicsPresentationId != null)
            message.GraphicsPresentationId = object.GraphicsPresentationId | 0;
        if (object.Name != null)
            message.Name = String(object.Name);
        if (object.Path != null)
            message.Path = String(object.Path);
        if (object.IsLive != null)
            message.IsLive = Boolean(object.IsLive);
        if (object.SportCategoryId != null)
            message.SportCategoryId = String(object.SportCategoryId);
        if (object.SportName != null)
            message.SportName = String(object.SportName);
        if (object.Date != null) {
            if (typeof object.Date !== "object")
                throw TypeError(".CalendarEvent.Date: object expected");
            message.Date = $root.Timestamp.fromObject(object.Date);
        }
        if (object.IsVideoStreamAvailable != null)
            message.IsVideoStreamAvailable = Boolean(object.IsVideoStreamAvailable);
        if (object.Flags != null)
            message.Flags = object.Flags >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a CalendarEvent message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CalendarEvent
     * @static
     * @param {CalendarEvent} message CalendarEvent
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CalendarEvent.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.Id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.Id = options.longs === String ? "0" : 0;
            object.GraphicsPresentationId = 0;
            object.Name = "";
            object.Path = "";
            object.IsLive = false;
            object.SportCategoryId = "";
            object.SportName = "";
            object.Date = null;
            object.IsVideoStreamAvailable = false;
            object.Flags = 0;
        }
        if (message.Id != null && message.hasOwnProperty("Id"))
            if (typeof message.Id === "number")
                object.Id = options.longs === String ? String(message.Id) : message.Id;
            else
                object.Id = options.longs === String ? $util.Long.prototype.toString.call(message.Id) : options.longs === Number ? new $util.LongBits(message.Id.low >>> 0, message.Id.high >>> 0).toNumber() : message.Id;
        if (message.GraphicsPresentationId != null && message.hasOwnProperty("GraphicsPresentationId"))
            object.GraphicsPresentationId = message.GraphicsPresentationId;
        if (message.Name != null && message.hasOwnProperty("Name"))
            object.Name = message.Name;
        if (message.Path != null && message.hasOwnProperty("Path"))
            object.Path = message.Path;
        if (message.IsLive != null && message.hasOwnProperty("IsLive"))
            object.IsLive = message.IsLive;
        if (message.SportCategoryId != null && message.hasOwnProperty("SportCategoryId"))
            object.SportCategoryId = message.SportCategoryId;
        if (message.SportName != null && message.hasOwnProperty("SportName"))
            object.SportName = message.SportName;
        if (message.Date != null && message.hasOwnProperty("Date"))
            object.Date = $root.Timestamp.toObject(message.Date, options);
        if (message.IsVideoStreamAvailable != null && message.hasOwnProperty("IsVideoStreamAvailable"))
            object.IsVideoStreamAvailable = message.IsVideoStreamAvailable;
        if (message.Flags != null && message.hasOwnProperty("Flags"))
            object.Flags = message.Flags;
        return object;
    };

    /**
     * Converts this CalendarEvent to JSON.
     * @function toJSON
     * @memberof CalendarEvent
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CalendarEvent.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CalendarEvent;
})();

$root.CalendarEvents = (function() {

    /**
     * Properties of a CalendarEvents.
     * @exports ICalendarEvents
     * @interface ICalendarEvents
     * @property {Array.<ICalendarEvent>|null} [Events] CalendarEvents Events
     * @property {number|null} [TotalCount] CalendarEvents TotalCount
     */

    /**
     * Constructs a new CalendarEvents.
     * @exports CalendarEvents
     * @classdesc Represents a CalendarEvents.
     * @implements ICalendarEvents
     * @constructor
     * @param {ICalendarEvents=} [properties] Properties to set
     */
    function CalendarEvents(properties) {
        this.Events = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * CalendarEvents Events.
     * @member {Array.<ICalendarEvent>} Events
     * @memberof CalendarEvents
     * @instance
     */
    CalendarEvents.prototype.Events = $util.emptyArray;

    /**
     * CalendarEvents TotalCount.
     * @member {number} TotalCount
     * @memberof CalendarEvents
     * @instance
     */
    CalendarEvents.prototype.TotalCount = 0;

    /**
     * Creates a new CalendarEvents instance using the specified properties.
     * @function create
     * @memberof CalendarEvents
     * @static
     * @param {ICalendarEvents=} [properties] Properties to set
     * @returns {CalendarEvents} CalendarEvents instance
     */
    CalendarEvents.create = function create(properties) {
        return new CalendarEvents(properties);
    };

    /**
     * Encodes the specified CalendarEvents message. Does not implicitly {@link CalendarEvents.verify|verify} messages.
     * @function encode
     * @memberof CalendarEvents
     * @static
     * @param {ICalendarEvents} message CalendarEvents message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CalendarEvents.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Events != null && message.Events.length)
            for (var i = 0; i < message.Events.length; ++i)
                $root.CalendarEvent.encode(message.Events[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.TotalCount != null && message.hasOwnProperty("TotalCount"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.TotalCount);
        return writer;
    };

    /**
     * Encodes the specified CalendarEvents message, length delimited. Does not implicitly {@link CalendarEvents.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CalendarEvents
     * @static
     * @param {ICalendarEvents} message CalendarEvents message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CalendarEvents.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CalendarEvents message from the specified reader or buffer.
     * @function decode
     * @memberof CalendarEvents
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CalendarEvents} CalendarEvents
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CalendarEvents.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CalendarEvents();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.Events && message.Events.length))
                    message.Events = [];
                message.Events.push($root.CalendarEvent.decode(reader, reader.uint32()));
                break;
            case 2:
                message.TotalCount = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a CalendarEvents message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CalendarEvents
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CalendarEvents} CalendarEvents
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CalendarEvents.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CalendarEvents message.
     * @function verify
     * @memberof CalendarEvents
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CalendarEvents.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Events != null && message.hasOwnProperty("Events")) {
            if (!Array.isArray(message.Events))
                return "Events: array expected";
            for (var i = 0; i < message.Events.length; ++i) {
                var error = $root.CalendarEvent.verify(message.Events[i]);
                if (error)
                    return "Events." + error;
            }
        }
        if (message.TotalCount != null && message.hasOwnProperty("TotalCount"))
            if (!$util.isInteger(message.TotalCount))
                return "TotalCount: integer expected";
        return null;
    };

    /**
     * Creates a CalendarEvents message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CalendarEvents
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CalendarEvents} CalendarEvents
     */
    CalendarEvents.fromObject = function fromObject(object) {
        if (object instanceof $root.CalendarEvents)
            return object;
        var message = new $root.CalendarEvents();
        if (object.Events) {
            if (!Array.isArray(object.Events))
                throw TypeError(".CalendarEvents.Events: array expected");
            message.Events = [];
            for (var i = 0; i < object.Events.length; ++i) {
                if (typeof object.Events[i] !== "object")
                    throw TypeError(".CalendarEvents.Events: object expected");
                message.Events[i] = $root.CalendarEvent.fromObject(object.Events[i]);
            }
        }
        if (object.TotalCount != null)
            message.TotalCount = object.TotalCount | 0;
        return message;
    };

    /**
     * Creates a plain object from a CalendarEvents message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CalendarEvents
     * @static
     * @param {CalendarEvents} message CalendarEvents
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CalendarEvents.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.Events = [];
        if (options.defaults)
            object.TotalCount = 0;
        if (message.Events && message.Events.length) {
            object.Events = [];
            for (var j = 0; j < message.Events.length; ++j)
                object.Events[j] = $root.CalendarEvent.toObject(message.Events[j], options);
        }
        if (message.TotalCount != null && message.hasOwnProperty("TotalCount"))
            object.TotalCount = message.TotalCount;
        return object;
    };

    /**
     * Converts this CalendarEvents to JSON.
     * @function toJSON
     * @memberof CalendarEvents
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CalendarEvents.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CalendarEvents;
})();

$root.CalendarEventsWithTs = (function() {

    /**
     * Properties of a CalendarEventsWithTs.
     * @exports ICalendarEventsWithTs
     * @interface ICalendarEventsWithTs
     * @property {ICalendarEvents|null} [Data] CalendarEventsWithTs Data
     * @property {number|null} [Timestamp] CalendarEventsWithTs Timestamp
     */

    /**
     * Constructs a new CalendarEventsWithTs.
     * @exports CalendarEventsWithTs
     * @classdesc Represents a CalendarEventsWithTs.
     * @implements ICalendarEventsWithTs
     * @constructor
     * @param {ICalendarEventsWithTs=} [properties] Properties to set
     */
    function CalendarEventsWithTs(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * CalendarEventsWithTs Data.
     * @member {ICalendarEvents|null|undefined} Data
     * @memberof CalendarEventsWithTs
     * @instance
     */
    CalendarEventsWithTs.prototype.Data = null;

    /**
     * CalendarEventsWithTs Timestamp.
     * @member {number} Timestamp
     * @memberof CalendarEventsWithTs
     * @instance
     */
    CalendarEventsWithTs.prototype.Timestamp = 0;

    /**
     * Creates a new CalendarEventsWithTs instance using the specified properties.
     * @function create
     * @memberof CalendarEventsWithTs
     * @static
     * @param {ICalendarEventsWithTs=} [properties] Properties to set
     * @returns {CalendarEventsWithTs} CalendarEventsWithTs instance
     */
    CalendarEventsWithTs.create = function create(properties) {
        return new CalendarEventsWithTs(properties);
    };

    /**
     * Encodes the specified CalendarEventsWithTs message. Does not implicitly {@link CalendarEventsWithTs.verify|verify} messages.
     * @function encode
     * @memberof CalendarEventsWithTs
     * @static
     * @param {ICalendarEventsWithTs} message CalendarEventsWithTs message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CalendarEventsWithTs.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Data != null && message.hasOwnProperty("Data"))
            $root.CalendarEvents.encode(message.Data, writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.Timestamp != null && message.hasOwnProperty("Timestamp"))
            writer.uint32(/* id 2, wireType 0 =*/16).int32(message.Timestamp);
        return writer;
    };

    /**
     * Encodes the specified CalendarEventsWithTs message, length delimited. Does not implicitly {@link CalendarEventsWithTs.verify|verify} messages.
     * @function encodeDelimited
     * @memberof CalendarEventsWithTs
     * @static
     * @param {ICalendarEventsWithTs} message CalendarEventsWithTs message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    CalendarEventsWithTs.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a CalendarEventsWithTs message from the specified reader or buffer.
     * @function decode
     * @memberof CalendarEventsWithTs
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {CalendarEventsWithTs} CalendarEventsWithTs
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CalendarEventsWithTs.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.CalendarEventsWithTs();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Data = $root.CalendarEvents.decode(reader, reader.uint32());
                break;
            case 2:
                message.Timestamp = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a CalendarEventsWithTs message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof CalendarEventsWithTs
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {CalendarEventsWithTs} CalendarEventsWithTs
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    CalendarEventsWithTs.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a CalendarEventsWithTs message.
     * @function verify
     * @memberof CalendarEventsWithTs
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    CalendarEventsWithTs.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Data != null && message.hasOwnProperty("Data")) {
            var error = $root.CalendarEvents.verify(message.Data);
            if (error)
                return "Data." + error;
        }
        if (message.Timestamp != null && message.hasOwnProperty("Timestamp"))
            if (!$util.isInteger(message.Timestamp))
                return "Timestamp: integer expected";
        return null;
    };

    /**
     * Creates a CalendarEventsWithTs message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof CalendarEventsWithTs
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {CalendarEventsWithTs} CalendarEventsWithTs
     */
    CalendarEventsWithTs.fromObject = function fromObject(object) {
        if (object instanceof $root.CalendarEventsWithTs)
            return object;
        var message = new $root.CalendarEventsWithTs();
        if (object.Data != null) {
            if (typeof object.Data !== "object")
                throw TypeError(".CalendarEventsWithTs.Data: object expected");
            message.Data = $root.CalendarEvents.fromObject(object.Data);
        }
        if (object.Timestamp != null)
            message.Timestamp = object.Timestamp | 0;
        return message;
    };

    /**
     * Creates a plain object from a CalendarEventsWithTs message. Also converts values to other types if specified.
     * @function toObject
     * @memberof CalendarEventsWithTs
     * @static
     * @param {CalendarEventsWithTs} message CalendarEventsWithTs
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    CalendarEventsWithTs.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.Data = null;
            object.Timestamp = 0;
        }
        if (message.Data != null && message.hasOwnProperty("Data"))
            object.Data = $root.CalendarEvents.toObject(message.Data, options);
        if (message.Timestamp != null && message.hasOwnProperty("Timestamp"))
            object.Timestamp = message.Timestamp;
        return object;
    };

    /**
     * Converts this CalendarEventsWithTs to JSON.
     * @function toJSON
     * @memberof CalendarEventsWithTs
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    CalendarEventsWithTs.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return CalendarEventsWithTs;
})();

$root.FavoriteEvent = (function() {

    /**
     * Properties of a FavoriteEvent.
     * @exports IFavoriteEvent
     * @interface IFavoriteEvent
     * @property {number|Long|null} [Id] FavoriteEvent Id
     * @property {string|null} [Name] FavoriteEvent Name
     * @property {number|null} [GraphicsPresentationId] FavoriteEvent GraphicsPresentationId
     * @property {boolean|null} [IsLive] FavoriteEvent IsLive
     */

    /**
     * Constructs a new FavoriteEvent.
     * @exports FavoriteEvent
     * @classdesc Represents a FavoriteEvent.
     * @implements IFavoriteEvent
     * @constructor
     * @param {IFavoriteEvent=} [properties] Properties to set
     */
    function FavoriteEvent(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * FavoriteEvent Id.
     * @member {number|Long} Id
     * @memberof FavoriteEvent
     * @instance
     */
    FavoriteEvent.prototype.Id = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * FavoriteEvent Name.
     * @member {string} Name
     * @memberof FavoriteEvent
     * @instance
     */
    FavoriteEvent.prototype.Name = "";

    /**
     * FavoriteEvent GraphicsPresentationId.
     * @member {number} GraphicsPresentationId
     * @memberof FavoriteEvent
     * @instance
     */
    FavoriteEvent.prototype.GraphicsPresentationId = 0;

    /**
     * FavoriteEvent IsLive.
     * @member {boolean} IsLive
     * @memberof FavoriteEvent
     * @instance
     */
    FavoriteEvent.prototype.IsLive = false;

    /**
     * Creates a new FavoriteEvent instance using the specified properties.
     * @function create
     * @memberof FavoriteEvent
     * @static
     * @param {IFavoriteEvent=} [properties] Properties to set
     * @returns {FavoriteEvent} FavoriteEvent instance
     */
    FavoriteEvent.create = function create(properties) {
        return new FavoriteEvent(properties);
    };

    /**
     * Encodes the specified FavoriteEvent message. Does not implicitly {@link FavoriteEvent.verify|verify} messages.
     * @function encode
     * @memberof FavoriteEvent
     * @static
     * @param {IFavoriteEvent} message FavoriteEvent message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FavoriteEvent.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Id != null && message.hasOwnProperty("Id"))
            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.Id);
        if (message.Name != null && message.hasOwnProperty("Name"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.Name);
        if (message.GraphicsPresentationId != null && message.hasOwnProperty("GraphicsPresentationId"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.GraphicsPresentationId);
        if (message.IsLive != null && message.hasOwnProperty("IsLive"))
            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.IsLive);
        return writer;
    };

    /**
     * Encodes the specified FavoriteEvent message, length delimited. Does not implicitly {@link FavoriteEvent.verify|verify} messages.
     * @function encodeDelimited
     * @memberof FavoriteEvent
     * @static
     * @param {IFavoriteEvent} message FavoriteEvent message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FavoriteEvent.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a FavoriteEvent message from the specified reader or buffer.
     * @function decode
     * @memberof FavoriteEvent
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {FavoriteEvent} FavoriteEvent
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FavoriteEvent.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FavoriteEvent();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Id = reader.int64();
                break;
            case 2:
                message.Name = reader.string();
                break;
            case 3:
                message.GraphicsPresentationId = reader.int32();
                break;
            case 4:
                message.IsLive = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a FavoriteEvent message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof FavoriteEvent
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {FavoriteEvent} FavoriteEvent
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FavoriteEvent.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a FavoriteEvent message.
     * @function verify
     * @memberof FavoriteEvent
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    FavoriteEvent.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Id != null && message.hasOwnProperty("Id"))
            if (!$util.isInteger(message.Id) && !(message.Id && $util.isInteger(message.Id.low) && $util.isInteger(message.Id.high)))
                return "Id: integer|Long expected";
        if (message.Name != null && message.hasOwnProperty("Name"))
            if (!$util.isString(message.Name))
                return "Name: string expected";
        if (message.GraphicsPresentationId != null && message.hasOwnProperty("GraphicsPresentationId"))
            if (!$util.isInteger(message.GraphicsPresentationId))
                return "GraphicsPresentationId: integer expected";
        if (message.IsLive != null && message.hasOwnProperty("IsLive"))
            if (typeof message.IsLive !== "boolean")
                return "IsLive: boolean expected";
        return null;
    };

    /**
     * Creates a FavoriteEvent message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof FavoriteEvent
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {FavoriteEvent} FavoriteEvent
     */
    FavoriteEvent.fromObject = function fromObject(object) {
        if (object instanceof $root.FavoriteEvent)
            return object;
        var message = new $root.FavoriteEvent();
        if (object.Id != null)
            if ($util.Long)
                (message.Id = $util.Long.fromValue(object.Id)).unsigned = false;
            else if (typeof object.Id === "string")
                message.Id = parseInt(object.Id, 10);
            else if (typeof object.Id === "number")
                message.Id = object.Id;
            else if (typeof object.Id === "object")
                message.Id = new $util.LongBits(object.Id.low >>> 0, object.Id.high >>> 0).toNumber();
        if (object.Name != null)
            message.Name = String(object.Name);
        if (object.GraphicsPresentationId != null)
            message.GraphicsPresentationId = object.GraphicsPresentationId | 0;
        if (object.IsLive != null)
            message.IsLive = Boolean(object.IsLive);
        return message;
    };

    /**
     * Creates a plain object from a FavoriteEvent message. Also converts values to other types if specified.
     * @function toObject
     * @memberof FavoriteEvent
     * @static
     * @param {FavoriteEvent} message FavoriteEvent
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    FavoriteEvent.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.Id = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.Id = options.longs === String ? "0" : 0;
            object.Name = "";
            object.GraphicsPresentationId = 0;
            object.IsLive = false;
        }
        if (message.Id != null && message.hasOwnProperty("Id"))
            if (typeof message.Id === "number")
                object.Id = options.longs === String ? String(message.Id) : message.Id;
            else
                object.Id = options.longs === String ? $util.Long.prototype.toString.call(message.Id) : options.longs === Number ? new $util.LongBits(message.Id.low >>> 0, message.Id.high >>> 0).toNumber() : message.Id;
        if (message.Name != null && message.hasOwnProperty("Name"))
            object.Name = message.Name;
        if (message.GraphicsPresentationId != null && message.hasOwnProperty("GraphicsPresentationId"))
            object.GraphicsPresentationId = message.GraphicsPresentationId;
        if (message.IsLive != null && message.hasOwnProperty("IsLive"))
            object.IsLive = message.IsLive;
        return object;
    };

    /**
     * Converts this FavoriteEvent to JSON.
     * @function toJSON
     * @memberof FavoriteEvent
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    FavoriteEvent.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FavoriteEvent;
})();

$root.FavoriteCategory = (function() {

    /**
     * Properties of a FavoriteCategory.
     * @exports IFavoriteCategory
     * @interface IFavoriteCategory
     * @property {string|null} [Id] FavoriteCategory Id
     * @property {string|null} [Name] FavoriteCategory Name
     * @property {number|null} [GraphicsPresentationId] FavoriteCategory GraphicsPresentationId
     * @property {boolean|null} [HasLive] FavoriteCategory HasLive
     */

    /**
     * Constructs a new FavoriteCategory.
     * @exports FavoriteCategory
     * @classdesc Represents a FavoriteCategory.
     * @implements IFavoriteCategory
     * @constructor
     * @param {IFavoriteCategory=} [properties] Properties to set
     */
    function FavoriteCategory(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * FavoriteCategory Id.
     * @member {string} Id
     * @memberof FavoriteCategory
     * @instance
     */
    FavoriteCategory.prototype.Id = "";

    /**
     * FavoriteCategory Name.
     * @member {string} Name
     * @memberof FavoriteCategory
     * @instance
     */
    FavoriteCategory.prototype.Name = "";

    /**
     * FavoriteCategory GraphicsPresentationId.
     * @member {number} GraphicsPresentationId
     * @memberof FavoriteCategory
     * @instance
     */
    FavoriteCategory.prototype.GraphicsPresentationId = 0;

    /**
     * FavoriteCategory HasLive.
     * @member {boolean} HasLive
     * @memberof FavoriteCategory
     * @instance
     */
    FavoriteCategory.prototype.HasLive = false;

    /**
     * Creates a new FavoriteCategory instance using the specified properties.
     * @function create
     * @memberof FavoriteCategory
     * @static
     * @param {IFavoriteCategory=} [properties] Properties to set
     * @returns {FavoriteCategory} FavoriteCategory instance
     */
    FavoriteCategory.create = function create(properties) {
        return new FavoriteCategory(properties);
    };

    /**
     * Encodes the specified FavoriteCategory message. Does not implicitly {@link FavoriteCategory.verify|verify} messages.
     * @function encode
     * @memberof FavoriteCategory
     * @static
     * @param {IFavoriteCategory} message FavoriteCategory message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FavoriteCategory.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Id != null && message.hasOwnProperty("Id"))
            writer.uint32(/* id 1, wireType 2 =*/10).string(message.Id);
        if (message.Name != null && message.hasOwnProperty("Name"))
            writer.uint32(/* id 2, wireType 2 =*/18).string(message.Name);
        if (message.GraphicsPresentationId != null && message.hasOwnProperty("GraphicsPresentationId"))
            writer.uint32(/* id 3, wireType 0 =*/24).int32(message.GraphicsPresentationId);
        if (message.HasLive != null && message.hasOwnProperty("HasLive"))
            writer.uint32(/* id 4, wireType 0 =*/32).bool(message.HasLive);
        return writer;
    };

    /**
     * Encodes the specified FavoriteCategory message, length delimited. Does not implicitly {@link FavoriteCategory.verify|verify} messages.
     * @function encodeDelimited
     * @memberof FavoriteCategory
     * @static
     * @param {IFavoriteCategory} message FavoriteCategory message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FavoriteCategory.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a FavoriteCategory message from the specified reader or buffer.
     * @function decode
     * @memberof FavoriteCategory
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {FavoriteCategory} FavoriteCategory
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FavoriteCategory.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FavoriteCategory();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.Id = reader.string();
                break;
            case 2:
                message.Name = reader.string();
                break;
            case 3:
                message.GraphicsPresentationId = reader.int32();
                break;
            case 4:
                message.HasLive = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a FavoriteCategory message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof FavoriteCategory
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {FavoriteCategory} FavoriteCategory
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FavoriteCategory.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a FavoriteCategory message.
     * @function verify
     * @memberof FavoriteCategory
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    FavoriteCategory.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Id != null && message.hasOwnProperty("Id"))
            if (!$util.isString(message.Id))
                return "Id: string expected";
        if (message.Name != null && message.hasOwnProperty("Name"))
            if (!$util.isString(message.Name))
                return "Name: string expected";
        if (message.GraphicsPresentationId != null && message.hasOwnProperty("GraphicsPresentationId"))
            if (!$util.isInteger(message.GraphicsPresentationId))
                return "GraphicsPresentationId: integer expected";
        if (message.HasLive != null && message.hasOwnProperty("HasLive"))
            if (typeof message.HasLive !== "boolean")
                return "HasLive: boolean expected";
        return null;
    };

    /**
     * Creates a FavoriteCategory message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof FavoriteCategory
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {FavoriteCategory} FavoriteCategory
     */
    FavoriteCategory.fromObject = function fromObject(object) {
        if (object instanceof $root.FavoriteCategory)
            return object;
        var message = new $root.FavoriteCategory();
        if (object.Id != null)
            message.Id = String(object.Id);
        if (object.Name != null)
            message.Name = String(object.Name);
        if (object.GraphicsPresentationId != null)
            message.GraphicsPresentationId = object.GraphicsPresentationId | 0;
        if (object.HasLive != null)
            message.HasLive = Boolean(object.HasLive);
        return message;
    };

    /**
     * Creates a plain object from a FavoriteCategory message. Also converts values to other types if specified.
     * @function toObject
     * @memberof FavoriteCategory
     * @static
     * @param {FavoriteCategory} message FavoriteCategory
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    FavoriteCategory.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            object.Id = "";
            object.Name = "";
            object.GraphicsPresentationId = 0;
            object.HasLive = false;
        }
        if (message.Id != null && message.hasOwnProperty("Id"))
            object.Id = message.Id;
        if (message.Name != null && message.hasOwnProperty("Name"))
            object.Name = message.Name;
        if (message.GraphicsPresentationId != null && message.hasOwnProperty("GraphicsPresentationId"))
            object.GraphicsPresentationId = message.GraphicsPresentationId;
        if (message.HasLive != null && message.hasOwnProperty("HasLive"))
            object.HasLive = message.HasLive;
        return object;
    };

    /**
     * Converts this FavoriteCategory to JSON.
     * @function toJSON
     * @memberof FavoriteCategory
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    FavoriteCategory.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FavoriteCategory;
})();

$root.FavoriteOffers = (function() {

    /**
     * Properties of a FavoriteOffers.
     * @exports IFavoriteOffers
     * @interface IFavoriteOffers
     * @property {Array.<IFavoriteEvent>|null} [Events] FavoriteOffers Events
     * @property {Array.<IFavoriteCategory>|null} [Categories] FavoriteOffers Categories
     */

    /**
     * Constructs a new FavoriteOffers.
     * @exports FavoriteOffers
     * @classdesc Represents a FavoriteOffers.
     * @implements IFavoriteOffers
     * @constructor
     * @param {IFavoriteOffers=} [properties] Properties to set
     */
    function FavoriteOffers(properties) {
        this.Events = [];
        this.Categories = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * FavoriteOffers Events.
     * @member {Array.<IFavoriteEvent>} Events
     * @memberof FavoriteOffers
     * @instance
     */
    FavoriteOffers.prototype.Events = $util.emptyArray;

    /**
     * FavoriteOffers Categories.
     * @member {Array.<IFavoriteCategory>} Categories
     * @memberof FavoriteOffers
     * @instance
     */
    FavoriteOffers.prototype.Categories = $util.emptyArray;

    /**
     * Creates a new FavoriteOffers instance using the specified properties.
     * @function create
     * @memberof FavoriteOffers
     * @static
     * @param {IFavoriteOffers=} [properties] Properties to set
     * @returns {FavoriteOffers} FavoriteOffers instance
     */
    FavoriteOffers.create = function create(properties) {
        return new FavoriteOffers(properties);
    };

    /**
     * Encodes the specified FavoriteOffers message. Does not implicitly {@link FavoriteOffers.verify|verify} messages.
     * @function encode
     * @memberof FavoriteOffers
     * @static
     * @param {IFavoriteOffers} message FavoriteOffers message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FavoriteOffers.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Events != null && message.Events.length)
            for (var i = 0; i < message.Events.length; ++i)
                $root.FavoriteEvent.encode(message.Events[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.Categories != null && message.Categories.length)
            for (var i = 0; i < message.Categories.length; ++i)
                $root.FavoriteCategory.encode(message.Categories[i], writer.uint32(/* id 2, wireType 2 =*/18).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified FavoriteOffers message, length delimited. Does not implicitly {@link FavoriteOffers.verify|verify} messages.
     * @function encodeDelimited
     * @memberof FavoriteOffers
     * @static
     * @param {IFavoriteOffers} message FavoriteOffers message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    FavoriteOffers.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a FavoriteOffers message from the specified reader or buffer.
     * @function decode
     * @memberof FavoriteOffers
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {FavoriteOffers} FavoriteOffers
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FavoriteOffers.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.FavoriteOffers();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.Events && message.Events.length))
                    message.Events = [];
                message.Events.push($root.FavoriteEvent.decode(reader, reader.uint32()));
                break;
            case 2:
                if (!(message.Categories && message.Categories.length))
                    message.Categories = [];
                message.Categories.push($root.FavoriteCategory.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a FavoriteOffers message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof FavoriteOffers
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {FavoriteOffers} FavoriteOffers
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    FavoriteOffers.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a FavoriteOffers message.
     * @function verify
     * @memberof FavoriteOffers
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    FavoriteOffers.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Events != null && message.hasOwnProperty("Events")) {
            if (!Array.isArray(message.Events))
                return "Events: array expected";
            for (var i = 0; i < message.Events.length; ++i) {
                var error = $root.FavoriteEvent.verify(message.Events[i]);
                if (error)
                    return "Events." + error;
            }
        }
        if (message.Categories != null && message.hasOwnProperty("Categories")) {
            if (!Array.isArray(message.Categories))
                return "Categories: array expected";
            for (var i = 0; i < message.Categories.length; ++i) {
                var error = $root.FavoriteCategory.verify(message.Categories[i]);
                if (error)
                    return "Categories." + error;
            }
        }
        return null;
    };

    /**
     * Creates a FavoriteOffers message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof FavoriteOffers
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {FavoriteOffers} FavoriteOffers
     */
    FavoriteOffers.fromObject = function fromObject(object) {
        if (object instanceof $root.FavoriteOffers)
            return object;
        var message = new $root.FavoriteOffers();
        if (object.Events) {
            if (!Array.isArray(object.Events))
                throw TypeError(".FavoriteOffers.Events: array expected");
            message.Events = [];
            for (var i = 0; i < object.Events.length; ++i) {
                if (typeof object.Events[i] !== "object")
                    throw TypeError(".FavoriteOffers.Events: object expected");
                message.Events[i] = $root.FavoriteEvent.fromObject(object.Events[i]);
            }
        }
        if (object.Categories) {
            if (!Array.isArray(object.Categories))
                throw TypeError(".FavoriteOffers.Categories: array expected");
            message.Categories = [];
            for (var i = 0; i < object.Categories.length; ++i) {
                if (typeof object.Categories[i] !== "object")
                    throw TypeError(".FavoriteOffers.Categories: object expected");
                message.Categories[i] = $root.FavoriteCategory.fromObject(object.Categories[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a FavoriteOffers message. Also converts values to other types if specified.
     * @function toObject
     * @memberof FavoriteOffers
     * @static
     * @param {FavoriteOffers} message FavoriteOffers
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    FavoriteOffers.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults) {
            object.Events = [];
            object.Categories = [];
        }
        if (message.Events && message.Events.length) {
            object.Events = [];
            for (var j = 0; j < message.Events.length; ++j)
                object.Events[j] = $root.FavoriteEvent.toObject(message.Events[j], options);
        }
        if (message.Categories && message.Categories.length) {
            object.Categories = [];
            for (var j = 0; j < message.Categories.length; ++j)
                object.Categories[j] = $root.FavoriteCategory.toObject(message.Categories[j], options);
        }
        return object;
    };

    /**
     * Converts this FavoriteOffers to JSON.
     * @function toJSON
     * @memberof FavoriteOffers
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    FavoriteOffers.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return FavoriteOffers;
})();

$root.TicketOneTapBetStartResponse = (function() {

    /**
     * Properties of a TicketOneTapBetStartResponse.
     * @exports ITicketOneTapBetStartResponse
     * @interface ITicketOneTapBetStartResponse
     * @property {Array.<ITicketError>|null} [Errors] TicketOneTapBetStartResponse Errors
     */

    /**
     * Constructs a new TicketOneTapBetStartResponse.
     * @exports TicketOneTapBetStartResponse
     * @classdesc Represents a TicketOneTapBetStartResponse.
     * @implements ITicketOneTapBetStartResponse
     * @constructor
     * @param {ITicketOneTapBetStartResponse=} [properties] Properties to set
     */
    function TicketOneTapBetStartResponse(properties) {
        this.Errors = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * TicketOneTapBetStartResponse Errors.
     * @member {Array.<ITicketError>} Errors
     * @memberof TicketOneTapBetStartResponse
     * @instance
     */
    TicketOneTapBetStartResponse.prototype.Errors = $util.emptyArray;

    /**
     * Creates a new TicketOneTapBetStartResponse instance using the specified properties.
     * @function create
     * @memberof TicketOneTapBetStartResponse
     * @static
     * @param {ITicketOneTapBetStartResponse=} [properties] Properties to set
     * @returns {TicketOneTapBetStartResponse} TicketOneTapBetStartResponse instance
     */
    TicketOneTapBetStartResponse.create = function create(properties) {
        return new TicketOneTapBetStartResponse(properties);
    };

    /**
     * Encodes the specified TicketOneTapBetStartResponse message. Does not implicitly {@link TicketOneTapBetStartResponse.verify|verify} messages.
     * @function encode
     * @memberof TicketOneTapBetStartResponse
     * @static
     * @param {ITicketOneTapBetStartResponse} message TicketOneTapBetStartResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TicketOneTapBetStartResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Errors != null && message.Errors.length)
            for (var i = 0; i < message.Errors.length; ++i)
                $root.TicketError.encode(message.Errors[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        return writer;
    };

    /**
     * Encodes the specified TicketOneTapBetStartResponse message, length delimited. Does not implicitly {@link TicketOneTapBetStartResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof TicketOneTapBetStartResponse
     * @static
     * @param {ITicketOneTapBetStartResponse} message TicketOneTapBetStartResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TicketOneTapBetStartResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TicketOneTapBetStartResponse message from the specified reader or buffer.
     * @function decode
     * @memberof TicketOneTapBetStartResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TicketOneTapBetStartResponse} TicketOneTapBetStartResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TicketOneTapBetStartResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TicketOneTapBetStartResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.Errors && message.Errors.length))
                    message.Errors = [];
                message.Errors.push($root.TicketError.decode(reader, reader.uint32()));
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a TicketOneTapBetStartResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof TicketOneTapBetStartResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {TicketOneTapBetStartResponse} TicketOneTapBetStartResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TicketOneTapBetStartResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TicketOneTapBetStartResponse message.
     * @function verify
     * @memberof TicketOneTapBetStartResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TicketOneTapBetStartResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Errors != null && message.hasOwnProperty("Errors")) {
            if (!Array.isArray(message.Errors))
                return "Errors: array expected";
            for (var i = 0; i < message.Errors.length; ++i) {
                var error = $root.TicketError.verify(message.Errors[i]);
                if (error)
                    return "Errors." + error;
            }
        }
        return null;
    };

    /**
     * Creates a TicketOneTapBetStartResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TicketOneTapBetStartResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TicketOneTapBetStartResponse} TicketOneTapBetStartResponse
     */
    TicketOneTapBetStartResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.TicketOneTapBetStartResponse)
            return object;
        var message = new $root.TicketOneTapBetStartResponse();
        if (object.Errors) {
            if (!Array.isArray(object.Errors))
                throw TypeError(".TicketOneTapBetStartResponse.Errors: array expected");
            message.Errors = [];
            for (var i = 0; i < object.Errors.length; ++i) {
                if (typeof object.Errors[i] !== "object")
                    throw TypeError(".TicketOneTapBetStartResponse.Errors: object expected");
                message.Errors[i] = $root.TicketError.fromObject(object.Errors[i]);
            }
        }
        return message;
    };

    /**
     * Creates a plain object from a TicketOneTapBetStartResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TicketOneTapBetStartResponse
     * @static
     * @param {TicketOneTapBetStartResponse} message TicketOneTapBetStartResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TicketOneTapBetStartResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.Errors = [];
        if (message.Errors && message.Errors.length) {
            object.Errors = [];
            for (var j = 0; j < message.Errors.length; ++j)
                object.Errors[j] = $root.TicketError.toObject(message.Errors[j], options);
        }
        return object;
    };

    /**
     * Converts this TicketOneTapBetStartResponse to JSON.
     * @function toJSON
     * @memberof TicketOneTapBetStartResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TicketOneTapBetStartResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TicketOneTapBetStartResponse;
})();

/**
 * TicketCancelResult enum.
 * @exports TicketCancelResult
 * @enum {string}
 * @property {number} None=0 None value
 * @property {number} Success=1 Success value
 * @property {number} NotForThisPlayer=2 NotForThisPlayer value
 * @property {number} PeriodOver=3 PeriodOver value
 * @property {number} AlreadyCancelled=4 AlreadyCancelled value
 */
$root.TicketCancelResult = (function() {
    var valuesById = {}, values = Object.create(valuesById);
    values[valuesById[0] = "None"] = 0;
    values[valuesById[1] = "Success"] = 1;
    values[valuesById[2] = "NotForThisPlayer"] = 2;
    values[valuesById[3] = "PeriodOver"] = 3;
    values[valuesById[4] = "AlreadyCancelled"] = 4;
    return values;
})();

$root.TicketCancelResponse = (function() {

    /**
     * Properties of a TicketCancelResponse.
     * @exports ITicketCancelResponse
     * @interface ITicketCancelResponse
     * @property {TicketCancelResult|null} [ResultType] TicketCancelResponse ResultType
     */

    /**
     * Constructs a new TicketCancelResponse.
     * @exports TicketCancelResponse
     * @classdesc Represents a TicketCancelResponse.
     * @implements ITicketCancelResponse
     * @constructor
     * @param {ITicketCancelResponse=} [properties] Properties to set
     */
    function TicketCancelResponse(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * TicketCancelResponse ResultType.
     * @member {TicketCancelResult} ResultType
     * @memberof TicketCancelResponse
     * @instance
     */
    TicketCancelResponse.prototype.ResultType = 0;

    /**
     * Creates a new TicketCancelResponse instance using the specified properties.
     * @function create
     * @memberof TicketCancelResponse
     * @static
     * @param {ITicketCancelResponse=} [properties] Properties to set
     * @returns {TicketCancelResponse} TicketCancelResponse instance
     */
    TicketCancelResponse.create = function create(properties) {
        return new TicketCancelResponse(properties);
    };

    /**
     * Encodes the specified TicketCancelResponse message. Does not implicitly {@link TicketCancelResponse.verify|verify} messages.
     * @function encode
     * @memberof TicketCancelResponse
     * @static
     * @param {ITicketCancelResponse} message TicketCancelResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TicketCancelResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.ResultType != null && message.hasOwnProperty("ResultType"))
            writer.uint32(/* id 1, wireType 0 =*/8).int32(message.ResultType);
        return writer;
    };

    /**
     * Encodes the specified TicketCancelResponse message, length delimited. Does not implicitly {@link TicketCancelResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof TicketCancelResponse
     * @static
     * @param {ITicketCancelResponse} message TicketCancelResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    TicketCancelResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a TicketCancelResponse message from the specified reader or buffer.
     * @function decode
     * @memberof TicketCancelResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {TicketCancelResponse} TicketCancelResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TicketCancelResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.TicketCancelResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.ResultType = reader.int32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a TicketCancelResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof TicketCancelResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {TicketCancelResponse} TicketCancelResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    TicketCancelResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a TicketCancelResponse message.
     * @function verify
     * @memberof TicketCancelResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    TicketCancelResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.ResultType != null && message.hasOwnProperty("ResultType"))
            switch (message.ResultType) {
            default:
                return "ResultType: enum value expected";
            case 0:
            case 1:
            case 2:
            case 3:
            case 4:
                break;
            }
        return null;
    };

    /**
     * Creates a TicketCancelResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof TicketCancelResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {TicketCancelResponse} TicketCancelResponse
     */
    TicketCancelResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.TicketCancelResponse)
            return object;
        var message = new $root.TicketCancelResponse();
        switch (object.ResultType) {
        case "None":
        case 0:
            message.ResultType = 0;
            break;
        case "Success":
        case 1:
            message.ResultType = 1;
            break;
        case "NotForThisPlayer":
        case 2:
            message.ResultType = 2;
            break;
        case "PeriodOver":
        case 3:
            message.ResultType = 3;
            break;
        case "AlreadyCancelled":
        case 4:
            message.ResultType = 4;
            break;
        }
        return message;
    };

    /**
     * Creates a plain object from a TicketCancelResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof TicketCancelResponse
     * @static
     * @param {TicketCancelResponse} message TicketCancelResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    TicketCancelResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults)
            object.ResultType = options.enums === String ? "None" : 0;
        if (message.ResultType != null && message.hasOwnProperty("ResultType"))
            object.ResultType = options.enums === String ? $root.TicketCancelResult[message.ResultType] : message.ResultType;
        return object;
    };

    /**
     * Converts this TicketCancelResponse to JSON.
     * @function toJSON
     * @memberof TicketCancelResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    TicketCancelResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return TicketCancelResponse;
})();

$root.ReuseAliveSelection = (function() {

    /**
     * Properties of a ReuseAliveSelection.
     * @exports IReuseAliveSelection
     * @interface IReuseAliveSelection
     * @property {number|Long|null} [SelectionId] ReuseAliveSelection SelectionId
     * @property {number|Long|null} [FixtureId] ReuseAliveSelection FixtureId
     * @property {string|null} [GameId] ReuseAliveSelection GameId
     * @property {number|Long|null} [TipId] ReuseAliveSelection TipId
     * @property {number|null} [Rate] ReuseAliveSelection Rate
     * @property {string|null} [DetailName] ReuseAliveSelection DetailName
     * @property {string|null} [TipName] ReuseAliveSelection TipName
     * @property {string|null} [SportName] ReuseAliveSelection SportName
     * @property {string|null} [FixtureName] ReuseAliveSelection FixtureName
     * @property {ITimestamp|null} [FixtureDate] ReuseAliveSelection FixtureDate
     * @property {OfferType|null} [OfferType] ReuseAliveSelection OfferType
     * @property {number|Long|null} [Number] ReuseAliveSelection Number
     * @property {number|Long|null} [DetailId] ReuseAliveSelection DetailId
     * @property {number|null} [SelectionVisualisationFlags] ReuseAliveSelection SelectionVisualisationFlags
     */

    /**
     * Constructs a new ReuseAliveSelection.
     * @exports ReuseAliveSelection
     * @classdesc Represents a ReuseAliveSelection.
     * @implements IReuseAliveSelection
     * @constructor
     * @param {IReuseAliveSelection=} [properties] Properties to set
     */
    function ReuseAliveSelection(properties) {
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ReuseAliveSelection SelectionId.
     * @member {number|Long} SelectionId
     * @memberof ReuseAliveSelection
     * @instance
     */
    ReuseAliveSelection.prototype.SelectionId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * ReuseAliveSelection FixtureId.
     * @member {number|Long} FixtureId
     * @memberof ReuseAliveSelection
     * @instance
     */
    ReuseAliveSelection.prototype.FixtureId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * ReuseAliveSelection GameId.
     * @member {string} GameId
     * @memberof ReuseAliveSelection
     * @instance
     */
    ReuseAliveSelection.prototype.GameId = "";

    /**
     * ReuseAliveSelection TipId.
     * @member {number|Long} TipId
     * @memberof ReuseAliveSelection
     * @instance
     */
    ReuseAliveSelection.prototype.TipId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * ReuseAliveSelection Rate.
     * @member {number} Rate
     * @memberof ReuseAliveSelection
     * @instance
     */
    ReuseAliveSelection.prototype.Rate = 0;

    /**
     * ReuseAliveSelection DetailName.
     * @member {string} DetailName
     * @memberof ReuseAliveSelection
     * @instance
     */
    ReuseAliveSelection.prototype.DetailName = "";

    /**
     * ReuseAliveSelection TipName.
     * @member {string} TipName
     * @memberof ReuseAliveSelection
     * @instance
     */
    ReuseAliveSelection.prototype.TipName = "";

    /**
     * ReuseAliveSelection SportName.
     * @member {string} SportName
     * @memberof ReuseAliveSelection
     * @instance
     */
    ReuseAliveSelection.prototype.SportName = "";

    /**
     * ReuseAliveSelection FixtureName.
     * @member {string} FixtureName
     * @memberof ReuseAliveSelection
     * @instance
     */
    ReuseAliveSelection.prototype.FixtureName = "";

    /**
     * ReuseAliveSelection FixtureDate.
     * @member {ITimestamp|null|undefined} FixtureDate
     * @memberof ReuseAliveSelection
     * @instance
     */
    ReuseAliveSelection.prototype.FixtureDate = null;

    /**
     * ReuseAliveSelection OfferType.
     * @member {OfferType} OfferType
     * @memberof ReuseAliveSelection
     * @instance
     */
    ReuseAliveSelection.prototype.OfferType = 0;

    /**
     * ReuseAliveSelection Number.
     * @member {number|Long} Number
     * @memberof ReuseAliveSelection
     * @instance
     */
    ReuseAliveSelection.prototype.Number = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * ReuseAliveSelection DetailId.
     * @member {number|Long} DetailId
     * @memberof ReuseAliveSelection
     * @instance
     */
    ReuseAliveSelection.prototype.DetailId = $util.Long ? $util.Long.fromBits(0,0,false) : 0;

    /**
     * ReuseAliveSelection SelectionVisualisationFlags.
     * @member {number} SelectionVisualisationFlags
     * @memberof ReuseAliveSelection
     * @instance
     */
    ReuseAliveSelection.prototype.SelectionVisualisationFlags = 0;

    /**
     * Creates a new ReuseAliveSelection instance using the specified properties.
     * @function create
     * @memberof ReuseAliveSelection
     * @static
     * @param {IReuseAliveSelection=} [properties] Properties to set
     * @returns {ReuseAliveSelection} ReuseAliveSelection instance
     */
    ReuseAliveSelection.create = function create(properties) {
        return new ReuseAliveSelection(properties);
    };

    /**
     * Encodes the specified ReuseAliveSelection message. Does not implicitly {@link ReuseAliveSelection.verify|verify} messages.
     * @function encode
     * @memberof ReuseAliveSelection
     * @static
     * @param {IReuseAliveSelection} message ReuseAliveSelection message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ReuseAliveSelection.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.SelectionId != null && message.hasOwnProperty("SelectionId"))
            writer.uint32(/* id 1, wireType 0 =*/8).int64(message.SelectionId);
        if (message.FixtureId != null && message.hasOwnProperty("FixtureId"))
            writer.uint32(/* id 2, wireType 0 =*/16).int64(message.FixtureId);
        if (message.GameId != null && message.hasOwnProperty("GameId"))
            writer.uint32(/* id 3, wireType 2 =*/26).string(message.GameId);
        if (message.TipId != null && message.hasOwnProperty("TipId"))
            writer.uint32(/* id 4, wireType 0 =*/32).int64(message.TipId);
        if (message.Rate != null && message.hasOwnProperty("Rate"))
            writer.uint32(/* id 5, wireType 1 =*/41).double(message.Rate);
        if (message.DetailName != null && message.hasOwnProperty("DetailName"))
            writer.uint32(/* id 6, wireType 2 =*/50).string(message.DetailName);
        if (message.TipName != null && message.hasOwnProperty("TipName"))
            writer.uint32(/* id 7, wireType 2 =*/58).string(message.TipName);
        if (message.SportName != null && message.hasOwnProperty("SportName"))
            writer.uint32(/* id 8, wireType 2 =*/66).string(message.SportName);
        if (message.FixtureName != null && message.hasOwnProperty("FixtureName"))
            writer.uint32(/* id 9, wireType 2 =*/74).string(message.FixtureName);
        if (message.FixtureDate != null && message.hasOwnProperty("FixtureDate"))
            $root.Timestamp.encode(message.FixtureDate, writer.uint32(/* id 10, wireType 2 =*/82).fork()).ldelim();
        if (message.OfferType != null && message.hasOwnProperty("OfferType"))
            writer.uint32(/* id 11, wireType 0 =*/88).int32(message.OfferType);
        if (message.Number != null && message.hasOwnProperty("Number"))
            writer.uint32(/* id 12, wireType 0 =*/96).int64(message.Number);
        if (message.DetailId != null && message.hasOwnProperty("DetailId"))
            writer.uint32(/* id 13, wireType 0 =*/104).int64(message.DetailId);
        if (message.SelectionVisualisationFlags != null && message.hasOwnProperty("SelectionVisualisationFlags"))
            writer.uint32(/* id 14, wireType 0 =*/112).uint32(message.SelectionVisualisationFlags);
        return writer;
    };

    /**
     * Encodes the specified ReuseAliveSelection message, length delimited. Does not implicitly {@link ReuseAliveSelection.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ReuseAliveSelection
     * @static
     * @param {IReuseAliveSelection} message ReuseAliveSelection message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ReuseAliveSelection.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ReuseAliveSelection message from the specified reader or buffer.
     * @function decode
     * @memberof ReuseAliveSelection
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ReuseAliveSelection} ReuseAliveSelection
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ReuseAliveSelection.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ReuseAliveSelection();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                message.SelectionId = reader.int64();
                break;
            case 2:
                message.FixtureId = reader.int64();
                break;
            case 3:
                message.GameId = reader.string();
                break;
            case 4:
                message.TipId = reader.int64();
                break;
            case 5:
                message.Rate = reader.double();
                break;
            case 6:
                message.DetailName = reader.string();
                break;
            case 7:
                message.TipName = reader.string();
                break;
            case 8:
                message.SportName = reader.string();
                break;
            case 9:
                message.FixtureName = reader.string();
                break;
            case 10:
                message.FixtureDate = $root.Timestamp.decode(reader, reader.uint32());
                break;
            case 11:
                message.OfferType = reader.int32();
                break;
            case 12:
                message.Number = reader.int64();
                break;
            case 13:
                message.DetailId = reader.int64();
                break;
            case 14:
                message.SelectionVisualisationFlags = reader.uint32();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ReuseAliveSelection message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ReuseAliveSelection
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ReuseAliveSelection} ReuseAliveSelection
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ReuseAliveSelection.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ReuseAliveSelection message.
     * @function verify
     * @memberof ReuseAliveSelection
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ReuseAliveSelection.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.SelectionId != null && message.hasOwnProperty("SelectionId"))
            if (!$util.isInteger(message.SelectionId) && !(message.SelectionId && $util.isInteger(message.SelectionId.low) && $util.isInteger(message.SelectionId.high)))
                return "SelectionId: integer|Long expected";
        if (message.FixtureId != null && message.hasOwnProperty("FixtureId"))
            if (!$util.isInteger(message.FixtureId) && !(message.FixtureId && $util.isInteger(message.FixtureId.low) && $util.isInteger(message.FixtureId.high)))
                return "FixtureId: integer|Long expected";
        if (message.GameId != null && message.hasOwnProperty("GameId"))
            if (!$util.isString(message.GameId))
                return "GameId: string expected";
        if (message.TipId != null && message.hasOwnProperty("TipId"))
            if (!$util.isInteger(message.TipId) && !(message.TipId && $util.isInteger(message.TipId.low) && $util.isInteger(message.TipId.high)))
                return "TipId: integer|Long expected";
        if (message.Rate != null && message.hasOwnProperty("Rate"))
            if (typeof message.Rate !== "number")
                return "Rate: number expected";
        if (message.DetailName != null && message.hasOwnProperty("DetailName"))
            if (!$util.isString(message.DetailName))
                return "DetailName: string expected";
        if (message.TipName != null && message.hasOwnProperty("TipName"))
            if (!$util.isString(message.TipName))
                return "TipName: string expected";
        if (message.SportName != null && message.hasOwnProperty("SportName"))
            if (!$util.isString(message.SportName))
                return "SportName: string expected";
        if (message.FixtureName != null && message.hasOwnProperty("FixtureName"))
            if (!$util.isString(message.FixtureName))
                return "FixtureName: string expected";
        if (message.FixtureDate != null && message.hasOwnProperty("FixtureDate")) {
            var error = $root.Timestamp.verify(message.FixtureDate);
            if (error)
                return "FixtureDate." + error;
        }
        if (message.OfferType != null && message.hasOwnProperty("OfferType"))
            switch (message.OfferType) {
            default:
                return "OfferType: enum value expected";
            case 0:
            case 1:
                break;
            }
        if (message.Number != null && message.hasOwnProperty("Number"))
            if (!$util.isInteger(message.Number) && !(message.Number && $util.isInteger(message.Number.low) && $util.isInteger(message.Number.high)))
                return "Number: integer|Long expected";
        if (message.DetailId != null && message.hasOwnProperty("DetailId"))
            if (!$util.isInteger(message.DetailId) && !(message.DetailId && $util.isInteger(message.DetailId.low) && $util.isInteger(message.DetailId.high)))
                return "DetailId: integer|Long expected";
        if (message.SelectionVisualisationFlags != null && message.hasOwnProperty("SelectionVisualisationFlags"))
            if (!$util.isInteger(message.SelectionVisualisationFlags))
                return "SelectionVisualisationFlags: integer expected";
        return null;
    };

    /**
     * Creates a ReuseAliveSelection message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ReuseAliveSelection
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ReuseAliveSelection} ReuseAliveSelection
     */
    ReuseAliveSelection.fromObject = function fromObject(object) {
        if (object instanceof $root.ReuseAliveSelection)
            return object;
        var message = new $root.ReuseAliveSelection();
        if (object.SelectionId != null)
            if ($util.Long)
                (message.SelectionId = $util.Long.fromValue(object.SelectionId)).unsigned = false;
            else if (typeof object.SelectionId === "string")
                message.SelectionId = parseInt(object.SelectionId, 10);
            else if (typeof object.SelectionId === "number")
                message.SelectionId = object.SelectionId;
            else if (typeof object.SelectionId === "object")
                message.SelectionId = new $util.LongBits(object.SelectionId.low >>> 0, object.SelectionId.high >>> 0).toNumber();
        if (object.FixtureId != null)
            if ($util.Long)
                (message.FixtureId = $util.Long.fromValue(object.FixtureId)).unsigned = false;
            else if (typeof object.FixtureId === "string")
                message.FixtureId = parseInt(object.FixtureId, 10);
            else if (typeof object.FixtureId === "number")
                message.FixtureId = object.FixtureId;
            else if (typeof object.FixtureId === "object")
                message.FixtureId = new $util.LongBits(object.FixtureId.low >>> 0, object.FixtureId.high >>> 0).toNumber();
        if (object.GameId != null)
            message.GameId = String(object.GameId);
        if (object.TipId != null)
            if ($util.Long)
                (message.TipId = $util.Long.fromValue(object.TipId)).unsigned = false;
            else if (typeof object.TipId === "string")
                message.TipId = parseInt(object.TipId, 10);
            else if (typeof object.TipId === "number")
                message.TipId = object.TipId;
            else if (typeof object.TipId === "object")
                message.TipId = new $util.LongBits(object.TipId.low >>> 0, object.TipId.high >>> 0).toNumber();
        if (object.Rate != null)
            message.Rate = Number(object.Rate);
        if (object.DetailName != null)
            message.DetailName = String(object.DetailName);
        if (object.TipName != null)
            message.TipName = String(object.TipName);
        if (object.SportName != null)
            message.SportName = String(object.SportName);
        if (object.FixtureName != null)
            message.FixtureName = String(object.FixtureName);
        if (object.FixtureDate != null) {
            if (typeof object.FixtureDate !== "object")
                throw TypeError(".ReuseAliveSelection.FixtureDate: object expected");
            message.FixtureDate = $root.Timestamp.fromObject(object.FixtureDate);
        }
        switch (object.OfferType) {
        case "Prematch":
        case 0:
            message.OfferType = 0;
            break;
        case "Live":
        case 1:
            message.OfferType = 1;
            break;
        }
        if (object.Number != null)
            if ($util.Long)
                (message.Number = $util.Long.fromValue(object.Number)).unsigned = false;
            else if (typeof object.Number === "string")
                message.Number = parseInt(object.Number, 10);
            else if (typeof object.Number === "number")
                message.Number = object.Number;
            else if (typeof object.Number === "object")
                message.Number = new $util.LongBits(object.Number.low >>> 0, object.Number.high >>> 0).toNumber();
        if (object.DetailId != null)
            if ($util.Long)
                (message.DetailId = $util.Long.fromValue(object.DetailId)).unsigned = false;
            else if (typeof object.DetailId === "string")
                message.DetailId = parseInt(object.DetailId, 10);
            else if (typeof object.DetailId === "number")
                message.DetailId = object.DetailId;
            else if (typeof object.DetailId === "object")
                message.DetailId = new $util.LongBits(object.DetailId.low >>> 0, object.DetailId.high >>> 0).toNumber();
        if (object.SelectionVisualisationFlags != null)
            message.SelectionVisualisationFlags = object.SelectionVisualisationFlags >>> 0;
        return message;
    };

    /**
     * Creates a plain object from a ReuseAliveSelection message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ReuseAliveSelection
     * @static
     * @param {ReuseAliveSelection} message ReuseAliveSelection
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ReuseAliveSelection.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.defaults) {
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.SelectionId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.SelectionId = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.FixtureId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.FixtureId = options.longs === String ? "0" : 0;
            object.GameId = "";
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.TipId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.TipId = options.longs === String ? "0" : 0;
            object.Rate = 0;
            object.DetailName = "";
            object.TipName = "";
            object.SportName = "";
            object.FixtureName = "";
            object.FixtureDate = null;
            object.OfferType = options.enums === String ? "Prematch" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.Number = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.Number = options.longs === String ? "0" : 0;
            if ($util.Long) {
                var long = new $util.Long(0, 0, false);
                object.DetailId = options.longs === String ? long.toString() : options.longs === Number ? long.toNumber() : long;
            } else
                object.DetailId = options.longs === String ? "0" : 0;
            object.SelectionVisualisationFlags = 0;
        }
        if (message.SelectionId != null && message.hasOwnProperty("SelectionId"))
            if (typeof message.SelectionId === "number")
                object.SelectionId = options.longs === String ? String(message.SelectionId) : message.SelectionId;
            else
                object.SelectionId = options.longs === String ? $util.Long.prototype.toString.call(message.SelectionId) : options.longs === Number ? new $util.LongBits(message.SelectionId.low >>> 0, message.SelectionId.high >>> 0).toNumber() : message.SelectionId;
        if (message.FixtureId != null && message.hasOwnProperty("FixtureId"))
            if (typeof message.FixtureId === "number")
                object.FixtureId = options.longs === String ? String(message.FixtureId) : message.FixtureId;
            else
                object.FixtureId = options.longs === String ? $util.Long.prototype.toString.call(message.FixtureId) : options.longs === Number ? new $util.LongBits(message.FixtureId.low >>> 0, message.FixtureId.high >>> 0).toNumber() : message.FixtureId;
        if (message.GameId != null && message.hasOwnProperty("GameId"))
            object.GameId = message.GameId;
        if (message.TipId != null && message.hasOwnProperty("TipId"))
            if (typeof message.TipId === "number")
                object.TipId = options.longs === String ? String(message.TipId) : message.TipId;
            else
                object.TipId = options.longs === String ? $util.Long.prototype.toString.call(message.TipId) : options.longs === Number ? new $util.LongBits(message.TipId.low >>> 0, message.TipId.high >>> 0).toNumber() : message.TipId;
        if (message.Rate != null && message.hasOwnProperty("Rate"))
            object.Rate = options.json && !isFinite(message.Rate) ? String(message.Rate) : message.Rate;
        if (message.DetailName != null && message.hasOwnProperty("DetailName"))
            object.DetailName = message.DetailName;
        if (message.TipName != null && message.hasOwnProperty("TipName"))
            object.TipName = message.TipName;
        if (message.SportName != null && message.hasOwnProperty("SportName"))
            object.SportName = message.SportName;
        if (message.FixtureName != null && message.hasOwnProperty("FixtureName"))
            object.FixtureName = message.FixtureName;
        if (message.FixtureDate != null && message.hasOwnProperty("FixtureDate"))
            object.FixtureDate = $root.Timestamp.toObject(message.FixtureDate, options);
        if (message.OfferType != null && message.hasOwnProperty("OfferType"))
            object.OfferType = options.enums === String ? $root.OfferType[message.OfferType] : message.OfferType;
        if (message.Number != null && message.hasOwnProperty("Number"))
            if (typeof message.Number === "number")
                object.Number = options.longs === String ? String(message.Number) : message.Number;
            else
                object.Number = options.longs === String ? $util.Long.prototype.toString.call(message.Number) : options.longs === Number ? new $util.LongBits(message.Number.low >>> 0, message.Number.high >>> 0).toNumber() : message.Number;
        if (message.DetailId != null && message.hasOwnProperty("DetailId"))
            if (typeof message.DetailId === "number")
                object.DetailId = options.longs === String ? String(message.DetailId) : message.DetailId;
            else
                object.DetailId = options.longs === String ? $util.Long.prototype.toString.call(message.DetailId) : options.longs === Number ? new $util.LongBits(message.DetailId.low >>> 0, message.DetailId.high >>> 0).toNumber() : message.DetailId;
        if (message.SelectionVisualisationFlags != null && message.hasOwnProperty("SelectionVisualisationFlags"))
            object.SelectionVisualisationFlags = message.SelectionVisualisationFlags;
        return object;
    };

    /**
     * Converts this ReuseAliveSelection to JSON.
     * @function toJSON
     * @memberof ReuseAliveSelection
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ReuseAliveSelection.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ReuseAliveSelection;
})();

$root.ReuseAliveSelectionResponse = (function() {

    /**
     * Properties of a ReuseAliveSelectionResponse.
     * @exports IReuseAliveSelectionResponse
     * @interface IReuseAliveSelectionResponse
     * @property {Array.<IReuseAliveSelection>|null} [Selections] ReuseAliveSelectionResponse Selections
     * @property {boolean|null} [WasAllActiveFound] ReuseAliveSelectionResponse WasAllActiveFound
     */

    /**
     * Constructs a new ReuseAliveSelectionResponse.
     * @exports ReuseAliveSelectionResponse
     * @classdesc Represents a ReuseAliveSelectionResponse.
     * @implements IReuseAliveSelectionResponse
     * @constructor
     * @param {IReuseAliveSelectionResponse=} [properties] Properties to set
     */
    function ReuseAliveSelectionResponse(properties) {
        this.Selections = [];
        if (properties)
            for (var keys = Object.keys(properties), i = 0; i < keys.length; ++i)
                if (properties[keys[i]] != null)
                    this[keys[i]] = properties[keys[i]];
    }

    /**
     * ReuseAliveSelectionResponse Selections.
     * @member {Array.<IReuseAliveSelection>} Selections
     * @memberof ReuseAliveSelectionResponse
     * @instance
     */
    ReuseAliveSelectionResponse.prototype.Selections = $util.emptyArray;

    /**
     * ReuseAliveSelectionResponse WasAllActiveFound.
     * @member {boolean} WasAllActiveFound
     * @memberof ReuseAliveSelectionResponse
     * @instance
     */
    ReuseAliveSelectionResponse.prototype.WasAllActiveFound = false;

    /**
     * Creates a new ReuseAliveSelectionResponse instance using the specified properties.
     * @function create
     * @memberof ReuseAliveSelectionResponse
     * @static
     * @param {IReuseAliveSelectionResponse=} [properties] Properties to set
     * @returns {ReuseAliveSelectionResponse} ReuseAliveSelectionResponse instance
     */
    ReuseAliveSelectionResponse.create = function create(properties) {
        return new ReuseAliveSelectionResponse(properties);
    };

    /**
     * Encodes the specified ReuseAliveSelectionResponse message. Does not implicitly {@link ReuseAliveSelectionResponse.verify|verify} messages.
     * @function encode
     * @memberof ReuseAliveSelectionResponse
     * @static
     * @param {IReuseAliveSelectionResponse} message ReuseAliveSelectionResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ReuseAliveSelectionResponse.encode = function encode(message, writer) {
        if (!writer)
            writer = $Writer.create();
        if (message.Selections != null && message.Selections.length)
            for (var i = 0; i < message.Selections.length; ++i)
                $root.ReuseAliveSelection.encode(message.Selections[i], writer.uint32(/* id 1, wireType 2 =*/10).fork()).ldelim();
        if (message.WasAllActiveFound != null && message.hasOwnProperty("WasAllActiveFound"))
            writer.uint32(/* id 2, wireType 0 =*/16).bool(message.WasAllActiveFound);
        return writer;
    };

    /**
     * Encodes the specified ReuseAliveSelectionResponse message, length delimited. Does not implicitly {@link ReuseAliveSelectionResponse.verify|verify} messages.
     * @function encodeDelimited
     * @memberof ReuseAliveSelectionResponse
     * @static
     * @param {IReuseAliveSelectionResponse} message ReuseAliveSelectionResponse message or plain object to encode
     * @param {$protobuf.Writer} [writer] Writer to encode to
     * @returns {$protobuf.Writer} Writer
     */
    ReuseAliveSelectionResponse.encodeDelimited = function encodeDelimited(message, writer) {
        return this.encode(message, writer).ldelim();
    };

    /**
     * Decodes a ReuseAliveSelectionResponse message from the specified reader or buffer.
     * @function decode
     * @memberof ReuseAliveSelectionResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @param {number} [length] Message length if known beforehand
     * @returns {ReuseAliveSelectionResponse} ReuseAliveSelectionResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ReuseAliveSelectionResponse.decode = function decode(reader, length) {
        if (!(reader instanceof $Reader))
            reader = $Reader.create(reader);
        var end = length === undefined ? reader.len : reader.pos + length, message = new $root.ReuseAliveSelectionResponse();
        while (reader.pos < end) {
            var tag = reader.uint32();
            switch (tag >>> 3) {
            case 1:
                if (!(message.Selections && message.Selections.length))
                    message.Selections = [];
                message.Selections.push($root.ReuseAliveSelection.decode(reader, reader.uint32()));
                break;
            case 2:
                message.WasAllActiveFound = reader.bool();
                break;
            default:
                reader.skipType(tag & 7);
                break;
            }
        }
        return message;
    };

    /**
     * Decodes a ReuseAliveSelectionResponse message from the specified reader or buffer, length delimited.
     * @function decodeDelimited
     * @memberof ReuseAliveSelectionResponse
     * @static
     * @param {$protobuf.Reader|Uint8Array} reader Reader or buffer to decode from
     * @returns {ReuseAliveSelectionResponse} ReuseAliveSelectionResponse
     * @throws {Error} If the payload is not a reader or valid buffer
     * @throws {$protobuf.util.ProtocolError} If required fields are missing
     */
    ReuseAliveSelectionResponse.decodeDelimited = function decodeDelimited(reader) {
        if (!(reader instanceof $Reader))
            reader = new $Reader(reader);
        return this.decode(reader, reader.uint32());
    };

    /**
     * Verifies a ReuseAliveSelectionResponse message.
     * @function verify
     * @memberof ReuseAliveSelectionResponse
     * @static
     * @param {Object.<string,*>} message Plain object to verify
     * @returns {string|null} `null` if valid, otherwise the reason why it is not
     */
    ReuseAliveSelectionResponse.verify = function verify(message) {
        if (typeof message !== "object" || message === null)
            return "object expected";
        if (message.Selections != null && message.hasOwnProperty("Selections")) {
            if (!Array.isArray(message.Selections))
                return "Selections: array expected";
            for (var i = 0; i < message.Selections.length; ++i) {
                var error = $root.ReuseAliveSelection.verify(message.Selections[i]);
                if (error)
                    return "Selections." + error;
            }
        }
        if (message.WasAllActiveFound != null && message.hasOwnProperty("WasAllActiveFound"))
            if (typeof message.WasAllActiveFound !== "boolean")
                return "WasAllActiveFound: boolean expected";
        return null;
    };

    /**
     * Creates a ReuseAliveSelectionResponse message from a plain object. Also converts values to their respective internal types.
     * @function fromObject
     * @memberof ReuseAliveSelectionResponse
     * @static
     * @param {Object.<string,*>} object Plain object
     * @returns {ReuseAliveSelectionResponse} ReuseAliveSelectionResponse
     */
    ReuseAliveSelectionResponse.fromObject = function fromObject(object) {
        if (object instanceof $root.ReuseAliveSelectionResponse)
            return object;
        var message = new $root.ReuseAliveSelectionResponse();
        if (object.Selections) {
            if (!Array.isArray(object.Selections))
                throw TypeError(".ReuseAliveSelectionResponse.Selections: array expected");
            message.Selections = [];
            for (var i = 0; i < object.Selections.length; ++i) {
                if (typeof object.Selections[i] !== "object")
                    throw TypeError(".ReuseAliveSelectionResponse.Selections: object expected");
                message.Selections[i] = $root.ReuseAliveSelection.fromObject(object.Selections[i]);
            }
        }
        if (object.WasAllActiveFound != null)
            message.WasAllActiveFound = Boolean(object.WasAllActiveFound);
        return message;
    };

    /**
     * Creates a plain object from a ReuseAliveSelectionResponse message. Also converts values to other types if specified.
     * @function toObject
     * @memberof ReuseAliveSelectionResponse
     * @static
     * @param {ReuseAliveSelectionResponse} message ReuseAliveSelectionResponse
     * @param {$protobuf.IConversionOptions} [options] Conversion options
     * @returns {Object.<string,*>} Plain object
     */
    ReuseAliveSelectionResponse.toObject = function toObject(message, options) {
        if (!options)
            options = {};
        var object = {};
        if (options.arrays || options.defaults)
            object.Selections = [];
        if (options.defaults)
            object.WasAllActiveFound = false;
        if (message.Selections && message.Selections.length) {
            object.Selections = [];
            for (var j = 0; j < message.Selections.length; ++j)
                object.Selections[j] = $root.ReuseAliveSelection.toObject(message.Selections[j], options);
        }
        if (message.WasAllActiveFound != null && message.hasOwnProperty("WasAllActiveFound"))
            object.WasAllActiveFound = message.WasAllActiveFound;
        return object;
    };

    /**
     * Converts this ReuseAliveSelectionResponse to JSON.
     * @function toJSON
     * @memberof ReuseAliveSelectionResponse
     * @instance
     * @returns {Object.<string,*>} JSON object
     */
    ReuseAliveSelectionResponse.prototype.toJSON = function toJSON() {
        return this.constructor.toObject(this, $protobuf.util.toJSONOptions);
    };

    return ReuseAliveSelectionResponse;
})();

module.exports = $root;
